/*! Copyright 2025 Healthwise, Incorporated */
webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGlobalStyle", function() { return createGlobalStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetConsumer", function() { return StyleSheetConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetContext", function() { return StyleSheetContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeConsumer", function() { return ThemeConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeContext", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_merge_anything__ = __webpack_require__(877);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











// 

var interleave = function interleave(strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = function isPlainObject(x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
};

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (__webpack_require__.i({"NODE_ENV":"production"}).REACT_APP_SC_ATTR || __webpack_require__.i({"NODE_ENV":"production"}).SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (__webpack_require__.i({"NODE_ENV":"production"}).REACT_APP_SC_DISABLE_SPEEDY || __webpack_require__.i({"NODE_ENV":"production"}).SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = function extractComps(maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = function getNonce() {
  return  true ? __webpack_require__.nc : null;
};

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */

  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */

  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */

  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */

  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */

  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */

  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */

  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */

  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */

  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;

    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" /* default */])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {
        // eslint-disable-next-line no-console
        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
      }

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = "production" === 'production' && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */

  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = function createWarnTooManyClasses(displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
};

// 

var determineTheme = function determineTheme(props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
};

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_4_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = function once(cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
};

// 

var ThemeContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeContext.Consumer, null, this.renderInner);
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeContext.Provider, { value: context }, this.props.children);
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */

  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */

  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyleSheetManager, { sheet: this.instance }, children);
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyleSheetContext.Provider, { value: this.getContext(sheet, target) },  false ? React.Children.only(children) : children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyleSheetConsumer, null, this.renderOuter);
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeConsumer, null, this.renderInner);
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;

    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;

  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);

    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_merge_anything__["a" /* default */])(target.defaultProps, obj) : obj;
    }
  });

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;

      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyleSheetConsumer, null, function (styleSheet) {
        _this2.styleSheet = styleSheet || StyleSheet.master;

        var globalStyle = _this2.state.globalStyle;

        if (globalStyle.isStatic) {
          globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

          return null;
        } else {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeConsumer, null, function (theme) {
            // $FlowFixMe
            var defaultProps = _this2.constructor.defaultProps;

            var context = _extends({}, _this2.props);

            if (typeof theme !== 'undefined') {
              context.theme = determineTheme(_this2.props, theme, defaultProps);
            }

            globalStyle.renderStyles(context, _this2.styleSheet);

            return null;
          });
        }
      });
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;

  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = function withTheme(Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeConsumer, null, function (theme) {
      // $FlowFixMe
      var defaultProps = Component$$1.defaultProps;

      var themeProp = determineTheme(props, theme, defaultProps);

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
    });
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
};

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(878)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 100%;\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var IconContainer = _styledComponents["default"].div(_templateObject());

var Svg = _styledComponents["default"].svg(_templateObject2(), function (props) {
  return props.theme.colorTextPrimary;
});

var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Icon).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          viewBox = _this$props.viewBox,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className", "viewBox"]);

      var iconClass = (0, _classnames["default"])(_defineProperty({
        'hw-icon': true
      }, className, className));
      return _react["default"].createElement(IconContainer, {
        className: iconClass
      }, _react["default"].createElement(Svg, _extends({
        viewBox: viewBox,
        focusable: "false"
      }, otherProps), children));
    }
  }]);

  return Icon;
}(_react.Component);

Icon.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  viewBox: _propTypes["default"].string,
  theme: _propTypes["default"].shape({
    colorTextPrimary: _propTypes["default"].string
  })
};
Icon.defaultProps = {
  viewBox: '0 0 24 24',
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Icon);

exports["default"] = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames['default'] = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(118)) === 'object' && __webpack_require__(118)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "colorPalette", {
  enumerable: true,
  get: function get() {
    return _colorPalette["default"];
  }
});
Object.defineProperty(exports, "createTheme", {
  enumerable: true,
  get: function get() {
    return _createTheme["default"];
  }
});
Object.defineProperty(exports, "CssVars", {
  enumerable: true,
  get: function get() {
    return _CssVars["default"];
  }
});
Object.defineProperty(exports, "defaultTheme", {
  enumerable: true,
  get: function get() {
    return _defaultTheme["default"];
  }
});
Object.defineProperty(exports, "getThemeVariable", {
  enumerable: true,
  get: function get() {
    return _getThemeVariable["default"];
  }
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _ThemeProvider["default"];
  }
});

var _colorPalette = _interopRequireDefault(__webpack_require__(245));

var _createTheme = _interopRequireDefault(__webpack_require__(246));

var _CssVars = _interopRequireDefault(__webpack_require__(433));

var _defaultTheme = _interopRequireDefault(__webpack_require__(167));

var _getThemeVariable = _interopRequireDefault(__webpack_require__(435));

var _ThemeProvider = _interopRequireDefault(__webpack_require__(434));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(372);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(237);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__componentPropType__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "componentPropType", function() { return __WEBPACK_IMPORTED_MODULE_0__componentPropType___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "chainPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__exactProp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "exactProp", function() { return __WEBPACK_IMPORTED_MODULE_2__exactProp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getDisplayName__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ponyfillGlobal", function() { return __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default.a; });
/** @license Material-UI v3.0.0-alpha.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(237);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGuid = getGuid;
exports.getKey = getKey;

function getGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function getKey() {
  return "key-".concat(new Date().valueOf(), "-").concat(Math.ceil(Math.random() * 99999999));
}

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(373);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(69)["default"];
var assertThisInitialized = __webpack_require__(235);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _xmldom = __webpack_require__(229);

var _xmldom2 = _interopRequireDefault(_xmldom);

var _react = __webpack_require__(0);

var _KeyGen = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComponentBuilder = function () {
  function ComponentBuilder(options) {
    _classCallCheck(this, ComponentBuilder);

    this.options = options || {};

    this.componentMap = this.options.componentMap || [];

    this.attributeMapping = {
      'class': 'className',
      'for': 'htmlFor',
      'http-equiv': 'httpEquiv',
      'crossorigin': 'crossOrigin',
      'srclang': 'srcLang',
      'accesskey': 'accessKey'
    };

    this.selfClosingTags = {
      'area': true,
      'base': true,
      'br': true,
      'col': true,
      'embed': true,
      'hr': true,
      'img': true,
      'input': true,
      'keygen': true,
      'link': true,
      'meta': true,
      'param': true,
      'source': true,
      'track': true,
      'wbr': true
    };
  }

  _createClass(ComponentBuilder, [{
    key: 'build',
    value: function build(html) {
      var parser = new _xmldom2.default.DOMParser();
      var root = parser.parseFromString(html, 'text/html');
      return this.getReactComponent(root.childNodes['0']);
    }
  }, {
    key: 'getReactComponent',
    value: function getReactComponent(root) {
      if (root.childNodes) {
        var componentInfo = this.getComponentInfoFromNode(root);
        if (componentInfo !== null) {
          if (componentInfo.selfClosing) {
            return (0, _react.createElement)(componentInfo.use, this.getProps(root, componentInfo.withProps));
          }
          return (0, _react.createElement)(componentInfo.use, this.getProps(root, componentInfo.withProps), this.getChildren(root.childNodes));
        }
      }
      return null;
    }
  }, {
    key: 'getComponentInfoFromNode',
    value: function getComponentInfoFromNode(node) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.componentMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mapItem = _step.value;

          if (typeof mapItem.when === 'function' && mapItem.when(node)) {
            if (mapItem.ignore) {
              return null;
            }
            return { use: mapItem.use, withProps: mapItem.withProps || {}, selfClosing: mapItem.selfClosing || false };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var tagName = (node.tagName || '').toLowerCase();
      return { use: tagName, withProps: {}, selfClosing: this.selfClosingTags[tagName] || false };
    }
  }, {
    key: 'getChildren',
    value: function getChildren(children) {
      var childComponents = [];
      for (var key in children || {}) {
        if (children.hasOwnProperty(key)) {
          var node = children[key];
          if (node.data) {
            childComponents.push(this.removeExtraSpaces(node.data));
          } else if (node.tagName) {
            childComponents.push(this.getReactComponent(node));
          }
        }
      }
      return childComponents;
    }
  }, {
    key: 'getProps',
    value: function getProps(node) {
      var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var props = { key: (0, _KeyGen.getKey)() };
      if (node.attributes && node.attributes.length !== 0) {
        for (var key in node.attributes) {
          if (node.attributes.hasOwnProperty(key)) {
            var attribute = node.attributes[key];

            if (attribute.nodeName !== attribute.tagName) {
              var attributeName = this.attributeMapping[attribute.nodeName] || attribute.nodeName;
              props[attributeName] = attribute.nodeValue;
            }
          }
        }
      }
      return Object.assign(defaultProps, props);
    }
  }, {
    key: 'removeExtraSpaces',
    value: function removeExtraSpaces(data) {
      return (data || '').replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ');
    }
  }]);

  return ComponentBuilder;
}();

exports.default = ComponentBuilder;

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (o) {
    return typeof o === "undefined" ? "undefined" : _typeof2(o);
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o === "undefined" ? "undefined" : _typeof2(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

var Insights = /*#__PURE__*/function () {
  function Insights(provider) {
    _classCallCheck(this, Insights);

    this.insightsConfig = {};
    this.insightsProvider = provider;

    if (!provider) {
      // grab the page-included Insights provider
      if (window.org && window.org.healthwise) {
        // global config
        if (window.org.healthwise.config) {
          this.insightsConfig = window.org.healthwise.config;
        } // Insights provider


        if (window.org.healthwise.analytics && window.org.healthwise.analytics.insights) {
          this.insightsProvider = window.org.healthwise.analytics.insights;
        }
      } else {
        this.sendError();
      }
    }
  }

  _createClass(Insights, [{
    key: "setConfigOption",
    value: function setConfigOption(key, value) {
      this.insightsConfig[key] = value;
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(event) {
      if (this.insightsProvider && this.insightsProvider.trackEvent) {
        this.insightsProvider.trackEvent(event);
      } else {
        this.sendError(event);
      }
    }
  }, {
    key: "sendError",
    value: function sendError(event) {
      var errorMsg = 'Insights provider not available.';
      if (event) errorMsg += console.error(errorMsg + '  Event not sent.', event);else console.error(errorMsg, event);
    }
  }]);

  return Insights;
}();

exports["default"] = Insights;

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_VISITED_NAV = exports.JWT_REFRESH = exports.LOCATION_CHANGE = exports.QUIZ_RESPONSE = exports.OPINION_RESPONSE = exports.LIKERT_RESPONSE = exports.MAP_LOADED = exports.SUMMARY_EMAIL_STATUS__LOADING = exports.SUMMARY_EMAIL_STATUS = exports.SUMMARY_TAB_ENABLED = undefined;
exports.loadMap = loadMap;
exports.enableSummary = enableSummary;
exports.updateStatus = updateStatus;
exports.updateResponses = updateResponses;
exports.emailEsdpSummary = emailEsdpSummary;
exports.updateJWT = updateJWT;
exports.setVisitedNav = setVisitedNav;
exports.setSummaryEmailStatus = setSummaryEmailStatus;

__webpack_require__(232);

var _mock = __webpack_require__(441);

var _mock2 = _interopRequireDefault(_mock);

var _cloneDeep = __webpack_require__(233);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _TabNavigation = __webpack_require__(123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global fetch, Headers */
var SUMMARY_TAB_ENABLED = exports.SUMMARY_TAB_ENABLED = 'SUMMARY_TAB_ENABLED';
var SUMMARY_EMAIL_STATUS = exports.SUMMARY_EMAIL_STATUS = 'SUMMARY_EMAIL_STATUS';
var SUMMARY_EMAIL_STATUS__LOADING = exports.SUMMARY_EMAIL_STATUS__LOADING = 'SUMMARY_EMAIL_STATUS__LOADING';
var MAP_LOADED = exports.MAP_LOADED = 'MAP_LOADED';
var LIKERT_RESPONSE = exports.LIKERT_RESPONSE = 'LIKERT_RESPONSE';
var OPINION_RESPONSE = exports.OPINION_RESPONSE = 'OPINION_RESPONSE';
var QUIZ_RESPONSE = exports.QUIZ_RESPONSE = 'QUIZ_RESPONSE';
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var JWT_REFRESH = exports.JWT_REFRESH = 'JWT_REFRESH';
var SET_VISITED_NAV = exports.SET_VISITED_NAV = 'SET_VISITED_NAV';

function loadMap(mapId) {
  return function (dispatch, getState) {
    var _getState = getState(),
        serviceInfo = _getState.serviceInfo,
        prescriptionInfo = _getState.prescriptionInfo;

    var sendDispatch = function sendDispatch(json) {
      json.navigationInfo = json.data.navigation.topics.map(function (topic, index) {
        return Object.assign(topic, { 'tab': _TabNavigation.TabMap[index] });
      });
      json.data.applicationUrl = prescriptionInfo && prescriptionInfo.applicationUrl || hwPreloadedState.prescriptionInfo.applicationUrl;

      dispatch(mapLoaded(json));
    };

    if (serviceInfo.isMocked) {
      var json = {};
      json.data = _mock2.default;

      sendDispatch(json);
    } else {
      var servicePath = serviceInfo.contentServiceUrl + ('/articles/' + mapId.toUpperCase() + '/' + prescriptionInfo.localization);

      var headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + serviceInfo.token
      });

      fetch(servicePath, {
        headers: headers,
        mode: 'cors'
      }).then(function (response) {
        if (response.status >= 400) {
          throw new Error('Bad response from server: ' + response.status);
        }

        return response.json().then(function (json) {
          sendDispatch(json);
        });
      }).catch(function (error) {
        console.error('Request failed: ' + error);
      });
    }
  };
}

function enableSummary() {
  return function (dispatch, getState) {
    dispatch({ type: SUMMARY_TAB_ENABLED, enabled: true });
  };
}

function updateStatus(newStatus) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        serviceInfo = _getState2.serviceInfo,
        prescriptionInfo = _getState2.prescriptionInfo;

    // for pass-through demo usage, there is no prescriptionID, so we don't want to send status


    if (prescriptionInfo.prescriptionId.length && !serviceInfo.isMocked) {
      getRequestToConsumerService(serviceInfo, prescriptionInfo, 'status').then(function (json) {
        if (json.status >= 400) {
          console.error(json);
          throw new Error('Bad response from server: ' + json.status + ' - ' + json.type + ' - ' + json.statusText);
        }

        var shouldUpdate = false;
        switch (json.data.statusName) {
          case 'No-Activity':
            // Nothing has been set, yet, so we're good to go.
            shouldUpdate = true;
            break;
          case 'In-Progress':
            if (newStatus === 'Partial' || newStatus === 'Completed') {
              shouldUpdate = true;
            }
            break;
          case 'Partial':
          case 'Completed':
            // Partial and Completed are status endpoints.  We should not update beyond this.
            break;
          default:
            break;
        }

        if (shouldUpdate) {
          postRequestToConsumerService(serviceInfo, prescriptionInfo, {
            status: newStatus,
            timestamp: new Date().toISOString()
          }, 'status');
        }
      }).catch(function (err) {
        console.error('Error retrieving status: ' + err);
      });
    }
  };
}

function updateResponses(eventName, data) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        responseState = _getState3.responseState,
        serviceInfo = _getState3.serviceInfo,
        prescriptionInfo = _getState3.prescriptionInfo;

    var newResponseState = (0, _cloneDeep2.default)(responseState);

    if (data.id && data.answerId) {
      var responseSequenceNumber = 1;

      if (newResponseState.responses && newResponseState.responses[data.id]) {
        responseSequenceNumber = newResponseState.responses[data.id].answer.responseSequenceNumber + 1;
      }

      newResponseState.responses[data.id] = {
        'sequenceNumber': sequenceNumber,
        'timestamp': new Date().toISOString(),
        'questionId': data.id,
        'locale': prescriptionInfo.localization,
        'type': data.type,
        'answer': {
          'id': data.answerId,
          'responseSequenceNumber': responseSequenceNumber,
          'value': (data.answers || []).reduce(function (prev, curr) {
            return curr.id === data.answerId ? curr.answer : prev;
          }, '')
        }

        // iterate sequence number after each answer (hint: doing this here, since the calls are async)
      };sequenceNumber++;
    }

    var response = newResponseState.responses[data.id];
    var responses = newResponseState.responses;

    switch (eventName) {
      case 'LikertResponse':
        postRequestToConsumerService(serviceInfo, prescriptionInfo, response);
        // dispatch immediately, since we don't have a failure mode
        dispatch({ type: LIKERT_RESPONSE, responses: responses });

        break;

      case 'OpinionResponse':
        postRequestToConsumerService(serviceInfo, prescriptionInfo, response);
        dispatch({ type: OPINION_RESPONSE, responses: responses });

        break;

      case 'QuizResponse':
        if (response && response.answer && response.answer.responseSequenceNumber === 1) {
          postRequestToConsumerService(serviceInfo, prescriptionInfo, response);
        }
        dispatch({ type: QUIZ_RESPONSE, responses: responses });

        break;
    }
  };
}

// counter to track which answer we're on (handled here, since the Redux store value could be behind, based on async calls)
var sequenceNumber = 0;

function postRequestToConsumerService(serviceInfo, prescriptionInfo, response) {
  var endPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'responses';

  // for pass-through demo usage, there is no prescriptionID, so we don't want to send status
  if (prescriptionInfo.prescriptionId.length && !serviceInfo.isMocked) {
    var headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + serviceInfo.token
    });

    var url = serviceInfo.consumerServiceUrl + '/consumers/' + prescriptionInfo.consumerId + ('/messages/' + prescriptionInfo.prescriptionId + '/items/' + prescriptionInfo.contentItemId) + ('/' + prescriptionInfo.localization + '/' + endPoint);

    return new Promise(function (resolve, reject) {
      fetch(url, {
        method: 'post',
        headers: headers,
        mode: 'cors',
        body: JSON.stringify(response)
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
}

function getRequestToConsumerService(serviceInfo, prescriptionInfo) {
  var endPoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'responses';

  if (!serviceInfo.isMocked) {
    var headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + serviceInfo.token
    });

    var url = serviceInfo.consumerServiceUrl + '/consumers/' + prescriptionInfo.consumerId + ('/messages/' + prescriptionInfo.prescriptionId + '/items/' + prescriptionInfo.contentItemId) + ('/' + prescriptionInfo.localization + '/' + endPoint);

    return new Promise(function (resolve, reject) {
      fetch(url, {
        method: 'get',
        headers: headers,
        mode: 'cors'
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
}

function emailEsdpSummary(emailJSON) {
  return function (dispatch, getState) {
    var services = getState().serviceInfo;

    emailJSON.headerText = '';
    emailJSON.emailMessage = '';
    emailJSON.legalMessage = '<p>This information does not replace the advice of a doctor. Healthwise, Incorporated, disclaims any warranty or liability for your use of this information.<span> Your use of this information means that you agree to the <a target="_blank" href="https://www.healthwise.org/specialpages/legal/terms.aspx"><!-- react-text: 1466 -->Terms of Use<!-- /react-text --></a> and <a target="_blank" href="https://www.healthwise.org/specialpages/legal/privacy.aspx">Privacy Policy</a>.</span></p><p>To learn more about Healthwise, visit <a target="_blank" href="https://www.healthwise.org">Healthwise.org</a>.</p><p>© 1995-2021 Healthwise, Incorporated. Healthwise, Healthwise for every health decision, and the Healthwise logo are trademarks of Healthwise, Incorporated.</p>';

    // get the email template
    fetch(services.atomicFireballServiceUrl + '/email/esdp', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(emailJSON)
    }).then(function (response) {
      if (response.status < 400) {
        return response.text();
      }
      throw new Error('Unable to send email.');
    }).then(function (emailHTML) {
      dispatch(setSummaryEmailStatus(SUMMARY_EMAIL_STATUS__LOADING));

      var body = {
        to: emailJSON.to,
        from: 'noreply@healthwise.org',
        subject: emailJSON.subject,
        body: emailHTML,
        resources: emailJSON.resources

        // send the email template to the notification service
      };fetch(services.notificationServiceUrl + '/email', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + services.token
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (response.status < 400) {
          return response.text();
        }
        throw new Error('Unable to send email.');
      }).then(function () {
        dispatch(setSummaryEmailStatus(true));
      }, function (err) {
        console.error(err);
        dispatch(setSummaryEmailStatus(false));
      });
    }).catch(function (err) {
      console.error(err);
      dispatch(setSummaryEmailStatus(false));
    });
  };
}

function updateJWT() {
  return function (dispatch, getState) {
    if (!serviceInfo.isMocked) {
      fetch(getState().prescriptionInfo.applicationUrl + '/client/token', { credentials: 'same-origin' }).then(function (res) {
        res.json().then(function (data) {
          dispatch(jwtUpdated(data.token));
        });
      }).catch(function (err) {
        console.error(err);
      });
    }
  };
}

function setVisitedNav(id) {
  return {
    type: SET_VISITED_NAV,
    id: id
  };
}

// 'status' can be:
// - true: successfully sent
// - false: error on send
// - null: no active status
function setSummaryEmailStatus(status) {
  return {
    type: SUMMARY_EMAIL_STATUS,
    status: status
  };
}

function jwtUpdated(token) {
  return {
    type: JWT_REFRESH,
    token: token
  };
}

function mapLoaded(json) {
  return {
    type: MAP_LOADED,
    mapData: json
  };
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.sheetsManager = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _extends3 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(140));

var _utils = __webpack_require__(45);

var _jss = __webpack_require__(305);

var _reactJssContext = _interopRequireDefault(__webpack_require__(509));

var _jssPreset = _interopRequireDefault(__webpack_require__(258));

var _mergeClasses = _interopRequireDefault(__webpack_require__(507));

var _multiKeyStore = _interopRequireDefault(__webpack_require__(508));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(169));

var _themeListener = _interopRequireDefault(__webpack_require__(170));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(256));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(505));

var _getThemeProps = _interopRequireDefault(__webpack_require__(506));

/* eslint-disable no-underscore-dangle */
// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset["default"])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0, _createGenerateClassName["default"])(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme = (0, _createMuiTheme["default"])({
  typography: {
    suppressWarning: true
  }
}); // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStylesOld = function withStylesOld(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _extends2;

    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2["default"])(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator["default"])(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || typeof name === 'string' || withTheme;
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning["default"])(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2["default"])(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2["default"])(this, WithStyles);
        _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(WithStyles).call(this, props, context));
        _this.jss = context[_reactJssContext["default"].jss] || jss;
        _this.sheetsManager = sheetsManager;
        _this.unsubscribeId = null;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.sheetsCache = muiThemeProviderOptions.sheetsCache;
          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3["default"])({
          generateClassName: generateClassName
        }, context[_reactJssContext["default"].sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener["default"].initial(context) || defaultTheme : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2["default"])(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener["default"].subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener["default"].unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          if (this.disableStylesGeneration) {
            return this.props.classes || {};
          } // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.


          var generate = false;

          var sheetManager = _multiKeyStore["default"].get(this.sheetsManager, this.stylesCreatorSaved, this.theme);

          if (sheetManager.sheet.classes !== this.cacheClasses.lastJSS) {
            this.cacheClasses.lastJSS = sheetManager.sheet.classes;
            generate = true;
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses["default"])({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;

          var sheetManager = _multiKeyStore["default"].get(this.sheetsManager, stylesCreatorSaved, theme);

          if (!sheetManager) {
            sheetManager = {
              refs: 0,
              sheet: null
            };

            _multiKeyStore["default"].set(this.sheetsManager, stylesCreatorSaved, theme, sheetManager);
          }

          if (sheetManager.refs === 0) {
            var sheet;

            if (this.sheetsCache) {
              sheet = _multiKeyStore["default"].get(this.sheetsCache, stylesCreatorSaved, theme);
            }

            if (!sheet) {
              sheet = this.createSheet(theme);
              sheet.attach();

              if (this.sheetsCache) {
                _multiKeyStore["default"].set(this.sheetsCache, stylesCreatorSaved, theme, sheet);
              }
            }

            sheetManager.sheet = sheet;
            var sheetsRegistry = this.context[_reactJssContext["default"].sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManager.refs += 1;
        }
      }, {
        key: "createSheet",
        value: function createSheet(theme) {
          var styles = this.stylesCreatorSaved.create(theme, name);
          var meta = name;

          if (false) {
            // Provide a better DX outside production.
            meta = (0, _utils.getDisplayName)(Component);
            process.env.NODE_ENV !== "production" ? (0, _warning["default"])(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
          }

          var sheet = this.jss.createStyleSheet(styles, (0, _extends3["default"])({
            meta: meta,
            classNamePrefix: meta,
            flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
            link: false
          }, this.sheetOptions, this.stylesCreatorSaved.options, {
            name: name || Component.displayName
          }, styleSheetOptions));
          return sheet;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var sheetManager = _multiKeyStore["default"].get(this.sheetsManager, this.stylesCreatorSaved, theme);

          sheetManager.refs -= 1;

          if (sheetManager.refs === 0) {
            _multiKeyStore["default"]["delete"](this.sheetsManager, this.stylesCreatorSaved, theme);

            this.jss.removeStyleSheet(sheetManager.sheet);
            var sheetsRegistry = this.context[_reactJssContext["default"].sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManager.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2["default"])(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps["default"])({
            theme: this.theme,
            name: name,
            props: other
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme && !more.theme) {
            more.theme = this.theme;
          }

          return _react["default"].createElement(Component, (0, _extends3["default"])({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }));
        }
      }]);
      return WithStyles;
    }(_react["default"].Component);

     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes["default"].object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
    } : void 0;
    WithStyles.contextTypes = (0, _extends3["default"])((_extends2 = {
      muiThemeProviderOptions: _propTypes["default"].object
    }, (0, _defineProperty2["default"])(_extends2, _reactJssContext["default"].jss, _propTypes["default"].object), (0, _defineProperty2["default"])(_extends2, _reactJssContext["default"].sheetOptions, _propTypes["default"].object), (0, _defineProperty2["default"])(_extends2, _reactJssContext["default"].sheetsRegistry, _propTypes["default"].object), _extends2), listenToTheme ? _themeListener["default"].contextTypes : {});

    if (false) {
      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics["default"])(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};
/* istanbul ignore if */

if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withStyles) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withStyles = withStylesOld;
}

var _default = function _default(styles, options) {
  return _utils.ponyfillGlobal.__MUI_STYLES__.withStyles(styles, (0, _extends3["default"])({
    defaultTheme: defaultTheme
  }, options));
};

exports["default"] = _default;

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _warning = __webpack_require__(93);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(206);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(143);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */

  _createClass(StyleRule, [{
    key: 'prop',

    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */

    , get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Heading = __webpack_require__(1021);

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Heading = function (_Component) {
  _inherits(Heading, _Component);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          headingLevel = _props.headingLevel,
          styleLevel = _props.styleLevel,
          className = _props.className,
          otherAttributes = _objectWithoutProperties(_props, ['children', 'headingLevel', 'styleLevel', 'className']);

      if (!styleLevel && styleLevel !== 0) {
        styleLevel = headingLevel;
      }

      var headingStyle = styleLevel === 0 ? '' : _Heading2.default['h' + styleLevel + '_style'];
      var styleInfo = ('hw-heading-' + styleLevel + ' ' + _Heading2.default.heading_reset + ' ' + className + ' ' + headingStyle).replace('  ', ' ');

      var header = _react2.default.createElement(
        'p',
        null,
        children
      );
      switch (this.props.headingLevel) {
        case 1:
          header = _react2.default.createElement(
            'h1',
            _extends({ className: styleInfo }, otherAttributes),
            children
          );
          break;
        case 2:
          header = _react2.default.createElement(
            'h2',
            _extends({ className: styleInfo }, otherAttributes),
            children
          );
          break;
        case 3:
          header = _react2.default.createElement(
            'h3',
            _extends({ className: styleInfo }, otherAttributes),
            children
          );
          break;
        case 4:
          header = _react2.default.createElement(
            'h4',
            _extends({ className: styleInfo }, otherAttributes),
            children
          );
          break;
        case 5:
          header = _react2.default.createElement(
            'h5',
            _extends({ className: styleInfo }, otherAttributes),
            children
          );
          break;
        case 6:
          header = _react2.default.createElement(
            'h6',
            _extends({ className: styleInfo }, otherAttributes),
            children
          );
          break;
      }

      return header;
    }
  }]);

  return Heading;
}(_react.Component);

Heading.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  headingLevel: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  styleLevel: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6])
};

Heading.defaultProps = {
  children: '&nbsp;',
  className: ''
};

exports.default = Heading;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports["default"] = _default;

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _createRule = __webpack_require__(142);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(308);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(92);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(775);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */

  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;

      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',

    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 */

function copy(src, dest) {
	for (var p in src) {
		dest[p] = src[p];
	}
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */
function _extends(Class, Super) {
	var pt = Class.prototype;
	if (Object.create) {
		var ppt = Object.create(Super.prototype);
		pt.__proto__ = ppt;
	}
	if (!(pt instanceof Super)) {
		var t = function t() {};

		;
		t.prototype = Super.prototype;
		t = new t();
		copy(pt, t);
		Class.prototype = pt = t;
	}
	if (pt.constructor != Class) {
		if (typeof Class != 'function') {
			console.error("unknow Class:" + Class);
		}
		pt.constructor = Class;
	}
}
var htmlns = 'http://www.w3.org/1999/xhtml';
// Node Types
var NodeType = {};
var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
var TEXT_NODE = NodeType.TEXT_NODE = 3;
var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var NOTATION_NODE = NodeType.NOTATION_NODE = 12;

// ExceptionCode
var ExceptionCode = {};
var ExceptionMessage = {};
var INDEX_SIZE_ERR = ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
var DOMSTRING_SIZE_ERR = ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
var WRONG_DOCUMENT_ERR = ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
var INVALID_CHARACTER_ERR = ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
var NO_DATA_ALLOWED_ERR = ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
var NOT_SUPPORTED_ERR = ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
//level2
var INVALID_STATE_ERR = ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
var SYNTAX_ERR = ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
var INVALID_MODIFICATION_ERR = ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
var NAMESPACE_ERR = ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
var INVALID_ACCESS_ERR = ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);

function DOMException(code, message) {
	if (message instanceof Error) {
		var error = message;
	} else {
		error = this;
		Error.call(this, ExceptionMessage[code]);
		this.message = ExceptionMessage[code];
		if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
	}
	error.code = code;
	if (message) this.message = this.message + ": " + message;
	return error;
};
DOMException.prototype = Error.prototype;
copy(ExceptionCode, DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */
function NodeList() {};
NodeList.prototype = {
	/**
  * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
  * @standard level1
  */
	length: 0,
	/**
  * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
  * @standard level1
  * @param index  unsigned long 
  *   Index into the collection.
  * @return Node
  * 	The node at the indexth position in the NodeList, or null if that is not a valid index. 
  */
	item: function item(index) {
		return this[index] || null;
	},
	toString: function toString(isHTML, nodeFilter) {
		for (var buf = [], i = 0; i < this.length; i++) {
			serializeToString(this[i], buf, isHTML, nodeFilter);
		}
		return buf.join('');
	}
};
function LiveNodeList(node, refresh) {
	this._node = node;
	this._refresh = refresh;
	_updateLiveList(this);
}
function _updateLiveList(list) {
	var inc = list._node._inc || list._node.ownerDocument._inc;
	if (list._inc != inc) {
		var ls = list._refresh(list._node);
		//console.log(ls.length)
		__set__(list, 'length', ls.length);
		copy(ls, list);
		list._inc = inc;
	}
}
LiveNodeList.prototype.item = function (i) {
	_updateLiveList(this);
	return this[i];
};

_extends(LiveNodeList, NodeList);
/**
 * 
 * Objects implementing the NamedNodeMap interface are used to represent collections of nodes that can be accessed by name. Note that NamedNodeMap does not inherit from NodeList; NamedNodeMaps are not maintained in any particular order. Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index, but this is simply to allow convenient enumeration of the contents of a NamedNodeMap, and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities 
 */
function NamedNodeMap() {};

function _findNodeIndex(list, node) {
	var i = list.length;
	while (i--) {
		if (list[i] === node) {
			return i;
		}
	}
}

function _addNamedNode(el, list, newAttr, oldAttr) {
	if (oldAttr) {
		list[_findNodeIndex(list, oldAttr)] = newAttr;
	} else {
		list[list.length++] = newAttr;
	}
	if (el) {
		newAttr.ownerElement = el;
		var doc = el.ownerDocument;
		if (doc) {
			oldAttr && _onRemoveAttribute(doc, el, oldAttr);
			_onAddAttribute(doc, el, newAttr);
		}
	}
}
function _removeNamedNode(el, list, attr) {
	//console.log('remove attr:'+attr)
	var i = _findNodeIndex(list, attr);
	if (i >= 0) {
		var lastIndex = list.length - 1;
		while (i < lastIndex) {
			list[i] = list[++i];
		}
		list.length = lastIndex;
		if (el) {
			var doc = el.ownerDocument;
			if (doc) {
				_onRemoveAttribute(doc, el, attr);
				attr.ownerElement = null;
			}
		}
	} else {
		throw DOMException(NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
	}
}
NamedNodeMap.prototype = {
	length: 0,
	item: NodeList.prototype.item,
	getNamedItem: function getNamedItem(key) {
		//		if(key.indexOf(':')>0 || key == 'xmlns'){
		//			return null;
		//		}
		//console.log()
		var i = this.length;
		while (i--) {
			var attr = this[i];
			//console.log(attr.nodeName,key)
			if (attr.nodeName == key) {
				return attr;
			}
		}
	},
	setNamedItem: function setNamedItem(attr) {
		var el = attr.ownerElement;
		if (el && el != this._ownerElement) {
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		var oldAttr = this.getNamedItem(attr.nodeName);
		_addNamedNode(this._ownerElement, this, attr, oldAttr);
		return oldAttr;
	},
	/* returns Node */
	setNamedItemNS: function setNamedItemNS(attr) {
		// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
		var el = attr.ownerElement,
		    oldAttr;
		if (el && el != this._ownerElement) {
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
		_addNamedNode(this._ownerElement, this, attr, oldAttr);
		return oldAttr;
	},

	/* returns Node */
	removeNamedItem: function removeNamedItem(key) {
		var attr = this.getNamedItem(key);
		_removeNamedNode(this._ownerElement, this, attr);
		return attr;
	}, // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR

	//for level2
	removeNamedItemNS: function removeNamedItemNS(namespaceURI, localName) {
		var attr = this.getNamedItemNS(namespaceURI, localName);
		_removeNamedNode(this._ownerElement, this, attr);
		return attr;
	},
	getNamedItemNS: function getNamedItemNS(namespaceURI, localName) {
		var i = this.length;
		while (i--) {
			var node = this[i];
			if (node.localName == localName && node.namespaceURI == namespaceURI) {
				return node;
			}
		}
		return null;
	}
};
/**
 * @see http://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490
 */
function DOMImplementation( /* Object */features) {
	this._features = {};
	if (features) {
		for (var feature in features) {
			this._features = features[feature];
		}
	}
};

DOMImplementation.prototype = {
	hasFeature: function hasFeature( /* string */feature, /* string */version) {
		var versions = this._features[feature.toLowerCase()];
		if (versions && (!version || version in versions)) {
			return true;
		} else {
			return false;
		}
	},
	// Introduced in DOM Level 2:
	createDocument: function createDocument(namespaceURI, qualifiedName, doctype) {
		// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR,WRONG_DOCUMENT_ERR
		var doc = new Document();
		doc.implementation = this;
		doc.childNodes = new NodeList();
		doc.doctype = doctype;
		if (doctype) {
			doc.appendChild(doctype);
		}
		if (qualifiedName) {
			var root = doc.createElementNS(namespaceURI, qualifiedName);
			doc.appendChild(root);
		}
		return doc;
	},
	// Introduced in DOM Level 2:
	createDocumentType: function createDocumentType(qualifiedName, publicId, systemId) {
		// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR
		var node = new DocumentType();
		node.name = qualifiedName;
		node.nodeName = qualifiedName;
		node.publicId = publicId;
		node.systemId = systemId;
		// Introduced in DOM Level 2:
		//readonly attribute DOMString        internalSubset;

		//TODO:..
		//  readonly attribute NamedNodeMap     entities;
		//  readonly attribute NamedNodeMap     notations;
		return node;
	}
};

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */

function Node() {};

Node.prototype = {
	firstChild: null,
	lastChild: null,
	previousSibling: null,
	nextSibling: null,
	attributes: null,
	parentNode: null,
	childNodes: null,
	ownerDocument: null,
	nodeValue: null,
	namespaceURI: null,
	prefix: null,
	localName: null,
	// Modified in DOM Level 2:
	insertBefore: function insertBefore(newChild, refChild) {
		//raises 
		return _insertBefore(this, newChild, refChild);
	},
	replaceChild: function replaceChild(newChild, oldChild) {
		//raises 
		this.insertBefore(newChild, oldChild);
		if (oldChild) {
			this.removeChild(oldChild);
		}
	},
	removeChild: function removeChild(oldChild) {
		return _removeChild(this, oldChild);
	},
	appendChild: function appendChild(newChild) {
		return this.insertBefore(newChild, null);
	},
	hasChildNodes: function hasChildNodes() {
		return this.firstChild != null;
	},
	cloneNode: function cloneNode(deep) {
		return _cloneNode(this.ownerDocument || this, this, deep);
	},
	// Modified in DOM Level 2:
	normalize: function normalize() {
		var child = this.firstChild;
		while (child) {
			var next = child.nextSibling;
			if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
				this.removeChild(next);
				child.appendData(next.data);
			} else {
				child.normalize();
				child = next;
			}
		}
	},
	// Introduced in DOM Level 2:
	isSupported: function isSupported(feature, version) {
		return this.ownerDocument.implementation.hasFeature(feature, version);
	},
	// Introduced in DOM Level 2:
	hasAttributes: function hasAttributes() {
		return this.attributes.length > 0;
	},
	lookupPrefix: function lookupPrefix(namespaceURI) {
		var el = this;
		while (el) {
			var map = el._nsMap;
			//console.dir(map)
			if (map) {
				for (var n in map) {
					if (map[n] == namespaceURI) {
						return n;
					}
				}
			}
			el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
		}
		return null;
	},
	// Introduced in DOM Level 3:
	lookupNamespaceURI: function lookupNamespaceURI(prefix) {
		var el = this;
		while (el) {
			var map = el._nsMap;
			//console.dir(map)
			if (map) {
				if (prefix in map) {
					return map[prefix];
				}
			}
			el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
		}
		return null;
	},
	// Introduced in DOM Level 3:
	isDefaultNamespace: function isDefaultNamespace(namespaceURI) {
		var prefix = this.lookupPrefix(namespaceURI);
		return prefix == null;
	}
};

function _xmlEncoder(c) {
	return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}

copy(NodeType, Node);
copy(NodeType, Node.prototype);

/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */
function _visitNode(node, callback) {
	if (callback(node)) {
		return true;
	}
	if (node = node.firstChild) {
		do {
			if (_visitNode(node, callback)) {
				return true;
			}
		} while (node = node.nextSibling);
	}
}

function Document() {}
function _onAddAttribute(doc, el, newAttr) {
	doc && doc._inc++;
	var ns = newAttr.namespaceURI;
	if (ns == 'http://www.w3.org/2000/xmlns/') {
		//update namespace
		el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
	}
}
function _onRemoveAttribute(doc, el, newAttr, remove) {
	doc && doc._inc++;
	var ns = newAttr.namespaceURI;
	if (ns == 'http://www.w3.org/2000/xmlns/') {
		//update namespace
		delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
	}
}
function _onUpdateChild(doc, el, newChild) {
	if (doc && doc._inc) {
		doc._inc++;
		//update childNodes
		var cs = el.childNodes;
		if (newChild) {
			cs[cs.length++] = newChild;
		} else {
			//console.log(1)
			var child = el.firstChild;
			var i = 0;
			while (child) {
				cs[i++] = child;
				child = child.nextSibling;
			}
			cs.length = i;
		}
	}
}

/**
 * attributes;
 * children;
 * 
 * writeable properties:
 * nodeValue,Attr:value,CharacterData:data
 * prefix
 */
function _removeChild(parentNode, child) {
	var previous = child.previousSibling;
	var next = child.nextSibling;
	if (previous) {
		previous.nextSibling = next;
	} else {
		parentNode.firstChild = next;
	}
	if (next) {
		next.previousSibling = previous;
	} else {
		parentNode.lastChild = previous;
	}
	_onUpdateChild(parentNode.ownerDocument, parentNode);
	return child;
}
/**
 * preformance key(refChild == null)
 */
function _insertBefore(parentNode, newChild, nextChild) {
	var cp = newChild.parentNode;
	if (cp) {
		cp.removeChild(newChild); //remove and update
	}
	if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
		var newFirst = newChild.firstChild;
		if (newFirst == null) {
			return newChild;
		}
		var newLast = newChild.lastChild;
	} else {
		newFirst = newLast = newChild;
	}
	var pre = nextChild ? nextChild.previousSibling : parentNode.lastChild;

	newFirst.previousSibling = pre;
	newLast.nextSibling = nextChild;

	if (pre) {
		pre.nextSibling = newFirst;
	} else {
		parentNode.firstChild = newFirst;
	}
	if (nextChild == null) {
		parentNode.lastChild = newLast;
	} else {
		nextChild.previousSibling = newLast;
	}
	do {
		newFirst.parentNode = parentNode;
	} while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
	_onUpdateChild(parentNode.ownerDocument || parentNode, parentNode);
	//console.log(parentNode.lastChild.nextSibling == null)
	if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
		newChild.firstChild = newChild.lastChild = null;
	}
	return newChild;
}
function _appendSingleChild(parentNode, newChild) {
	var cp = newChild.parentNode;
	if (cp) {
		var pre = parentNode.lastChild;
		cp.removeChild(newChild); //remove and update
		var pre = parentNode.lastChild;
	}
	var pre = parentNode.lastChild;
	newChild.parentNode = parentNode;
	newChild.previousSibling = pre;
	newChild.nextSibling = null;
	if (pre) {
		pre.nextSibling = newChild;
	} else {
		parentNode.firstChild = newChild;
	}
	parentNode.lastChild = newChild;
	_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
	return newChild;
	//console.log("__aa",parentNode.lastChild.nextSibling == null)
}
Document.prototype = {
	//implementation : null,
	nodeName: '#document',
	nodeType: DOCUMENT_NODE,
	doctype: null,
	documentElement: null,
	_inc: 1,

	insertBefore: function insertBefore(newChild, refChild) {
		//raises 
		if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
			var child = newChild.firstChild;
			while (child) {
				var next = child.nextSibling;
				this.insertBefore(child, refChild);
				child = next;
			}
			return newChild;
		}
		if (this.documentElement == null && newChild.nodeType == ELEMENT_NODE) {
			this.documentElement = newChild;
		}

		return _insertBefore(this, newChild, refChild), newChild.ownerDocument = this, newChild;
	},
	removeChild: function removeChild(oldChild) {
		if (this.documentElement == oldChild) {
			this.documentElement = null;
		}
		return _removeChild(this, oldChild);
	},
	// Introduced in DOM Level 2:
	importNode: function importNode(importedNode, deep) {
		return _importNode(this, importedNode, deep);
	},
	// Introduced in DOM Level 2:
	getElementById: function getElementById(id) {
		var rtv = null;
		_visitNode(this.documentElement, function (node) {
			if (node.nodeType == ELEMENT_NODE) {
				if (node.getAttribute('id') == id) {
					rtv = node;
					return true;
				}
			}
		});
		return rtv;
	},

	//document factory method:
	createElement: function createElement(tagName) {
		var node = new Element();
		node.ownerDocument = this;
		node.nodeName = tagName;
		node.tagName = tagName;
		node.childNodes = new NodeList();
		var attrs = node.attributes = new NamedNodeMap();
		attrs._ownerElement = node;
		return node;
	},
	createDocumentFragment: function createDocumentFragment() {
		var node = new DocumentFragment();
		node.ownerDocument = this;
		node.childNodes = new NodeList();
		return node;
	},
	createTextNode: function createTextNode(data) {
		var node = new Text();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createComment: function createComment(data) {
		var node = new Comment();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createCDATASection: function createCDATASection(data) {
		var node = new CDATASection();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createProcessingInstruction: function createProcessingInstruction(target, data) {
		var node = new ProcessingInstruction();
		node.ownerDocument = this;
		node.tagName = node.target = target;
		node.nodeValue = node.data = data;
		return node;
	},
	createAttribute: function createAttribute(name) {
		var node = new Attr();
		node.ownerDocument = this;
		node.name = name;
		node.nodeName = name;
		node.localName = name;
		node.specified = true;
		return node;
	},
	createEntityReference: function createEntityReference(name) {
		var node = new EntityReference();
		node.ownerDocument = this;
		node.nodeName = name;
		return node;
	},
	// Introduced in DOM Level 2:
	createElementNS: function createElementNS(namespaceURI, qualifiedName) {
		var node = new Element();
		var pl = qualifiedName.split(':');
		var attrs = node.attributes = new NamedNodeMap();
		node.childNodes = new NodeList();
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.tagName = qualifiedName;
		node.namespaceURI = namespaceURI;
		if (pl.length == 2) {
			node.prefix = pl[0];
			node.localName = pl[1];
		} else {
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		attrs._ownerElement = node;
		return node;
	},
	// Introduced in DOM Level 2:
	createAttributeNS: function createAttributeNS(namespaceURI, qualifiedName) {
		var node = new Attr();
		var pl = qualifiedName.split(':');
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.name = qualifiedName;
		node.namespaceURI = namespaceURI;
		node.specified = true;
		if (pl.length == 2) {
			node.prefix = pl[0];
			node.localName = pl[1];
		} else {
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		return node;
	}
};
_extends(Document, Node);

function Element() {
	this._nsMap = {};
};
Element.prototype = {
	nodeType: ELEMENT_NODE,
	hasAttribute: function hasAttribute(name) {
		return this.getAttributeNode(name) != null;
	},
	getAttribute: function getAttribute(name) {
		var attr = this.getAttributeNode(name);
		return attr && attr.value || '';
	},
	getAttributeNode: function getAttributeNode(name) {
		return this.attributes.getNamedItem(name);
	},
	setAttribute: function setAttribute(name, value) {
		var attr = this.ownerDocument.createAttribute(name);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr);
	},
	removeAttribute: function removeAttribute(name) {
		var attr = this.getAttributeNode(name);
		attr && this.removeAttributeNode(attr);
	},

	//four real opeartion method
	appendChild: function appendChild(newChild) {
		if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
			return this.insertBefore(newChild, null);
		} else {
			return _appendSingleChild(this, newChild);
		}
	},
	setAttributeNode: function setAttributeNode(newAttr) {
		return this.attributes.setNamedItem(newAttr);
	},
	setAttributeNodeNS: function setAttributeNodeNS(newAttr) {
		return this.attributes.setNamedItemNS(newAttr);
	},
	removeAttributeNode: function removeAttributeNode(oldAttr) {
		//console.log(this == oldAttr.ownerElement)
		return this.attributes.removeNamedItem(oldAttr.nodeName);
	},
	//get real attribute name,and remove it by removeAttributeNode
	removeAttributeNS: function removeAttributeNS(namespaceURI, localName) {
		var old = this.getAttributeNodeNS(namespaceURI, localName);
		old && this.removeAttributeNode(old);
	},

	hasAttributeNS: function hasAttributeNS(namespaceURI, localName) {
		return this.getAttributeNodeNS(namespaceURI, localName) != null;
	},
	getAttributeNS: function getAttributeNS(namespaceURI, localName) {
		var attr = this.getAttributeNodeNS(namespaceURI, localName);
		return attr && attr.value || '';
	},
	setAttributeNS: function setAttributeNS(namespaceURI, qualifiedName, value) {
		var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr);
	},
	getAttributeNodeNS: function getAttributeNodeNS(namespaceURI, localName) {
		return this.attributes.getNamedItemNS(namespaceURI, localName);
	},

	getElementsByTagName: function getElementsByTagName(tagName) {
		return new LiveNodeList(this, function (base) {
			var ls = [];
			_visitNode(base, function (node) {
				if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) {
					ls.push(node);
				}
			});
			return ls;
		});
	},
	getElementsByTagNameNS: function getElementsByTagNameNS(namespaceURI, localName) {
		return new LiveNodeList(this, function (base) {
			var ls = [];
			_visitNode(base, function (node) {
				if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) {
					ls.push(node);
				}
			});
			return ls;
		});
	}
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;

_extends(Element, Node);
function Attr() {};
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node);

function CharacterData() {};
CharacterData.prototype = {
	data: '',
	substringData: function substringData(offset, count) {
		return this.data.substring(offset, offset + count);
	},
	appendData: function appendData(text) {
		text = this.data + text;
		this.nodeValue = this.data = text;
		this.length = text.length;
	},
	insertData: function insertData(offset, text) {
		this.replaceData(offset, 0, text);
	},
	appendChild: function appendChild(newChild) {
		throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
	},
	deleteData: function deleteData(offset, count) {
		this.replaceData(offset, count, "");
	},
	replaceData: function replaceData(offset, count, text) {
		var start = this.data.substring(0, offset);
		var end = this.data.substring(offset + count);
		text = start + text + end;
		this.nodeValue = this.data = text;
		this.length = text.length;
	}
};
_extends(CharacterData, Node);
function Text() {};
Text.prototype = {
	nodeName: "#text",
	nodeType: TEXT_NODE,
	splitText: function splitText(offset) {
		var text = this.data;
		var newText = text.substring(offset);
		text = text.substring(0, offset);
		this.data = this.nodeValue = text;
		this.length = text.length;
		var newNode = this.ownerDocument.createTextNode(newText);
		if (this.parentNode) {
			this.parentNode.insertBefore(newNode, this.nextSibling);
		}
		return newNode;
	}
};
_extends(Text, CharacterData);
function Comment() {};
Comment.prototype = {
	nodeName: "#comment",
	nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);

function CDATASection() {};
CDATASection.prototype = {
	nodeName: "#cdata-section",
	nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);

function DocumentType() {};
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node);

function Notation() {};
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node);

function Entity() {};
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity, Node);

function EntityReference() {};
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node);

function DocumentFragment() {};
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node);

function ProcessingInstruction() {}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node);
function XMLSerializer() {}
XMLSerializer.prototype.serializeToString = function (node, isHtml, nodeFilter) {
	return nodeSerializeToString.call(node, isHtml, nodeFilter);
};
Node.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml, nodeFilter) {
	var buf = [];
	var refNode = this.nodeType == 9 ? this.documentElement : this;
	var prefix = refNode.prefix;
	var uri = refNode.namespaceURI;

	if (uri && prefix == null) {
		//console.log(prefix)
		var prefix = refNode.lookupPrefix(uri);
		if (prefix == null) {
			//isHTML = true;
			var visibleNamespaces = [{ namespace: uri, prefix: null
				//{namespace:uri,prefix:''}
			}];
		}
	}
	serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
	//console.log('###',this.nodeType,uri,prefix,buf.join(''))
	return buf.join('');
}
function needNamespaceDefine(node, isHTML, visibleNamespaces) {
	var prefix = node.prefix || '';
	var uri = node.namespaceURI;
	if (!prefix && !uri) {
		return false;
	}
	if (prefix === "xml" && uri === "http://www.w3.org/XML/1998/namespace" || uri == 'http://www.w3.org/2000/xmlns/') {
		return false;
	}

	var i = visibleNamespaces.length;
	//console.log('@@@@',node.tagName,prefix,uri,visibleNamespaces)
	while (i--) {
		var ns = visibleNamespaces[i];
		// get namespace prefix
		//console.log(node.nodeType,node.tagName,ns.prefix,prefix)
		if (ns.prefix == prefix) {
			return ns.namespace != uri;
		}
	}
	//console.log(isHTML,uri,prefix=='')
	//if(isHTML && prefix ==null && uri == 'http://www.w3.org/1999/xhtml'){
	//	return false;
	//}
	//node.flag = '11111'
	//console.error(3,true,node.flag,node.prefix,node.namespaceURI)
	return true;
}
function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
	if (nodeFilter) {
		node = nodeFilter(node);
		if (node) {
			if (typeof node == 'string') {
				buf.push(node);
				return;
			}
		} else {
			return;
		}
		//buf.sort.apply(attrs, attributeSorter);
	}
	switch (node.nodeType) {
		case ELEMENT_NODE:
			if (!visibleNamespaces) visibleNamespaces = [];
			var startVisibleNamespaces = visibleNamespaces.length;
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;

			isHTML = htmlns === node.namespaceURI || isHTML;
			buf.push('<', nodeName);

			for (var i = 0; i < len; i++) {
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				} else if (attr.nodeName == 'xmlns') {
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
			for (var i = 0; i < len; i++) {
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
					var prefix = attr.prefix || '';
					var uri = attr.namespaceURI;
					var ns = prefix ? ' xmlns:' + prefix : " xmlns";
					buf.push(ns, '="', uri, '"');
					visibleNamespaces.push({ prefix: prefix, namespace: uri });
				}
				serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
			}
			// add namespace for current node		
			if (needNamespaceDefine(node, isHTML, visibleNamespaces)) {
				var prefix = node.prefix || '';
				var uri = node.namespaceURI;
				var ns = prefix ? ' xmlns:' + prefix : " xmlns";
				buf.push(ns, '="', uri, '"');
				visibleNamespaces.push({ prefix: prefix, namespace: uri });
			}

			if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
				buf.push('>');
				//if is cdata child node
				if (isHTML && /^script$/i.test(nodeName)) {
					while (child) {
						if (child.data) {
							buf.push(child.data);
						} else {
							serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
						}
						child = child.nextSibling;
					}
				} else {
					while (child) {
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
						child = child.nextSibling;
					}
				}
				buf.push('</', nodeName, '>');
			} else {
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while (child) {
				serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			return buf.push(' ', node.name, '="', node.value.replace(/[<&"]/g, _xmlEncoder), '"');
		case TEXT_NODE:
			return buf.push(node.data.replace(/[<&]/g, _xmlEncoder));
		case CDATA_SECTION_NODE:
			return buf.push('<![CDATA[', node.data, ']]>');
		case COMMENT_NODE:
			return buf.push("<!--", node.data, "-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ', node.name);
			if (pubid) {
				buf.push(' PUBLIC "', pubid);
				if (sysid && sysid != '.') {
					buf.push('" "', sysid);
				}
				buf.push('">');
			} else if (sysid && sysid != '.') {
				buf.push(' SYSTEM "', sysid, '">');
			} else {
				var sub = node.internalSubset;
				if (sub) {
					buf.push(" [", sub, "]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push("<?", node.target, " ", node.data, "?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push('&', node.nodeName, ';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??', node.nodeName);
	}
}
function _importNode(doc, node, deep) {
	var node2;
	switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
		//var attrs = node2.attributes;
		//var len = attrs.length;
		//for(var i=0;i<len;i++){
		//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
		//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
	}
	if (!node2) {
		node2 = node.cloneNode(false); //false
	}
	node2.ownerDocument = doc;
	node2.parentNode = null;
	if (deep) {
		var child = node.firstChild;
		while (child) {
			node2.appendChild(_importNode(doc, child, deep));
			child = child.nextSibling;
		}
	}
	return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function _cloneNode(doc, node, deep) {
	var node2 = new node.constructor();
	for (var n in node) {
		var v = node[n];
		if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) != 'object') {
			if (v != node2[n]) {
				node2[n] = v;
			}
		}
	}
	if (node.childNodes) {
		node2.childNodes = new NodeList();
	}
	node2.ownerDocument = doc;
	switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs = node.attributes;
			var attrs2 = node2.attributes = new NamedNodeMap();
			var len = attrs.length;
			attrs2._ownerElement = node2;
			for (var i = 0; i < len; i++) {
				node2.setAttributeNode(_cloneNode(doc, attrs.item(i), true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
	}
	if (deep) {
		var child = node.firstChild;
		while (child) {
			node2.appendChild(_cloneNode(doc, child, deep));
			child = child.nextSibling;
		}
	}
	return node2;
}

function __set__(object, key, value) {
	object[key] = value;
}
//do dynamic
try {
	if (Object.defineProperty) {
		var getTextContent = function getTextContent(node) {
			switch (node.nodeType) {
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while (node) {
						if (node.nodeType !== 7 && node.nodeType !== 8) {
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
			}
		};

		Object.defineProperty(LiveNodeList.prototype, 'length', {
			get: function get() {
				_updateLiveList(this);
				return this.$$length;
			}
		});
		Object.defineProperty(Node.prototype, 'textContent', {
			get: function get() {
				return getTextContent(this);
			},
			set: function set(data) {
				switch (this.nodeType) {
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while (this.firstChild) {
							this.removeChild(this.firstChild);
						}
						if (data || String(data)) {
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
					default:
						//TODO:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
				}
			}
		});

		__set__ = function __set__(object, key, value) {
			//console.log(value)
			object['$$' + key] = value;
		};
	}
} catch (e) {} //ie8


//if(typeof require == 'function'){
exports.DOMImplementation = DOMImplementation;
exports.XMLSerializer = XMLSerializer;
//}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: ", ";\n  border-radius: ", ";\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  font-size: 1em;\n  font-style: normal;\n  text-decoration: none;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n\n  :hover,\n  :active {\n    box-shadow: ", ";\n  }\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  svg {\n    width: 1em;\n    height: 1em;\n    fill: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

// TODO: Need better mechanism to get focus indicator color. Right now, it uses
// the regular, dark focus indicator unless it's a light color with a flat or
// outlined style button, in which case it's assumed that the button needs to be
// on a dark background and needs the lighter focusIndicatorContrast style.
var getFocusIndicator = function getFocusIndicator(props) {
  var flat = props.flat,
      outlined = props.outlined,
      color = props.color,
      theme = props.theme;

  if (flat || outlined) {
    if (color === 'primaryLight' || color === 'neutralLight') {
      return theme.focusIndicatorContrast;
    }
  }

  return theme.focusIndicator;
};

var Root = _styledComponents["default"].button(_templateObject(), function (props) {
  return props.flat ? '0.75rem' : '0.75rem 1rem';
}, function (props) {
  return props.flat ? 'none' : "1px solid ".concat((0, _Theme.getThemeVariable)('color')(props));
}, function (props) {
  return props.rounded ? '4px' : '0';
}, function (props) {
  return props.flat || props.outlined ? 'transparent' : (0, _Theme.getThemeVariable)('color')(props);
}, function (props) {
  return props.flat || props.outlined ? (0, _Theme.getThemeVariable)('color')(props) : (0, _Theme.getThemeVariable)('colorText')(props);
}, function (props) {
  return props.raised && !props.disabled ? '0 1px 3px 0 rgba(0, 0, 0, 0.1)' : 'none';
}, function (props) {
  return props.disabled ? '0.35' : '1';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
}, function (props) {
  return props.raised && !props.disabled ? '0 1px 3px rgba(0, 0, 0, 0.4)' : 'none';
}, getFocusIndicator, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.flat || props.outlined ? (0, _Theme.getThemeVariable)('color')(props) : (0, _Theme.getThemeVariable)('colorText')(props);
});

var Child = _styledComponents["default"].div(_templateObject2());

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          href = _this$props.href,
          render = _this$props.render,
          otherProps = _objectWithoutProperties(_this$props, ["className", "disabled", "href", "render"]);

      var ariaProps = href || otherProps.to ? {
        role: 'button',
        'aria-disabled': disabled
      } : {}; // Wrap all children in a div to allow setting margin on text nodes

      var children = _react["default"].Children.map(this.props.children, function (child, index) {
        return _react["default"].createElement(Child, {
          key: index
        }, child);
      });

      var props = _objectSpread({
        className: (0, _classnames["default"])('hw-button', className),
        disabled: disabled,
        href: href
      }, ariaProps, {}, otherProps);

      if (render) {
        return render(_objectSpread({}, props, {
          children: children
        }));
      } else if (href) {
        return _react["default"].createElement(Root, _extends({
          as: "a"
        }, props), children);
      } else {
        return _react["default"].createElement(Root, props, children);
      }
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  render: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  flat: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  id: _propTypes["default"].string,
  outlined: _propTypes["default"].bool,
  raised: _propTypes["default"].bool,
  rounded: _propTypes["default"].bool,
  color: _propTypes["default"].oneOf(['primary', 'primaryLight', 'primaryDark', 'primaryDarker', 'accent', 'accentDark', 'neutral', 'neutralLight', 'neutralDark']),
  theme: _propTypes["default"].shape({
    colorPrimaryLight: _propTypes["default"].string,
    colorPrimary: _propTypes["default"].string,
    colorPrimaryDark: _propTypes["default"].string,
    colorPrimaryDarker: _propTypes["default"].string,
    colorAccent: _propTypes["default"].string,
    colorAccentDark: _propTypes["default"].string,
    colorNeutralLight: _propTypes["default"].string,
    colorNeutral: _propTypes["default"].string,
    colorNeutralDark: _propTypes["default"].string,
    colorTextOnPrimaryLight: _propTypes["default"].string,
    colorTextOnPrimary: _propTypes["default"].string,
    colorTextOnPrimaryDark: _propTypes["default"].string,
    colorTextOnPrimaryDarker: _propTypes["default"].string,
    colorTextOnAccent: _propTypes["default"].string,
    colorTextOnAccentDark: _propTypes["default"].string,
    colorTextOnNeutralLight: _propTypes["default"].string,
    colorTextOnNeutral: _propTypes["default"].string,
    colorTextOnNeutralDark: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    focusIndicatorContrast: _propTypes["default"].string,
    focusIndicatorOffset: _propTypes["default"].string
  }),
  type: _propTypes["default"].oneOf(['button', 'submit', 'reset'])
};
Button.defaultProps = {
  color: 'primary',
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Button);

exports["default"] = _default;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PathContrastStroke = exports.PathPrimaryStroke = exports.PathPrimary = exports.PathContrast = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var PathContrast = _styledComponents["default"].path(_templateObject(), function (props) {
  return props.theme.colorPrimaryLight;
});

exports.PathContrast = PathContrast;

var PathPrimary = _styledComponents["default"].path(_templateObject2(), function (props) {
  return props.theme.colorTextPrimary;
});

exports.PathPrimary = PathPrimary;

var PathPrimaryStroke = _styledComponents["default"].path(_templateObject3(), function (props) {
  return props.theme.colorTextPrimary;
});

exports.PathPrimaryStroke = PathPrimaryStroke;

var PathContrastStroke = _styledComponents["default"].path(_templateObject4(), function (props) {
  return props.theme.colorPrimaryLight;
});

exports.PathContrastStroke = PathContrastStroke;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _CssParser = _interopRequireDefault(__webpack_require__(390));

var _KeyGen = __webpack_require__(53);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  max-width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .svg {\n    box-sizing: border-box;\n    max-width: 100%;\n    height: auto;\n  }\n\n  .hw-svg-built {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].span(_templateObject(), function (props) {
  return props.recolor ? "\n      stroke: ".concat(props.theme.colorNeutral, ";\n      fill: ").concat(props.theme.colorNeutral, ";\n    ") : '';
});

var Image = _styledComponents["default"].img(_templateObject2());

var SvgImage = /*#__PURE__*/function (_Component) {
  _inherits(SvgImage, _Component);

  function SvgImage() {
    _classCallCheck(this, SvgImage);

    return _possibleConstructorReturn(this, _getPrototypeOf(SvgImage).apply(this, arguments));
  }

  _createClass(SvgImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          alt = _this$props.alt,
          recolor = _this$props.recolor;

      if (new RegExp('^https?://.*\\.svg$').test(this.props.src)) {
        var wrapper = this.imageWrapper;

        if (wrapper) {
          fetch(this.props.src, {
            method: 'get',
            mode: 'cors',
            cache: 'no-store'
          }).then(function (response) {
            return response.text();
          }).then(function (text) {
            var Parser = new DOMParser();
            var doc = Parser.parseFromString(text, 'text/xml');
            var svg = doc.querySelector('svg');
            var img = wrapper.querySelector('img');
            var styleMap = {};

            if (svg && img) {
              svg.setAttribute('class', 'svg');

              if (alt) {
                svg.setAttribute('role', 'img');
                svg.setAttribute('aria-label', alt);
              } else {
                svg.setAttribute('role', 'presentation');
                svg.setAttribute('focusable', 'false');
              } // Remove all non-none color from svg to make it easier to overwrite color without losing any other style data


              var styleNode = svg.querySelector('style');
              if (styleNode) styleNode.setAttribute('aria-hidden', true);

              if (recolor && styleNode) {
                var styleParser = new _CssParser["default"]();
                var textSelector = styleNode.innerHTML ? 'innerHTML' : 'textContent';
                var styleHtml = styleNode[textSelector] || '';
                var styleJson = styleParser.parse(styleHtml) || [];
                var workingJson = styleJson.slice(0);

                for (var index = 0; index < workingJson.length; index++) {
                  // Renaming svg class names to avoid name collisions across multiple svg elements
                  var declaration = workingJson[index];

                  if (declaration.selector.indexOf('.') === 0) {
                    var newSelector = declaration.selector + '_' + (0, _KeyGen.getKey)();
                    styleMap[declaration.selector] = newSelector;
                    styleJson[index].selector = newSelector;
                  } // Apply new rules for fill and stroke so these properties can be overwritten


                  var hasStroke = false;

                  for (var ri = 0; ri < declaration.rules.length; ri++) {
                    var rule = declaration.rules[ri];

                    if (rule.directive === 'stroke') {
                      hasStroke = true;
                    }

                    if (rule.directive === 'fill' || rule.directive === 'stroke') {
                      if (rule.value === 'none') {
                        styleJson[index].rules[ri].value = 'none !important';
                      } else {
                        styleJson[index].rules[ri].value = 'inherit';
                      }
                    }
                  }

                  if (!hasStroke) {
                    styleJson[index].rules[declaration.rules.length] = {
                      directive: 'stroke-width',
                      value: '0'
                    };
                  }
                }

                styleNode[textSelector] = styleParser.compose(styleJson);
              }

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = svg.querySelectorAll('[class]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var classElement = _step.value;
                  var className = classElement.getAttribute('class'); // Use new class name if one exists

                  if (styleMap[".".concat(className)]) {
                    className = styleMap[".".concat(className)].substr(1);
                  }

                  classElement.setAttribute('class', "".concat(className, " hw-svg-built"));
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              wrapper.replaceChild(svg, img);
            }
          })["catch"](function (err) {
            console.error(err);
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          src = _this$props2.src,
          alt = _this$props2.alt,
          additionalClassName = _this$props2.additionalClassName,
          children = _this$props2.children,
          recolor = _this$props2.recolor,
          theme = _this$props2.theme,
          otherProps = _objectWithoutProperties(_this$props2, ["src", "alt", "additionalClassName", "children", "recolor", "theme"]);

      if (children || recolor) {// Peeled off invalid image attributes
      }

      return _react["default"].createElement(Root, {
        className: (0, _classnames["default"])('hw-structured-image-wrapper', additionalClassName),
        ref: function ref(wrapper) {
          _this.imageWrapper = wrapper;
        },
        recolor: recolor,
        theme: theme
      }, _react["default"].createElement(Image, _extends({
        className: "hw-image",
        src: src,
        alt: alt
      }, otherProps)));
    }
  }]);

  return SvgImage;
}(_react.Component);

SvgImage.propTypes = {
  src: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string,
  additionalClassName: _propTypes["default"].string,
  recolor: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  theme: _propTypes["default"].shape({
    colorNeutral: _propTypes["default"].string
  })
};
SvgImage.defaultProps = {
  alt: '',
  recolor: true,
  additionalClassName: null,
  children: null,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(SvgImage);

exports["default"] = _default;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TabMap = exports.TabMap = ['home', 'facts', 'compare', 'learn', 'decide', 'summary'];

var GetTopicNavigationInfoById = exports.GetTopicNavigationInfoById = function GetTopicNavigationInfoById(navigationInfo, id) {
  if (navigationInfoIsValid(navigationInfo)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = navigationInfo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var topic = _step.value;

        if (topic && topic.id === id) {
          return topic;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return { id: null, tab: null, title: null, visited: false };
};

var GetTopicNavigationInfoByPathName = exports.GetTopicNavigationInfoByPathName = function GetTopicNavigationInfoByPathName(navigationInfo, pathName) {
  var id = pathName;
  if (typeof pathName === 'string' && pathName.indexOf('/') !== -1) {
    var pathParts = pathName.split('/');
    while (pathParts.length > 0) {
      var part = pathParts.pop();
      if (part !== '') {
        id = part;
        break;
      }
    }
  }
  return GetTopicNavigationInfoById(navigationInfo, id);
};

var navigationInfoIsValid = function navigationInfoIsValid(navigationInfo) {
  return navigationInfo && Array.isArray(navigationInfo) && navigationInfo.length !== 0;
};

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
	( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.deepmerge = factory());
})(this, function () {
	'use strict';

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value) && !isSpecial(value);
	};

	function isNonNullObject(value) {
		return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol['for'];
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol['for']('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE;
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {};
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function (element) {
			return cloneUnlessOtherwiseSpecified(element, options);
		});
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge;
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge;
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
			return target.propertyIsEnumerable(symbol);
		}) : [];
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function (key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function (key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination;
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options);
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options);
		} else {
			return mergeObject(target, source, options);
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array');
		}

		return array.reduce(function (prev, next) {
			return deepmerge(prev, next, options);
		}, {});
	};

	var deepmerge_1 = deepmerge;

	return deepmerge_1;
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(93);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(92);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(774);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(814);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (a, b, reserved) {
  // This will get id, className, style, etc.
  for (var x in b) {
    if (!b.hasOwnProperty(x)) continue;
    if (reserved[x]) continue;
    a[x] = b[x];
  }
};

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Credits = _interopRequireDefault(__webpack_require__(238));

var _KeyGen = __webpack_require__(53);

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8em;\n  margin: 5px 2px 0;\n  padding: 10px 15px;\n  color: #017acd;\n  border: none;\n  background: transparent;\n  border-radius: 1px;\n\n  &:focus, \n  &:hover {\n    outline: 2px dotted #000;\n  }\n\n  padding: 5px 15px;\n  &:disabled {\n    padding: 0;\n  }\n  \n  &:disabled:focus,\n  &:disabled:hover {\n    outline: none;\n    cursor: default;\n  }\n  \n\n  @media screen and (-ms-high-contrast: active) {\n    background: #fff;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #000;\n    color: #fff;\n    outline: 2px dotted #fff;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 18px;\n  margin-right: 4px;\n\n  & svg {\n    width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: space-between;\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #fff;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #000;\n    color: #fff;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n  box-sizing: border-box;\n  width: 100%;\n\n  & p {\n    font-size: 0.8em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var DivWrapper = _styledComponents["default"].div(_templateObject());

var DivNavWrapper = _styledComponents["default"].div(_templateObject2());

var NavButtonsRow = _styledComponents["default"].div(_templateObject3());

var IconSpan = _styledComponents["default"].span(_templateObject4());

var NavRightWrapper = _styledComponents["default"].div(_templateObject5());

var NavButton = _styledComponents["default"].button(_templateObject6());

var MediaCredits = /*#__PURE__*/function (_Component) {
  _inherits(MediaCredits, _Component);

  var _super = _createSuper(MediaCredits);

  function MediaCredits(props) {
    var _this;

    _classCallCheck(this, MediaCredits);

    _this = _super.call(this, props);
    _this.toggleDisclaimer = _this.toggleDisclaimer.bind(_assertThisInitialized(_this));
    _this.toggleCredits = _this.toggleCredits.bind(_assertThisInitialized(_this));
    _this.toggleTranscript = _this.toggleTranscript.bind(_assertThisInitialized(_this));
    _this.renderDisclaimer = _this.renderDisclaimer.bind(_assertThisInitialized(_this));
    _this.renderCredits = _this.renderCredits.bind(_assertThisInitialized(_this));
    _this.renderTranscript = _this.renderTranscript.bind(_assertThisInitialized(_this)); // set up component state so we can retain the selected thumbnail

    _this.state = {
      showDisclaimer: false,
      showCredits: false,
      showTranscript: false
    };
    return _this;
  }

  _createClass(MediaCredits, [{
    key: "toggleDisclaimer",
    value: function toggleDisclaimer() {
      var newState = !this.state.showDisclaimer;
      this.setState({
        showDisclaimer: newState,
        showCredits: false,
        showTranscript: false
      });
    }
  }, {
    key: "toggleCredits",
    value: function toggleCredits() {
      var newState = !this.state.showCredits;
      this.setState({
        showDisclaimer: false,
        showCredits: newState,
        showTranscript: false
      });
    }
  }, {
    key: "toggleTranscript",
    value: function toggleTranscript() {
      var newState = !this.state.showTranscript;
      this.setState({
        showDisclaimer: false,
        showCredits: false,
        showTranscript: newState
      });
    }
  }, {
    key: "renderTranscript",
    value: function renderTranscript(html, id) {
      return this.state.showTranscript ? /*#__PURE__*/_react["default"].createElement("div", {
        role: "region",
        "aria-live": "polite",
        "aria-atomic": "false",
        className: "hw-media-credits-transcript",
        id: id,
        dangerouslySetInnerHTML: {
          __html: html
        }
      }) : null;
    }
  }, {
    key: "renderDisclaimer",
    value: function renderDisclaimer(text, id) {
      return this.state.showDisclaimer ? /*#__PURE__*/_react["default"].createElement("p", {
        role: "region",
        id: id,
        "aria-live": "polite"
      }, text) : null;
    }
  }, {
    key: "renderCredits",
    value: function renderCredits(id) {
      var _this$props = this.props,
          asOfDate = _this$props.asOfDate,
          credits = _this$props.credits;
      return this.state.showCredits ? /*#__PURE__*/_react["default"].createElement(_Credits["default"], {
        role: "region",
        id: id,
        "aria-live": "polite",
        "aria-atomic": "false",
        asOfDate: asOfDate,
        credits: credits
      }) : '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          legal = _this$props2.legal,
          hideDisclaimer = _this$props2.hideDisclaimer,
          transcriptHtml = _this$props2.transcriptHtml;
      var creditsId = (0, _KeyGen.getKey)();

      var creditsButton = /*#__PURE__*/_react["default"].createElement(NavButton, {
        "aria-controls": creditsId,
        type: "button",
        onClick: this.toggleCredits,
        "aria-expanded": this.state.showCredits
      }, "Credits");

      var disclaimerId = (0, _KeyGen.getKey)();
      var disclaimerElement = hideDisclaimer ? null : this.renderDisclaimer(legal.disclaimerText, disclaimerId); // if hideDisclaimer prop was true, disclaimerElement will be null therefore no button

      var disclaimerButton = disclaimerElement ? /*#__PURE__*/_react["default"].createElement(NavButton, {
        "aria-controls": disclaimerId,
        type: "button",
        onClick: this.toggleDisclaimer,
        "aria-expanded": this.state.showDisclaimer
      }, "Disclaimer") : '';
      var transcriptId = (0, _KeyGen.getKey)();
      var transcriptElement = transcriptHtml ? this.renderTranscript(transcriptHtml, transcriptId) : null;
      var transcriptButton = transcriptHtml ? /*#__PURE__*/_react["default"].createElement(NavButton, {
        "aria-controls": transcriptId,
        type: "button",
        onClick: this.toggleTranscript,
        "aria-expanded": this.state.showTranscript
      }, /*#__PURE__*/_react["default"].createElement(IconSpan, null, /*#__PURE__*/_react["default"].createElement("svg", {
        role: "presentation",
        focusable: "false",
        width: "18",
        height: "22",
        viewBox: "0 0 18 22",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M1.528 1.634h14.944v18.732H1.528V1.634z",
        fill: "#017acd"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M3.728 9.646h10.59v2.26H3.728v-2.26zm0-4.355h10.59v2.26H3.728V5.29zm-.073 9.036h6.403v2.404H3.655v-2.404z",
        fill: "#fff"
      })))), /*#__PURE__*/_react["default"].createElement("span", null, "Transcript")) : /*#__PURE__*/_react["default"].createElement(NavButton, {
        tabIndex: "-1",
        disabled: true,
        type: "button",
        role: "presentation",
        "aria-hidden": "true"
      }, ' ');
      return (/*#__PURE__*/_react["default"].createElement(DivWrapper, null, /*#__PURE__*/_react["default"].createElement(DivNavWrapper, null, /*#__PURE__*/_react["default"].createElement(NavButtonsRow, null, transcriptButton, /*#__PURE__*/_react["default"].createElement(NavRightWrapper, null, disclaimerButton, creditsButton))), transcriptElement, disclaimerElement, this.renderCredits(creditsId))
      );
    }
  }]);

  return MediaCredits;
}(_react.Component);

MediaCredits.defaultProps = {
  credits: {},
  legal: {
    disclaimerText: '*** Missing disclaimer ***'
  },
  hideDisclaimer: false
};
MediaCredits.propTypes = {
  asOfDate: _propTypes["default"].string,
  transcriptHtml: _propTypes["default"].string,
  legal: _propTypes["default"].shape({
    disclaimerText: _propTypes["default"].string.isRequired
  }),
  credits: _propTypes["default"].object,
  hideDisclaimer: _propTypes["default"].bool
};
var _default = MediaCredits;
exports["default"] = _default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddIcon", {
  enumerable: true,
  get: function get() {
    return _AddIcon["default"];
  }
});
Object.defineProperty(exports, "AnalyticsIcon", {
  enumerable: true,
  get: function get() {
    return _AnalyticsIcon["default"];
  }
});
Object.defineProperty(exports, "AnalyticsSimpleIcon", {
  enumerable: true,
  get: function get() {
    return _AnalyticsSimpleIcon["default"];
  }
});
Object.defineProperty(exports, "BrandingIcon", {
  enumerable: true,
  get: function get() {
    return _BrandingIcon["default"];
  }
});
Object.defineProperty(exports, "BrandingSimpleIcon", {
  enumerable: true,
  get: function get() {
    return _BrandingSimpleIcon["default"];
  }
});
Object.defineProperty(exports, "CheckboxCheckedIcon", {
  enumerable: true,
  get: function get() {
    return _CheckboxCheckedIcon["default"];
  }
});
Object.defineProperty(exports, "CheckboxUncheckedIcon", {
  enumerable: true,
  get: function get() {
    return _CheckboxUncheckedIcon["default"];
  }
});
Object.defineProperty(exports, "CheckIcon", {
  enumerable: true,
  get: function get() {
    return _CheckIcon["default"];
  }
});
Object.defineProperty(exports, "CollapseIcon", {
  enumerable: true,
  get: function get() {
    return _CollapseIcon["default"];
  }
});
Object.defineProperty(exports, "DashboardIcon", {
  enumerable: true,
  get: function get() {
    return _DashboardIcon["default"];
  }
});
Object.defineProperty(exports, "DownArrowIcon", {
  enumerable: true,
  get: function get() {
    return _DownArrowIcon["default"];
  }
});
Object.defineProperty(exports, "DownloadIcon", {
  enumerable: true,
  get: function get() {
    return _DownloadIcon["default"];
  }
});
Object.defineProperty(exports, "EditIcon", {
  enumerable: true,
  get: function get() {
    return _EditIcon["default"];
  }
});
Object.defineProperty(exports, "ExpandIcon", {
  enumerable: true,
  get: function get() {
    return _ExpandIcon["default"];
  }
});
Object.defineProperty(exports, "GroupsIcon", {
  enumerable: true,
  get: function get() {
    return _GroupsIcon["default"];
  }
});
Object.defineProperty(exports, "HomeIcon", {
  enumerable: true,
  get: function get() {
    return _HomeIcon["default"];
  }
});
Object.defineProperty(exports, "InfoIcon", {
  enumerable: true,
  get: function get() {
    return _InfoIcon["default"];
  }
});
Object.defineProperty(exports, "KeyIcon", {
  enumerable: true,
  get: function get() {
    return _KeyIcon["default"];
  }
});
Object.defineProperty(exports, "LeftArrowIcon", {
  enumerable: true,
  get: function get() {
    return _LeftArrowIcon["default"];
  }
});
Object.defineProperty(exports, "LockedIcon", {
  enumerable: true,
  get: function get() {
    return _LockedIcon["default"];
  }
});
Object.defineProperty(exports, "MagnifyingGlassIcon", {
  enumerable: true,
  get: function get() {
    return _MagnifyingGlassIcon["default"];
  }
});
Object.defineProperty(exports, "PrinterIcon", {
  enumerable: true,
  get: function get() {
    return _PrinterIcon["default"];
  }
});
Object.defineProperty(exports, "ProfileIcon", {
  enumerable: true,
  get: function get() {
    return _ProfileIcon["default"];
  }
});
Object.defineProperty(exports, "RestoreIcon", {
  enumerable: true,
  get: function get() {
    return _RestoreIcon["default"];
  }
});
Object.defineProperty(exports, "RightArrowIcon", {
  enumerable: true,
  get: function get() {
    return _RightArrowIcon["default"];
  }
});
Object.defineProperty(exports, "ScrollToTopIcon", {
  enumerable: true,
  get: function get() {
    return _ScrollToTopIcon["default"];
  }
});
Object.defineProperty(exports, "TrashIcon", {
  enumerable: true,
  get: function get() {
    return _TrashIcon["default"];
  }
});
Object.defineProperty(exports, "UnlockedIcon", {
  enumerable: true,
  get: function get() {
    return _UnlockedIcon["default"];
  }
});
Object.defineProperty(exports, "UpArrowIcon", {
  enumerable: true,
  get: function get() {
    return _UpArrowIcon["default"];
  }
});
Object.defineProperty(exports, "UsersIcon", {
  enumerable: true,
  get: function get() {
    return _UsersIcon["default"];
  }
});
Object.defineProperty(exports, "UsersSimpleIcon", {
  enumerable: true,
  get: function get() {
    return _UsersSimpleIcon["default"];
  }
});
Object.defineProperty(exports, "WarningIcon", {
  enumerable: true,
  get: function get() {
    return _WarningIcon["default"];
  }
});
exports["default"] = void 0;

var _Icon = _interopRequireDefault(__webpack_require__(8));

var _AddIcon = _interopRequireDefault(__webpack_require__(395));

var _AnalyticsIcon = _interopRequireDefault(__webpack_require__(396));

var _AnalyticsSimpleIcon = _interopRequireDefault(__webpack_require__(397));

var _BrandingIcon = _interopRequireDefault(__webpack_require__(398));

var _BrandingSimpleIcon = _interopRequireDefault(__webpack_require__(399));

var _CheckboxCheckedIcon = _interopRequireDefault(__webpack_require__(401));

var _CheckboxUncheckedIcon = _interopRequireDefault(__webpack_require__(402));

var _CheckIcon = _interopRequireDefault(__webpack_require__(400));

var _CollapseIcon = _interopRequireDefault(__webpack_require__(403));

var _DashboardIcon = _interopRequireDefault(__webpack_require__(404));

var _DownArrowIcon = _interopRequireDefault(__webpack_require__(405));

var _DownloadIcon = _interopRequireDefault(__webpack_require__(406));

var _EditIcon = _interopRequireDefault(__webpack_require__(407));

var _ExpandIcon = _interopRequireDefault(__webpack_require__(408));

var _GroupsIcon = _interopRequireDefault(__webpack_require__(409));

var _HomeIcon = _interopRequireDefault(__webpack_require__(410));

var _InfoIcon = _interopRequireDefault(__webpack_require__(411));

var _KeyIcon = _interopRequireDefault(__webpack_require__(412));

var _LeftArrowIcon = _interopRequireDefault(__webpack_require__(413));

var _LockedIcon = _interopRequireDefault(__webpack_require__(414));

var _MagnifyingGlassIcon = _interopRequireDefault(__webpack_require__(415));

var _PrinterIcon = _interopRequireDefault(__webpack_require__(416));

var _ProfileIcon = _interopRequireDefault(__webpack_require__(417));

var _RestoreIcon = _interopRequireDefault(__webpack_require__(418));

var _RightArrowIcon = _interopRequireDefault(__webpack_require__(419));

var _ScrollToTopIcon = _interopRequireDefault(__webpack_require__(420));

var _TrashIcon = _interopRequireDefault(__webpack_require__(421));

var _UnlockedIcon = _interopRequireDefault(__webpack_require__(422));

var _UpArrowIcon = _interopRequireDefault(__webpack_require__(423));

var _UsersIcon = _interopRequireDefault(__webpack_require__(424));

var _UsersSimpleIcon = _interopRequireDefault(__webpack_require__(425));

var _WarningIcon = _interopRequireDefault(__webpack_require__(426));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var _default = _Icon["default"];
exports["default"] = _default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _ScreenReaderOnly = _interopRequireDefault(__webpack_require__(242));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: top;\n  display: inline-block;\n  width: 100%;\n  background-color: ", ";\n  animation: ", " 4s infinite ease-in;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  box-sizing: border-box;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  border: ", ";\n  top: 10px;\n  left: 50%;\n  transform: translateX(-15px);\n  animation: ", " 4s infinite ease;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  min-height: 50px;\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% { height: 0%; }\n  25% { height: 0%; }\n  50% { height: 100%; }\n  75% { height: 100%; }\n  100% { height: 0%; }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  25% { transform: rotate(180deg); }\n  50% { transform: rotate(180deg); }\n  75% { transform: rotate(360deg); }\n  100% { transform: rotate(360deg); }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var spinnerOuterAnimation = (0, _styledComponents.keyframes)(_templateObject());
var spinnerInnerAnimation = (0, _styledComponents.keyframes)(_templateObject2());

var Root = _styledComponents["default"].div(_templateObject3());

var SpinnerOuter = _styledComponents["default"].span(_templateObject4(), function (props) {
  return props.inverted ? "4px solid ".concat(props.theme.colorPrimaryLight) : "4px solid ".concat(props.theme.colorPrimaryDark);
}, spinnerOuterAnimation);

var SpinnerInner = _styledComponents["default"].span(_templateObject5(), function (props) {
  return props.inverted ? props.theme.colorPrimaryLight : props.theme.colorPrimaryDark;
}, spinnerInnerAnimation);

var LoadingIndicator = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadingIndicator, _React$Component);

  function LoadingIndicator() {
    _classCallCheck(this, LoadingIndicator);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingIndicator).apply(this, arguments));
  }

  _createClass(LoadingIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hiddenText = _this$props.hiddenText,
          inverted = _this$props.inverted,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["hiddenText", "inverted", "theme"]);

      return _react["default"].createElement(Root, _extends({
        className: "hw-loading-indicator-wrapper"
      }, otherProps), _react["default"].createElement(_ScreenReaderOnly["default"], null, hiddenText), _react["default"].createElement(SpinnerOuter, {
        className: "hw-loading-indicator",
        inverted: inverted,
        theme: theme
      }, _react["default"].createElement(SpinnerInner, {
        className: "hw-loading-indicator-inner",
        inverted: inverted,
        theme: theme
      })));
    }
  }]);

  return LoadingIndicator;
}(_react["default"].Component);

LoadingIndicator.propTypes = {
  hiddenText: _propTypes["default"].string,
  inverted: _propTypes["default"].bool,
  theme: _propTypes["default"].shape({
    colorPrimaryLight: _propTypes["default"].string,
    colorPrimaryDark: _propTypes["default"].string
  })
};
LoadingIndicator.defaultProps = {
  hiddenText: 'Loading page',
  inverted: false,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(LoadingIndicator);

exports["default"] = _default;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colorPalette = _interopRequireDefault(__webpack_require__(245));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var defaultTheme = {
  // Base background colors. The color-background variable and its variants are
  // the primary backgrounds for the application. These will usually be white or
  // light grey for light-colored themes, while the color-background-contrast
  // group will be dark grey/black. For dark themes, these groups would be
  // reversed (color-background black, color-background-contrast white).
  colorBackgroundLight: _colorPalette["default"].white,
  colorBackground: _colorPalette["default"].neutralLighter,
  colorBackgroundDark: _colorPalette["default"].neutralLight,
  colorBackgroundContrastLight: _colorPalette["default"].neutralLight,
  colorBackgroundContrast: _colorPalette["default"].neutralMed,
  colorBackgroundContrastDark: _colorPalette["default"].neutralDark,
  colorBorder: _colorPalette["default"].neutralMed,
  // Theme primary and accent colors
  colorPrimaryLight: _colorPalette["default"].primaryLight,
  colorPrimary: _colorPalette["default"].primary,
  colorPrimaryDark: _colorPalette["default"].primaryDark,
  colorPrimaryDarker: _colorPalette["default"].stormy,
  colorAccent: _colorPalette["default"].accent,
  colorAccentDark: _colorPalette["default"].accentDark,
  colorNeutralLight: _colorPalette["default"].neutralLight,
  colorNeutral: _colorPalette["default"].neutralMed,
  colorNeutralDark: _colorPalette["default"].neutralDark,
  // Success/error message coloring
  colorInfo: _colorPalette["default"].primaryDark,
  colorSuccess: _colorPalette["default"].primaryLight,
  colorWarning: _colorPalette["default"].yellow,
  colorError: _colorPalette["default"].accent,
  // Text colors
  colorTextPrimary: _colorPalette["default"].neutralDark,
  colorTextSecondary: _colorPalette["default"].neutralMed,
  colorTextDisabled: _colorPalette["default"].neutralLight,
  colorTextAccent: _colorPalette["default"].primaryDark,
  colorTextOnContrastLight: _colorPalette["default"].neutralDark,
  colorTextOnContrast: _colorPalette["default"].neutralDarker,
  colorTextOnContrastDark: _colorPalette["default"].white,
  colorTextOnPrimaryLight: _colorPalette["default"].neutralDark,
  colorTextOnPrimary: _colorPalette["default"].white,
  colorTextOnPrimaryDark: _colorPalette["default"].white,
  colorTextOnPrimaryDarker: _colorPalette["default"].white,
  colorTextOnAccent: _colorPalette["default"].white,
  colorTextOnAccentDark: _colorPalette["default"].white,
  colorTextOnNeutralLight: _colorPalette["default"].neutralDark,
  colorTextOnNeutral: _colorPalette["default"].white,
  colorTextOnNeutralDark: _colorPalette["default"].white,
  // Focus indicator settings
  focusIndicator: "2px dotted ".concat(_colorPalette["default"].neutralDark),
  focusIndicatorContrast: "2px dotted ".concat(_colorPalette["default"].neutralLighter),
  focusIndicatorOffset: '2px',
  focusIndicatorInset: '-2px',
  // Spacing variables for white space or spacing within and between components
  spacingXs: '4px',
  spacingS: '8px',
  spacingM: '16px',
  spacingL: '24px',
  spacingXl: '32px',
  spacingXxl: '64px',
  spacingXxxl: '96px'
};
var _default = defaultTheme;
exports["default"] = _default;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var themeSettings = {
  colorPrimary: '#017acd',
  colorPrimaryLight: '#99caeb',
  colorPrimaryDark: '#017acd',
  focusIndicator: '3px dotted #017acd',
  colorTextPrimary: '#363942',
  colorNeutral: '#017acd',
  colorNeutralLight: '#abb2c1'

  // This shouldnt be needed ... but keeping it in for reference for the time being
};var legacyTheme = {
  'font-color': 'black',
  'color-base': 'black',
  'color-light': 'white',
  'color-dark': '#017acd',
  'color-bar': '#015c9a',
  'color-medium-border': '#abb2c1',
  'color-bg-lighter': 'rgba(240, 241, 244, 0.5)',
  'color-bg-light': '#f0f1f4',
  'color-visited': '#5aa8de',
  'color-disabled': '#5a5f6c',
  'color-focus': '#99caeb',
  'color-hover': '#99caeb',
  'color-active': '#017acd',

  'max-page-width': '1024px',
  'full-page-padding': '0 12.9%' /* 132px/1024px */
  , 'mobile-page-padding': '0 4%',
  'content-padding': '0 6.32%' /* 48px/1024px */

  , 'print-heading-bg-color': '#f5f5f5'
};

var theme = __webpack_require__(17).createTheme(themeSettings);
var defaultTheme = theme;

module.exports = {
  defaultTheme: defaultTheme,
  localTheme: defaultTheme,
  theme: defaultTheme,
  legacyTheme: legacyTheme
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _deepmerge = _interopRequireDefault(__webpack_require__(138));

var _isPlainObject = _interopRequireDefault(__webpack_require__(750));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(500));

var _createMixins = _interopRequireDefault(__webpack_require__(501));

var _createPalette = _interopRequireDefault(__webpack_require__(502));

var _createTypography = _interopRequireDefault(__webpack_require__(504));

var _shadows = _interopRequireDefault(__webpack_require__(510));

var _shape = _interopRequireDefault(__webpack_require__(511));

var _spacing = _interopRequireDefault(__webpack_require__(512));

var _transitions = _interopRequireDefault(__webpack_require__(171));

var _zIndex = _interopRequireDefault(__webpack_require__(513));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$spacing = options.spacing,
      spacingInput = _options$spacing === void 0 ? {} : _options$spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2["default"])(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);
  var palette = (0, _createPalette["default"])(paletteInput);
  var breakpoints = (0, _createBreakpoints["default"])(breakpointsInput);
  var spacing = (0, _extends2["default"])({}, _spacing["default"], spacingInput);
  var muiTheme = (0, _extends2["default"])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins["default"])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows["default"],
    typography: (0, _createTypography["default"])(palette, typographyInput)
  }, (0, _deepmerge["default"])({
    shape: _shape["default"],
    spacing: spacing,
    transitions: _transitions["default"],
    zIndex: _zIndex["default"]
  }, other, {
    isMergeableObject: _isPlainObject["default"]
  }));

  if (false) {
    var statesWarning = ['disabled', 'focused', 'selected', 'checked'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (statesWarning.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          process.env.NODE_ENV !== "production" ? (0, _warning["default"])(false, ["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify((0, _defineProperty2["default"])({}, "&$".concat(key), child), null, 2), '', 'https://v3.material-ui.com/customization/overrides#internal-states'].join('\n')) : void 0;
        }
      }
    };

    traverse(other.overrides);
  }

   false ? (0, _warning["default"])(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports["default"] = _default;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2["default"])({}, CHANNEL, function () {}),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports["default"] = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _warning = _interopRequireDefault(__webpack_require__(33));

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */

exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2["default"])(options, ["duration", "easing", "delay"]);
     false ? (0, _warning["default"])(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning["default"])(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning["default"])(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning["default"])(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning["default"])(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports["default"] = _default;

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(141);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(303);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(143);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(151);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function DOMParser(options) {
	this.options = options || { locator: {} };
}
DOMParser.prototype.parseFromString = function (source, mimeType) {
	var options = this.options;
	var sax = new XMLReader();
	var domBuilder = options.domBuilder || new DOMHandler(); //contentHandler and LexicalHandler
	var errorHandler = options.errorHandler;
	var locator = options.locator;
	var defaultNSMap = options.xmlns || {};
	var entityMap = { 'lt': '<', 'gt': '>', 'amp': '&', 'quot': '"', 'apos': "'" };
	if (locator) {
		domBuilder.setDocumentLocator(locator);
	}

	sax.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
	sax.domBuilder = options.domBuilder || domBuilder;
	if (/\/x?html?$/.test(mimeType)) {
		entityMap.nbsp = '\xa0';
		entityMap.copy = '\xa9';
		defaultNSMap[''] = 'http://www.w3.org/1999/xhtml';
	}
	defaultNSMap.xml = defaultNSMap.xml || 'http://www.w3.org/XML/1998/namespace';
	if (source) {
		sax.parse(source, defaultNSMap, entityMap);
	} else {
		sax.errorHandler.error("invalid doc source");
	}
	return domBuilder.doc;
};
function buildErrorHandler(errorImpl, domBuilder, locator) {
	if (!errorImpl) {
		if (domBuilder instanceof DOMHandler) {
			return domBuilder;
		}
		errorImpl = domBuilder;
	}
	var errorHandler = {};
	var isCallback = errorImpl instanceof Function;
	locator = locator || {};
	function build(key) {
		var fn = errorImpl[key];
		if (!fn && isCallback) {
			fn = errorImpl.length == 2 ? function (msg) {
				errorImpl(key, msg);
			} : errorImpl;
		}
		errorHandler[key] = fn && function (msg) {
			fn('[xmldom ' + key + ']\t' + msg + _locator(locator));
		} || function () {};
	}
	build('warning');
	build('error');
	build('fatalError');
	return errorHandler;
}

//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler 
 * 
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */
function DOMHandler() {
	this.cdata = false;
}
function position(locator, node) {
	node.lineNumber = locator.lineNumber;
	node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */
DOMHandler.prototype = {
	startDocument: function startDocument() {
		this.doc = new DOMImplementation().createDocument(null, null, null);
		if (this.locator) {
			this.doc.documentURI = this.locator.systemId;
		}
	},
	startElement: function startElement(namespaceURI, localName, qName, attrs) {
		var doc = this.doc;
		var el = doc.createElementNS(namespaceURI, qName || localName);
		var len = attrs.length;
		appendElement(this, el);
		this.currentElement = el;

		this.locator && position(this.locator, el);
		for (var i = 0; i < len; i++) {
			var namespaceURI = attrs.getURI(i);
			var value = attrs.getValue(i);
			var qName = attrs.getQName(i);
			var attr = doc.createAttributeNS(namespaceURI, qName);
			this.locator && position(attrs.getLocator(i), attr);
			attr.value = attr.nodeValue = value;
			el.setAttributeNode(attr);
		}
	},
	endElement: function endElement(namespaceURI, localName, qName) {
		var current = this.currentElement;
		var tagName = current.tagName;
		this.currentElement = current.parentNode;
	},
	startPrefixMapping: function startPrefixMapping(prefix, uri) {},
	endPrefixMapping: function endPrefixMapping(prefix) {},
	processingInstruction: function processingInstruction(target, data) {
		var ins = this.doc.createProcessingInstruction(target, data);
		this.locator && position(this.locator, ins);
		appendElement(this, ins);
	},
	ignorableWhitespace: function ignorableWhitespace(ch, start, length) {},
	characters: function characters(chars, start, length) {
		chars = _toString.apply(this, arguments);
		//console.log(chars)
		if (chars) {
			if (this.cdata) {
				var charNode = this.doc.createCDATASection(chars);
			} else {
				var charNode = this.doc.createTextNode(chars);
			}
			if (this.currentElement) {
				this.currentElement.appendChild(charNode);
			} else if (/^\s*$/.test(chars)) {
				this.doc.appendChild(charNode);
				//process xml
			}
			this.locator && position(this.locator, charNode);
		}
	},
	skippedEntity: function skippedEntity(name) {},
	endDocument: function endDocument() {
		this.doc.normalize();
	},
	setDocumentLocator: function setDocumentLocator(locator) {
		if (this.locator = locator) {
			// && !('lineNumber' in locator)){
			locator.lineNumber = 0;
		}
	},
	//LexicalHandler
	comment: function comment(chars, start, length) {
		chars = _toString.apply(this, arguments);
		var comm = this.doc.createComment(chars);
		this.locator && position(this.locator, comm);
		appendElement(this, comm);
	},

	startCDATA: function startCDATA() {
		//used in characters() methods
		this.cdata = true;
	},
	endCDATA: function endCDATA() {
		this.cdata = false;
	},

	startDTD: function startDTD(name, publicId, systemId) {
		var impl = this.doc.implementation;
		if (impl && impl.createDocumentType) {
			var dt = impl.createDocumentType(name, publicId, systemId);
			this.locator && position(this.locator, dt);
			appendElement(this, dt);
		}
	},
	/**
  * @see org.xml.sax.ErrorHandler
  * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
  */
	warning: function warning(error) {
		console.warn('[xmldom warning]\t' + error, _locator(this.locator));
	},
	error: function error(_error) {
		console.error('[xmldom error]\t' + _error, _locator(this.locator));
	},
	fatalError: function fatalError(error) {
		console.error('[xmldom fatalError]\t' + error, _locator(this.locator));
		throw error;
	}
};
function _locator(l) {
	if (l) {
		return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
	}
}
function _toString(chars, start, length) {
	if (typeof chars == 'string') {
		return chars.substr(start, length);
	} else {
		//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
		if (chars.length >= start + length || start) {
			return new java.lang.String(chars, start, length) + '';
		}
		return chars;
	}
}

/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (key) {
	DOMHandler.prototype[key] = function () {
		return null;
	};
});

/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
function appendElement(hander, node) {
	if (!hander.currentElement) {
		hander.doc.appendChild(node);
	} else {
		hander.currentElement.appendChild(node);
	}
} //appendChild and setAttributeNS are preformance key

//if(typeof require == 'function'){
var XMLReader = __webpack_require__(230).XMLReader;
var DOMImplementation = exports.DOMImplementation = __webpack_require__(117).DOMImplementation;
exports.XMLSerializer = __webpack_require__(117).XMLSerializer;
exports.DOMParser = DOMParser;
//}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/; //\u10000-\uEFFFF
var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp('^' + nameStartChar.source + nameChar.source + '*(?:\:' + nameStartChar.source + nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var S_TAG = 0; //tag name offerring
var S_ATTR = 1; //attr name offerring 
var S_ATTR_SPACE = 2; //attr name end and space offer
var S_EQ = 3; //=space?
var S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var S_ATTR_END = 5; //attr value end and no space(quot end)
var S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var S_TAG_CLOSE = 7; //closed el<el />

function XMLReader() {}

XMLReader.prototype = {
	parse: function parse(source, defaultNSMap, entityMap) {
		var domBuilder = this.domBuilder;
		domBuilder.startDocument();
		_copy(defaultNSMap, defaultNSMap = {});
		_parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
		domBuilder.endDocument();
	}
};
function _parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
	function fixedFromCharCode(code) {
		// String.prototype.fromCharCode does not supports
		// > 2 bytes unicode chars directly
		if (code > 0xffff) {
			code -= 0x10000;
			var surrogate1 = 0xd800 + (code >> 10),
			    surrogate2 = 0xdc00 + (code & 0x3ff);

			return String.fromCharCode(surrogate1, surrogate2);
		} else {
			return String.fromCharCode(code);
		}
	}
	function entityReplacer(a) {
		var k = a.slice(1, -1);
		if (k in entityMap) {
			return entityMap[k];
		} else if (k.charAt(0) === '#') {
			return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
		} else {
			errorHandler.error('entity not found:' + a);
			return a;
		}
	}
	function appendText(end) {
		//has some bugs
		if (end > start) {
			var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
			locator && position(start);
			domBuilder.characters(xt, 0, end - start);
			start = end;
		}
	}
	function position(p, m) {
		while (p >= lineEnd && (m = linePattern.exec(source))) {
			lineStart = m.index;
			lineEnd = lineStart + m[0].length;
			locator.lineNumber++;
			//console.log('line++:',locator,startPos,endPos)
		}
		locator.columnNumber = p - lineStart + 1;
	}
	var lineStart = 0;
	var lineEnd = 0;
	var linePattern = /.*(?:\r\n?|\n)|.*$/g;
	var locator = domBuilder.locator;

	var parseStack = [{ currentNSMap: defaultNSMapCopy }];
	var closeMap = {};
	var start = 0;
	while (true) {
		try {
			var tagStart = source.indexOf('<', start);
			if (tagStart < 0) {
				if (!source.substr(start).match(/^\s*$/)) {
					var doc = domBuilder.doc;
					var text = doc.createTextNode(source.substr(start));
					doc.appendChild(text);
					domBuilder.currentElement = text;
				}
				return;
			}
			if (tagStart > start) {
				appendText(tagStart);
			}
			switch (source.charAt(tagStart + 1)) {
				case '/':
					var end = source.indexOf('>', tagStart + 3);
					var tagName = source.substring(tagStart + 2, end);
					var config = parseStack.pop();
					if (end < 0) {

						tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
						//console.error('#@@@@@@'+tagName)
						errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
						end = tagStart + 1 + tagName.length;
					} else if (tagName.match(/\s</)) {
						tagName = tagName.replace(/[\s<].*/, '');
						errorHandler.error("end tag name: " + tagName + ' maybe not complete');
						end = tagStart + 1 + tagName.length;
					}
					//console.error(parseStack.length,parseStack)
					//console.error(config);
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
					if (endIgnoreCaseMach) {
						domBuilder.endElement(config.uri, config.localName, tagName);
						if (localNSMap) {
							for (var prefix in localNSMap) {
								domBuilder.endPrefixMapping(prefix);
							}
						}
						if (!endMatch) {
							errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName);
						}
					} else {
						parseStack.push(config);
					}

					end++;
					break;
				// end elment
				case '?':
					// <?...?>
					locator && position(tagStart);
					end = parseInstruction(source, tagStart, domBuilder);
					break;
				case '!':
					// <!doctype,<![CDATA,<!--
					locator && position(tagStart);
					end = parseDCC(source, tagStart, domBuilder, errorHandler);
					break;
				default:
					locator && position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
					var len = el.length;

					if (!el.closed && fixSelfClosed(source, end, el.tagName, closeMap)) {
						el.closed = true;
						if (!entityMap.nbsp) {
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if (locator && len) {
						var locator2 = copyLocator(locator, {});
						//try{//attribute position fixed
						for (var i = 0; i < len; i++) {
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator, {});
						}
						//}catch(e){console.error('@@@@@'+e)}
						domBuilder.locator = locator2;
						if (appendElement(el, domBuilder, currentNSMap)) {
							parseStack.push(el);
						}
						domBuilder.locator = locator;
					} else {
						if (appendElement(el, domBuilder, currentNSMap)) {
							parseStack.push(el);
						}
					}

					if (el.uri === 'http://www.w3.org/1999/xhtml' && !el.closed) {
						end = parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
					} else {
						end++;
					}
			}
		} catch (e) {
			errorHandler.error('element parse error: ' + e);
			//errorHandler.error('element parse error: '+e);
			end = -1;
			//throw e;
		}
		if (end > start) {
			start = end;
		} else {
			//TODO: 这里有可能sax回退，有位置错误风险
			appendText(Math.max(tagStart, start) + 1);
		}
	}
}
function copyLocator(f, t) {
	t.lineNumber = f.lineNumber;
	t.columnNumber = f.columnNumber;
	return t;
}

/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */
function parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
	var attrName;
	var value;
	var p = ++start;
	var s = S_TAG; //status
	while (true) {
		var c = source.charAt(p);
		switch (c) {
			case '=':
				if (s === S_ATTR) {
					//attrName
					attrName = source.slice(start, p);
					s = S_EQ;
				} else if (s === S_ATTR_SPACE) {
					s = S_EQ;
				} else {
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName');
				}
				break;
			case '\'':
			case '"':
				if (s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
				) {
						//equal
						if (s === S_ATTR) {
							errorHandler.warning('attribute value must after "="');
							attrName = source.slice(start, p);
						}
						start = p + 1;
						p = source.indexOf(c, start);
						if (p > 0) {
							value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
							el.add(attrName, value, start - 1);
							s = S_ATTR_END;
						} else {
							//fatalError: no end quot match
							throw new Error('attribute value no end \'' + c + '\' match');
						}
					} else if (s == S_ATTR_NOQUOT_VALUE) {
					value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
					//console.log(attrName,value,start,p)
					el.add(attrName, value, start);
					//console.dir(el)
					errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
					start = p + 1;
					s = S_ATTR_END;
				} else {
					//fatalError: no equal before
					throw new Error('attribute value must after "="');
				}
				break;
			case '/':
				switch (s) {
					case S_TAG:
						el.setTagName(source.slice(start, p));
					case S_ATTR_END:
					case S_TAG_SPACE:
					case S_TAG_CLOSE:
						s = S_TAG_CLOSE;
						el.closed = true;
					case S_ATTR_NOQUOT_VALUE:
					case S_ATTR:
					case S_ATTR_SPACE:
						break;
					//case S_EQ:
					default:
						throw new Error("attribute invalid close char('/')");
				}
				break;
			case '':
				//end document
				//throw new Error('unexpected end of input')
				errorHandler.error('unexpected end of input');
				if (s == S_TAG) {
					el.setTagName(source.slice(start, p));
				}
				return p;
			case '>':
				switch (s) {
					case S_TAG:
						el.setTagName(source.slice(start, p));
					case S_ATTR_END:
					case S_TAG_SPACE:
					case S_TAG_CLOSE:
						break; //normal
					case S_ATTR_NOQUOT_VALUE: //Compatible state
					case S_ATTR:
						value = source.slice(start, p);
						if (value.slice(-1) === '/') {
							el.closed = true;
							value = value.slice(0, -1);
						}
					case S_ATTR_SPACE:
						if (s === S_ATTR_SPACE) {
							value = attrName;
						}
						if (s == S_ATTR_NOQUOT_VALUE) {
							errorHandler.warning('attribute "' + value + '" missed quot(")!!');
							el.add(attrName, value.replace(/&#?\w+;/g, entityReplacer), start);
						} else {
							if (currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !value.match(/^(?:disabled|checked|selected)$/i)) {
								errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
							}
							el.add(value, value, start);
						}
						break;
					case S_EQ:
						throw new Error('attribute value missed!!');
				}
				//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case "\x80":
				c = ' ';
			default:
				if (c <= ' ') {
					//space
					switch (s) {
						case S_TAG:
							el.setTagName(source.slice(start, p)); //tagName
							s = S_TAG_SPACE;
							break;
						case S_ATTR:
							attrName = source.slice(start, p);
							s = S_ATTR_SPACE;
							break;
						case S_ATTR_NOQUOT_VALUE:
							var value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
							errorHandler.warning('attribute "' + value + '" missed quot(")!!');
							el.add(attrName, value, start);
						case S_ATTR_END:
							s = S_TAG_SPACE;
							break;
						//case S_TAG_SPACE:
						//case S_EQ:
						//case S_ATTR_SPACE:
						//	void();break;
						//case S_TAG_CLOSE:
						//ignore warning
					}
				} else {
					//not space
					//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
					//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch (s) {
						//case S_TAG:void();break;
						//case S_ATTR:void();break;
						//case S_ATTR_NOQUOT_VALUE:void();break;
						case S_ATTR_SPACE:
							var tagName = el.tagName;
							if (currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
								errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
							}
							el.add(attrName, attrName, start);
							start = p;
							s = S_ATTR;
							break;
						case S_ATTR_END:
							errorHandler.warning('attribute space is required"' + attrName + '"!!');
						case S_TAG_SPACE:
							s = S_ATTR;
							start = p;
							break;
						case S_EQ:
							s = S_ATTR_NOQUOT_VALUE;
							start = p;
							break;
						case S_TAG_CLOSE:
							throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
		} //end outer switch
		//console.log('p++',p)
		p++;
	}
}
/**
 * @return true if has new namespace define
 */
function appendElement(el, domBuilder, currentNSMap) {
	var tagName = el.tagName;
	var localNSMap = null;
	//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
	var i = el.length;
	while (i--) {
		var a = el[i];
		var qName = a.qName;
		var value = a.value;
		var nsp = qName.indexOf(':');
		if (nsp > 0) {
			var prefix = a.prefix = qName.slice(0, nsp);
			var localName = qName.slice(nsp + 1);
			var nsPrefix = prefix === 'xmlns' && localName;
		} else {
			localName = qName;
			prefix = null;
			nsPrefix = qName === 'xmlns' && '';
		}
		//can not set prefix,because prefix !== ''
		a.localName = localName;
		//prefix == null for no ns prefix attribute 
		if (nsPrefix !== false) {
			//hack!!
			if (localNSMap == null) {
				localNSMap = {};
				//console.log(currentNSMap,0)
				_copy(currentNSMap, currentNSMap = {});
				//console.log(currentNSMap,1)
			}
			currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
			a.uri = 'http://www.w3.org/2000/xmlns/';
			domBuilder.startPrefixMapping(nsPrefix, value);
		}
	}
	var i = el.length;
	while (i--) {
		a = el[i];
		var prefix = a.prefix;
		if (prefix) {
			//no prefix attribute has no namespace
			if (prefix === 'xml') {
				a.uri = 'http://www.w3.org/XML/1998/namespace';
			}if (prefix !== 'xmlns') {
				a.uri = currentNSMap[prefix || ''];

				//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
			}
		}
	}
	var nsp = tagName.indexOf(':');
	if (nsp > 0) {
		prefix = el.prefix = tagName.slice(0, nsp);
		localName = el.localName = tagName.slice(nsp + 1);
	} else {
		prefix = null; //important!!
		localName = el.localName = tagName;
	}
	//no prefix element has default namespace
	var ns = el.uri = currentNSMap[prefix || ''];
	domBuilder.startElement(ns, localName, tagName, el);
	//endPrefixMapping and startPrefixMapping have not any help for dom builder
	//localNSMap = null
	if (el.closed) {
		domBuilder.endElement(ns, localName, tagName);
		if (localNSMap) {
			for (prefix in localNSMap) {
				domBuilder.endPrefixMapping(prefix);
			}
		}
	} else {
		el.currentNSMap = currentNSMap;
		el.localNSMap = localNSMap;
		//parseStack.push(el);
		return true;
	}
}
function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
	if (/^(?:script|textarea)$/i.test(tagName)) {
		var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
		var text = source.substring(elStartEnd + 1, elEndStart);
		if (/[&<]/.test(text)) {
			if (/^script$/i.test(tagName)) {
				//if(!/\]\]>/.test(text)){
				//lexHandler.startCDATA();
				domBuilder.characters(text, 0, text.length);
				//lexHandler.endCDATA();
				return elEndStart;
				//}
			} //}else{//text area
			text = text.replace(/&#?\w+;/g, entityReplacer);
			domBuilder.characters(text, 0, text.length);
			return elEndStart;
			//}
		}
	}
	return elStartEnd + 1;
}
function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
	//if(tagName in closeMap){
	var pos = closeMap[tagName];
	if (pos == null) {
		//console.log(tagName)
		pos = source.lastIndexOf('</' + tagName + '>');
		if (pos < elStartEnd) {
			//忘记闭合
			pos = source.lastIndexOf('</' + tagName);
		}
		closeMap[tagName] = pos;
	}
	return pos < elStartEnd;
	//} 
}
function _copy(source, target) {
	for (var n in source) {
		target[n] = source[n];
	}
}
function parseDCC(source, start, domBuilder, errorHandler) {
	//sure start with '<!'
	var next = source.charAt(start + 2);
	switch (next) {
		case '-':
			if (source.charAt(start + 3) === '-') {
				var end = source.indexOf('-->', start + 4);
				//append comment source.substring(4,end)//<!--
				if (end > start) {
					domBuilder.comment(source, start + 4, end - start - 4);
					return end + 3;
				} else {
					errorHandler.error("Unclosed comment");
					return -1;
				}
			} else {
				//error
				return -1;
			}
		default:
			if (source.substr(start + 3, 6) == 'CDATA[') {
				var end = source.indexOf(']]>', start + 9);
				domBuilder.startCDATA();
				domBuilder.characters(source, start + 9, end - start - 9);
				domBuilder.endCDATA();
				return end + 3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId) 
			var matchs = split(source, start);
			var len = matchs.length;
			if (len > 1 && /!doctype/i.test(matchs[0][0])) {
				var name = matchs[1][0];
				var pubid = len > 3 && /^public$/i.test(matchs[2][0]) && matchs[3][0];
				var sysid = len > 4 && matchs[4][0];
				var lastMatch = matchs[len - 1];
				domBuilder.startDTD(name, pubid && pubid.replace(/^(['"])(.*?)\1$/, '$2'), sysid && sysid.replace(/^(['"])(.*?)\1$/, '$2'));
				domBuilder.endDTD();

				return lastMatch.index + lastMatch[0].length;
			}
	}
	return -1;
}

function parseInstruction(source, start, domBuilder) {
	var end = source.indexOf('?>', start);
	if (end) {
		var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
		if (match) {
			var len = match[0].length;
			domBuilder.processingInstruction(match[1], match[2]);
			return end + 2;
		} else {
			//error
			return -1;
		}
	}
	return -1;
}

/**
 * @param source
 */
function ElementAttributes(source) {}
ElementAttributes.prototype = {
	setTagName: function setTagName(tagName) {
		if (!tagNamePattern.test(tagName)) {
			throw new Error('invalid tagName:' + tagName);
		}
		this.tagName = tagName;
	},
	add: function add(qName, value, offset) {
		if (!tagNamePattern.test(qName)) {
			throw new Error('invalid attribute:' + qName);
		}
		this[this.length++] = { qName: qName, value: value, offset: offset };
	},
	length: 0,
	getLocalName: function getLocalName(i) {
		return this[i].localName;
	},
	getLocator: function getLocator(i) {
		return this[i].locator;
	},
	getQName: function getQName(i) {
		return this[i].qName;
	},
	getURI: function getURI(i) {
		return this[i].uri;
	},
	getValue: function getValue(i) {
		return this[i].value;
	}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//			
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
};

function _set_proto_(thiz, parent) {
	thiz.__proto__ = parent;
	return thiz;
}
if (!(_set_proto_({}, _set_proto_.prototype) instanceof _set_proto_)) {
	_set_proto_ = function _set_proto_(thiz, parent) {
		function p() {};
		p.prototype = parent;
		p = new p();
		for (parent in thiz) {
			p[parent] = thiz[parent];
		}
		return p;
	};
}

function split(source, start) {
	var match;
	var buf = [];
	var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
	reg.lastIndex = start;
	reg.exec(source); //skip <
	while (match = reg.exec(source)) {
		buf.push(match);
		if (match[1]) return buf;
	}
}

exports.XMLReader = XMLReader;

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 236 */,
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(69)["default"];
var toPrimitive = __webpack_require__(374);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  &:first-child {\n    margin-top: 1em;\n  }\n  &:last-child {\n    margin-bottom: 1em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var P = _styledComponents["default"].p(_templateObject());

var Span = _styledComponents["default"].span(_templateObject2());

var Credits = /*#__PURE__*/function (_Component) {
  _inherits(Credits, _Component);

  var _super = _createSuper(Credits);

  function Credits() {
    _classCallCheck(this, Credits);

    return _super.apply(this, arguments);
  }

  _createClass(Credits, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          asOfDate = _this$props.asOfDate,
          _this$props$credits = _this$props.credits,
          credits = _this$props$credits === void 0 ? {} : _this$props$credits,
          reviewLabel = _this$props.reviewLabel,
          authorLabel = _this$props.authorLabel,
          currentLabel = _this$props.currentLabel,
          className = _this$props.className,
          otherAttributes = _objectWithoutProperties(_this$props, ["asOfDate", "credits", "reviewLabel", "authorLabel", "currentLabel", "className"]);

      var primaryReviewers = [];
      var secondaryReviewers = [];
      credits.primaryReviewers && credits.primaryReviewers.forEach(function (reviewer) {
        primaryReviewers.push(reviewer.name);
      });
      credits.secondaryReviewers && credits.secondaryReviewers.forEach(function (reviewer) {
        secondaryReviewers.push(reviewer.name);
      });
      var creditsClass = 'hw-structured-content-credits';
      return (/*#__PURE__*/_react["default"].createElement("div", _extends({
          className: className ? className + ' ' + creditsClass : creditsClass
        }, otherAttributes), asOfDate ? /*#__PURE__*/_react["default"].createElement(P, null, /*#__PURE__*/_react["default"].createElement(Span, null, currentLabel, ":"), " ", asOfDate) : '', credits.author && credits.author.name ? /*#__PURE__*/_react["default"].createElement(P, null, /*#__PURE__*/_react["default"].createElement(Span, null, authorLabel, ":"), " ", credits.author.name) : '', primaryReviewers.length ? /*#__PURE__*/_react["default"].createElement(P, null, /*#__PURE__*/_react["default"].createElement(Span, null, reviewLabel, ":"), " ", primaryReviewers.join('; '), secondaryReviewers.length ? ' & ' + secondaryReviewers.join('; ') : '') : '')
      );
    }
  }]);

  return Credits;
}(_react.Component);

Credits.defaultProps = {
  currentLabel: 'Current as of',
  authorLabel: 'Author',
  reviewLabel: 'Medical Review',
  className: null
};
Credits.propTypes = {
  currentLabel: _propTypes["default"].string,
  authorLabel: _propTypes["default"].string,
  reviewLabel: _propTypes["default"].string,
  asOfDate: _propTypes["default"].string,
  className: _propTypes["default"].string,
  credits: _propTypes["default"].shape({
    author: _propTypes["default"].shape({
      name: _propTypes["default"].string
    }),
    primaryReviewers: _propTypes["default"].array,
    secondaryReviewers: _propTypes["default"].array
  })
};
var _default = Credits;
exports["default"] = _default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _MediaCredits = _interopRequireDefault(__webpack_require__(164));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.75em;\n  margin: 0.75em 0 0;\n  padding-left: 0;\n  padding-right: 0;\n  display: block;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0.5em 0;\n  font-size: 1.375em;\n  line-height: 1.1em;\n  font-weight: 400;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 0;\n  padding-right: 0;\n  display: block;\n  margin: 1em 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var SpanAbstract = _styledComponents["default"].span(_templateObject());

var H3Title = _styledComponents["default"].h3(_templateObject2());

var SpanType = _styledComponents["default"].span(_templateObject3());

var Video = _styledComponents["default"].div(_templateObject4());

var MediaServiceVideo = /*#__PURE__*/function (_Component) {
  _inherits(MediaServiceVideo, _Component);

  var _super = _createSuper(MediaServiceVideo);

  function MediaServiceVideo(props) {
    var _this;

    _classCallCheck(this, MediaServiceVideo);

    _this = _super.call(this, props);
    _this.updateVideoHeight = _this.updateVideoHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MediaServiceVideo, [{
    key: "getVideoInformationFromUrl",
    value: function getVideoInformationFromUrl(html) {
      var dom = this.parseHtml(html);
      var src = dom && dom.querySelector('source').getAttribute('src');
      var parts = src.split('/');
      var partsNames = ['version', 'lang', 'id'];
      var partsToReturn = {};
      var partIndex = 0;
      var shouldProcess = false;

      for (var i = 0; i < parts.length; i++) {
        var candidate = parts[i];

        if (shouldProcess) {
          partsToReturn[partsNames[partIndex]] = candidate;
          partIndex++;
        }

        if (candidate.indexOf('cloudfront.net') !== -1) {
          shouldProcess = true;
        }

        if (partIndex === partsNames.length) {
          break;
        }
      }

      return partsToReturn;
    }
  }, {
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    }
  }, {
    key: "updateVideoHeight",
    value: function updateVideoHeight() {
      if (this.videoElement) {
        var box = this.videoWrapperElement.getBoundingClientRect();
        var aspectRatio = 1.77777777778; // 16/9

        if (box.width > 0) {
          var height = box.width / aspectRatio;
          this.videoElement.style.height = height + 'px';
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.updateVideoHeight, this.props.updateTimeout);
      window.addEventListener('resize', this.updateVideoHeight);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateVideoHeight();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          item = _this$props.item,
          hideDisclaimer = _this$props.hideDisclaimer,
          hideAbstract = _this$props.hideAbstract,
          hideType = _this$props.hideType,
          mediaServiceUrl = _this$props.mediaServiceUrl,
          mediaHash = _this$props.mediaHash,
          mediaToken = _this$props.mediaToken,
          videoLabel = _this$props.videoLabel;
      var videoParts = this.getVideoInformationFromUrl(item.html);
      var videoUrl = "".concat(mediaServiceUrl, "/html/").concat(mediaToken, "/").concat(videoParts.id, "/").concat(videoParts.lang, "?autostart=false&rt=").concat(mediaToken, "&hash=").concat(mediaHash, "&disclaimer=false");
      var abstract = null;
      var type = null;
      var titleText = null;
      var titleElement = null;

      if (!hideAbstract) {
        var dom = this.parseHtml("<div>".concat(item.html, "</div>"));
        abstract = /*#__PURE__*/_react["default"].createElement(SpanAbstract, null, item.abstract.consumer);
        titleText = dom.querySelector('h3').firstChild.nodeValue;
        titleElement = /*#__PURE__*/_react["default"].createElement(H3Title, null, dom.querySelector('h3').firstChild.nodeValue);
      }

      if (!hideType) {
        type = /*#__PURE__*/_react["default"].createElement(SpanType, null, videoLabel);
      }

      return (/*#__PURE__*/_react["default"].createElement(Video, {
          ref: function ref(el) {
            _this2.videoWrapperElement = el;
          }
        }, type, titleElement, abstract, /*#__PURE__*/_react["default"].createElement(Video, {
          as: "iframe",
          ref: function ref(el) {
            _this2.videoElement = el;
          },
          title: "Play Video ".concat(titleText),
          className: "hw-slide-video",
          src: videoUrl,
          frameBorder: "0",
          scrolling: "no",
          allowFullScreen: true
        }), /*#__PURE__*/_react["default"].createElement(_MediaCredits["default"], {
          hideDisclaimer: hideDisclaimer,
          asOfDate: item.certifiedDate,
          legal: item.legal || undefined,
          credits: item.credits || undefined,
          transcriptHtml: item.transcript.html
        }))
      );
    }
  }]);

  return MediaServiceVideo;
}(_react.Component);

MediaServiceVideo.propTypes = {
  item: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    legal: _propTypes["default"].object,
    html: _propTypes["default"].string.isRequired,
    duration: _propTypes["default"].string.isRequired,
    transcript: _propTypes["default"].shape({
      html: _propTypes["default"].string
    }).isRequired
  }).isRequired,
  hideDisclaimer: _propTypes["default"].bool,
  hideAbstract: _propTypes["default"].bool,
  hideType: _propTypes["default"].bool,
  updateTimeout: _propTypes["default"].number,
  videoLabel: _propTypes["default"].string,
  mediaServiceUrl: _propTypes["default"].string,
  mediaHash: _propTypes["default"].string,
  mediaToken: _propTypes["default"].string
};
MediaServiceVideo.defaultProps = {
  hideDisclaimer: false,
  hideAbstract: false,
  updateTimeout: 0,
  videoLabel: 'Video'
};
var _default = MediaServiceVideo;
exports["default"] = _default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _Icon = __webpack_require__(165);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1em;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 2em;\n  height: 2em;\n  margin-right: 0.5em;\n  flex: 0 0 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  color: ", ";\n\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var icons = {
  info: _react["default"].createElement(_Icon.InfoIcon, null),
  warning: _react["default"].createElement(_Icon.WarningIcon, null),
  error: _react["default"].createElement(_Icon.WarningIcon, null)
}; // Map align prop to justify-content value

var alignMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};

var Root = _styledComponents["default"].span(_templateObject(), function (props) {
  return alignMap[props.align];
}, (0, _Theme.getThemeVariable)('color'), (0, _Theme.getThemeVariable)('color'));

var Icon = _styledComponents["default"].div(_templateObject2());

var Container = _styledComponents["default"].div(_templateObject3());

var Message = /*#__PURE__*/function (_Component) {
  _inherits(Message, _Component);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, _getPrototypeOf(Message).apply(this, arguments));
  }

  _createClass(Message, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          type = _this$props.type,
          align = _this$props.align,
          showIcon = _this$props.showIcon,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "type", "align", "showIcon", "theme"]);

      return _react["default"].createElement(Root, _extends({
        className: "hw-message-container",
        align: align,
        color: type,
        theme: theme
      }, otherProps), showIcon && _react["default"].createElement(Icon, null, icons[type]), _react["default"].createElement(Container, {
        className: (0, _classnames["default"])('hw-message', "hw-message-".concat(type), className)
      }, children));
    }
  }]);

  return Message;
}(_react.Component);

Message.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  type: _propTypes["default"].oneOf(['info', 'warning', 'error']),
  align: _propTypes["default"].oneOf(['left', 'center', 'right']),
  showIcon: _propTypes["default"].bool,
  theme: _propTypes["default"].shape({
    colorInfo: _propTypes["default"].string,
    colorWarning: _propTypes["default"].string,
    colorError: _propTypes["default"].string
  })
};
Message.defaultProps = {
  type: 'info',
  align: 'left',
  showIcon: true,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Message);

exports["default"] = _default;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 0.3rem;\n  font-size: 0.75em;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: ", ";\n  height: 28px;\n  width: 28px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  opacity: 0;\n  cursor: pointer;\n\n  :focus + ", " {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  :focus:invalid {\n    border-color: ", ";\n  }\n\n  :checked + ", " ", " {\n    display: inline-block;\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n  stroke-width: 1;\n  display: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  stroke: ", ";\n  fill: ", ";\n  stroke-width: 2;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  margin-top: 8px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n\n  opacity: ", ";\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].span(_templateObject(), function (props) {
  return props.readonly || props.disabled ? 0.35 : 1;
}, function (props) {
  return props.readonly || props.disabled ? 'not-allowed' : 'default';
});

var Label = _styledComponents["default"].label(_templateObject2());

var Svg = _styledComponents["default"].svg(_templateObject3(), function (props) {
  return props.forPrint ? '1em' : '28px';
}, function (props) {
  return props.forPrint ? '1em' : '28px';
});

var OuterCircle = _styledComponents["default"].circle(_templateObject4(), function (props) {
  return props.forPrint ? '28px' : 'auto';
}, function (props) {
  return props.forPrint ? '28px' : 'auto';
}, function (props) {
  return props.forPrint ? 'black' : props.theme.colorTextPrimary;
}, function (props) {
  return props.forPrint ? 'white' : 'transparent';
});

var InnerCircle = _styledComponents["default"].circle(_templateObject5(), function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.colorTextPrimary;
});

var Input = _styledComponents["default"].input(_templateObject6(), function (props) {
  return props.forPrint ? 'none' : 'block';
}, Svg, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.theme.colorError;
}, Svg, InnerCircle);

var LabelContent = _styledComponents["default"].span(_templateObject7());

var Radio = /*#__PURE__*/function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, _getPrototypeOf(Radio).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          label = _this$props.label,
          value = _this$props.value,
          isRequired = _this$props.isRequired,
          onClick = _this$props.onClick,
          readonly = _this$props.readonly,
          disabled = _this$props.disabled,
          forPrint = _this$props.forPrint,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["id", "name", "label", "value", "isRequired", "onClick", "readonly", "disabled", "forPrint", "theme"]);

      return _react["default"].createElement(Root, {
        disabled: readonly || disabled,
        className: "hw-radio-wrapper"
      }, _react["default"].createElement(Label, {
        className: "hw-radio-wrapper-label"
      }, _react["default"].createElement(Input, _extends({
        type: "radio",
        id: id,
        name: name,
        value: value,
        required: isRequired,
        className: "hw-radio",
        onClick: onClick,
        disabled: readonly || disabled,
        forPrint: forPrint,
        theme: theme
      }, otherProps)), _react["default"].createElement(Svg, {
        role: "presentation",
        viewBox: "0 0 28 28",
        className: "hw-radio-image",
        focusable: "false",
        forPrint: forPrint
      }, _react["default"].createElement(OuterCircle, {
        className: "hw-radio-outer-circle",
        cx: "14",
        cy: "14",
        r: "9",
        forPrint: forPrint,
        theme: theme
      }), _react["default"].createElement(InnerCircle, {
        className: "hw-radio-checked",
        cx: "14",
        cy: "14",
        r: "5",
        theme: theme
      })), _react["default"].createElement(LabelContent, {
        className: "hw-checkbox-wrapper-label-text"
      }, label)));
    }
  }]);

  return Radio;
}(_react.Component);

Radio.propTypes = {
  id: _propTypes["default"].string,
  isRequired: _propTypes["default"].bool,
  name: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  readonly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  forPrint: _propTypes["default"].bool,
  theme: _propTypes["default"].shape({
    colorTextPrimary: _propTypes["default"].string,
    colorError: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    focusIndicatorOffset: _propTypes["default"].string
  })
};
Radio.defaultProps = {
  isRequired: false,
  readonly: false,
  forPrint: false,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Radio);

exports["default"] = _default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].div(_templateObject());

var ScreenReaderOnly = /*#__PURE__*/function (_Component) {
  _inherits(ScreenReaderOnly, _Component);

  function ScreenReaderOnly() {
    _classCallCheck(this, ScreenReaderOnly);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScreenReaderOnly).apply(this, arguments));
  }

  _createClass(ScreenReaderOnly, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children"]);

      return _react["default"].createElement(Root, _extends({
        className: (0, _classnames["default"])('hw-screen-reader-only', className)
      }, otherProps), children);
    }
  }]);

  return ScreenReaderOnly;
}(_react.Component);

ScreenReaderOnly.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};

var _default = (0, _styledComponents.withTheme)(ScreenReaderOnly);

exports["default"] = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  padding: ", ";\n  font-size: 1.25em;\n  text-align: center;\n  text-decoration: none;\n  border-bottom-width: 4px;\n  border-bottom-style: solid;\n  border-bottom-color: ", ";\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :hover {\n    border-bottom-color: ", ";\n  }\n\n  :focus {\n    outline: ", ";\n  }\n\n  :active {\n    border-bottom-color: ", ";\n  }\n\n  @media screen and (max-width: 750px) {\n    padding: 15px;\n    font-size: 1em;\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    color: ", ";\n    border-bottom-color: ", ";\n\n    :hover,\n    :focus,\n    :active {\n      border-bottom-color: ", ";\n    }\n\n    :focus {\n      outline: solid 2px #fff;\n    }\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    color: #000;\n    border-bottom-color: ", ";\n\n    :hover,\n    :focus,\n    :active {\n      border-bottom-color: ", ";\n    }\n\n    :focus {\n      outline: solid 2px #000;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].a(_templateObject(), function (props) {
  return props.disabled ? props.theme.colorTextDisabled : props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.spacingM;
}, function (props) {
  return props.isActive ? props.theme.colorPrimary : props.visited ? props.theme.colorPrimaryLight : 'transparent';
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
}, function (props) {
  return props.disabled ? 'transparent' : props.theme.colorPrimary;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.disabled ? 'transparent' : props.theme.colorPrimaryDark;
}, function (props) {
  return props.disabled ? '#767676' : '#fff';
}, function (props) {
  return props.isActive ? '#fff' : props.visited ? '#fff' : '#000';
}, function (props) {
  return props.disabled ? '#000' : '#fff';
}, function (props) {
  return props.isActive ? '#000' : props.visited ? '#000' : '#fff';
}, function (props) {
  return props.disabled ? '#fff' : '#000';
});

var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tab).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          href = _this$props.href,
          accessKey = _this$props.accessKey,
          isActive = _this$props.isActive,
          visited = _this$props.visited,
          minWidth = _this$props.minWidth,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className", "href", "accessKey", "isActive", "visited", "minWidth", "disabled", "onClick", "theme"]);

      var tabClassName = (0, _classnames["default"])('hw-tab', {
        'hw-tab-is-active': isActive
      }, className);
      return _react["default"].createElement(Root, _extends({
        className: tabClassName,
        href: href,
        "aria-disabled": disabled,
        accessKey: accessKey,
        onClick: onClick,
        theme: theme,
        visited: visited,
        isActive: isActive,
        disabled: disabled,
        style: {
          minWidth: minWidth
        }
      }, otherProps), _react["default"].createElement("div", null, children));
    }
  }]);

  return Tab;
}(_react.Component);

Tab.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  href: _propTypes["default"].string,
  accessKey: _propTypes["default"].number,
  isActive: _propTypes["default"].bool,
  visited: _propTypes["default"].bool,
  minWidth: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    colorPrimaryLight: _propTypes["default"].string,
    colorPrimary: _propTypes["default"].string,
    colorPrimaryDark: _propTypes["default"].string,
    colorTextPrimary: _propTypes["default"].string,
    colorTextDisabled: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    spacingM: _propTypes["default"].string
  })
};
Tab.defaultProps = {
  isActive: false,
  visited: false,
  disabled: false,
  onClick: null,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Tab);

exports["default"] = _default;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _Message = _interopRequireDefault(__webpack_require__(240));

var _KeyGen = __webpack_require__(53);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.75em;\n  margin-top: 0.25em;\n  line-height: 1.7;\n  letter-spacing: 0.5px;\n  height: 1em;\n  display: inline-block;\n  margin-right: 10px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  padding: 0;\n  min-height: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  padding: 0.5em;\n  margin: 0;\n  border: 1px solid ", ";\n  min-height: 88px;\n  font-size: 1em;\n  line-height: 1.5em;\n  resize: vertical;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  margin-bottom: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.25em;\n  font-size: 0.75em;\n  letter-spacing: 0.5px;\n\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Label = _styledComponents["default"].label(_templateObject());

var Wrapper = _styledComponents["default"].div(_templateObject2());

var TextArea = _styledComponents["default"].textarea(_templateObject3(), function (props) {
  return props.error ? props.theme.colorError : props.theme.colorBorder;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
});

var ReadOnly = (0, _styledComponents["default"])(TextArea)(_templateObject4());

var Subtext = _styledComponents["default"].div(_templateObject5());

var Textarea = /*#__PURE__*/function (_React$Component) {
  _inherits(Textarea, _React$Component);

  function Textarea(props) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Textarea).call(this, props));
    _this.fallbackError = 'Value is unexpected.';
    var validationErrors = Object.assign({
      patternMismatch: 'Value is unexpected.',
      rangeOverflow: 'Value is too large.',
      rangeUnderflow: 'Value is too small.',
      stepMismatch: 'This is an invalid step interval value.',
      tooLong: 'Value is too long.',
      tooShort: 'Value is too short.',
      typeMismatch: 'Value is not the correct format.',
      valueMissing: 'This field is required.',
      fallback: _this.fallbackError
    }, props.validationErrors);
    var hasError = props.error && props.error.length;
    _this.state = {
      isValid: !hasError,
      error: hasError ? props.error : null,
      // error message string
      dirty: hasError,
      validationErrors: validationErrors
    };
    _this.counterId = (0, _KeyGen.getKey)();
    _this.checkValidity = _this.checkValidity.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Textarea, [{
    key: "onFocus",
    value: function onFocus(e) {
      this.setState({
        dirty: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      this.checkValidity(false);
      this.setState({
        dirty: true
      });
      this.props.onBlur(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (this.props.maxCharacters !== null && e.target.value.length >= parseInt(this.props.maxCharacters, 10) && // don't block the delete key
      e.keyCode !== 8) {
        e.preventDefault();
        e.stopPropagation();
      }

      this.props.onKeyDown(e);
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      if (this.charCountElement) {
        this.charCountElement.innerHTML = this.getMaxCharLabel(this.props.maxCharacters, this.props.readonly, e.target.value.length);
      }

      this.props.onChange(e);
    }
  }, {
    key: "getMaxCharLabel",
    value: function getMaxCharLabel(maxChars) {
      var readonly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var numChars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var label = "".concat(maxChars, " character limit");
      return readonly ? label : "".concat(label, " (").concat(numChars, " used)");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.error !== this.props.error) {
        // if error is truthy, fire off an error, otherwise recheck it
        if (this.props.error && this.props.error.length) {
          this.setState({
            isValid: false,
            error: this.props.error,
            dirty: true
          });
        } else {
          this.setState({
            isValid: true,
            error: this.props.error
          }, function () {
            return _this2.checkValidity(false);
          });
        }
      }
    }
  }, {
    key: "checkValidity",
    value: function checkValidity() {
      var calledExternally = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props = this.props,
          error = _this$props.error,
          validators = _this$props.validators,
          onValid = _this$props.onValid,
          onInvalid = _this$props.onInvalid;
      var validationErrors = this.state.validationErrors;
      var fallbackError = this.fallbackError;
      var input = this.input;
      var validity = input.validity;
      var isValid = !error;
      var errorType = error ? 'supplied' : null;
      var errorMessage = error || null; // if there's not an error yet AND the field is dirty AND we have browser support...

      if (isValid && (this.state.dirty || calledExternally) && validity) {
        isValid = validity.valid;
      } // if we're valid so far, run the custom validation


      if (isValid && validators) {
        Object.keys(validators).forEach(function (key) {
          // the "!!" gets us a boolean, regardless of what comes back
          var customIsValid = !!validators[key](input.value);
          isValid = isValid && customIsValid;

          if (!customIsValid) {
            errorType = key;
            errorMessage = validationErrors[key] || validationErrors['fallback'] || fallbackError;
          }
        });
      } // when there's an error


      if (!isValid) {
        // find the right error message
        if (!errorMessage) {
          // try to find a known message (via the HTML5 validity API)
          Object.keys(validationErrors).forEach(function (key) {
            if (typeof validity[key] !== 'undefined' && validity[key] === true) {
              errorType = key;
              errorMessage = validationErrors[key];
            }
          }); // if we can't find one, go with the fallback

          if (!errorMessage) {
            errorType = 'unknown';
            errorMessage = validationErrors.fallback;
          }
        } // invalid callback


        onInvalid(input.value, errorType);
      } else {
        // valid callback
        onValid(input.value);
      }

      this.setState({
        isValid: isValid,
        error: errorMessage,
        dirty: true
      });
      return isValid;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id,
          name = _this$props2.name,
          defaultValue = _this$props2.defaultValue,
          value = _this$props2.value,
          label = _this$props2.label,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          required = _this$props2.required,
          maxCharacters = _this$props2.maxCharacters,
          readonly = _this$props2.readonly,
          theme = _this$props2.theme;
      var isValid = this.state.isValid;
      var characterCounter = '';
      var title = label ? _react["default"].createElement(Label, {
        htmlFor: id,
        className: 'hw-textarea-label',
        "aria-disabled": disabled
      }, label, required && ' *') : null;

      if (maxCharacters) {
        value = value && value.length ? value.substring(0, maxCharacters) : null;
        characterCounter = _react["default"].createElement(Subtext, {
          id: this.counterId,
          ref: function ref(el) {
            _this3.charCountElement = el;
          },
          className: 'hw-textarea-counter'
        }, this.getMaxCharLabel(maxCharacters, readonly));
      }

      var errorLabel = error || !isValid ? _react["default"].createElement(Subtext, {
        className: "hw-text-area-error-container"
      }, _react["default"].createElement(_Message["default"], {
        className: (0, _classnames["default"])('hw-text-area-error', "".concat(className, "-error")),
        type: "error",
        showIcon: false
      }, this.state.error)) : null; // if it's readonly, just display the text

      var textarea = readonly ? _react["default"].createElement(ReadOnly, {
        as: "p",
        className: 'hw-textarea-textarea hw-textarea-textarea-readonly'
      }, value || defaultValue || '') : _react["default"].createElement(Wrapper, {
        className: 'hw-textarea-textarea-wrapper'
      }, _react["default"].createElement(TextArea, {
        className: 'hw-textarea-textarea',
        ref: function ref(el) {
          _this3.input = el;
        },
        id: id,
        name: name,
        defaultValue: defaultValue,
        value: value,
        disabled: disabled,
        error: error || !isValid,
        required: required,
        "aria-required": required,
        "aria-describedby": this.counterId,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        theme: theme
      }), characterCounter, errorLabel);
      return _react["default"].createElement("div", {
        className: 'hw-textarea',
        "aria-disabled": disabled
      }, title, textarea);
    }
  }]);

  return Textarea;
}(_react["default"].Component);

Textarea.propTypes = {
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  value: _propTypes["default"].string,
  label: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  maxCharacters: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  readonly: _propTypes["default"].bool,
  theme: _propTypes["default"].shape({
    colorBorder: _propTypes["default"].string,
    colorError: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    focusIndicatorOffset: _propTypes["default"].string
  })
};
Textarea.defaultProps = {
  id: (0, _KeyGen.getKey)(),
  defaultValue: undefined,
  value: undefined,
  readonly: false,
  disabled: false,
  maxCharacters: null,
  onFocus: function onFocus(e) {
    return e;
  },
  onBlur: function onBlur(e) {
    return e;
  },
  onKeyDown: function onKeyDown(e) {
    return e;
  },
  onChange: function onChange(e) {
    return e;
  },
  onValid: function onValid(val) {
    return val;
  },
  onInvalid: function onInvalid(val, errType) {
    return {
      val: val,
      errType: errType
    };
  },
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Textarea);

exports["default"] = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Healthwise color palette. These variables should NOT be used directly
// in the CSS of applications. Instead they should be used to define color
// variables based on functionality.
var colorPalette = {
  // Primary palette
  primaryLight: '#aae2d0',
  primary: '#0d8484',
  primaryDark: '#006272',
  accent: '#dd372f',
  accentDark: '#a03123',
  skylight: '#00a2c7',
  stormy: '#003a47',
  // Neutral palette
  white: '#fff',
  neutralLighter: '#f4f4f4',
  neutralLight: '#d8d8d8',
  neutral: '#979797',
  neutralMed: '#676767',
  neutralDark: '#424242',
  neutralDarker: '#262626',
  // Accent palette
  yellow: '#ffb71b',
  orange: '#ff6c37',
  green: '#00a887',
  purpleLight: '#e0c7e6',
  purple: '#6c3175',
  blueLight: '#63cfe3',
  blue: '#00a6ce'
};
var _default = colorPalette;
exports["default"] = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defaultTheme = _interopRequireDefault(__webpack_require__(167));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var createTheme = function createTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({}, _defaultTheme["default"], {}, theme);
};

var _default = createTheme;
exports["default"] = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(localization, key) {
  var terms = {
    __TEST__DesiredBehavior: {
      en: 'Desired behavior',
      'en-ca': 'Desired behaviour',
      es: 'Comportamiento deseado',
      fr: 'Comportement souhaité'
    },
    DecisionAid: {
      en: 'Decision Aid',
      es: 'Ayuda a la decisión',
      fr: 'Aide à la décision'
    },
    Loading: {
      en: 'Decision Aid: Loading…'
    }
  };
  var shortLocalization = localization.substr(0, 2);

  if (terms[key] && terms[key][localization]) {
    return terms[key][localization];
  } else if (terms[key] && terms[key][shortLocalization]) {
    return terms[key][shortLocalization];
  }

  return "  [".concat(key, " not defined for ").concat(localization, "]  ");
};

exports["default"] = _default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Content = __webpack_require__(1017);

var _Content2 = _interopRequireDefault(_Content);

var _LearningAssessment = __webpack_require__(454);

var _LearningAssessment2 = _interopRequireDefault(_LearningAssessment);

var _RelatedContent = __webpack_require__(460);

var _RelatedContent2 = _interopRequireDefault(_RelatedContent);

var _HeadingFactory = __webpack_require__(450);

var _HeadingFactory2 = _interopRequireDefault(_HeadingFactory);

var _TabNavigation = __webpack_require__(123);

var _InfoConcept = __webpack_require__(452);

var _InfoConcept2 = _interopRequireDefault(_InfoConcept);

var _CallToAction = __webpack_require__(380);

var _CallToAction2 = _interopRequireDefault(_CallToAction);

var _MediaGallery = __webpack_require__(383);

var _MediaGallery2 = _interopRequireDefault(_MediaGallery);

var _SvgImage = __webpack_require__(122);

var _SvgImage2 = _interopRequireDefault(_SvgImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Content = function (_Component) {
  _inherits(Content, _Component);

  function Content() {
    _classCallCheck(this, Content);

    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
  }

  _createClass(Content, [{
    key: 'shouldShowHeader',
    value: function shouldShowHeader(item, title) {
      return (item.aspect || '').indexOf('[decisionOptions]') === -1;
    }
  }, {
    key: 'getHeadingIconImage',
    value: function getHeadingIconImage(item) {
      var hasHtml = item && item.html;
      var hasIntroHtml = item && Array.isArray(item.content) && item.content.length !== 0 && item.content[0].intro;
      if (!hasHtml && !hasIntroHtml) {
        return null;
      }

      var html = hasIntroHtml ? item.content[0].intro : item.html;
      if (html.indexOf('wIconTitle') === -1) {
        return null;
      }

      var parser = new window.DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var image = doc.querySelector('.HwIconTitle');

      if (!image) {
        image = doc.querySelector('.hwIconTitle');
      }
      var src = image.getAttribute('src');

      if (src) {
        return _react2.default.createElement(_SvgImage2.default, { src: src });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          actionButtons = _props.actionButtons,
          onQuestionRender = _props.onQuestionRender,
          readonly = _props.readonly,
          item = _props.item,
          mediaServiceUrl = _props.mediaServiceUrl,
          mediaHash = _props.mediaHash,
          mediaToken = _props.mediaToken,
          responseState = _props.responseState,
          isSummary = _props.isSummary,
          sectionIndex = _props.sectionIndex,
          resourcesRoot = _props.resourcesRoot,
          location = _props.location,
          navigationInfo = _props.navigationInfo;


      var currentLocation = location || (0, _TabNavigation.GetTopicNavigationInfoByPathName)(navigationInfo, window.location.pathname).tab;
      var image = this.getHeadingIconImage(item);
      var header = this.shouldShowHeader(this.props.item, item.title.consumer) ? _react2.default.createElement(
        _HeadingFactory2.default,
        {
          currentLocation: currentLocation,
          sectionIndex: sectionIndex,
          image: image
        },
        item.title.consumer
      ) : null;

      switch (item.type) {
        case 'hwDecisionComponent':
          return _react2.default.createElement(
            'section',
            { className: _Content2.default.content_section },
            header,
            _react2.default.createElement(_InfoConcept2.default, {
              item: item,
              navigationInfo: navigationInfo,
              title: item.title.consumer,
              currentLocation: currentLocation
            })
          );
        case 'hwDecisionAssessment':
          return _react2.default.createElement(
            'section',
            {
              className: _Content2.default.content_section,
              'data-page-order': this.props['data-page-order']
            },
            header,
            _react2.default.createElement(_LearningAssessment2.default, {
              item: item,
              responseState: responseState,
              onQuestionRender: onQuestionRender,
              readonly: readonly
            })
          );
        case 'hwGallery':
        case 'Gallery':
          return _react2.default.createElement(
            'section',
            {
              className: _Content2.default.content_section + ' ' + _Content2.default.hide_for_print
            },
            header,
            isSummary ? _react2.default.createElement(_RelatedContent2.default, {
              item: item,
              mediaServiceUrl: mediaServiceUrl,
              mediaHash: mediaHash,
              mediaToken: mediaToken
            }) : _react2.default.createElement(_MediaGallery2.default, {
              item: item,
              resourcesRoot: resourcesRoot,
              mediaServiceUrl: mediaServiceUrl,
              mediaHash: mediaHash,
              mediaToken: mediaToken
            })
          );
        case 'hwMessage':
          return _react2.default.createElement(_CallToAction2.default, { item: item, actionButtons: actionButtons });

        default:
          return _react2.default.createElement(
            'div',
            null,
            item.type
          );
      }
    }
  }]);

  return Content;
}(_react.Component);

Content.propTypes = {
  responseState: _propTypes2.default.object,
  navigationInfo: _propTypes2.default.array,
  sectionIndex: _propTypes2.default.number,
  mediaServiceUrl: _propTypes2.default.string,
  mediaHash: _propTypes2.default.string,
  mediaToken: _propTypes2.default.string,
  location: _propTypes2.default.oneOf(_TabNavigation.TabMap),
  resourcesRoot: _propTypes2.default.string,
  item: _propTypes2.default.shape({
    title: _propTypes2.default.shape({
      consumer: _propTypes2.default.string.isRequired
    }).isRequired,
    type: _propTypes2.default.oneOf(['hwDecisionComponent', 'hwDecisionAssessment', 'hwGallery', 'Gallery', 'hwMessage'])
  }).isRequired,
  actionButtons: _propTypes2.default.node,
  onQuestionRender: _propTypes2.default.func,
  readonly: _propTypes2.default.bool,
  isSummary: _propTypes2.default.bool
};

exports.default = Content;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ListItem = __webpack_require__(1024);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          otherAttributes = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        'li',
        _extends({ className: 'hw-list-item ' + _ListItem2.default.list_item }, otherAttributes),
        children
      );
    }
  }]);

  return ListItem;
}(_react.Component);

ListItem.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ListItem;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuestionBlock = __webpack_require__(1027);

var _QuestionBlock2 = _interopRequireDefault(_QuestionBlock);

var _ComponentBuilder = __webpack_require__(61);

var _ComponentBuilder2 = _interopRequireDefault(_ComponentBuilder);

var _ValidationError = __webpack_require__(436);

var _ValidationError2 = _interopRequireDefault(_ValidationError);

var _KeyGen = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuestionBlock = function (_React$Component) {
  _inherits(QuestionBlock, _React$Component);

  function QuestionBlock() {
    _classCallCheck(this, QuestionBlock);

    return _possibleConstructorReturn(this, (QuestionBlock.__proto__ || Object.getPrototypeOf(QuestionBlock)).apply(this, arguments));
  }

  _createClass(QuestionBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          question = _props.question,
          questionId = _props.questionId,
          questionNumber = _props.questionNumber,
          requiredNotice = _props.requiredNotice,
          isRequired = _props.isRequired,
          validationErrorText = _props.validationErrorText,
          otherAttributes = _objectWithoutProperties(_props, ['children', 'question', 'questionId', 'questionNumber', 'requiredNotice', 'isRequired', 'validationErrorText']);

      var questionNumberElement = void 0,
          requiredNoticeElement = void 0,
          requiredIndicator = void 0,
          validationError = void 0;
      if (questionNumber) {
        questionNumberElement = _react2.default.createElement(
          'span',
          { className: 'hw-question-number' },
          _react2.default.createElement(
            'span',
            { className: 'hw-question-number-value' },
            questionNumber
          ),
          _react2.default.createElement(
            'span',
            { className: 'hw-question-dot' },
            '. '
          )
        );
      }

      var questionElement = question;
      if (/^<div(.+)div>$/.test(question)) {
        var componentBuilder = new _ComponentBuilder2.default({
          componentMap: [{
            when: function when(node) {
              return node && (node.tagName || '').toLowerCase() === 'div';
            },
            use: 'span',
            withProps: { className: 'hw-question-text' }
          }]
        });
        questionElement = componentBuilder.build(question);
      } else {
        questionElement = new _ComponentBuilder2.default().build('<span class=\'hw-question-text\'>' + question + '</span>');
      }

      var localClassName = 'hw-question ';
      if (isRequired) {
        requiredNoticeElement = _react2.default.createElement(
          'span',
          { className: _QuestionBlock2.default.common_hidden_text },
          requiredNotice
        );
        requiredIndicator = _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true', className: 'hw-question-required-indicator ' + _QuestionBlock2.default.question_is_required_indicator + (isRequired ? ' ' + _QuestionBlock2.default.question_is_required : '') },
          '*'
        );
        localClassName += 'hw-required ';
        if (validationErrorText) {
          localClassName += _QuestionBlock2.default.invalid;
          validationError = _react2.default.createElement(
            _ValidationError2.default,
            { forId: questionId },
            validationErrorText
          );
        }
      }

      return _react2.default.createElement(
        'fieldset',
        _extends({ className: 'hw-question-block ' + _QuestionBlock2.default.question_block }, otherAttributes),
        _react2.default.createElement(
          'legend',
          _extends({
            className: localClassName + _QuestionBlock2.default.question,
            'data-hw-qnumber': questionNumber,
            'data-hw-qid': questionId,
            id: questionId
          }, otherAttributes),
          validationError,
          requiredIndicator,
          requiredNoticeElement,
          questionNumberElement,
          questionElement
        ),
        children
      );
    }
  }]);

  return QuestionBlock;
}(_react2.default.Component);

QuestionBlock.propTypes = {
  children: _propTypes2.default.node.isRequired,
  requiredNotice: _propTypes2.default.string,
  validationErrorText: _propTypes2.default.string,
  question: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  questionId: _propTypes2.default.string,
  isRequired: _propTypes2.default.bool,
  questionNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

QuestionBlock.defaultProps = {
  questionId: (0, _KeyGen.getKey)(),
  requiredNotice: 'required question',
  isRequired: false
};

exports.default = QuestionBlock;

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade["default"];
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(483));

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _style = _interopRequireDefault(__webpack_require__(731));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(738));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _isOverflowing = _interopRequireDefault(__webpack_require__(486));

var _manageAriaHidden = __webpack_require__(255);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style["default"])(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data) {
  // We are only interested in the actual `style` here because we will override it.
  data.style = {
    overflow: data.container.style.overflow,
    paddingRight: data.container.style.paddingRight
  };
  var style = {
    overflow: 'hidden'
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize["default"])(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(data.container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument["default"])(data.container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    data.container.style[key] = style[key];
  });
}

function removeContainerStyle(data) {
  // The modal might be closed before it had the chance to be mounted in the DOM.
  if (data.style) {
    Object.keys(data.style).forEach(function (key) {
      data.container.style[key] = data.style[key];
    });
  }

  var fixedNodes = (0, _ownerDocument["default"])(data.container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */

var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.data[containerIdx] = {
    //   modals: [],
    //   container,
    //   overflowing,
    //   prevPaddings,
    // }

    this.data = [];
  }

  (0, _createClass2["default"])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        (0, _manageAriaHidden.ariaHidden)(modal.modalRef, false);
      }

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.ariaHiddenSiblings)(container, modal.mountNode, modal.modalRef, true);
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.container === container;
      });

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        container: container,
        overflowing: (0, _isOverflowing["default"])(container),
        prevPaddings: []
      };
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "mount",
    value: function mount(modal) {
      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];

      if (!data.style && this.handleContainerOverflow) {
        setContainerStyle(data);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data);
        } // In case the modal wasn't in the DOM yet.


        if (modal.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(modal.modalRef, true);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.ariaHiddenSiblings)(data.container, modal.mountNode, modal.modalRef, false);
        }

        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = data.modals[data.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(nextTop.modalRef, false);
        }
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports["default"] = _default;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.ariaHiddenSiblings = ariaHiddenSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHideable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, currentNode, callback) {
  var blacklist = [mount, currentNode];
  [].forEach.call(container.children, function (node) {
    if (blacklist.indexOf(node) === -1 && isHideable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function ariaHiddenSiblings(container, mountNode, currentNode, show) {
  siblings(container, mountNode, currentNode, function (node) {
    return ariaHidden(node, show);
  });
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(33));

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning["default"])(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning["default"])(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    if (dangerouslyUseGlobalCSS && styleSheet && styleSheet.options.name) {
      return "".concat(safePrefix(styleSheet.options.name), "-").concat(rule.key);
    }

    if (true) {
      return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
    } // Help with debuggability.


    if (styleSheet && styleSheet.options.classNamePrefix) {
      return "".concat(safePrefix(styleSheet.options.classNamePrefix), "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
  };
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName["default"];
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme["default"];
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset["default"];
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider["default"];
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles["default"];
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles["default"];
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme["default"];
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(256));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(169));

var _jssPreset = _interopRequireDefault(__webpack_require__(258));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(498));

var _createStyles = _interopRequireDefault(__webpack_require__(503));

var _withStyles = _interopRequireDefault(__webpack_require__(87));

var _withTheme = _interopRequireDefault(__webpack_require__(259));

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(756));

var _jssNested = _interopRequireDefault(__webpack_require__(757));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(753));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(755));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(760));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(759));

// Subset of jss-preset-default with only the plugins the Material-UI components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal["default"])(), (0, _jssNested["default"])(), (0, _jssCamelCase["default"])(), (0, _jssDefaultUnit["default"])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0, _jssVendorPrefixer["default"])(), (0, _jssPropsSort["default"])()]
  };
}

var _default = jssPreset;
exports["default"] = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(140));

var _utils = __webpack_require__(45);

var _createMuiTheme = _interopRequireDefault(__webpack_require__(169));

var _themeListener = _interopRequireDefault(__webpack_require__(170));

/* eslint-disable no-underscore-dangle */
var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme["default"])({
    typography: {
      suppressWarning: true
    }
  });
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withThemeOld = function withThemeOld() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2["default"])(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2["default"])(this, WithTheme);
        _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(WithTheme).call(this));
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener["default"].initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2["default"])(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener["default"].subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener["default"].unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2["default"])(_this$props, ["innerRef"]);
          return _react["default"].createElement(Component, (0, _extends2["default"])({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react["default"].Component);

     false ? WithTheme.propTypes = {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
    } : void 0;
    WithTheme.contextTypes = _themeListener["default"].contextTypes;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics["default"])(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};
/* istanbul ignore if */

if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withTheme) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withTheme = withThemeOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.withTheme;
exports["default"] = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(69));

var _warning = _interopRequireDefault(__webpack_require__(33));

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2["default"])(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */

function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning["default"])(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

exports.__esModule = true;
exports["default"] = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(735));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize["default"])(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports["default"] = _default;
module.exports = exports["default"];

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',

    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;

      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _linkRule = __webpack_require__(308);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(108);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */

  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',

    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(776);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(143);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(303);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(763);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(108);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(205);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(306);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(761);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(93);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(304);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(777);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var maxRules = 1e10;

var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(347);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var registeredManagers = {};

var errorCommon = 'a menu outside a mounted Wrapper with an id, or a menu that does not exist';

function registerManager(menuId, manager) {
  registeredManagers[menuId] = manager;
}

function unregisterManager(menuId) {
  delete registeredManagers[menuId];
}

function openMenu(menuId, openOptions) {
  var manager = registeredManagers[menuId];
  if (!manager) throw new Error('Cannot open ' + errorCommon);
  manager.openMenu(openOptions);
}

function closeMenu(menuId, closeOptions) {
  var manager = registeredManagers[menuId];
  if (!manager) throw new Error('Cannot close ' + errorCommon);
  manager.closeMenu(closeOptions);
}

module.exports = {
  registerManager: registerManager,
  unregisterManager: unregisterManager,
  openMenu: openMenu,
  closeMenu: closeMenu
};

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(85);

var _reactRouter = __webpack_require__(159);

var _history = __webpack_require__(231);

var _reactRouterRedux = __webpack_require__(119);

var _configureStore = __webpack_require__(471);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _App = __webpack_require__(467);

var _App2 = _interopRequireDefault(_App);

var _EsdpMap = __webpack_require__(468);

var _EsdpMap2 = _interopRequireDefault(_EsdpMap);

var _Topic = __webpack_require__(469);

var _Topic2 = _interopRequireDefault(_Topic);

var _styledComponents = __webpack_require__(7);

var _theme = __webpack_require__(168);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Esdp = function (_Component) {
  _inherits(Esdp, _Component);

  function Esdp() {
    _classCallCheck(this, Esdp);

    return _possibleConstructorReturn(this, (Esdp.__proto__ || Object.getPrototypeOf(Esdp)).apply(this, arguments));
  }

  _createClass(Esdp, [{
    key: 'render',
    value: function render() {
      // set up routing
      var routeName = this.props.baseRoute;
      var pathLocation = window.location.pathname.indexOf(routeName);
      var routeRoot = window.location.pathname.slice(0, pathLocation + routeName.length);
      var routedHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
        basename: routeRoot
      });

      // set up store
      var preloadedState = this.props.preloadedState || window && window.hwPreloadedState || hwPreloadedState || {}; // eslint-disable-line
      var store = (0, _configureStore2.default)(routedHistory, preloadedState);

      var history = (0, _reactRouterRedux.syncHistoryWithStore)(routedHistory, store);

      return _react2.default.createElement(
        _styledComponents.ThemeProvider,
        { theme: _theme2.default.defaultTheme },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: store },
          _react2.default.createElement(
            _reactRouter.Router,
            { history: history },
            _react2.default.createElement(
              _reactRouter.Route,
              { path: '/', component: _App2.default },
              _react2.default.createElement(
                _reactRouter.Route,
                { path: '/mock' },
                _react2.default.createElement(
                  _reactRouter.Route,
                  { path: ':mapId/:localization', component: _EsdpMap2.default },
                  _react2.default.createElement(_reactRouter.Route, { path: ':topicId', component: _Topic2.default })
                )
              ),
              _react2.default.createElement(
                _reactRouter.Route,
                { path: ':mapId/:localization', component: _EsdpMap2.default },
                _react2.default.createElement(_reactRouter.Route, { path: ':topicId', component: _Topic2.default })
              )
            )
          )
        )
      );
    }
  }]);

  return Esdp;
}(_react.Component);

exports.default = Esdp;


Esdp.propTypes = {
  baseRoute: _propTypes2.default.string.isRequired,
  preloadedState: _propTypes2.default.shape({
    prescriptionInfo: _propTypes2.default.shape({
      consumerId: _propTypes2.default.string,
      prescriptionId: _propTypes2.default.string,
      contentItemId: _propTypes2.default.string,
      parent: _propTypes2.default.string,
      mediaServiceUrl: _propTypes2.default.string,
      mediaToken: _propTypes2.default.string,
      mediaHash: _propTypes2.default.string,
      token: _propTypes2.default.string,
      localization: _propTypes2.default.string,
      applicationUrl: _propTypes2.default.string,
      resourcesRoot: _propTypes2.default.string
    }),
    serviceInfo: _propTypes2.default.shape({
      isMocked: _propTypes2.default.bool,
      token: _propTypes2.default.string,
      contentServiceUrl: _propTypes2.default.string,
      consumerServiceUrl: _propTypes2.default.string,
      atomicFireballServiceUrl: _propTypes2.default.string,
      notificationServiceUrl: _propTypes2.default.string
    })
  })
};

Esdp.defaultProps = {
  baseRoute: '/'
};

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(69)["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(69)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(376);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Div = _styledComponents["default"].div(_templateObject());

var Action = /*#__PURE__*/function (_React$Component) {
  _inherits(Action, _React$Component);

  var _super = _createSuper(Action);

  function Action() {
    _classCallCheck(this, Action);

    return _super.apply(this, arguments);
  }

  _createClass(Action, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          otherProps = _objectWithoutProperties(_this$props, ["data"]);

      var outerClasses = 'hw-content-action';
      return (/*#__PURE__*/_react["default"].createElement(Div, _extends({
          className: outerClasses
        }, otherProps, {
          dangerouslySetInnerHTML: {
            __html: data.html
          }
        }))
      );
    }
  }]);

  return Action;
}(_react["default"].Component);

Action.propTypes = {
  data: _propTypes["default"].shape({
    html: _propTypes["default"].string
  })
};
var _default = Action;
exports["default"] = _default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = __webpack_require__(7);

var _Insights = _interopRequireDefault(__webpack_require__(70));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .hw-article-style .HwImageWrapper {\n    display: inline;\n    float: right;\n    padding: 0 0 1em 1em;\n  }\n  .hw-article-style li .HwCmd {\n    display: inline;\n    font-weight: bold;\n  }\n  .hw-article-style li .HwInfo {\n    padding-left: 30px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject());

var Article = /*#__PURE__*/function (_Component) {
  _inherits(Article, _Component);

  var _super = _createSuper(Article);

  function Article(props) {
    var _this;

    _classCallCheck(this, Article);

    _this = _super.call(this, props);
    _this.insights = new _Insights["default"]();
    _this.state = {
      sections: props.productMap && props.productMap.topics
    };
    return _this;
  }

  _createClass(Article, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.productMap !== this.props.productMap) {
        this.setState({
          sections: nextProps.productMap.topics
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var sections = this.state.sections;

      if (sections && sections.length) {
        return (/*#__PURE__*/_react["default"].createElement("div", {
            className: "hw-article-style"
          }, /*#__PURE__*/_react["default"].createElement(GlobalStyle, null), sections.map(function (item, i) {
            return (/*#__PURE__*/_react["default"].createElement("div", {
                key: i,
                dangerouslySetInnerHTML: {
                  __html: item.html
                }
              })
            );
          }))
        );
      }
    }
  }]);

  return Article;
}(_react.Component);

Article.propTypes = {
  productMap: _propTypes["default"].shape({
    topics: _propTypes["default"].array
  })
};
var _default = Article;
exports["default"] = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _SvgImage = _interopRequireDefault(__webpack_require__(122));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  padding: 14px 24px 24px;\n  text-align: center;\n  background-color: ", ";\n\n  & h3 {\n    margin-top: 23px;\n    margin-left: 65px;\n    font-size: 2em;\n    line-height: 1em;\n    font-weight: normal;\n    color: ", ";\n  }\n\n  & img,\n  & svg {\n    position: absolute;\n    top: 27px;\n    max-width: 48px !important;\n    max-height: 48px;\n  }\n\n  & p {\n    font-size: 1em;\n    line-height: 1.33;\n    color: ", ";\n  }\n\n  & button {\n    margin-right: 0.5em;\n    margin-bottom: 0.5em;\n    font-size: 1.5em;\n    border-radius: 0.25em;\n    border-color: transparent;\n    color: ", ";\n    background: ", ";\n  }\n\n  & button:hover {\n    color: ", ";\n    background: ", ";\n  }\n\n  @media screen and (max-width: 750px) {\n    & h3 {\n      margin-top: 26px;\n    }\n  }\n\n  @media print {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 0.75em;\n  text-align: left;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var TextWrapperDiv = _styledComponents["default"].div(_templateObject());

var WrapperSection = _styledComponents["default"].section(_templateObject2(), function (props) {
  return props.theme.colorBackground;
}, function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.colorTextOnPrimary;
}, function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return props.theme.colorTextOnPrimaryLight;
}, function (props) {
  return props.theme.colorPrimaryLight;
});

var CallToAction = /*#__PURE__*/function (_Component) {
  _inherits(CallToAction, _Component);

  var _super = _createSuper(CallToAction);

  function CallToAction(props) {
    var _this;

    _classCallCheck(this, CallToAction);

    _this = _super.call(this, props);
    _this.renderHtmlParts = _this.renderHtmlParts.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CallToAction, [{
    key: "parseHtml",
    value: function parseHtml() {
      var elements = {};

      if (this.props.item && this.props.item.html) {
        var parser = new window.DOMParser();
        var doc = parser.parseFromString(this.props.item.html, 'text/html'); // TODO: temporary logic until we get one consistent format

        var title = doc.querySelector('h3') || doc.querySelector('head title');
        var img = doc.querySelector('img');
        var paragraphs = doc.querySelectorAll('p');

        if (title) {
          elements['title'] = /*#__PURE__*/_react["default"].createElement("h3", null, title.innerHTML);
        }

        if (img) {
          elements['img'] = /*#__PURE__*/_react["default"].createElement(_SvgImage["default"], {
            src: img.getAttribute('src')
          });
        }

        if (paragraphs) {
          elements.paragraphs = [];

          for (var i = 0; i < paragraphs.length; i++) {
            var newArray = elements.paragraphs;
            newArray.push( /*#__PURE__*/_react["default"].createElement("p", {
              key: 'cta_para_' + newArray.length
            }, paragraphs[i].innerHTML));
          }
        }
      }

      return elements;
    }
  }, {
    key: "renderHtmlParts",
    value: function renderHtmlParts() {
      var elements = this.parseHtml();
      return (/*#__PURE__*/_react["default"].createElement(TextWrapperDiv, null, elements.title, elements.img, elements.paragraphs)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var renderHtmlParts = this.renderHtmlParts;
      var wrapperClasses = (0, _classnames["default"])({
        'hw-call-to-action': true
      });
      return (/*#__PURE__*/_react["default"].createElement(WrapperSection, {
          className: wrapperClasses
        }, renderHtmlParts(), this.props.actionButtons)
      );
    }
  }]);

  return CallToAction;
}(_react.Component);

CallToAction.propTypes = {
  item: _propTypes["default"].object,
  actionButtons: _propTypes["default"].node
}; // CallToAction.defaultProps = {
//   theme: defaultTheme,
// }

var _default = (0, _styledComponents.withTheme)(CallToAction);

exports["default"] = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

var _Credits = _interopRequireDefault(__webpack_require__(238));

var _References = _interopRequireDefault(__webpack_require__(431));

var _KeyGen = __webpack_require__(53);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 19px 0 0;\n\n  & p {\n    font-size: 0.8em;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  background: transparent;\n  border: none;\n  color: #017acd;\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    outline: 2px #017acd solid;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 16px;\n  padding: 0 4px 4px 0;\n  & svg {\n    width: 100%;\n  }\n  & svg path {\n    fill: #017acd;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var SpanIcon = _styledComponents["default"].span(_templateObject());

var Button = _styledComponents["default"].button(_templateObject2());

var Div = _styledComponents["default"].div(_templateObject3());

var CreditsAndReferences = /*#__PURE__*/function (_Component) {
  _inherits(CreditsAndReferences, _Component);

  var _super = _createSuper(CreditsAndReferences);

  function CreditsAndReferences(props) {
    var _this;

    _classCallCheck(this, CreditsAndReferences);

    _this = _super.call(this, props);
    _this.toggleCredits = _this.toggleCredits.bind(_assertThisInitialized(_this));
    _this.getIcon = _this.getIcon.bind(_assertThisInitialized(_this));
    _this.renderRegion = _this.renderRegion.bind(_assertThisInitialized(_this));
    _this.state = {
      showCredits: false
    };
    return _this;
  }

  _createClass(CreditsAndReferences, [{
    key: "toggleCredits",
    value: function toggleCredits() {
      this.setState({
        showCredits: !this.state.showCredits
      });
    }
  }, {
    key: "getIcon",
    value: function getIcon(id) {
      if (this.state.showCredits) {
        return (/*#__PURE__*/_react["default"].createElement(SpanIcon, null, /*#__PURE__*/_react["default"].createElement("title", null, "Close"), /*#__PURE__*/_react["default"].createElement("svg", {
            role: "presentation",
            focusable: "false",
            xmlns: "http://www.w3.org/2000/svg",
            width: "10",
            height: "5",
            viewBox: "0 0 10 5"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            d: "M0 5l5-5 5 5",
            fillRule: "evenodd"
          })))
        );
      }

      return (/*#__PURE__*/_react["default"].createElement(SpanIcon, null, /*#__PURE__*/_react["default"].createElement("svg", {
          role: "presentation",
          focusable: "false",
          xmlns: "http://www.w3.org/2000/svg",
          width: "10",
          height: "5",
          viewBox: "0 0 10 5"
        }, /*#__PURE__*/_react["default"].createElement("title", null, "Open"), /*#__PURE__*/_react["default"].createElement("path", {
          d: "M10 0H0l5 5",
          fillRule: "evenodd"
        })))
      );
    }
  }, {
    key: "renderRegion",
    value: function renderRegion(id) {
      var _this$props = this.props,
          asOfDate = _this$props.asOfDate,
          credits = _this$props.credits,
          references = _this$props.references,
          referencesLabel = _this$props.referencesLabel;
      var template = '';
      var referenceElement = references && references.length ? /*#__PURE__*/_react["default"].createElement(_References["default"], {
        references: references,
        referencesLabel: referencesLabel
      }) : null;
      template = this.state.showCredits || this.props.readOnly ? /*#__PURE__*/_react["default"].createElement("div", {
        id: id,
        role: "region",
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-expanded": this.state.showCredits
      }, /*#__PURE__*/_react["default"].createElement(_Credits["default"], {
        asOfDate: asOfDate,
        credits: credits
      }), referenceElement) : '';
      return template;
    }
  }, {
    key: "render",
    value: function render() {
      var creditsId = this.props.id || (0, _KeyGen.getKey)();
      var toggleButton = this.props.readOnly ? /*#__PURE__*/_react["default"].createElement("h3", null, this.props.buttonLabel) : /*#__PURE__*/_react["default"].createElement(Button, {
        "aria-controls": creditsId,
        type: "button",
        onClick: this.toggleCredits
      }, this.getIcon(), /*#__PURE__*/_react["default"].createElement("span", null, this.props.buttonLabel));
      return (/*#__PURE__*/_react["default"].createElement(Div, null, /*#__PURE__*/_react["default"].createElement("div", null, toggleButton), this.renderRegion(creditsId))
      );
    }
  }]);

  return CreditsAndReferences;
}(_react.Component);

CreditsAndReferences.defaultProps = {
  buttonLabel: 'Credits and References'
};
CreditsAndReferences.propTypes = {
  id: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  asOfDate: _propTypes["default"].string,
  buttonLabel: _propTypes["default"].string,
  credits: _propTypes["default"].object,
  referencesLabel: _propTypes["default"].string,
  references: _propTypes["default"].array
};
var _default = CreditsAndReferences;
exports["default"] = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _MediaCredits = _interopRequireDefault(__webpack_require__(164));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

var Image = /*#__PURE__*/function (_Component) {
  _inherits(Image, _Component);

  var _super = _createSuper(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, props);
    _this.parseHtml = _this.parseHtml.bind(_assertThisInitialized(_this));
    _this.remapHtmlStructure = _this.remapHtmlStructure.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Image, [{
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    } // The entire point of this function is to give us a similar structure to a slideshow
    // slide. It wraps the image and paragraph(s) with <div class="HwInfo"></div>

  }, {
    key: "remapHtmlStructure",
    value: function remapHtmlStructure(html) {
      var serializer = new window.XMLSerializer();
      var dom = this.parseHtml(html);
      var imgContainers = dom.querySelectorAll('.HwImageWrapper');
      var section = dom.querySelector('.HwSection');
      var wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'HwInfo'); // find the first image wrapper and insert the wrapper div before it

      imgContainers[0].parentNode.insertBefore(wrapper, imgContainers[0]); // move the image wrapper(s) into it

      for (var i = 0; i < imgContainers.length; i++) {
        wrapper.appendChild(imgContainers[i]);
      } // move the section (with paragraphs) into it


      wrapper.appendChild(section);
      return serializer.serializeToString(dom);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          hideDisclaimer = _this$props.hideDisclaimer;
      return (/*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          dangerouslySetInnerHTML: {
            __html: this.remapHtmlStructure(item.html)
          }
        }), /*#__PURE__*/_react["default"].createElement(_MediaCredits["default"], {
          hideDisclaimer: hideDisclaimer,
          asOfDate: item.certifiedDate,
          legal: item.legal,
          credits: item.credits
        }))
      );
    }
  }]);

  return Image;
}(_react.Component);

Image.defaultProps = {
  hideDisclaimer: false
};
Image.propTypes = {
  item: _propTypes["default"].object,
  hideDisclaimer: _propTypes["default"].bool
};
var _default = Image;
exports["default"] = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Insights = _interopRequireDefault(__webpack_require__(70));

var _Slideshow = _interopRequireDefault(__webpack_require__(384));

var _MediaServiceVideo = _interopRequireDefault(__webpack_require__(239));

var _Image = _interopRequireDefault(__webpack_require__(382));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 84px;\n  height: 56px;\n  border: 1px solid #017acd;\n  cursor: pointer;\n\n  &:focus,\n  &:hover {\n    border: 1px solid #99caeb;\n    outline: 2px solid #000;\n  }\n\n  & img {\n    width: 84px;\n    height: 56px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 84px;\n  height: 56px;\n  border: 1px solid #abb2c1;\n  cursor: pointer;\n\n  &:focus,\n  &:hover {\n    border: 1px solid #99caeb;\n    outline: 2px solid #000;\n  }\n\n  & img {\n    width: 84px;\n    height: 56px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  & li {\n    display: inline-block;\n    margin-right: 4px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 48px;\n  margin-bottom: 40px;\n\n  @media screen and (max-width: 750px) {\n    padding: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 25%;\n  left: 25%;\n  width: 50%;\n  height: 50%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .hw-section-gallery-style h3,\n  .hw-section-gallery-style .HwCmd {\n    margin: 0.5em 0;\n    font-size: 1.375em;\n    line-height: 1.1em;\n    font-weight: normal;\n    color: #212121;\n  }\n\n  .hw-section-gallery-style .HwInfo,\n  .hw-section-gallery-style .HwVideo {\n    padding: 8px;\n    border: 1px solid #abb2c1;\n    line-height: 0;\n  }\n\n  .hw-section-gallery-style .HwInfo {\n    text-align: center;\n  }\n\n  .hw-section-gallery-style .HwInfo p,\n  .hw-section-gallery-style .HwVideo p {\n    padding: 0 8px;\n    line-height: 1.3em;\n    text-align: left;\n  }\n\n  .hw-section-gallery-style .HwImageWrapper {\n    display: inline-block;\n    width: 50%;\n    padding: 8px;\n    box-sizing: border-box;\n    text-align: center;\n  }\n\n  .hw-section-gallery-style .HwImageWrapper:only-of-type {\n    float: none;\n    width: 100%;\n  }\n\n  .hw-section-gallery-style .HwImageWrapper img {\n    max-width: 100%;\n  }\n\n  .hw-section-gallery-style .HwInfo .HwSection {\n    clear: both;\n  }\n\n  @media screen and (max-width: 750px) {\n    .hw-section-gallery-style .HwImageWrapper {\n      float: none;\n      width: 100%;\n    }\n\n    .hw-section-gallery-style .HwMedicalImage {\n      width: 100%;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject());

var SvgVideoThumbnailOverlay = _styledComponents["default"].svg(_templateObject2());

var SectionGallery = _styledComponents["default"].section(_templateObject3());

var UlList = _styledComponents["default"].ul(_templateObject4());

var ThumbnailButton = _styledComponents["default"].button(_templateObject5());

var ActiveThumbnailButton = _styledComponents["default"].button(_templateObject6());

var MediaGallery = /*#__PURE__*/function (_Component) {
  _inherits(MediaGallery, _Component);

  var _super = _createSuper(MediaGallery);

  function MediaGallery(props) {
    var _this;

    _classCallCheck(this, MediaGallery);

    _this = _super.call(this, props);
    _this.onThumbnailClick = _this.onThumbnailClick.bind(_assertThisInitialized(_this));
    _this.onSlideSelected = _this.onSlideSelected.bind(_assertThisInitialized(_this));
    _this.parseHtml = _this.parseHtml.bind(_assertThisInitialized(_this));
    _this.slideClass = 'mediaGallerySlide_';
    _this.insights = new _Insights["default"]();
    _this.state = {
      currentSlide: 0
    };
    return _this;
  }

  _createClass(MediaGallery, [{
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    }
  }, {
    key: "getUrlFromDomString",
    value: function getUrlFromDomString(html) {
      var dom = this.parseHtml(html);
      var src = dom && dom.querySelector('img').getAttribute('src');
      var dotIndex = src.lastIndexOf('.');
      return src && src.substring(0, dotIndex) + '_tt' + src.substring(dotIndex);
    }
  }, {
    key: "onThumbnailClick",
    value: function onThumbnailClick(index, item) {
      var _this2 = this;

      var gallery = this.props.item;
      var galleryTypes = {
        hwVideo: 'video',
        hwSlideshow: 'slideshow',
        'Product Map': 'article',
        hwMedia: 'image'
      };
      var insightsObj = {
        pageName: document.title,
        eventName: 'galleryNav',
        galleryHwid: gallery.id,
        thumbnailType: galleryTypes[item.type],
        targetHwid: item.id,
        targetTitle: item.title.consumer,
        navIndex: index + 1,
        navItems: gallery.topics.length
      };
      this.insights.trackEvent(insightsObj);
      this.setState({
        currentSlide: index
      }, function () {
        // this focuses the slide on click, for accessibility/screen reader purposes
        _this2.slide.focus();
      }); // fire props callback

      this.props.onThumbnailClick(index + 1, item);
    }
  }, {
    key: "onSlideSelected",
    value: function onSlideSelected(index, item) {
      // fire props callback
      this.props.onSlideSelected(index, item);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          item = _this$props.item,
          mediaHash = _this$props.mediaHash,
          mediaServiceUrl = _this$props.mediaServiceUrl,
          mediaToken = _this$props.mediaToken;
      var onThumbnailClick = this.onThumbnailClick;
      var onSlideSelected = this.onSlideSelected;
      var itemList = item;

      if (item && item.topics) {
        var slides = [];
        var thumbnails = [];
        var currentSlide = itemList.topics.length > this.state.currentSlide ? this.state.currentSlide : 0;
        itemList.topics.forEach(function (item, i) {
          var activeThumbnail = currentSlide === i ? true : false;
          var userIndex = i + 1;

          switch (item.type) {
            case 'hwVideo':
              thumbnails.push( /*#__PURE__*/_react["default"].createElement("li", {
                key: i
              }, activeThumbnail ? /*#__PURE__*/_react["default"].createElement(ActiveThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: item.thumbnail,
                alt: "load video, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }), /*#__PURE__*/_react["default"].createElement(SvgVideoThumbnailOverlay, {
                role: "presentation",
                focusable: "false",
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
              }, /*#__PURE__*/_react["default"].createElement("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd"
              }, /*#__PURE__*/_react["default"].createElement("rect", {
                fillOpacity: "0.8",
                fill: "#017ACD",
                x: "0",
                y: "0",
                width: "40",
                height: "40"
              }), /*#__PURE__*/_react["default"].createElement("g", {
                transform: "translate(12.5, 12.5)",
                fill: "#FAFAFA"
              }, /*#__PURE__*/_react["default"].createElement("polygon", {
                points: "5 3.125 5 11.875 11.875 7.5"
              }))))) : /*#__PURE__*/_react["default"].createElement(ThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: item.thumbnail,
                alt: "load video, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }), /*#__PURE__*/_react["default"].createElement(SvgVideoThumbnailOverlay, {
                role: "presentation",
                focusable: "false",
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
              }, /*#__PURE__*/_react["default"].createElement("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd"
              }, /*#__PURE__*/_react["default"].createElement("rect", {
                fillOpacity: "0.8",
                fill: "#017ACD",
                x: "0",
                y: "0",
                width: "40",
                height: "40"
              }), /*#__PURE__*/_react["default"].createElement("g", {
                transform: "translate(12.5, 12.5)",
                fill: "#FAFAFA"
              }, /*#__PURE__*/_react["default"].createElement("polygon", {
                points: "5 3.125 5 11.875 11.875 7.5"
              })))))));
              slides.push( /*#__PURE__*/_react["default"].createElement("div", {
                className: "slide",
                key: i
              }, /*#__PURE__*/_react["default"].createElement(_MediaServiceVideo["default"], {
                hideDisclaimer: true,
                item: item,
                mediaServiceUrl: mediaServiceUrl,
                mediaHash: mediaHash,
                mediaToken: mediaToken
              })));
              break;

            case 'hwSlideshow':
              var slideshowThumbSrc = _this3.getUrlFromDomString(item.html);

              thumbnails.push( /*#__PURE__*/_react["default"].createElement("li", {
                key: i
              }, activeThumbnail ? /*#__PURE__*/_react["default"].createElement(ActiveThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: slideshowThumbSrc,
                alt: "load slideshow, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              })) : /*#__PURE__*/_react["default"].createElement(ThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: slideshowThumbSrc,
                alt: "load slideshow, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }))));
              slides.push( /*#__PURE__*/_react["default"].createElement("div", {
                className: "slide",
                key: i
              }, /*#__PURE__*/_react["default"].createElement(_Slideshow["default"], {
                hideDisclaimer: true,
                item: item,
                onSlideSelected: onSlideSelected
              })));
              break;

            case 'hwMedia':
              var mediaThumbSrc = _this3.getUrlFromDomString(item.html);

              thumbnails.push( /*#__PURE__*/_react["default"].createElement("li", {
                key: i
              }, activeThumbnail ? /*#__PURE__*/_react["default"].createElement(ActiveThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: mediaThumbSrc,
                alt: "load image, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              })) : /*#__PURE__*/_react["default"].createElement(ThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react["default"].createElement("img", {
                src: mediaThumbSrc,
                alt: "load image, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }))));
              slides.push( /*#__PURE__*/_react["default"].createElement("div", {
                className: "slide",
                key: i
              }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
                hideDisclaimer: true,
                item: item
              })));
              break;

            default:
          }
        });
        return (/*#__PURE__*/_react["default"].createElement(SectionGallery, {
            className: "hw-section-gallery-style"
          }, /*#__PURE__*/_react["default"].createElement(GlobalStyle, null), /*#__PURE__*/_react["default"].createElement(UlList, {
            className: "ulist"
          }, thumbnails), /*#__PURE__*/_react["default"].createElement("div", {
            id: "hwGallery_slide",
            "aria-live": "polite",
            tabIndex: "-1",
            ref: function ref(div) {
              _this3.slide = div;
            }
          }, slides[currentSlide]))
        );
      } else {
        return null;
      }
    }
  }]);

  return MediaGallery;
}(_react.Component);

MediaGallery.propTypes = {
  item: _propTypes["default"].object.isRequired,
  onThumbnailClick: _propTypes["default"].func,
  mediaServiceUrl: _propTypes["default"].string,
  mediaHash: _propTypes["default"].string,
  mediaToken: _propTypes["default"].string,
  onSlideSelected: _propTypes["default"].func
};
MediaGallery.defaultProps = {
  onThumbnailClick: function onThumbnailClick() {},
  onSlideSelected: function onSlideSelected() {}
};
var _default = MediaGallery;
exports["default"] = _default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireDefault(__webpack_require__(7));

var _Insights = _interopRequireDefault(__webpack_require__(70));

var _MediaCredits = _interopRequireDefault(__webpack_require__(164));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  font-size: 1em;\n  text-align: center;\n  padding-left: 0;\n  padding-right: 0;\n  background: #fff;\n  border: 1px solid #abb2c1;\n  border-radius: 1px;\n\n  &:focus,\n  &:hover {\n    background: #99caeb;\n    outline: solid 1px #000;\n    outline-offset: 1px;\n    cursor: pointer;\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #000;\n    border: 1px solid #fff;\n\n    &:focus,\n    &:hover {\n      background: #fff;\n      color: #000;\n    }\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #fff;\n    border: 1px solid #000;\n\n    &:focus,\n    &:hover {\n      background: #000;\n      color: #fff;\n    }\n  }\n\n  background: #017acd;\n  border: 1px solid #abb2c1;\n  color: #fff;\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #fff;\n    border: 1px solid #000;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #000;\n    border: 1px solid #fff;\n    color: #fff;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  font-size: 1em;\n  text-align: center;\n  padding-left: 0;\n  padding-right: 0;\n  background: #fff;\n  border: 1px solid #abb2c1;\n  border-radius: 1px;\n\n  &:focus,\n  &:hover {\n    background: #99caeb;\n    outline: solid 1px #000;\n    outline-offset: 1px;\n    cursor: pointer;\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #000;\n    border: 1px solid #fff;\n\n    &:focus,\n    &:hover {\n      background: #fff;\n      color: #000;\n    }\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #fff;\n    border: 1px solid #000;\n\n    &:focus,\n    &:hover {\n      background: #000;\n      color: #fff;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  & li {\n    display: inline-block;\n    margin-right: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var UlNav = _styledComponents["default"].span(_templateObject());

var NavItemButton = _styledComponents["default"].button(_templateObject2());

var NavItemActiveButton = _styledComponents["default"].button(_templateObject3());
/* ensures that larger images don't exceed the slideshow wrapper */

var SlideshowDiv = _styledComponents["default"].div(_templateObject4());

var Slideshow = /*#__PURE__*/function (_Component) {
  _inherits(Slideshow, _Component);

  var _super = _createSuper(Slideshow);

  function Slideshow(props) {
    var _this;

    _classCallCheck(this, Slideshow);

    _this = _super.call(this, props);

    if (props.item) {
      var html = _this.parseHtml(props.item.html);

      var lis = html.querySelectorAll('li'); // set up component state so we can retain the selected thumbnail

      _this.state = {
        currentSlide: 0,
        lis: lis
      };
      _this.insights = new _Insights["default"]();
      _this.onNavClick = _this.onNavClick.bind(_assertThisInitialized(_this));
      _this.renderSlide = _this.renderSlide.bind(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(Slideshow, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.item && nextProps.item.html !== this.props.item.html) {
        var html = this.parseHtml(nextProps.item.html);
        var lis = html.querySelectorAll('li');
        this.setState({
          lis: lis
        });
      }
    }
  }, {
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    }
  }, {
    key: "onNavClick",
    value: function onNavClick(index) {
      var item = this.props.item;
      var slide = this.state.lis[index];
      var slideTitle = slide.querySelector('.HwCmd').innerText; // this parses out the GUID from the IMG src

      var slideSrc = slide.querySelector('img').src;
      var slideHwidWithExt = slideSrc.substring(slideSrc.lastIndexOf('/') + 1);
      var slideHwid = slideHwidWithExt.split('.')[0];
      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'slideshowAction',
        slideshowHwid: item.id,
        slideHwid: slideHwid,
        slideTitle: slideTitle,
        slideIndex: index + 1,
        slideshowItems: this.state.lis.length
      });
      this.props.onSlideSelected(index + 1, item);
      this.setState({
        currentSlide: index
      });
    }
  }, {
    key: "renderSlide",
    value: function renderSlide() {
      var lis = this.state.lis;

      if (lis.length) {
        return (/*#__PURE__*/_react["default"].createElement("div", {
            className: "hw-sc-slideshow-slide",
            dangerouslySetInnerHTML: {
              __html: lis[this.state.currentSlide].innerHTML
            }
          })
        );
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var onNavClick = this.onNavClick;
      var len = this.state.lis.length;
      var current = this.state.currentSlide + 1;
      var navLis = [];

      if (len > 1) {
        var _loop = function _loop() {
          var num = i;
          var currentItem = i === current;
          /* eslint-disable react/jsx-no-bind */

          navLis.push( /*#__PURE__*/_react["default"].createElement("li", {
            key: 'nav_' + i
          }, currentItem ? /*#__PURE__*/_react["default"].createElement(NavItemActiveButton, {
            type: "button",
            onClick: function onClick() {
              onNavClick(num - 1);
            }
          }, i) : /*#__PURE__*/_react["default"].createElement(NavItemButton, {
            type: "button",
            onClick: function onClick() {
              onNavClick(num - 1);
            }
          }, i)));
          /* eslint-enable react/jsx-no-bind */
        };

        for (var i = 1; i <= len; i++) {
          _loop();
        }
      }

      return (/*#__PURE__*/_react["default"].createElement(UlNav, null, navLis)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          hideDisclaimer = _this$props.hideDisclaimer;
      var toReturn = null;
      var previewItems = [];
      this.state.lis.forEach(function (element, i) {
        var src = element.querySelector('img').src;
        previewItems.push( /*#__PURE__*/_react["default"].createElement("img", {
          src: src,
          alt: "",
          key: 'preload-image-' + i
        }));
      });

      if (item) {
        toReturn = /*#__PURE__*/_react["default"].createElement(SlideshowDiv, {
          className: 'hw-sc-slideshow'
        }, this.renderSlide(), /*#__PURE__*/_react["default"].createElement(_MediaCredits["default"], {
          hideDisclaimer: hideDisclaimer,
          asOfDate: item.certifiedDate,
          legal: item.legal,
          credits: item.credits
        }), this.renderNavigation(), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'none'
          },
          "aria-hidden": "true"
        }, previewItems));
      }

      return toReturn;
    }
  }]);

  return Slideshow;
}(_react.Component);

Slideshow.propTypes = {
  item: _propTypes["default"].object.isRequired,
  hideDisclaimer: _propTypes["default"].bool,
  onSlideSelected: _propTypes["default"].func
};
Slideshow.defaultProps = {
  hideDisclaimer: false,
  onSlideSelected: function onSlideSelected() {}
};
var _default = Slideshow;
exports["default"] = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & .HwImageWrapper {\n    float: right;\n    margin: 0 0 0 20px;\n    background: ", ";\n    padding: 10px 10px 30px;\n    line-height: 1;\n  }\n\n  & .HwImageWrapper img {\n    border: 3px solid ", ";\n  }\n\n  & .HwNote {\n    float: right;\n    clear: both;\n    margin-bottom: 20px;\n    font-style: italic;\n    padding-right: 10px;\n    margin-top: -30px;\n    color: ", ";\n  }\n\n  & .HwNote ~ .hw-content-story .HwNote {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

// import { defaultTheme } from '@healthwise-ui/core/Theme'
var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.colorBackgroundContrastLight;
}, function (props) {
  return props.theme.colorBorder;
}, function (props) {
  return props.theme.colorTextPrimary;
});

var Story = /*#__PURE__*/function (_React$Component) {
  _inherits(Story, _React$Component);

  var _super = _createSuper(Story);

  function Story() {
    _classCallCheck(this, Story);

    return _super.apply(this, arguments);
  }

  _createClass(Story, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          otherProps = _objectWithoutProperties(_this$props, ["data"]);

      return (/*#__PURE__*/_react["default"].createElement(Root, _extends({
          className: "hw-content-story",
          dangerouslySetInnerHTML: {
            __html: data.html
          }
        }, otherProps))
      );
    }
  }]);

  return Story;
}(_react["default"].Component);

Story.propTypes = {
  data: _propTypes["default"].shape({
    html: _propTypes["default"].string
  })
}; // Story.defaultProps = {
//   theme: defaultTheme,
// }

var _default = (0, _styledComponents.withTheme)(Story);

exports["default"] = _default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: ", ";\n  margin: ", ";\n  font-weight: normal;\n  font-size: 1.5rem;\n  line-height: 1.5;\n  color: ", ";\n\n  @media print {\n    background: #f5f5f5;\n    margin: 4px 0 12px;\n    border: 1px solid #ccc;\n    padding: 5px 16px;\n    font-size: 14px;\n    color: #000;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Heading = _styledComponents["default"].h3(_templateObject(), function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return "".concat(props.theme.spacingM, " ").concat(props.theme.spacingL);
}, function (props) {
  return "".concat(props.theme.spacingL, " 0 ").concat(props.theme.spacingM);
}, function (props) {
  return props.theme.colorTextOnPrimary;
});

var BlockHeading = /*#__PURE__*/function (_Component) {
  _inherits(BlockHeading, _Component);

  function BlockHeading() {
    _classCallCheck(this, BlockHeading);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockHeading).apply(this, arguments));
  }

  _createClass(BlockHeading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          theme = _this$props.theme;
      return _react["default"].createElement(Heading, {
        className: (0, _classnames["default"])('hw-block-heading', className),
        theme: theme
      }, children);
    }
  }]);

  return BlockHeading;
}(_react.Component);

BlockHeading.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  theme: _propTypes["default"].shape({
    colorPrimary: _propTypes["default"].string,
    colorTextOnPrimary: _propTypes["default"].string,
    spacingM: _propTypes["default"].string,
    spacingL: _propTypes["default"].string
  })
};
BlockHeading.defaultProps = {
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(BlockHeading);

exports["default"] = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BlockHeading["default"];
  }
});

var _BlockHeading = _interopRequireDefault(__webpack_require__(386));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-content: center;\n  justify-content: ", ";\n\n  & > *:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

// Map align prop to justify-content value
var alignMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return alignMap[props.align];
}, function (props) {
  return props.theme.spacingS;
});

var ButtonGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonGroup, _React$Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ButtonGroup).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className"]);

      return _react["default"].createElement(Root, _extends({
        className: (0, _classnames["default"])('hw-button-grouop', className)
      }, otherProps), children);
    }
  }]);

  return ButtonGroup;
}(_react["default"].Component);

ButtonGroup.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(['left', 'center', 'right']),
  theme: _propTypes["default"].shape({
    spacingS: _propTypes["default"].string
  })
};
ButtonGroup.defaultProps = {
  align: 'left',
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(ButtonGroup);

exports["default"] = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable */

/* 
  Source: https://github.com/jotform/css.js
  License: https://github.com/jotform/css.js/blob/master/LICENSE
*/

/* global base64_decode, CSSWizardView, window, console, jQuery */
var fi = function fi() {
  this.cssImportStatements = [];
  this.cssKeyframeStatements = [];
  this.cssRegex = new RegExp('([\\s\\S]*?){([\\s\\S]*?)}', 'gi');
  this.cssMediaQueryRegex = '((@media [\\s\\S]*?){([\\s\\S]*?}\\s*?)})';
  this.cssKeyframeRegex = '((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})';
  this.combinedCSSRegex = '((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})'; //to match css & media queries together

  this.cssCommentsRegex = '(\\/\\*[\\s\\S]*?\\*\\/)';
  this.cssImportStatementRegex = new RegExp('@import .*?;', 'gi');
};
/*
  Strip outs css comments and returns cleaned css string
   @param css, the original css string to be stipped out of comments
   @return cleanedCSS contains no css comments
*/

fi.prototype.stripComments = function (cssString) {
  var regex = new RegExp(this.cssCommentsRegex, 'gi');
  return cssString.replace(regex, '');
};
/*
  Parses given css string, and returns css object
  keys as selectors and values are css rules
  eliminates all css comments before parsing
   @param source css string to be parsed
   @return object css
*/

fi.prototype.parseCSS = function (source) {
  if (source === undefined) {
    return [];
  }

  var css = []; //strip out comments
  //source = this.stripComments(source);
  //get import statements

  while (true) {
    var imports = this.cssImportStatementRegex.exec(source);

    if (imports !== null) {
      this.cssImportStatements.push(imports[0]);
      css.push({
        selector: '@imports',
        type: 'imports',
        styles: imports[0]
      });
    } else {
      break;
    }
  }

  source = source.replace(this.cssImportStatementRegex, ''); //get keyframe statements

  var keyframesRegex = new RegExp(this.cssKeyframeRegex, 'gi');
  var arr;

  while (true) {
    arr = keyframesRegex.exec(source);

    if (arr === null) {
      break;
    }

    css.push({
      selector: '@keyframes',
      type: 'keyframes',
      styles: arr[0]
    });
  }

  source = source.replace(keyframesRegex, ''); //unified regex

  var unified = new RegExp(this.combinedCSSRegex, 'gi');

  while (true) {
    arr = unified.exec(source);

    if (arr === null) {
      break;
    }

    var selector = '';

    if (arr[2] === undefined) {
      selector = arr[5].split('\r\n').join('\n').trim();
    } else {
      selector = arr[2].split('\r\n').join('\n').trim();
    }
    /*
      fetch comments and associate it with current selector
    */

    var commentsRegex = new RegExp(this.cssCommentsRegex, 'gi');
    var comments = commentsRegex.exec(selector);

    if (comments !== null) {
      selector = selector.replace(commentsRegex, '').trim();
    } // Never have more than a single line break in a row


    selector = selector.replace(/\n+/, "\n"); //determine the type

    if (selector.indexOf('@media') !== -1) {
      //we have a media query
      var cssObject = {
        selector: selector,
        type: 'media',
        subStyles: this.parseCSS(arr[3] + '\n}') //recursively parse media query inner css

      };

      if (comments !== null) {
        cssObject.comments = comments[0];
      }

      css.push(cssObject);
    } else {
      //we have standard css
      var rules = this.parseRules(arr[6]);
      var style = {
        selector: selector,
        rules: rules
      };

      if (selector === '@font-face') {
        style.type = 'font-face';
      }

      if (comments !== null) {
        style.comments = comments[0];
      }

      css.push(style);
    }
  }

  return css;
};
/*
  parses given string containing css directives
  and returns an array of objects containing ruleName:ruleValue pairs
   @param rules, css directive string example
      \n\ncolor:white;\n    font-size:18px;\n
*/

fi.prototype.parseRules = function (rules) {
  //convert all windows style line endings to unix style line endings
  rules = rules.split('\r\n').join('\n');
  var ret = [];
  rules = rules.split(';'); //proccess rules line by line

  for (var i = 0; i < rules.length; i++) {
    var line = rules[i]; //determine if line is a valid css directive, ie color:white;

    line = line.trim();

    if (line.indexOf(':') !== -1) {
      //line contains :
      line = line.split(':');
      var cssDirective = line[0].trim();
      var cssValue = line.slice(1).join(':').trim(); //more checks

      if (cssDirective.length < 1 || cssValue.length < 1) {
        continue; //there is no css directive or value that is of length 1 or 0
        // PLAIN WRONG WHAT ABOUT margin:0; ?
      } //push rule


      ret.push({
        directive: cssDirective,
        value: cssValue
      });
    } else {
      //if there is no ':', but what if it was mis splitted value which starts with base64
      if (line.trim().substr(0, 7) === 'base64,') {
        //hack :)
        ret[ret.length - 1].value += line.trim();
      } else {
        //add rule, even if it is defective
        if (line.length > 0) {
          ret.push({
            directive: '',
            value: line,
            defective: true
          });
        }
      }
    }
  }

  return ret; //we are done!
};
/*
  just returns the rule having given directive
  if not found returns false;
*/

fi.prototype.findCorrespondingRule = function (rules, directive, value) {
  if (value === undefined) {
    value = false;
  }

  var ret = false;

  for (var i = 0; i < rules.length; i++) {
    if (rules[i].directive === directive) {
      ret = rules[i];

      if (value === rules[i].value) {
        break;
      }
    }
  }

  return ret;
};
/*
    Finds styles that have given selector, compress them,
    and returns them
*/

fi.prototype.findBySelector = function (cssObjectArray, selector, contains) {
  if (contains === undefined) {
    contains = false;
  }

  var found = [];

  for (var i = 0; i < cssObjectArray.length; i++) {
    if (contains === false) {
      if (cssObjectArray[i].selector === selector) {
        found.push(cssObjectArray[i]);
      }
    } else {
      if (cssObjectArray[i].selector.indexOf(selector) !== -1) {
        found.push(cssObjectArray[i]);
      }
    }
  }

  if (selector === '@imports' || found.length < 2) {
    return found;
  } else {
    var base = found[0];

    for (i = 1; i < found.length; i++) {
      this.intelligentCSSPush([base], found[i]);
    }

    return [base]; //we are done!! all properties merged into base!
  }
};
/*
  deletes cssObjects having given selector, and returns new array
*/

fi.prototype.deleteBySelector = function (cssObjectArray, selector) {
  var ret = [];

  for (var i = 0; i < cssObjectArray.length; i++) {
    if (cssObjectArray[i].selector !== selector) {
      ret.push(cssObjectArray[i]);
    }
  }

  return ret;
};
/*
    Compresses given cssObjectArray and tries to minimize
    selector redundence.
*/

fi.prototype.compressCSS = function (cssObjectArray) {
  var compressed = [];
  var done = {};

  for (var i = 0; i < cssObjectArray.length; i++) {
    var obj = cssObjectArray[i];

    if (done[obj.selector] === true) {
      continue;
    }

    var found = this.findBySelector(cssObjectArray, obj.selector); //found compressed

    if (found.length !== 0) {
      compressed = compressed.concat(found);
      done[obj.selector] = true;
    }
  }

  return compressed;
};
/*
  Received 2 css objects with following structure
    {
      rules : [{directive:"", value:""}, {directive:"", value:""}, ...]
      selector : "SOMESELECTOR"
    }
   returns the changed(new,removed,updated) values on css1 parameter, on same structure
   if two css objects are the same, then returns false
     if a css directive exists in css1 and     css2, and its value is different, it is included in diff
    if a css directive exists in css1 and not css2, it is then included in diff
    if a css directive exists in css2 but not css1, then it is deleted in css1, it would be included in diff but will be marked as type='DELETED'
     @object css1 css object
    @object css2 css object
     @return diff css object contains changed values in css1 in regards to css2 see test input output in /test/data/css.js
*/

fi.prototype.cssDiff = function (css1, css2) {
  if (css1.selector !== css2.selector) {
    return false;
  } //if one of them is media query return false, because diff function can not operate on media queries


  if (css1.type === 'media' || css2.type === 'media') {
    return false;
  }

  var diff = {
    selector: css1.selector,
    rules: []
  };
  var rule1, rule2;

  for (var i = 0; i < css1.rules.length; i++) {
    rule1 = css1.rules[i]; //find rule2 which has the same directive as rule1

    rule2 = this.findCorrespondingRule(css2.rules, rule1.directive, rule1.value);

    if (rule2 === false) {
      //rule1 is a new rule in css1
      diff.rules.push(rule1);
    } else {
      //rule2 was found only push if its value is different too
      if (rule1.value !== rule2.value) {
        diff.rules.push(rule1);
      }
    }
  } //now for rules exists in css2 but not in css1, which means deleted rules


  for (var ii = 0; ii < css2.rules.length; ii++) {
    rule2 = css2.rules[ii]; //find rule2 which has the same directive as rule1

    rule1 = this.findCorrespondingRule(css1.rules, rule2.directive);

    if (rule1 === false) {
      //rule1 is a new rule
      rule2.type = 'DELETED'; //mark it as a deleted rule, so that other merge operations could be true

      diff.rules.push(rule2);
    }
  }

  if (diff.rules.length === 0) {
    return false;
  }

  return diff;
};
/*
    Merges 2 different css objects together
    using intelligentCSSPush,
     @param cssObjectArray, target css object array
    @param newArray, source array that will be pushed into cssObjectArray parameter
    @param reverse, [optional], if given true, first parameter will be traversed on reversed order
            effectively giving priority to the styles in newArray
*/

fi.prototype.intelligentMerge = function (cssObjectArray, newArray, reverse) {
  if (reverse === undefined) {
    reverse = false;
  }

  for (var i = 0; i < newArray.length; i++) {
    this.intelligentCSSPush(cssObjectArray, newArray[i], reverse);
  }

  for (i = 0; i < cssObjectArray.length; i++) {
    var cobj = cssObjectArray[i];

    if (cobj.type === 'media' || cobj.type === 'keyframes') {
      continue;
    }

    cobj.rules = this.compactRules(cobj.rules);
  }
};
/*
  inserts new css objects into a bigger css object
  with same selectors grouped together
   @param cssObjectArray, array of bigger css object to be pushed into
  @param minimalObject, single css object
  @param reverse [optional] default is false, if given, cssObjectArray will be reversly traversed
          resulting more priority in minimalObject's styles
*/

fi.prototype.intelligentCSSPush = function (cssObjectArray, minimalObject, reverse) {
  var pushSelector = minimalObject.selector; //find correct selector if not found just push minimalObject into cssObject

  var cssObject = false;

  if (reverse === undefined) {
    reverse = false;
  }

  if (reverse === false) {
    for (var i = 0; i < cssObjectArray.length; i++) {
      if (cssObjectArray[i].selector === minimalObject.selector) {
        cssObject = cssObjectArray[i];
        break;
      }
    }
  } else {
    for (var j = cssObjectArray.length - 1; j > -1; j--) {
      if (cssObjectArray[j].selector === minimalObject.selector) {
        cssObject = cssObjectArray[j];
        break;
      }
    }
  }

  if (cssObject === false) {
    cssObjectArray.push(minimalObject); //just push, because cssSelector is new
  } else {
    if (minimalObject.type !== 'media') {
      for (var ii = 0; ii < minimalObject.rules.length; ii++) {
        var rule = minimalObject.rules[ii]; //find rule inside cssObject

        var oldRule = this.findCorrespondingRule(cssObject.rules, rule.directive);

        if (oldRule === false) {
          cssObject.rules.push(rule);
        } else if (rule.type === 'DELETED') {
          oldRule.type = 'DELETED';
        } else {
          //rule found just update value
          oldRule.value = rule.value;
        }
      }
    } else {
      cssObject.subStyles = cssObject.subStyles.concat(minimalObject.subStyles); //TODO, make this intelligent too
    }
  }
};
/*
  filter outs rule objects whose type param equal to DELETED
   @param rules, array of rules
   @returns rules array, compacted by deleting all unnecessary rules
*/

fi.prototype.compactRules = function (rules) {
  var newRules = [];

  for (var i = 0; i < rules.length; i++) {
    if (rules[i].type !== 'DELETED') {
      newRules.push(rules[i]);
    }
  }

  return newRules;
};
/*
  computes string for ace editor using this.css or given cssBase optional parameter
   @param [optional] cssBase, if given computes cssString from cssObject array
*/

fi.prototype.getCSSForEditor = function (cssBase, depth) {
  if (depth === undefined) {
    depth = 0;
  }

  var ret = '';

  if (cssBase === undefined) {
    cssBase = this.css;
  } //append imports


  for (var i = 0; i < cssBase.length; i++) {
    if (cssBase[i].type === 'imports') {
      ret += cssBase[i].styles + '\n\n';
    }
  }

  for (i = 0; i < cssBase.length; i++) {
    var tmp = cssBase[i];

    if (tmp.selector === undefined) {
      //temporarily omit media queries
      continue;
    }

    var comments = "";

    if (tmp.comments !== undefined) {
      comments = tmp.comments + '\n';
    }

    if (tmp.type === 'media') {
      //also put media queries to output
      ret += comments + tmp.selector + '{\n';
      ret += this.getCSSForEditor(tmp.subStyles, depth + 1);
      ret += '}\n\n';
    } else if (tmp.type !== 'keyframes' && tmp.type !== 'imports') {
      ret += this.getSpaces(depth) + comments + tmp.selector + ' {\n';
      ret += this.getCSSOfRules(tmp.rules, depth + 1);
      ret += this.getSpaces(depth) + '}\n\n';
    }
  } //append keyFrames


  for (i = 0; i < cssBase.length; i++) {
    if (cssBase[i].type === 'keyframes') {
      ret += cssBase[i].styles + '\n\n';
    }
  }

  return ret;
};

fi.prototype.getImports = function (cssObjectArray) {
  var imps = [];

  for (var i = 0; i < cssObjectArray.length; i++) {
    if (cssObjectArray[i].type === 'imports') {
      imps.push(cssObjectArray[i].styles);
    }
  }

  return imps;
};
/*
  given rules array, returns visually formatted css string
  to be used inside editor
*/

fi.prototype.getCSSOfRules = function (rules, depth) {
  var ret = '';

  for (var i = 0; i < rules.length; i++) {
    if (rules[i] === undefined) {
      continue;
    }

    if (rules[i].defective === undefined) {
      ret += this.getSpaces(depth) + rules[i].directive + ': ' + rules[i].value + ';\n';
    } else {
      ret += this.getSpaces(depth) + rules[i].value + ';\n';
    }
  }

  return ret || '\n';
};
/*
    A very simple helper function returns number of spaces appended in a single string,
    the number depends input parameter, namely input*2
*/

fi.prototype.getSpaces = function (num) {
  var ret = '';

  for (var i = 0; i < num * 4; i++) {
    ret += ' ';
  }

  return ret;
};
/*
  Given css string or objectArray, parses it and then for every selector,
  prepends this.cssPreviewNamespace to prevent css collision issues
   @returns css string in which this.cssPreviewNamespace prepended
*/

fi.prototype.applyNamespacing = function (css, forcedNamespace) {
  var cssObjectArray = css;
  var namespaceClass = '.' + this.cssPreviewNamespace;

  if (forcedNamespace !== undefined) {
    namespaceClass = forcedNamespace;
  }

  if (typeof css === 'string') {
    cssObjectArray = this.parseCSS(css);
  }

  for (var i = 0; i < cssObjectArray.length; i++) {
    var obj = cssObjectArray[i]; //bypass namespacing for @font-face @keyframes @import

    if (obj.selector.indexOf('@font-face') > -1 || obj.selector.indexOf('keyframes') > -1 || obj.selector.indexOf('@import') > -1 || obj.selector.indexOf('.form-all') > -1 || obj.selector.indexOf('#stage') > -1) {
      continue;
    }

    if (obj.type !== 'media') {
      var selector = obj.selector.split(',');
      var newSelector = [];

      for (var j = 0; j < selector.length; j++) {
        if (selector[j].indexOf('.supernova') === -1) {
          //do not apply namespacing to selectors including supernova
          newSelector.push(namespaceClass + ' ' + selector[j]);
        } else {
          newSelector.push(selector[j]);
        }
      }

      obj.selector = newSelector.join(',');
    } else {
      obj.subStyles = this.applyNamespacing(obj.subStyles, forcedNamespace); //handle media queries as well
    }
  }

  return cssObjectArray;
};
/*
  given css string or object array, clears possible namespacing from
  all of the selectors inside the css
*/

fi.prototype.clearNamespacing = function (css, returnObj) {
  if (returnObj === undefined) {
    returnObj = false;
  }

  var cssObjectArray = css;
  var namespaceClass = '.' + this.cssPreviewNamespace;

  if (typeof css === 'string') {
    cssObjectArray = this.parseCSS(css);
  }

  for (var i = 0; i < cssObjectArray.length; i++) {
    var obj = cssObjectArray[i];

    if (obj.type !== 'media') {
      var selector = obj.selector.split(',');
      var newSelector = [];

      for (var j = 0; j < selector.length; j++) {
        newSelector.push(selector[j].split(namespaceClass + ' ').join(''));
      }

      obj.selector = newSelector.join(',');
    } else {
      obj.subStyles = this.clearNamespacing(obj.subStyles, true); //handle media queries as well
    }
  }

  if (returnObj === false) {
    return this.getCSSForEditor(cssObjectArray);
  } else {
    return cssObjectArray;
  }
};
/*
  creates a new style tag (also destroys the previous one)
  and injects given css string into that css tag
*/

fi.prototype.createStyleElement = function (id, css, format) {
  if (format === undefined) {
    format = false;
  }

  if (this.testMode === false && format !== 'nonamespace') {
    //apply namespacing classes
    css = this.applyNamespacing(css);
  }

  if (typeof css !== 'string') {
    css = this.getCSSForEditor(css);
  } //apply formatting for css


  if (format === true) {
    css = this.getCSSForEditor(this.parseCSS(css));
  }

  if (this.testMode !== false) {
    return this.testMode('create style #' + id, css); //if test mode, just pass result to callback
  }

  var __el = document.getElementById(id);

  if (__el) {
    __el.parentNode.removeChild(__el);
  }

  var head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');
  style.id = id;
  style.type = 'text/css';
  head.appendChild(style);

  if (style.styleSheet && !style.sheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};

var _default = fi;
exports["default"] = _default;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css = _interopRequireDefault(__webpack_require__(389));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

var CssParser = /*#__PURE__*/function () {
  function CssParser() {
    _classCallCheck(this, CssParser);
  }

  _createClass(CssParser, [{
    key: "parse",
    value: function parse(cssHtml) {
      var cssJs = new _css["default"]();
      var parsed = cssJs.parseCSS(cssHtml);
      return parsed;
    } // This doesn't support nested css properties at this time (e.g. @media { ... })

  }, {
    key: "compose",
    value: function compose(cssJson) {
      var cssHtml = '';

      if (Array.isArray(cssJson)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = cssJson[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var declaration = _step.value;
            cssHtml += declaration.selector + '{';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = declaration.rules[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var rule = _step2.value;
                cssHtml += "".concat(rule.directive, ":").concat(rule.value, ";");
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            cssHtml += '}\n';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        console.info("Unable to compose css from input that is not an array of declarations.\n      Example:\n      [\n        {\n          \"selector\": \".my-class-name\",\n          \"rules\": [\n            {\n              \"directive\": \"color\",\n              \"value\": \"black\"\n            }\n          ]\n        },\n        {\n          \"selector\": \".my-important-class-name\",\n          \"rules\": [\n            {\n              \"directive\": \"color\",\n              \"value\": \"red\"\n            },\n            {\n              \"directive\": \"font-weight\",\n              \"value\": \"600\"\n            }\n          ]\n        }\n      ]\n\n      Given: ".concat(JSON.stringify(cssJson)));
      }

      return cssHtml;
    }
  }]);

  return CssParser;
}();

exports["default"] = CssParser;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactAriaMenubutton = __webpack_require__(890);

var _uniqueId = _interopRequireDefault(__webpack_require__(216));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _Icon = __webpack_require__(165);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 2rem; /* Force IE to properly align flex items */\n  min-height: 2rem;\n  max-height: 3rem;\n  border: 1px solid ", ";\n  border-top-color: transparent;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  font-weight: normal;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-height: 24rem;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  overflow-y: auto;\n  overflow-x: hidden;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: auto;\n  background-color: ", ";\n  z-index: 1000;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  user-select: none;\n  pointer-events: none;\n  display: inline-block;\n  margin-right: auto;\n  flex: 1 1 auto;\n  overflow: hidden;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  background: ", ";\n  color: ", ";\n  font-weight: normal;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  list-style-type: none;\n  cursor: pointer;\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  &[aria-expanded='true'] ", " {\n    display: flex;\n  }\n\n  &[aria-expanded='false'] ", " {\n    display: flex;\n  }\n\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  height: 1rem;\n  width: 1rem;\n  margin-right: 5px;\n  margin-left: 0.5rem;\n  pointer-events: none;\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  height: 1rem;\n  width: 1rem;\n  margin-right: 5px;\n  margin-left: 0.5rem;\n  pointer-events: none;\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 1rem;\n  width: 1rem;\n  margin-right: 5px;\n  margin-left: 0.5rem;\n  pointer-events: none;\n  display: flex;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.25rem;\n  font-size: 0.75rem;\n  letter-spacing: 0.5px;\n\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 40px;\n  position: relative;\n  flex: 1 1 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  flex-flow: column nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].div(_templateObject());

var Wrapper = (0, _styledComponents["default"])(_reactAriaMenubutton.Wrapper)(_templateObject2());

var Label = _styledComponents["default"].span(_templateObject3());

var Icon = _styledComponents["default"].span(_templateObject4());

var DownArrowIconContainer = _styledComponents["default"].span(_templateObject5(), function (props) {
  return props.colorTextSecondary;
});

var UpArrowIconContainer = _styledComponents["default"].span(_templateObject6(), function (props) {
  return props.colorTextSecondary;
});

var Button = (0, _styledComponents["default"])(_reactAriaMenubutton.Button)(_templateObject7(), function (props) {
  return props.error ? props.theme.colorError : props.theme.colorBorder;
}, function (props) {
  return props.theme.colorBackgroundLight;
}, function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, UpArrowIconContainer, DownArrowIconContainer);

var Value = _styledComponents["default"].span(_templateObject8());

var Menu = (0, _styledComponents["default"])(_reactAriaMenubutton.Menu)(_templateObject9(), function (props) {
  return props.theme.colorBackgroundLight;
});

var MenuItems = _styledComponents["default"].ul(_templateObject10());

var MenuItem = (0, _styledComponents["default"])(_reactAriaMenubutton.MenuItem)(_templateObject11(), function (props) {
  return props.theme.colorBorder;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorInset;
});

var DropDown = /*#__PURE__*/function (_Component) {
  _inherits(DropDown, _Component);

  function DropDown(props) {
    var _this;

    _classCallCheck(this, DropDown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropDown).call(this, props));

    var mappedItems = _this.mapItemsToObjects(props.items);

    _this.state = {
      valueId: (0, _uniqueId["default"])('DropDownValue'),
      value: _this.findItemInArray(props.value, mappedItems) || {
        name: props.prompt,
        value: props.prompt
      },
      items: mappedItems
    };
    _this.onSelectNewValue = _this.onSelectNewValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DropDown, [{
    key: "mapItemsToObjects",
    value: function mapItemsToObjects(items) {
      if (items && items.length > 0) {
        return items.map(function (item) {
          if (typeof item.value !== 'undefined' && typeof item.name !== 'undefined') {
            return item;
          }

          return {
            value: item,
            name: item.toString()
          };
        });
      }

      return [];
    }
  }, {
    key: "findItemInArray",
    value: function findItemInArray(value, items) {
      if (value) {
        return items.find(function (item) {
          return item.value === value || item.name === value;
        });
      }

      return undefined;
    }
  }, {
    key: "onSelectNewValue",
    value: function onSelectNewValue(value, event) {
      var selectedItem = this.findItemInArray(value, this.state.items);

      if (selectedItem !== null && this.state.value !== selectedItem) {
        if (!this.props.maintainPrompt) {
          this.setState({
            value: selectedItem
          });
        }

        this.props.onSelect(value, event);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var itemsToSearch = this.state.items;

      if (newProps.items && newProps.items !== this.state.items) {
        itemsToSearch = this.mapItemsToObjects(newProps.items);
        this.setState({
          items: itemsToSearch
        });
      }

      var newValue = this.findItemInArray(newProps.value, itemsToSearch) || {
        name: newProps.prompt,
        value: newProps.prompt
      };

      if (newValue.value !== this.state.value.value) {
        this.setState({
          value: newValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          label = _this$props.label,
          prompt = _this$props.prompt,
          disabled = _this$props.disabled,
          error = _this$props.error,
          theme = _this$props.theme;
      var _this$state = this.state,
          valueId = _this$state.valueId,
          value = _this$state.value,
          items = _this$state.items;
      return _react["default"].createElement(Root, {
        className: "hw-drop-down"
      }, label && _react["default"].createElement(Label, {
        className: "hw-drop-down-label",
        "aria-hidden": "true",
        role: "presentation",
        "aria-disabled": disabled
      }, label), _react["default"].createElement(Wrapper, {
        onSelection: this.onSelectNewValue
      }, _react["default"].createElement(Button, {
        className: "hw-drop-down-button",
        "aria-label": label || prompt,
        "aria-describedby": valueId,
        theme: theme,
        error: error,
        disabled: disabled
      }, icon && _react["default"].createElement(Icon, {
        "aria-hidden": "true",
        role: "presentation"
      }, icon), _react["default"].createElement(Value, {
        id: valueId,
        tabIndex: "-1" // Makes IE read aria-describedby element

        , className: "hw-drop-down-value"
      }, value.name), _react["default"].createElement(DownArrowIconContainer, {
        className: "hw-drop-down-icon-arrow",
        "aria-hidden": "true",
        role: "presentation",
        theme: theme
      }, _react["default"].createElement(_Icon.DownArrowIcon, {
        role: "presentation"
      })), _react["default"].createElement(UpArrowIconContainer, {
        className: "hw-drop-down-icon-arrow",
        "aria-hidden": "true",
        role: "presentation",
        theme: theme
      }, _react["default"].createElement(_Icon.UpArrowIcon, {
        role: "presentation"
      }))), _react["default"].createElement(Menu, {
        theme: theme
      }, _react["default"].createElement(MenuItems, null, items.map(function (item, i) {
        return _react["default"].createElement("li", {
          key: i
        }, _react["default"].createElement(MenuItem, {
          value: item.value,
          text: item.name,
          theme: theme
        }, _react["default"].createElement(Value, {
          className: "hw-drop-down-option"
        }, item.component || item.name)));
      })))));
    }
  }]);

  return DropDown;
}(_react.Component);

DropDown.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    component: _propTypes["default"].node
  })])).isRequired,
  icon: _propTypes["default"].any,
  label: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  prompt: _propTypes["default"].string,
  maintainPrompt: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    component: _propTypes["default"].node
  })]),
  onSelect: _propTypes["default"].func.isRequired,
  theme: _propTypes["default"].shape({
    colorTextPrimary: _propTypes["default"].string,
    colorTextSecondary: _propTypes["default"].string,
    colorBackgroundLight: _propTypes["default"].string,
    colorBorder: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    focusIndicatorOffset: _propTypes["default"].string,
    focusIndicatorInset: _propTypes["default"].string
  })
};
DropDown.defaultProps = {
  prompt: 'Select a value',
  maintainPrompt: false,
  disabled: false,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(DropDown);

exports["default"] = _default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

/* I realize this is so trivial, at first glance, it may seem stupid, but, believe me, it isn't */
var FeatureDefaultWrapper = /*#__PURE__*/function (_Component) {
  _inherits(FeatureDefaultWrapper, _Component);

  function FeatureDefaultWrapper() {
    _classCallCheck(this, FeatureDefaultWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeatureDefaultWrapper).apply(this, arguments));
  }

  _createClass(FeatureDefaultWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("span", null, children);
    }
  }]);

  return FeatureDefaultWrapper;
}(_react.Component);

FeatureDefaultWrapper.propTypes = {
  children: _propTypes["default"].node
};

var FeatureFlipper = /*#__PURE__*/function (_Component2) {
  _inherits(FeatureFlipper, _Component2);

  function FeatureFlipper() {
    _classCallCheck(this, FeatureFlipper);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeatureFlipper).apply(this, arguments));
  }

  _createClass(FeatureFlipper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          evaluate = _this$props.evaluate,
          wrapper = _this$props.wrapper;

      if (typeof evaluate === 'boolean' && evaluate || typeof evaluate === 'function' && evaluate()) {
        return _react["default"].createElement("wrapper", null, children);
      }

      return null;
    }
  }]);

  return FeatureFlipper;
}(_react.Component);

FeatureFlipper.propTypes = {
  children: _propTypes["default"].node,
  wrapper: _propTypes["default"].element,
  evaluate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]).isRequired
};
FeatureFlipper.defaultProps = {
  wrapper: FeatureDefaultWrapper,
  evaluate: false
};
var _default = FeatureFlipper;
exports["default"] = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 1024px;\n  margin: 0 auto;\n  border-top: 1px solid ", ";\n  box-sizing: border-box;\n\n  @media screen and (max-width: 1040px) {\n    padding: 0 ", ";\n  }\n\n  @media screen and (max-width: 750px) {\n    padding: 0 ", ";\n  }\n\n  @media print {\n    padding: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var FooterContent = _styledComponents["default"].footer(_templateObject(), function (props) {
  return props.theme.colorBorder;
}, function (props) {
  return "".concat(props.theme.spacingL);
}, function (props) {
  return "".concat(props.theme.spacingM);
});

FooterContent.defaultProps = {
  theme: _Theme.defaultTheme
};

var Footer = /*#__PURE__*/function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          theme = _this$props.theme;
      return _react["default"].createElement(FooterContent, {
        className: (0, _classnames["default"])('hw-content-footer', className),
        theme: theme
      }, children);
    }
  }]);

  return Footer;
}(_react.Component);

Footer.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  theme: _propTypes["default"].shape({
    colorBorder: _propTypes["default"].string,
    spacingM: _propTypes["default"].string,
    spacingL: _propTypes["default"].string
  })
};

var _default = (0, _styledComponents.withTheme)(Footer);

exports["default"] = _default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

var HealthwiseLogo = /*#__PURE__*/function (_Component) {
  _inherits(HealthwiseLogo, _Component);

  function HealthwiseLogo() {
    _classCallCheck(this, HealthwiseLogo);

    return _possibleConstructorReturn(this, _getPrototypeOf(HealthwiseLogo).apply(this, arguments));
  }

  _createClass(HealthwiseLogo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["title", "className"]);

      return _react["default"].createElement("svg", _extends({
        className: (0, _classnames["default"])('hw-healthwise-logo', className),
        width: "165px",
        height: "74px",
        viewBox: "0 0 317.68 141.93"
      }, otherProps), _react["default"].createElement("defs", null, _react["default"].createElement("style", null, ".svg-hw-logo-color-1{fill:#58595b}.svg-hw-logo-color-2{fill:#f0534a}")), _react["default"].createElement("title", null, title), _react["default"].createElement("path", {
        d: "M27.77 57.85h3.94a.76.76 0 0 1 .75.75v16.19c0 1.34-.11 2.35-.11 2.35h.11a11.44 11.44 0 0 1 10.47-6.33c6.66 0 9.74 3.64 9.74 10.87v17.39a.74.74 0 0 1-.74.75H48a.75.75 0 0 1-.75-.75V82.91c0-4-.84-7.11-5.37-7.11a9.37 9.37 0 0 0-9 7 13.12 13.12 0 0 0-.45 3.75v12.52a.75.75 0 0 1-.75.75h-3.91a.74.74 0 0 1-.74-.75V58.6a.75.75 0 0 1 .74-.75M71.33 70.81c8 0 12.27 5.94 12.27 13.28 0 .37 0 1-.09 1.47a1 1 0 0 1-1 .88H62.76c.29 6.21 4.71 9.35 9.75 9.35a13.25 13.25 0 0 0 7.64-2.69.85.85 0 0 1 1.26.28l1.3 2.29a1.08 1.08 0 0 1-.28 1.39 17.19 17.19 0 0 1-10.26 3.43c-8.9 0-15-6.44-15-14.84 0-9 6.1-14.84 14.16-14.84m6.72 11.54c-.16-4.87-3.19-7.22-6.83-7.22-4.14 0-7.5 2.57-8.29 7.22zM103.32 82.12h1.23v-.5c0-4.65-2.63-6.21-6.22-6.21a14.07 14.07 0 0 0-7.27 2.31.71.71 0 0 1-1-.24L88.5 74.7a.68.68 0 0 1 .2-.9 18.26 18.26 0 0 1 10.08-3A11.24 11.24 0 0 1 110 82.07v17a.74.74 0 0 1-.75.75h-3.54a.75.75 0 0 1-.75-.75v-1.94a21.84 21.84 0 0 1 .11-2.24h-.11a9.81 9.81 0 0 1-9.07 5.6c-4.87 0-9.63-3-9.63-8.62 0-9.35 12.32-9.75 17.08-9.75m-6.27 14c4.59 0 7.56-4.82 7.56-9v-.9h-1.4c-4.09 0-11.48.28-11.48 5.38 0 2.29 1.79 4.54 5.32 4.54M121.53 91.14V65a.64.64 0 0 0-.78-.62l-3.8.83a1.1 1.1 0 0 0-.86 1.07v25.81c0 7.12 4.54 8 7.62 8h1.05a.81.81 0 0 0 .74-.82v-3.8c0-.32-.11-.34-.28-.32h-.67c-1.68 0-3-.61-3-4M136.2 88.85v-12.6h6.09a.76.76 0 0 0 .75-.75v-2.88a.75.75 0 0 0-.75-.74h-6.09v-10a.64.64 0 0 0-.77-.63l-3.63.8a1.09 1.09 0 0 0-.86 1.07v8.81h-3.12a.75.75 0 0 0-.75.74v2.83a.76.76 0 0 0 .75.75h3v13.21c0 9.47 7.23 10.59 10.87 10.59h1.21a.75.75 0 0 0 .69-.75v-3.7c0-.4-.14-.4-.4-.37a6.8 6.8 0 0 1-.89 0c-2.07 0-6.05-.73-6.05-6.38M163.87 70.81a11.45 11.45 0 0 0-10.47 6.33h-.11s.11-1 .11-2.35V58.06a.64.64 0 0 0-.78-.62l-3.8.83a1.08 1.08 0 0 0-.85 1.06v39.74a.74.74 0 0 0 .75.75h3.93a.75.75 0 0 0 .75-.75V86.55a13.12 13.12 0 0 1 .45-3.75 9.37 9.37 0 0 1 9-7c4.53 0 5.37 3.13 5.37 7.11v16.16a.75.75 0 0 0 .75.75h3.94a.74.74 0 0 0 .74-.75V81.68c0-7.23-3.08-10.87-9.74-10.87M177.72 71.26h5.88a1.08 1.08 0 0 1 1 .79l4.77 18a25.25 25.25 0 0 1 .56 3h.11s.28-1.51.68-3l5-17.93a1.07 1.07 0 0 1 1-.77h4.72a1.05 1.05 0 0 1 1 .77l5 17.93c.39 1.52.62 3 .62 3h.11s.22-1.51.62-3l4.77-18a1.06 1.06 0 0 1 1-.79h5.77a.6.6 0 0 1 .57.77l-8.26 27.16a.88.88 0 0 1-.85.63h-6.57a.88.88 0 0 1-.85-.63l-4.63-15.66c-.45-1.52-.73-3.08-.73-3.08h-.11a26.65 26.65 0 0 1-.67 3.08l-4.63 15.66a.89.89 0 0 1-.85.63h-6.63a.88.88 0 0 1-.85-.63L177.15 72a.6.6 0 0 1 .57-.77M226.79 71.26h5.62a.75.75 0 0 1 .74.75v27.06a.74.74 0 0 1-.74.75h-5.62a.74.74 0 0 1-.75-.75V72a.75.75 0 0 1 .75-.75M240.85 92a.68.68 0 0 1 1-.16 11.88 11.88 0 0 0 7.22 2.65c2 0 3.75-.9 3.75-2.58 0-4.26-13.88-3.7-13.88-12.88 0-5.32 4.76-8.4 10.92-8.4a14.67 14.67 0 0 1 8.81 2.62 1.16 1.16 0 0 1 .35 1.46l-1.85 3.7a.67.67 0 0 1-1 .25 11.17 11.17 0 0 0-6.39-2c-1.85 0-3.64.78-3.64 2.57 0 4 13.89 3.53 13.89 12.72 0 4.76-4.15 8.57-10.92 8.57A16.49 16.49 0 0 1 238.83 97a1.18 1.18 0 0 1-.25-1.56zM277.13 70.59c8.23 0 12.65 6 12.65 13.55 0 .55-.07 1.57-.12 2.19a.61.61 0 0 1-.6.56H269.9c.45 5 4.31 7.56 8.57 7.56a13.72 13.72 0 0 0 7.58-2.64.73.73 0 0 1 1.06.26l1.89 3.51a1.12 1.12 0 0 1-.31 1.44A18.25 18.25 0 0 1 278 100.5c-9.47 0-15.35-6.84-15.35-15 0-8.79 6-15 14.51-15m5.45 11.5c-.11-3.86-2.52-5.93-5.65-5.93-3.64 0-6.16 2.24-6.84 5.93zM291.52 62.41a4.59 4.59 0 1 1-4.47 4.59 4.53 4.53 0 0 1 4.47-4.59m0 8.32A3.73 3.73 0 1 0 288 67a3.61 3.61 0 0 0 3.55 3.73M290 65a.37.37 0 0 1 .42-.42h1.42a1.38 1.38 0 0 1 1.48 1.45 1.27 1.27 0 0 1-.87 1.26 1.47 1.47 0 0 1 .17.26l.65 1.27c.15.29.06.48-.23.48h-.15a.48.48 0 0 1-.49-.3l-.73-1.53h-.78V69a.35.35 0 0 1-.39.4h-.11a.35.35 0 0 1-.39-.4zm1.65 1.83a.72.72 0 0 0 .77-.8.7.7 0 0 0-.76-.77h-.77v1.57z"
      }), _react["default"].createElement("path", {
        "class": "svg-hw-logo-color-1",
        d: "M57.13 112.08h-.77a.4.4 0 0 1-.46-.46v-.15a.42.42 0 0 1 .46-.48h.77v-.45a3.2 3.2 0 0 1 3.24-3.54h.21a.42.42 0 0 1 .46.47v.24c0 .32-.17.44-.51.46-.83 0-2.1.26-2.1 2.41v.42h2a.42.42 0 0 1 .46.48v.15a.4.4 0 0 1-.46.46h-2v8a.43.43 0 0 1-.48.48h-.36a.42.42 0 0 1-.46-.48zM66.62 110.68a5.06 5.06 0 1 1-5.08 5 5 5 0 0 1 5.08-5m0 8.94a3.81 3.81 0 0 0 3.75-3.93 3.76 3.76 0 1 0-7.51 0 3.81 3.81 0 0 0 3.76 3.93M73.54 111.39a.44.44 0 0 1 .48-.48h.35a.43.43 0 0 1 .46.48v1.31a3.7 3.7 0 0 1-.08.76 3.45 3.45 0 0 1 3.11-2.61c.35 0 .5.16.5.46v.35c0 .31-.21.48-.54.48-2 0-3 2.32-3 4.34v3.6a.42.42 0 0 1-.46.48H74a.44.44 0 0 1-.48-.48zM89.43 110.68c2.57 0 4 1.86 4 4.61a.48.48 0 0 1-.5.48H86a3.68 3.68 0 0 0 3.75 3.85 4.09 4.09 0 0 0 2.53-.88.4.4 0 0 1 .63.12l.16.23a.45.45 0 0 1-.14.63 5.5 5.5 0 0 1-3.22 1.08 4.89 4.89 0 0 1-5-5 4.71 4.71 0 0 1 4.76-5.07m2.71 4.11c-.08-2-1.31-3-2.75-3a3.33 3.33 0 0 0-3.32 3zM94.66 111.47c-.14-.35 0-.56.36-.56h.42a.49.49 0 0 1 .52.38l2.55 6.7a10.34 10.34 0 0 1 .33 1.17 10.3 10.3 0 0 1 .34-1.17l2.54-6.7a.49.49 0 0 1 .52-.38h.4c.36 0 .5.21.38.56l-3.32 8.73a.49.49 0 0 1-.52.36h-.63a.52.52 0 0 1-.54-.36zM109 110.68c2.57 0 4 1.86 4 4.61a.48.48 0 0 1-.5.48h-7a3.68 3.68 0 0 0 3.74 3.85 4.15 4.15 0 0 0 2.54-.88.4.4 0 0 1 .63.12l.15.23a.44.44 0 0 1-.13.63 5.54 5.54 0 0 1-3.23 1.08 4.88 4.88 0 0 1-5-5 4.71 4.71 0 0 1 4.76-5.07m2.7 4.11c-.07-2-1.3-3-2.74-3a3.33 3.33 0 0 0-3.32 3zM115.5 111.39a.44.44 0 0 1 .48-.48h.35a.43.43 0 0 1 .46.48v1.31a3.7 3.7 0 0 1-.08.76 3.45 3.45 0 0 1 3.11-2.61c.35 0 .5.16.5.46v.35c0 .31-.21.48-.54.48-2 0-3 2.32-3 4.34v3.6a.42.42 0 0 1-.46.48H116a.44.44 0 0 1-.48-.48zM121.42 123.19a1.94 1.94 0 0 0 .84.25c.87 0 1.44-.75 1.81-1.59l.57-1.36-3.8-9c-.13-.33 0-.56.37-.56h.44a.51.51 0 0 1 .54.37l2.7 6.67c.17.48.35 1 .35 1a8.82 8.82 0 0 1 .32-1l2.65-6.66a.51.51 0 0 1 .54-.38h.42c.35 0 .5.21.38.56l-4.54 11a2.87 2.87 0 0 1-4.11 1.73.43.43 0 0 1-.21-.61l.11-.22a.45.45 0 0 1 .58-.23M136.24 107.55a.42.42 0 0 1 .46-.48h.37a.43.43 0 0 1 .47.48v4.82a4.48 4.48 0 0 1-.07.79 4.22 4.22 0 0 1 3.85-2.48c2.4 0 3.25 1.36 3.25 3.74v5.66a.42.42 0 0 1-.46.48h-.37a.43.43 0 0 1-.48-.48v-5.31c0-1.52-.23-2.86-2.11-2.86a3.75 3.75 0 0 0-3.65 4v4.18a.43.43 0 0 1-.47.48h-.37a.42.42 0 0 1-.46-.48zM151.39 110.68c2.57 0 4 1.86 4 4.61a.48.48 0 0 1-.5.48H148a3.68 3.68 0 0 0 3.74 3.85 4.15 4.15 0 0 0 2.54-.88.4.4 0 0 1 .63.12l.15.23a.44.44 0 0 1-.13.63 5.54 5.54 0 0 1-3.23 1.08 4.88 4.88 0 0 1-5-5 4.71 4.71 0 0 1 4.76-5.07m2.7 4.11c-.07-2-1.3-3-2.74-3a3.33 3.33 0 0 0-3.32 3zM162.58 114.65h.55v-.3c0-1.87-1-2.5-2.38-2.5a4.52 4.52 0 0 0-2.34.67.44.44 0 0 1-.65-.15l-.11-.19a.44.44 0 0 1 .13-.66 6 6 0 0 1 3.07-.84c2.3 0 3.59 1.29 3.59 3.7v5.7a.42.42 0 0 1-.46.48h-.31a.43.43 0 0 1-.48-.48v-.76a3.84 3.84 0 0 1 .06-.73 3.58 3.58 0 0 1-3.26 2.2c-1.63 0-3.26-1-3.26-2.82 0-3.14 4-3.32 5.89-3.32m-2.4 5c1.86 0 2.95-1.92 2.95-3.61v-.46h-.53c-1.52 0-4.57.06-4.57 2.23a1.93 1.93 0 0 0 2.15 1.84M167.28 107.55a.42.42 0 0 1 .46-.48h.37a.43.43 0 0 1 .48.48v10.5c0 1.21.57 1.34 1 1.4a.39.39 0 0 1 .4.42v.29a.43.43 0 0 1-.5.48c-.79 0-2.21-.25-2.21-2.36zM172.26 112.08h-.81a.4.4 0 0 1-.46-.46v-.15a.42.42 0 0 1 .46-.48h.83v-2.27a.43.43 0 0 1 .48-.48h.34a.42.42 0 0 1 .46.48V111h2a.43.43 0 0 1 .48.48v.15a.42.42 0 0 1-.48.46h-2v4.84c0 2.22 1.36 2.49 2.11 2.53.39 0 .52.15.52.48v.25c0 .31-.15.46-.54.46-2.11 0-3.39-1.29-3.39-3.55zM178 107.55a.42.42 0 0 1 .46-.48h.36a.43.43 0 0 1 .48.48v4.82a3.94 3.94 0 0 1-.08.79 4.24 4.24 0 0 1 3.86-2.48c2.4 0 3.24 1.36 3.24 3.74v5.66a.42.42 0 0 1-.46.48h-.36a.43.43 0 0 1-.48-.48v-5.31c0-1.52-.23-2.86-2.11-2.86a3.75 3.75 0 0 0-3.65 4v4.18a.43.43 0 0 1-.48.48h-.36a.42.42 0 0 1-.46-.48zM197.77 110.68a3.47 3.47 0 0 1 3.17 1.94 4.56 4.56 0 0 1-.06-.73v-4.34a.43.43 0 0 1 .48-.48h.36a.42.42 0 0 1 .46.48v12.53a.42.42 0 0 1-.46.48h-.32a.42.42 0 0 1-.48-.46v-.73a2.41 2.41 0 0 1 .07-.59 3.57 3.57 0 0 1-3.35 2c-2.59 0-4.21-2.07-4.21-5.06s1.81-5 4.34-5m.06 8.94c1.61 0 3.13-1.15 3.13-3.89 0-2-1-3.86-3.07-3.86-1.71 0-3.11 1.42-3.11 3.86s1.24 3.89 3.05 3.89M209.14 110.68c2.57 0 4 1.86 4 4.61a.48.48 0 0 1-.5.48h-6.95a3.67 3.67 0 0 0 3.74 3.85 4.09 4.09 0 0 0 2.53-.88.41.41 0 0 1 .64.12l.15.23a.44.44 0 0 1-.13.63 5.54 5.54 0 0 1-3.23 1.08 4.89 4.89 0 0 1-5-5 4.72 4.72 0 0 1 4.77-5.07m2.7 4.11c-.08-2-1.3-3-2.74-3a3.32 3.32 0 0 0-3.32 3zM219.68 110.68a5.07 5.07 0 0 1 3.2 1.09.42.42 0 0 1 .06.66l-.14.21c-.17.27-.38.27-.65.09a4 4 0 0 0-2.44-.88 3.89 3.89 0 0 0 0 7.77 4.24 4.24 0 0 0 2.73-1 .38.38 0 0 1 .63.11l.14.19a.48.48 0 0 1-.12.66 5.38 5.38 0 0 1-3.43 1.22 5.06 5.06 0 1 1 0-10.11M225.44 108.24v-.69a.42.42 0 0 1 .46-.48h.48a.42.42 0 0 1 .46.48v.69a.41.41 0 0 1-.46.46h-.48a.4.4 0 0 1-.46-.46m0 3.15a.44.44 0 0 1 .48-.48h.37a.42.42 0 0 1 .46.48v8.69a.42.42 0 0 1-.46.48H226a.44.44 0 0 1-.48-.48zM229.16 119l.15-.19a.44.44 0 0 1 .66-.08 4.13 4.13 0 0 0 2.55.88c1.08 0 2-.54 2-1.55 0-2.17-5.17-1.52-5.17-4.7 0-1.79 1.52-2.71 3.29-2.71a4.47 4.47 0 0 1 2.65.79.41.41 0 0 1 .13.63l-.13.21a.43.43 0 0 1-.66.14 3.58 3.58 0 0 0-2.07-.62c-1 0-1.9.44-1.9 1.5 0 2.22 5.14 1.51 5.14 4.74 0 1.59-1.34 2.72-3.26 2.72a5 5 0 0 1-3.26-1.11.43.43 0 0 1-.08-.65M238 108.24v-.69a.42.42 0 0 1 .46-.48h.48a.42.42 0 0 1 .46.48v.69a.4.4 0 0 1-.46.46h-.48a.41.41 0 0 1-.46-.46m0 3.15a.43.43 0 0 1 .48-.48h.37a.42.42 0 0 1 .46.48v8.69a.42.42 0 0 1-.46.48h-.37a.43.43 0 0 1-.48-.48zM246.73 110.68a5.06 5.06 0 1 1-5.09 5 5 5 0 0 1 5.09-5m0 8.94a3.8 3.8 0 0 0 3.74-3.93 3.76 3.76 0 1 0-7.51 0 3.81 3.81 0 0 0 3.77 3.93M253.81 111.39a.43.43 0 0 1 .48-.48h.34a.43.43 0 0 1 .46.48v1.11a3.37 3.37 0 0 1-.07.69 4.29 4.29 0 0 1 3.9-2.51c2.4 0 3.24 1.36 3.24 3.74v5.66a.43.43 0 0 1-.48.48h-.36a.42.42 0 0 1-.46-.48v-5.31c0-1.52-.25-2.86-2.11-2.86a3.74 3.74 0 0 0-3.67 3.93v4.24a.42.42 0 0 1-.46.48h-.36a.43.43 0 0 1-.48-.48zM264.72 106.49a2.49 2.49 0 1 1-2.42 2.51 2.45 2.45 0 0 1 2.42-2.48m0 4.51a2 2 0 1 0-1.92-2 2 2 0 0 0 1.92 2m-.83-3.1a.19.19 0 0 1 .22-.22h.77a.74.74 0 0 1 .81.78.67.67 0 0 1-.47.68.72.72 0 0 1 .08.14l.36.69c.08.15 0 .26-.12.26h-.09a.25.25 0 0 1-.26-.17l-.4-.83h-.42v.74a.19.19 0 0 1-.21.22h-.06a.19.19 0 0 1-.21-.22zm.89 1a.4.4 0 0 0 .42-.44.38.38 0 0 0-.41-.41h-.42v.85z"
      }), _react["default"].createElement("path", {
        "class": "svg-hw-logo-color-2",
        d: "M180.81 14.13A24.56 24.56 0 0 0 156 38.61a24.28 24.28 0 0 0 2.7 11.17.07.07 0 1 0 .12-.05 19.16 19.16 0 1 1 18.32 11.94 19.23 19.23 0 0 1-7.79-1.4c-.07 0-.13.08 0 .12a24.48 24.48 0 1 0 11.51-46.26"
      }), _react["default"].createElement("path", {
        "class": "svg-hw-logo-color-2",
        d: "M176 27.39a15.23 15.23 0 0 0-13.17 22c0 .06.14 0 .12 0a9.86 9.86 0 0 1-.38-3.32 10 10 0 1 1 10.53 10.47 10.18 10.18 0 0 1-3.33-.38c-.07 0-.11.08 0 .11a15.08 15.08 0 0 0 7.59 1.55A15.23 15.23 0 0 0 176 27.39"
      }), _react["default"].createElement("path", {
        "class": "svg-hw-logo-color-2",
        d: "M178.43 46.52a5.86 5.86 0 1 1-5.86-5.86 5.86 5.86 0 0 1 5.86 5.86"
      }));
    }
  }]);

  return HealthwiseLogo;
}(_react.Component);

HealthwiseLogo.propTypes = {
  title: _propTypes["default"].string,
  className: _propTypes["default"].string
};
HealthwiseLogo.defaultProps = {
  title: 'Healthwise: Helping People Make Better Health Decisions'
};
var _default = HealthwiseLogo;
exports["default"] = _default;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var AddIcon = function AddIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M21.3 0H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0zm-2.6 13.3h-5.3v5.3h-2.7v-5.3H5.3v-2.7h5.3V5.3h2.7v5.3h5.3v2.7h.1z"
  }));
};

var _default = AddIcon;
exports["default"] = _default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

var _IconFormatting = __webpack_require__(121);

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var AnalyticsIcon = function AnalyticsIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 96 96"
  }, props), _react["default"].createElement(_IconFormatting.PathContrast, {
    d: "M72.76 38.94h14.17v50.33H72.76zm-58.55 33.5h13.81v16.71H14.21zm19.68-13.49h14v30.33h-14zm19.44 5.45h13.94v24.88H53.33z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimary, {
    d: "M9.83 81.71H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm0-9.13H2.42a.87.87 0 1 1 0-1.73h7.41a.87.87 0 1 1 0 1.73zm82.76 81.69H2.42a.84.84 0 1 1 0-1.67h90.17a.84.84 0 1 1 0 1.67zM23.55 57.28a1 1 0 0 1-.81-.42 1 1 0 0 1 .24-1.4l58.87-41.75A1 1 0 0 1 83 15.34L24.13 57.09a1 1 0 0 1-.58.19z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimary, {
    d: "M83.51 23.28a1 1 0 0 1-1-1v-7.94h-8.92a1 1 0 0 1 0-2h9.91a1 1 0 0 1 1 1v8.93a1 1 0 0 1-1 1z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M76.71 35.44H90.3v50.5H76.71zM17.64 69.18h13.59v16.76H17.64zm19.69-13.66h13.59v30.43H37.33zm19.69 5.46h13.59v24.96H57.02z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.72",
    theme: props.theme
  }));
};

AnalyticsIcon.defaultProps = {
  theme: _Theme.defaultTheme
};
var _default = AnalyticsIcon;
exports["default"] = _default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var AnalyticsSimpleIcon = function AnalyticsSimpleIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M.1.06v23.9H24v-2.7H2.6V.06H.1zm20.2 19.4h3.5V3.76h-3.5v15.7zm-10.7 0h3.5V5.56H9.6v13.9zm5.2 0h3.5V8.96h-3.5v10.5zm-10.5 0h3.5v-7H4.3v7z"
  }));
};

var _default = AnalyticsSimpleIcon;
exports["default"] = _default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

var _IconFormatting = __webpack_require__(121);

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var BrandingIcon = function BrandingIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 96 96"
  }, props), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    as: "rect",
    x: "2.64",
    y: "7.36",
    width: "90.67",
    height: "59",
    rx: "2.88",
    ry: "2.88",
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathContrast, {
    d: "M31.06 25.81l8.31 9.9 12.37-20.15 22.09 38-60.04.06 17.27-27.81z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    as: "rect",
    x: "28.4",
    y: "84.69",
    width: "39.68",
    height: "5.83",
    rx: "2.57",
    ry: "2.57",
    fill: "none",
    strokeWidth: "1.5",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M28.72 85.94l7.83-19.7m23.34 0l7.75 19.54",
    strokeMiterlimit: "10",
    fill: "none",
    strokeWidth: "1.5",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M37.73 29.31l8.3 9.9 12.38-20.15 22.09 38-60.04.06 17.27-27.81z",
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    theme: props.theme
  }));
};

BrandingIcon.defaultProps = {
  theme: _Theme.defaultTheme
};
var _default = BrandingIcon;
exports["default"] = _default;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var BrandingSimpleIcon = function BrandingSimpleIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M23.3 1.4H.7c-.3 0-.5.2-.5.5v15.7c0 .3.2.5.5.5h8.2L8.2 21H8c-.3 0-.5.4-.5.9s.2.9.5.9h7.9c.3 0 .5-.4.5-.9s-.2-.9-.5-.9h-.2l-.6-2.9h8.2c.3 0 .5-.2.5-.5V1.9c0-.3-.3-.5-.5-.5zM9.2 21l.6-2.9h4.3l.6 2.9H9.2zM8.7 6.6l2.2 2.6 3.2-5.3 5.8 9.9H4.3l4.4-7.2z"
  }));
};

var _default = BrandingSimpleIcon;
exports["default"] = _default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var CheckIcon = function CheckIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M7.9 16.9l-5.4-5.3-1.8 1.8 7.2 7.1L23.3 5.3l-1.8-1.8z"
  }));
};

var _default = CheckIcon;
exports["default"] = _default;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var CheckboxCheckedIcon = function CheckboxCheckedIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M21.3 0H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0zM10.8 17.4l-2.1 2.1-6.2-6.2 2.1-2.1 4.1 4.1L19.4 4.5l2.1 2.1-10.7 10.8z"
  }));
};

var _default = CheckboxCheckedIcon;
exports["default"] = _default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var CheckboxUncheckedIcon = function CheckboxUncheckedIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M21.3 2.7v18.7H2.7V2.7h18.6zm0-2.7H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0z"
  }));
};

var _default = CheckboxUncheckedIcon;
exports["default"] = _default;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var CollapseIcon = function CollapseIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M21.3 0H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0zm0 21.3H2.7V2.7h18.7v18.6h-.1z"
  }), _react["default"].createElement("path", {
    d: "M12 5.3l-5.3 5.4h4V20h2.6v-9.3h4"
  }));
};

var _default = CollapseIcon;
exports["default"] = _default;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var DashboardIcon = function DashboardIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M19 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-1.26-4.703a1.012 1.012 0 0 0-1.435 0 1.004 1.004 0 0 0 0 1.444 1.02 1.02 0 0 0 1.434-1.444zM14 15.755a1.982 1.982 0 0 0-.368-1.132L11.494 8l-2.145 6.677c-.194.29-.313.638-.324 1.01L9 15.764h.012v.01c0 1.229 1.116 2.225 2.494 2.225C12.884 18 14 17.004 14 15.774v-.019zM11 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.701 5.293A.992.992 0 0 0 5.997 5 .999.999 0 0 0 5 6c0 .552.446 1 .997 1a.992.992 0 0 0 .704-.293.983.983 0 0 0 0-1.414zM4 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 14C5.372 24 0 18.628 0 12S5.372 0 12 0s12 5.372 12 12-5.372 12-12 12z",
    fillRule: "evenodd"
  }));
};

var _default = DashboardIcon;
exports["default"] = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

var DownArrowIcon = function DownArrowIcon(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var iconClass = (0, _classnames["default"])(_defineProperty({
    'hw-icon-down-arrow': true
  }, className, className));
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24",
    className: iconClass
  }, otherProps), _react["default"].createElement("path", {
    d: "M21.2 4L12 13.9 2.8 4 0 7l12 13L24 7"
  }));
};

DownArrowIcon.propTypes = {
  className: _propTypes["default"].string
};
var _default = DownArrowIcon;
exports["default"] = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var DownloadIcon = function DownloadIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M21.3 0H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0zm0 16H16c0 2.2-1.8 4-4 4s-4-1.8-4-4H2.7V2.7h18.7V16h-.1zm-4-6.7h-2.7v-4H9.3v4H6.7l5.3 5.3 5.3-5.3z"
  }));
};

var _default = DownloadIcon;
exports["default"] = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var EditIcon = function EditIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M14.6 5.4L16 6.8 5.4 17.4l-.4-1-1.2-.2L14.6 5.4zM2.8 17.3l1.4.2.7 1.6 1.8.8.1 1.3-.1.1-2.8.4-1.5-1.5.4-2.8v-.1zm5 2.8l-.1-.9-1.2-.6L17.2 8l1.4 1.4L7.8 20.1zm6.8-16.9l-1.1 1.1L1.1 16.7 0 24l7.3-1.1 12.4-12.4 1.1-1.1-6.2-6.2zM15.9 2L22 8.1l1.4-1.4c.7-.7.7-1.9 0-2.6L19.8.5c-.7-.7-1.9-.7-2.6 0L15.9 2z"
  }));
};

var _default = EditIcon;
exports["default"] = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var ExpandIcon = function ExpandIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M21.3 0H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0zm0 21.3H2.7V2.7h18.7v18.6h-.1z"
  }), _react["default"].createElement("path", {
    d: "M13.3 14.7V5.3h-2.6v9.4h-4L12 20l5.3-5.3"
  }));
};

var _default = ExpandIcon;
exports["default"] = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

var _IconFormatting = __webpack_require__(121);

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var GroupsIcon = function GroupsIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 170 170"
  }, props), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement(_IconFormatting.PathContrast, {
    d: "M61 49c0 11.6-9.4 21-21 21s-21-9.4-21-21 9.4-21 21-21 21 9.4 21 21m49 84.48c0 12.42-10.08 22.5-22.5 22.5-12.43 0-22.5-10.08-22.5-22.5 0-12.43 10.07-22.5 22.5-22.5 12.42 0 22.5 10.07 22.5 22.5",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathContrast, {
    d: "M150.5 50.5c0 8.3-6.72 15-15 15-8.3 0-15-6.7-15-15 0-8.28 6.7-15 15-15 8.28 0 15 6.72 15 15",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M39.5 99.94V57.2m42.16 73.97l-35.4-20.8m83.54-.47l-36.18 21.27m42.14-73.82v42.27M93.63 25.04l35.3 20.76m-82.98.22l35.27-20.74M66.04 65.4l-19.9-11.7m83.42 49.04l-18.3-10.76m.22-27.9l17.9-10.52m-83.52 49.1L65.68 91M88 50.66V28m0 98.66V104M47.55 50.3c0 3.85-3.14 7-7 7-3.87 0-7-3.15-7-7 0-3.88 3.13-7 7-7 3.86 0 7 3.12 7 7zm94.17-.16c0 3.8-3.02 6.86-6.73 6.86-3.76 0-6.77-3.07-6.77-6.86 0-3.78 3-6.85 6.74-6.85 3.7 0 6.72 3.04 6.72 6.82zM95 22c0 3.87-3.14 7-7 7-3.87 0-7-3.13-7-7s3.13-7 7-7c3.86 0 7 3.13 7 7zm-.53 111.86c0 3.78-3.02 6.85-6.74 6.85-3.72.04-6.73-3.04-6.73-6.82 0-3.8 3-6.86 6.73-6.86 3.72 0 6.74 3.08 6.74 6.87zm-46.92-27c0 3.86-3.14 7-7 7-3.87 0-7-3.14-7-7 0-3.87 3.13-7 7-7 3.86 0 7 3.13 7 7zm94.7 0c0 3.86-3.14 7-7 7-3.87 0-7-3.14-7-7 0-3.87 3.13-7 7-7 3.86 0 7 3.13 7 7zM115 79c0 14.9-12.1 27-27 27S61 93.9 61 79s12.1-27 27-27 27 12.1 27 27z",
    strokeWidth: "4",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M97.72 71.8c0 5.14-4.1 9.3-9.14 9.3-5.05 0-9.15-4.16-9.15-9.3 0-5.15 4.1-9.32 9.15-9.32 5.05 0 9.14 4.17 9.14 9.3z",
    strokeWidth: "4",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M106.58 98v-8.18c0-2.6-2-5.6-4.56-6.4-8.77-2.67-18.12-2.67-26.9 0-2.54.8-4.54 3.8-4.55 6.4l-.08 8.82m8.33-7.24v12.18M98.3 91.4v12.18",
    strokeWidth: "4",
    theme: props.theme
  })));
};

GroupsIcon.defaultProps = {
  theme: _Theme.defaultTheme
};
var _default = GroupsIcon;
exports["default"] = _default;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var HomeIcon = function HomeIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M19.5 24V12h-15v12H9v-9h6v9h4.5zM12 0L1.5 8.6V12h21V8.6L12 0z"
  }));
};

var _default = HomeIcon;
exports["default"] = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var InfoIcon = function InfoIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M0 12c0 6.6 5.4 12 12 12s12-5.4 12-12S18.6 0 12 0 0 5.4 0 12zm13.2 6h-2.4v-2.4h2.4V18zm0-4.8h-2.4V6h2.4v7.2z"
  }));
};

var _default = InfoIcon;
exports["default"] = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var KeyIcon = function KeyIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M12.7 9.8c-.9-2.5-3.3-4.4-6.2-4.4C2.9 5.5 0 8.4 0 12s2.9 6.5 6.5 6.5c2.8 0 5.3-1.8 6.2-4.4h4.7v4.4h4.4v-4.4H24V9.8H12.7zm-6.2 4.4c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.2-2.2 2.2z"
  }));
};

var _default = KeyIcon;
exports["default"] = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var LeftArrowIcon = function LeftArrowIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M20 21.2L10.1 12 20 2.8 17 0 4 12l13 12"
  }));
};

var _default = LeftArrowIcon;
exports["default"] = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var LockedIcon = function LockedIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M19.9 8.2h-1.1V4.5c.1-2.5-2-4.5-4.5-4.5h-4.2C7.6 0 5.5 2 5.5 4.5v3.7H4.1c-1.2 0-2.1.9-2.1 2.1V22c0 1.1.9 2 2.1 2h15.8c1.1 0 2.1-.9 2.1-2.1V10.3c0-1.2-.9-2.1-2.1-2.1zM7.8 8.1V4.5c0-1.2 1-2.3 2.3-2.3h4.2c1.3 0 2.3 1 2.3 2.3v3.7l-8.8-.1zm11.9 13.6H4.3V10.4h15.4v11.3z"
  }));
};

var _default = LockedIcon;
exports["default"] = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var MagnifyingGlassIcon = function MagnifyingGlassIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M17.2 15.1h-1.1l-.4-.4c1.3-1.6 2.2-3.6 2.2-5.8C17.9 4 13.9 0 9 0S0 4 0 8.9s4 8.9 8.9 8.9c2.2 0 4.2-.8 5.8-2.2l.4.4v1.1L22 24l2-2-6.8-6.9zm-8.3 0c-3.4 0-6.2-2.8-6.2-6.2s2.8-6.2 6.2-6.2 6.2 2.8 6.2 6.2-2.8 6.2-6.2 6.2z"
  }));
};

var _default = MagnifyingGlassIcon;
exports["default"] = _default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

var PrinterIcon = function PrinterIcon(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var iconClass = (0, _classnames["default"])(_defineProperty({
    'hw-icon-printer': true
  }, className, className));
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24",
    className: iconClass
  }, otherProps), _react["default"].createElement("path", {
    d: "M20.4 7.2H3.6c-2 0-3.6 1.6-3.6 3.6V18h4.8v4.8h14.4V18H24v-7.2c0-2-1.6-3.6-3.6-3.6zm-3.6 13.2H7.2v-6h9.6v6zm3.6-8.4c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2zM19.2 1.2H4.8V6h14.4V1.2z"
  }));
};

PrinterIcon.propTypes = {
  className: _propTypes["default"].string
};
var _default = PrinterIcon;
exports["default"] = _default;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var ProfileIcon = function ProfileIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M12 15c-4 0-12 2-12 6v3h24v-3c0-4-8-6-12-6zM12 12c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z"
  }));
};

var _default = ProfileIcon;
exports["default"] = _default;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var RestoreIcon = function RestoreIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M13.7 9.7c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3-1-2.3-2.3-2.3zm0-8C8 1.7 3.4 6.3 3.4 12H0l4.6 4.6L9.1 12H5.7c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-1.7 0-3.3-.6-4.6-1.5l-1.6 1.6c1.7 1.3 3.9 2.1 6.3 2.1C19.4 22.3 24 17.7 24 12S19.4 1.7 13.7 1.7z"
  }));
};

var _default = RestoreIcon;
exports["default"] = _default;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var RightArrowIcon = function RightArrowIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M4 2.8l9.9 9.2L4 21.2 7 24l13-12L7 0"
  }));
};

var _default = RightArrowIcon;
exports["default"] = _default;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var ScrollToTopIcon = function ScrollToTopIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 32 32"
  }, props), _react["default"].createElement("path", {
    d: "M16 32c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16zm0-30c-7.72 0-14 6.28-14 14s6.28 14 14 14 14-6.28 14-14-6.28-14-14-14zM21 19c-.256 0-.512-.098-.707-.293l-4.293-4.293-4.293 4.293c-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414l5-5c.391-.391 1.023-.391 1.414 0l5 5c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293zM16 25c-.552 0-1-.447-1-1v-11c0-.552.448-1 1-1s1 .448 1 1v11c0 .553-.448 1-1 1zM22 10h-12c-.552 0-1-.448-1-1s.448-1 1-1h12c.553 0 1 .448 1 1s-.447 1-1 1z"
  }));
};

var _default = ScrollToTopIcon;
exports["default"] = _default;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var TrashIcon = function TrashIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M2.8 7.4h18.4V3.7H2.8"
  }), _react["default"].createElement("path", {
    d: "M17.3 20.2c0 .5-.4.9-.9.9s-.9-.4-.9-.9V9.5c0-.5.4-.9.9-.9s.9.4.9.9v10.7zm-4.4 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9V9.5c0-.5.4-.9.9-.9s.9.4.9.9v10.7zm-4.4 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9V9.5c0-.5.4-.9.9-.9s.9.4.9.9v10.7zM4 6.8V23c0 .6.4 1 1 1h14c.5 0 1-.5 1-1V6.8H4zm13.5-5.5L16.2 0H7.8L6.5 1.3l1.6 1.2.9-.9h6l.9.9"
  }));
};

var _default = TrashIcon;
exports["default"] = _default;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var UnlockedIcon = function UnlockedIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M19.9 8.2H7.8V4.5c0-1.2 1-2.3 2.3-2.3h4.2c1.3 0 2.3 1 2.3 2.3v.2c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-.2c.1-2.5-2-4.5-4.5-4.5H10C7.5 0 5.5 2 5.5 4.5v3.7H4.1c-1.2 0-2.1.9-2.1 2.1V22c0 1.1.9 2 2.1 2h15.8c1.1 0 2.1-.9 2.1-2.1V10.3c0-1.2-.9-2.1-2.1-2.1zm-.2 13.5H4.3V10.4h15.4v11.3z"
  }));
};

var _default = UnlockedIcon;
exports["default"] = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

var UpArrowIcon = function UpArrowIcon(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var iconClass = (0, _classnames["default"])(_defineProperty({
    'hw-icon-up-arrow': true
  }, className, className));
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24",
    className: iconClass
  }, otherProps), _react["default"].createElement("path", {
    d: "M21.2 20L12 10.1 2.8 20 0 17 12 4l12 13"
  }));
};

UpArrowIcon.propTypes = {
  className: _propTypes["default"].string
};
var _default = UpArrowIcon;
exports["default"] = _default;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

var _IconFormatting = __webpack_require__(121);

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var UsersIcon = function UsersIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 96 96"
  }, props), _react["default"].createElement(_IconFormatting.PathContrast, {
    as: "circle",
    cx: "81.27",
    cy: "67.13",
    r: "11.96",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathContrast, {
    as: "circle",
    cx: "13.96",
    cy: "28.31",
    r: "11.96",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathContrast, {
    as: "circle",
    cx: "81.19",
    cy: "28.31",
    r: "11.96",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimary, {
    d: "M14.1 34.73a6.14 6.14 0 1 1 6.14-6.14 6.14 6.14 0 0 1-6.14 6.14zm0-10.54a4.41 4.41 0 1 0 4.41 4.4 4.41 4.41 0 0 0-4.41-4.4zm66.81 10.54A6.14 6.14 0 1 1 87 28.59a6.14 6.14 0 0 1-6.09 6.14zm0-10.54a4.41 4.41 0 1 0 4.4 4.4 4.42 4.42 0 0 0-4.4-4.4zM14.1 73.12A6.14 6.14 0 1 1 20.24 67a6.14 6.14 0 0 1-6.14 6.12zm0-10.54A4.4 4.4 0 1 0 18.51 67a4.4 4.4 0 0 0-4.41-4.42zm66.81 10.54A6.14 6.14 0 1 1 87 67a6.14 6.14 0 0 1-6.09 6.12zm0-10.54a4.4 4.4 0 1 0 4.4 4.4 4.41 4.41 0 0 0-4.4-4.4zM47.29 30.6a.87.87 0 0 1-.87-.87V14.35a.87.87 0 1 1 1.74 0v15.38a.87.87 0 0 1-.87.87zm0 51.14a.87.87 0 0 1-.87-.87V65.49a.87.87 0 1 1 1.74 0v15.38a.87.87 0 0 1-.87.87z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimary, {
    d: "M31.92 39.35a.88.88 0 0 1-.44-.12l-13-7.61a.86.86 0 1 1 .87-1.49l13 7.6a.88.88 0 0 1 .31 1.19.86.86 0 0 1-.74.43zm44.15 26.24a.8.8 0 0 1-.44-.13L62.4 57.61a.88.88 0 0 1-.3-1.19.86.86 0 0 1 1.19-.3L76.52 64a.87.87 0 0 1-.45 1.62zm-56.98-.09a.85.85 0 0 1-.74-.42.86.86 0 0 1 .29-1.19l12.83-7.75a.87.87 0 0 1 .9 1.48l-12.83 7.75a.84.84 0 0 1-.45.13zm43.73-26.07a.87.87 0 0 1-.45-1.61L75.44 30a.88.88 0 0 1 1.19.3.86.86 0 0 1-.3 1.19l-13.07 7.8a.88.88 0 0 1-.44.14zM42.73 85a.82.82 0 0 1-.43-.12L18.08 70.79a.87.87 0 0 1 .87-1.5L43.17 83.4a.86.86 0 0 1 .31 1.18.86.86 0 0 1-.75.42zM18.52 26.47a.86.86 0 0 1-.75-.43.88.88 0 0 1 .31-1.19l24.22-14.1a.87.87 0 0 1 .87 1.5L19 26.35a.82.82 0 0 1-.48.12zM14 62.22a.87.87 0 0 1-.87-.86V34a.87.87 0 0 1 1.74 0v27.36a.87.87 0 0 1-.87.86zM52.56 85a.86.86 0 0 1-.75-.43.86.86 0 0 1 .31-1.18L76.19 69.3a.87.87 0 1 1 .88 1.49L53 84.89a.88.88 0 0 1-.44.11zm23.93-58.67a.88.88 0 0 1-.44-.12l-23.93-14a.87.87 0 0 1 .88-1.5l23.93 14a.87.87 0 0 1-.44 1.62zm4.84 35.89a.86.86 0 0 1-.86-.86V34a.87.87 0 1 1 1.73 0v27.36a.87.87 0 0 1-.87.86z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimary, {
    d: "M47.66 15.22a6.14 6.14 0 1 1 6.14-6.14 6.14 6.14 0 0 1-6.14 6.14zm0-10.54a4.4 4.4 0 1 0 4.41 4.4 4.41 4.41 0 0 0-4.41-4.4zm0 87.6a6.14 6.14 0 1 1 6.14-6.14 6.15 6.15 0 0 1-6.14 6.14zm0-10.54a4.4 4.4 0 1 0 4.41 4.4 4.41 4.41 0 0 0-4.41-4.4zm0-15.67a18.53 18.53 0 1 1 18.53-18.53 18.55 18.55 0 0 1-18.53 18.53zm0-35.32a16.79 16.79 0 1 0 16.8 16.79 16.81 16.81 0 0 0-16.8-16.79z",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    as: "circle",
    cx: "47.51",
    cy: "41.69",
    r: "6.49",
    fill: "none",
    strokeMiterlimit: "10",
    strokeWidth: "1.75",
    theme: props.theme
  }), _react["default"].createElement(_IconFormatting.PathPrimaryStroke, {
    fill: "none",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M47.22 65.17a18 18 0 0 1-11.48-4.6c-.5-.41-.67-.69-.56-1.16 1.64-7.22 5.46-10.81 12.33-10.81s10.76 4 12.39 11.16c.1.43 0 .52-.19.71a17.81 17.81 0 0 1-12.49 4.7z",
    theme: props.theme
  }));
};

UsersIcon.defaultProps = {
  theme: _Theme.defaultTheme
};
var _default = UsersIcon;
exports["default"] = _default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var UsersSimpleIcon = function UsersSimpleIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("circle", {
    cx: "12",
    cy: "7.1",
    r: "3.2"
  }), _react["default"].createElement("circle", {
    cx: "19.1",
    cy: "7.8",
    r: "2.4"
  }), _react["default"].createElement("path", {
    d: "M23.7 15.7c-.5-3-2-4.7-4.7-4.7-1 0-1.9.2-2.5.7l.3.2a10 10 0 0 1 2.3 5.1v.2c2.6.1 4.8-.3 4.6-1.5z"
  }), _react["default"].createElement("circle", {
    cx: "4.9",
    cy: "7.8",
    r: "2.4"
  }), _react["default"].createElement("path", {
    d: "M7.2 12l.2-.2c-.6-.6-1.5-.8-2.5-.8-2.6 0-4.2 1.7-4.7 4.7-.2 1.2 2.1 1.6 4.7 1.6v-.2A9.3 9.3 0 0 1 7.2 12zm4.8 7.4c-3.5 0-6.5-.6-6.3-2.1.7-4 2.7-6.3 6.3-6.3s5.6 2.4 6.3 6.3c.2 1.4-2.9 2.1-6.3 2.1z"
  }));
};

var _default = UsersSimpleIcon;
exports["default"] = _default;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

var WarningIcon = function WarningIcon(props) {
  return _react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("path", {
    d: "M0 22.4h24L12 1.6 0 22.4zm13.1-3.3h-2.2v-2.2h2.2v2.2zm0-4.4h-2.2v-4.4h2.2v4.4z"
  }));
};

var _default = WarningIcon;
exports["default"] = _default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 15px 0;\n  max-width: 100%;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 95%;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 95%;\n  border-top: solid 1px ", ";\n  position: relative;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  width: 10%;\n\n  /* Thank you, IE, and the horse you rode in on */\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    padding-bottom: 160%;\n    height: 1px;\n    overflow: visible;\n    display: block;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-height: 16px;\n  max-width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  display: block;\n  right: 0;\n  transform: translate(90%, -50%);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var IconOffPath = _styledComponents["default"].path(_templateObject(), function (props) {
  return props.theme.colorNeutralLight;
}, function (props) {
  return props.theme.colorNeutralLight;
});

var IconOnPath = _styledComponents["default"].path(_templateObject2(), function (props) {
  return props.theme.colorPrimaryDark;
}, function (props) {
  return props.theme.colorPrimaryDark;
});

var IconRangePath = _styledComponents["default"].path(_templateObject3(), function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return props.theme.colorPrimary;
});

var IconRowBreakCountSpan = _styledComponents["default"].span(_templateObject4());

var IconRowBreakCountSvg = _styledComponents["default"].svg(_templateObject5());

var IconSpan = _styledComponents["default"].span(_templateObject6());

var RowBreakDiv = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.theme.colorBorder;
});

var IconSvg = _styledComponents["default"].svg(_templateObject8());

var RowIconDiv = _styledComponents["default"].div(_templateObject9());

var IconArrayDiv = _styledComponents["default"].div(_templateObject10());

function IconWrapper(props) {
  return _react["default"].createElement(IconSpan, {
    className: "hw-array-".concat(props.iconStyle),
    key: props.id
  }, _react["default"].createElement(IconSvg, {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 80",
    preserveAspectRatio: "xMidYMin slice",
    focusable: "false"
  }, props.children));
}

IconWrapper.propTypes = {
  iconStyle: _propTypes["default"].string,
  id: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
IconWrapper.defaultProps = {
  iconStyle: 'icon_off',
  theme: _Theme.defaultTheme
};

var IconArray = /*#__PURE__*/function (_Component) {
  _inherits(IconArray, _Component);

  function IconArray() {
    _classCallCheck(this, IconArray);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconArray).apply(this, arguments));
  }

  _createClass(IconArray, [{
    key: "getCountMarker",
    value: function getCountMarker(keyBase) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _react["default"].createElement(IconRowBreakCountSpan, {
        className: 'hw-icon-break-row-count',
        key: "count-marker-".concat(keyBase, "-").concat(count)
      }, _react["default"].createElement(IconRowBreakCountSvg, {
        role: "presentation",
        width: "42",
        height: "26",
        viewBox: "0 0 42 26",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
      }, _react["default"].createElement("g", null, _react["default"].createElement("text", {
        transform: "matrix(1.6493341922760008,0,0,1.6493341922760008,-0.23193762078881264,-0.11160431429743767) ",
        stroke: "null",
        y: "12.49819",
        x: "0.55858",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontSize: "12"
      }, count))));
    }
  }, {
    key: "getSvgPart",
    value: function getSvgPart(style, otherAttributes) {
      var as = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'path';

      switch (style) {
        case 'icon_on':
          return _react["default"].createElement(IconOnPath, _extends({
            as: as
          }, otherAttributes, {
            theme: this.props.theme
          }));

        case 'icon_range':
          return _react["default"].createElement(IconRangePath, _extends({
            as: as
          }, otherAttributes, {
            theme: this.props.theme
          }));

        default:
          return _react["default"].createElement(IconOffPath, _extends({
            as: as
          }, otherAttributes, {
            theme: this.props.theme
          }));
      }
    }
  }, {
    key: "getNeutralIcon",
    value: function getNeutralIcon(key) {
      var iconStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon_off';
      return _react["default"].createElement(IconWrapper, {
        key: key,
        id: key,
        iconStyle: iconStyle,
        theme: this.props.theme
      }, _react["default"].createElement("g", null, this.getSvgPart(iconStyle, {
        strokeWidth: '3',
        d: 'm40.50356,32.83198l-15.50356,47.16802l-15.50356,-47.16802l31.00712,0z'
      }), this.getSvgPart(iconStyle, {
        strokeWidth: '3',
        cy: '20.5',
        cx: '25',
        r: '9.0625'
      }, 'circle')));
    }
  }, {
    key: "getFemaleIcon",
    value: function getFemaleIcon(key) {
      var iconStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon_off';
      return _react["default"].createElement(IconWrapper, {
        key: key,
        id: key,
        iconStyle: iconStyle,
        theme: this.props.theme
      }, _react["default"].createElement("g", null, this.getSvgPart(iconStyle, {
        strokeWidth: '1',
        cy: '15.99642',
        cx: '25',
        r: '7.49054'
      }, 'circle'), this.getSvgPart(iconStyle, {
        d: 'm24.9478,22.25514c3.53531,0 6.40466,-2.46273 6.40466,-5.50086c0,-3.03984 -2.86934,-5.50428 -6.40466,-5.50428c-3.5383,0 -6.40863,2.46444 -6.40863,5.50428c0,3.03813 2.86934,5.50086 6.40863,5.50086zm17.96242,23.72371l-5.74762,-18.30894c-0.0536,-0.16623 -0.12903,-0.32478 -0.22033,-0.47141c-0.65308,-1.71513 -2.52792,-2.95715 -4.74221,-2.95715l-14.54719,0c-2.30858,0 -4.24696,1.34858 -4.81764,3.17879c-0.03871,0.08013 -0.07047,0.16452 -0.09925,0.25147l-5.64539,18.30809c-0.37617,1.20025 0.45357,2.43374 1.853,2.75683c1.39746,0.32137 2.83362,-0.39128 3.20979,-1.59152l4.43353,-14.3817l1.84706,0l-8.04627,26.02106l7.58179,0l0,17.96455c0,1.38182 1.30217,2.50109 2.91301,2.50109c1.60687,0 2.91202,-1.11842 2.91202,-2.50109l0,-17.96455l2.31652,0l0,17.96455c0,1.38182 1.30415,2.50109 2.915,2.50109c1.60687,0 2.91202,-1.11842 2.91202,-2.50109l0,-17.96455l7.5778,0l-8.07604,-26.02106l1.89569,0l4.51491,14.3817c0.37616,1.20025 1.81233,1.91289 3.20977,1.59152c1.39448,-0.32308 2.22421,-1.55743 1.85004,-2.75768l0,0z',
        fillOpacity: 'null',
        strokeOpacity: 'null',
        strokeWidth: '1',
        stroke: 'null',
        fill: 'null'
      })));
    }
  }, {
    key: "getMaleIcon",
    value: function getMaleIcon(key) {
      var iconStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon_off';
      return _react["default"].createElement(IconWrapper, {
        key: key,
        id: key,
        iconStyle: iconStyle,
        theme: this.props.theme
      }, _react["default"].createElement("g", null, this.getSvgPart(iconStyle, {
        strokeWidth: '1.53',
        d: 'm43.48424,33.63831l0,-2.74599c0,-2.88918 -3.36696,-5.23169 -7.52503,-5.23169l-21.92206,0c-4.15567,0 -7.52503,2.34251 -7.52503,5.23169l0,2.74599c-0.00727,0.06233 -0.01212,0.12635 -0.01212,0.1912l0,15.81639c0,1.22895 1.43208,2.22458 3.19975,2.22458c1.76525,0 3.20095,-0.99563 3.20095,-2.22458l0,-15.58222l2.14568,0l0,17.80848l0.01575,0l0,25.16285c0,1.6358 1.91065,2.96499 4.26592,2.96499c2.35649,0 4.26592,-1.3275 4.26592,-2.96499l0,-25.16285l2.81447,0l0,25.16285c0,1.6358 1.91183,2.96499 4.26592,2.96499c2.35648,0 4.26591,-1.3275 4.26591,-2.96499l0,-25.16285l0.01333,0l0,-17.80848l2.14568,0l0,15.58137c0,1.22896 1.4357,2.22543 3.20096,2.22543c1.76769,0 3.19975,-0.99647 3.19975,-2.22543l0,-15.81638c-0.0012,-0.0657 -0.0085,-0.12804 -0.01575,-0.19037l0,0l0,0.00001z'
      }), this.getSvgPart(iconStyle, {
        strokeWidth: '1.5',
        cy: '15.99642',
        cx: '25',
        r: '7.49054'
      }, 'circle')));
    }
  }, {
    key: "getRowBreak",
    value: function getRowBreak(keyBase, count) {
      return _react["default"].createElement(RowBreakDiv, {
        key: "row-break-".concat(keyBase, "-").concat(count)
      }, this.getCountMarker(keyBase, count));
    }
  }, {
    key: "getIconRow",
    value: function getIconRow(keyBase, icons, count) {
      return _react["default"].createElement(RowIconDiv, {
        key: "row-".concat(keyBase, "-").concat(count)
      }, icons);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var getIconFactory = {
        neutral: function neutral(key, style) {
          return _this.getNeutralIcon(key, style);
        },
        female: function female(key, style) {
          return _this.getFemaleIcon(key, style);
        },
        male: function male(key, style) {
          return _this.getMaleIcon(key, style);
        }
      };
      var iconStyles = {
        on: 'icon_on',
        off: 'icon_off',
        midRange: 'icon_range'
      };
      var _this$props = this.props,
          minRange = _this$props.minRange,
          maxRange = _this$props.maxRange,
          total = _this$props.total,
          iconType = _this$props.iconType,
          forceBreakOn = _this$props.forceBreakOn;
      minRange = parseInt(minRange, 10);
      maxRange = parseInt(maxRange, 10) || 0;
      total = parseInt(total, 10);
      var getIcon = getIconFactory[iconType];
      var keyBase = "icon-array-key-".concat(Math.ceil(Math.random() * 99999999));
      var rows = [this.getRowBreak(keyBase, 0)];
      var icons = [];

      for (var count = 1; count <= total; count++) {
        var iconStyle = iconStyles.off;

        if (count <= minRange) {
          iconStyle = iconStyles.on;
        } else if (count <= maxRange) {
          iconStyle = iconStyles.midRange;
        }

        icons.push(getIcon("".concat(keyBase, "-").concat(count), iconStyle));

        if (count % forceBreakOn === 0) {
          rows.unshift(this.getIconRow(keyBase, icons, count));
          rows.unshift(this.getRowBreak(keyBase, count));
          icons = [];
        }
      }

      if (icons.length !== 0) {
        rows.unshift(this.getIconRow(keyBase, icons, total));
        rows.unshift(this.getRowBreak(keyBase, total));
      }

      return _react["default"].createElement(IconArrayDiv, {
        "aria-hidden": true
      }, rows);
    }
  }]);

  return IconArray;
}(_react.Component);

IconArray.propTypes = {
  minRange: _propTypes["default"].string,
  maxRange: _propTypes["default"].string,
  total: _propTypes["default"].string,
  iconType: _propTypes["default"].oneOf(['male', 'female', 'neutral']),
  forceBreakOn: _propTypes["default"].number,
  theme: _propTypes["default"].shape({
    colorNeutralLight: _propTypes["default"].string,
    colorPrimaryDark: _propTypes["default"].string,
    colorPrimary: _propTypes["default"].string,
    colorBorder: _propTypes["default"].string
  })
};
IconArray.defaultProps = {
  minRange: '0',
  total: '100',
  iconType: 'neutral',
  forceBreakOn: 10,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(IconArray);

exports["default"] = _default;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _uniqueId = _interopRequireDefault(__webpack_require__(216));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _Message = _interopRequireDefault(__webpack_require__(240));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0.25em;\n  font-size: 0.75em;\n  line-height: 1;\n  height: 1em;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  width: 100%;\n  height: 40px;\n  padding: ", ";\n  color: ", ";\n  line-height: 30px;\n  vertical-align: middle;\n  box-sizing: border-box;\n  font-size: 1em;\n  border: ", ";\n  background: ", ";\n  transition: border ease 0.2s;\n  box-shadow: none;\n\n  ::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n\n  :invalid:not(:focus) {\n    border-color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.25em;\n  flex: 1 0 auto;\n  font-size: 0.75em;\n  letter-spacing: 0.5px;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n  display: inline-flex;\n  flex-flow: column nowrap;\n  align-items: flex-start;\n  cursor: ", ";\n  opacity: ", ";\n\n  ::after {\n    display: ", ";\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 1.125em;\n    height: ", ";\n    background: ", ";\n    background-image: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Label = _styledComponents["default"].label(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'auto';
}, function (props) {
  return props.disabled ? '0.35' : '1';
}, function (props) {
  return props.underlined ? 'block' : 'none';
}, function (props) {
  return props.autoFocus || props.focused || props.error && props.dirty ? '2px' : '1px';
}, function (props) {
  return props.autoFocus || props.focused ? 'transparent' : props.error && props.dirty && (!props.autoFocus || !props.focused) ? props.theme.colorError : props.theme.colorTextPrimary;
}, function (props) {
  return props.autoFocus || props.focused ? "repeating-linear-gradient(\n        to right,\n        ".concat(props.theme.colorTextPrimary, ",\n        ").concat(props.theme.colorTextPrimary, " 2px,\n        transparent 0,\n        transparent 4px\n      )") : 'none';
});

var LabelText = _styledComponents["default"].span(_templateObject2(), function (props) {
  return props.theme.colorTextPrimary;
});

var Input = _styledComponents["default"].input(_templateObject3(), function (props) {
  return props.underlined ? '0' : '0 8px';
}, function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.underlined ? 'none' : props.error && props.dirty && (!props.autoFocus || !props.focused) ? "1px solid ".concat(props.theme.colorError) : "1px solid ".concat(props.theme.colorTextPrimary);
}, function (props) {
  return props.underlined ? 'none' : props.theme.colorBackgroundLight;
}, function (props) {
  return props.theme.colorTextSecondary;
}, function (props) {
  return props.underlined ? 'none' : props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.error && props.dirty && (!props.autoFocus || !props.focused) ? props.theme.colorError : props.theme.colorTextPrimary;
});

var Error = _styledComponents["default"].div(_templateObject4());

var InputText = /*#__PURE__*/function (_Component) {
  _inherits(InputText, _Component);

  function InputText(props) {
    var _this;

    _classCallCheck(this, InputText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputText).call(this, props));
    _this.input = _react["default"].createRef();
    _this.fallbackError = 'Value is unexpected.';
    var validationErrors = Object.assign({
      patternMismatch: 'Value is unexpected.',
      rangeOverflow: 'Value is too large.',
      rangeUnderflow: 'Value is too small.',
      stepMismatch: 'This is an invalid step interval value.',
      tooLong: 'Value is too long.',
      tooShort: 'Value is too short.',
      typeMismatch: 'Value is not the correct format.',
      valueMissing: 'This field is required.',
      fallback: _this.fallbackError
    }, props.validationErrors);
    var hasError = props.error && props.error.length;
    _this.state = {
      isValid: !hasError,
      error: hasError ? props.error : null,
      // error message string
      dirty: hasError,
      validationErrors: validationErrors
    };
    _this.errorId = (0, _uniqueId["default"])('hw-input-text-error');
    _this.checkValidity = _this.checkValidity.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this lets the parent component fire off the validation whenever it wants to
      // - approach taken from https://stackoverflow.com/questions/37949981/call-child-method-from-parent/45582558#45582558
      this.props.getValidator(this.checkValidity.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.getValidator(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.error !== this.props.error) {
        // if error is truthy, fire off an error, otherwise recheck it
        if (this.props.error && this.props.error.length) {
          this.setState({
            isValid: false,
            error: this.props.error,
            dirty: true
          });
        } else {
          this.setState({
            isValid: true,
            error: this.props.error
          }, function () {
            return _this2.checkValidity(false);
          });
        }
      }
    }
  }, {
    key: "checkValidity",
    value: function checkValidity() {
      var calledExternally = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props = this.props,
          error = _this$props.error,
          validators = _this$props.validators,
          onValid = _this$props.onValid,
          onInvalid = _this$props.onInvalid;
      var validationErrors = this.state.validationErrors;
      var fallbackError = this.fallbackError;
      var input = this.input.current;
      var validity = input && input.validity;
      var isValid = !error;
      var errorType = error ? 'supplied' : null;
      var errorMessage = error || null; // if there's not an error yet AND the field is dirty AND we have browser support...

      if (isValid && (this.state.dirty || calledExternally) && validity) {
        isValid = validity.valid;
      } // if we're valid so far, run the custom validation


      if (isValid && validators) {
        Object.keys(validators).forEach(function (key) {
          // the "!!" gets us a boolean, regardless of what comes back
          var customIsValid = !!validators[key](input.value);
          isValid = isValid && customIsValid;

          if (!customIsValid) {
            errorType = key;
            errorMessage = validationErrors[key] || validationErrors['fallback'] || fallbackError;
          }
        });
      } // when there's an error


      if (!isValid) {
        // find the right error message
        if (!errorMessage) {
          // try to find a known message (via the HTML5 validity API)
          Object.keys(validationErrors).forEach(function (key) {
            if (typeof validity[key] !== 'undefined' && validity[key] === true) {
              errorType = key;
              errorMessage = validationErrors[key];
            }
          }); // if we can't find one, go with the fallback

          if (!errorMessage) {
            errorType = 'unknown';
            errorMessage = validationErrors.fallback;
          }
        } // invalid callback


        onInvalid(input.value, errorType);
      } else {
        // valid callback
        onValid(input.value);
      }

      this.setState({
        isValid: isValid,
        error: errorMessage,
        dirty: true
      });
      return isValid;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      this.setState({
        dirty: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      this.checkValidity(false);
      this.setState({
        dirty: true
      });
      this.props.onBlur(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          type = _this$props2.type,
          required = _this$props2.required,
          disabled = _this$props2.disabled,
          readonly = _this$props2.readonly,
          underlined = _this$props2.underlined,
          autoFocus = _this$props2.autoFocus,
          focused = _this$props2.focused,
          label = _this$props2.label,
          error = _this$props2.error,
          theme = _this$props2.theme,
          onBlur = _this$props2.onBlur,
          validationErrors = _this$props2.validationErrors,
          validators = _this$props2.validators,
          onValid = _this$props2.onValid,
          onInvalid = _this$props2.onInvalid,
          getValidator = _this$props2.getValidator,
          otherProps = _objectWithoutProperties(_this$props2, ["className", "placeholder", "type", "required", "disabled", "readonly", "underlined", "autoFocus", "focused", "label", "error", "theme", "onBlur", "validationErrors", "validators", "onValid", "onInvalid", "getValidator"]);

      var _this$state = this.state,
          dirty = _this$state.dirty,
          isValid = _this$state.isValid;
      return _react["default"].createElement(Label, {
        disabled: disabled,
        underlined: underlined,
        autoFocus: autoFocus || focused,
        error: error || !isValid,
        dirty: dirty,
        theme: theme
      }, label && _react["default"].createElement(LabelText, {
        className: "hw-input-text-label",
        theme: theme
      }, label, required && ' *'), _react["default"].createElement(Input, _extends({
        className: (0, _classnames["default"])('hw-input-text', "hw-input-text-".concat(type), className),
        ref: this.input,
        type: type,
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        readOnly: readonly,
        "aria-required": required,
        "aria-describedby": this.errorId,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        error: error || !isValid,
        dirty: dirty,
        autoFocus: autoFocus || focused,
        theme: theme,
        underlined: underlined
      }, otherProps)), _react["default"].createElement(Error, {
        id: this.errorId,
        className: "hw-input-text-error-container"
      }, !isValid && this.state.dirty && _react["default"].createElement(_Message["default"], {
        className: (0, _classnames["default"])('hw-input-text-error', "".concat(className, "-error")),
        type: "error",
        showIcon: false
      }, this.state.error)));
    }
  }]);

  return InputText;
}(_react.Component);

InputText.propTypes = {
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['text', 'tel', 'password', 'email', 'search', 'url', 'number', 'date', 'datetime', 'datetime-local', 'month', 'week', 'time']),
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readonly: _propTypes["default"].bool,
  underlined: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  onBlur: _propTypes["default"].func,
  error: _propTypes["default"].string,
  validationErrors: _propTypes["default"].object,
  validators: _propTypes["default"].object,
  onValid: _propTypes["default"].func,
  onInvalid: _propTypes["default"].func,
  // gives parent access to the validation function, to run at will
  getValidator: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    colorBackgroundLight: _propTypes["default"].string,
    colorTextPrimary: _propTypes["default"].string,
    colorTextSecondary: _propTypes["default"].string,
    colorError: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    focusIndicatorOffset: _propTypes["default"].string
  })
};
InputText.defaultProps = {
  type: 'text',
  onBlur: function onBlur() {},
  onValid: function onValid() {},
  onInvalid: function onInvalid() {},
  getValidator: function getValidator() {},
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(InputText);

exports["default"] = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Radio = _interopRequireDefault(__webpack_require__(241));

var _ScreenReaderOnly = _interopRequireDefault(__webpack_require__(242));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  padding: 6px;\n  cursor: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  @media print {\n    ", "\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    background-color: #fff;\n    border-color: #fff;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background-color: #000;\n    border-color: #000;\n    color: #fff;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  box-sizing: border-box;\n  width: 9.09092%;\n  height: ", ";\n  background: #fff;\n  font-size: 1.25em;\n  text-align: center;\n  border: 2px solid #dde0e6;\n  border-right: none;\n  margin: 0;\n  padding: 0;\n  padding-top: ", ";\n  transition: all 0.5s ease-out;\n\n  :first-child {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n  }\n\n  :last-child {\n    border-right: 2px solid #dde0e6;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n  }\n\n  @media screen and (max-width: 750px) {\n    border-width: 1px;\n    padding: 0;\n    ", "\n\n    :first-child {\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n\n    :last-child {\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n  }\n\n  @media print {\n    ", "\n  }\n\n  input[type='radio'] {\n    display: block;\n    margin: 15px auto 5px;\n    padding: 4px 2px 2px 4px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 30%;\n  color: #363942;\n  font-weight: 500;\n  line-height: 1em;\n  font-size: 0.75em;\n\n  @media screen and (max-width: 750px) {\n    width: 35%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  width: 50%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  padding-bottom: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px auto 2em;\n\n  @media screen and (max-width: 750px) {\n    margin-bottom: 1em;\n  }\n\n  .hw-radio-wrapper .hw-radio-image .hw-radio-focus-outline {\n    @media screen and (-ms-high-contrast: active) {\n      stroke: #000;\n    }\n    @media screen and (-ms-high-contrast: black-on-white) {\n      stroke: #fff;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].div(_templateObject());

var LabelsContainer = _styledComponents["default"].div(_templateObject2());

var ScaleLabel = _styledComponents["default"].span(_templateObject3());

var LeftScaleLabel = (0, _styledComponents["default"])(ScaleLabel)(_templateObject4());
var RightScaleLabel = (0, _styledComponents["default"])(ScaleLabel)(_templateObject5());

var ScaleLabelText = _styledComponents["default"].span(_templateObject6());

var ButtonDefault = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.readonly ? '74px' : props.forPrint ? '80px' : 'auto';
}, function (props) {
  return props.readonly ? '27px' : props.forPrint ? '16px' : '0';
}, function (props) {
  return props.readonly ? "\n      padding-top: 0;\n      height: inherit;\n      line-height: 2em;\n    " : '';
}, function (props) {
  return props.readonly ? "\n      padding: 0.25em;\n      border-color: #eee;\n      height: auto;\n      width: 9.09092%;\n      font-weight: normal;\n      color: #9e9e9e;\n    " : '';
});

var ButtonActive = (0, _styledComponents["default"])(ButtonDefault)(_templateObject8(), function (props) {
  return props.readonly ? "\n      font-weight: bold;\n      border-color: rgba(1, 122, 203, 1);\n      border-right: 2px solid rgba(1, 122, 203, 1);\n      border-left-width: 0;\n      background-color: #fff;\n      color: #000;\n    " : '';
});

var ButtonLabel = _styledComponents["default"].label(_templateObject9(), function (props) {
  return props.readonly ? 'default' : 'pointer';
});

var ButtonLabelNumber = _styledComponents["default"].span(_templateObject10(), function (props) {
  return props.readonly ? '0' : '0.4em 0 0';
});

var LikertScale = /*#__PURE__*/function (_React$Component) {
  _inherits(LikertScale, _React$Component);

  function LikertScale(props) {
    var _this;

    _classCallCheck(this, LikertScale);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LikertScale).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.getAxisId = _this.getAxisId.bind(_assertThisInitialized(_this));
    _this.axisBgColors = [];
    _this.axisTextColors = [];
    _this.classNameBase = 'hw_likert_axis_button_'; // set up component state so we can retain the selected value (even if the change doesn't trigger a rerender)

    _this.state = {
      currentValue: _this.props.selectedAnswer
    };

    _this.initStyle();

    return _this;
  }

  _createClass(LikertScale, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var currentVal = parseInt(this.props.selectedAnswer, 10);
      var newVal = parseInt(nextProps.selectedAnswer, 10);

      if (currentVal !== newVal) {
        this.setState({
          currentValue: newVal
        });
      }
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var props = this.props;
      var total = props.maxValue - props.minValue + 1;
      var increment = 1 / total;

      for (var num = 0; num < total; num++) {
        var alpha = increment * num + increment;
        this.axisBgColors[num] = {
          backgroundColor: 'rgba(' + this.props.baseRgbColor + ', ' + alpha + ')'
        };
        this.axisTextColors[num] = {
          color: this.getTextColor(alpha)
        };
      }
    }
  }, {
    key: "getTextColor",
    value: function getTextColor(alpha) {
      var rgbaToRgb = function rgbaToRgb(colors, alpha) {
        return colors.map(function (color) {
          return (1 - alpha) * 255 + alpha * color;
        });
      }; // adapted from http://stackoverflow.com/a/3943023


      var getLuminance = function getLuminance(colors) {
        colors = colors.map(function (c) {
          c = c / 255;
          return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * colors[0] + 0.7152 * colors[1] + 0.0722 * colors[2];
      };

      var bg = this.props.baseRgbColor.split(',');
      var darkText = this.props.darkTextRgbColor.split(',');
      var lightText = this.props.lightTextRgbColor.split(',');
      var toReturn = this.props.darkTextRgbColor; // compare the bg luminance to the dark and light text and pick the best color based on that

      if (bg && darkText && lightText && bg.length === 3 && darkText.length === 3 && lightText.length === 3) {
        var bgColor = rgbaToRgb(bg, alpha);
        var bgLuminance = getLuminance(bgColor);
        var darkLuminance = getLuminance(darkText);
        var lightLuminance = getLuminance(lightText); // TODO (enhancement): we could determine if their contrast ratio is high enough, and if it's not, just send black/white text

        toReturn = (bgLuminance + 0.05) / (darkLuminance + 0.05) > (lightLuminance + 0.05) / (bgLuminance + 0.05) ? this.props.darkTextRgbColor : this.props.lightTextRgbColor;
      }

      return 'rgb(' + toReturn + ')';
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var el = e.currentTarget;

      if (!this.props.readonly) {
        if (el) {
          var selectedValue = parseInt(el.getAttribute('data-hw-value'), 10); // record the value locally

          this.setState({
            currentValue: selectedValue
          }); // run callback with selected value

          this.props.onAnswer(e, selectedValue, this.props.answerId);
        }
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, {
    key: "getAxisId",
    value: function getAxisId(num) {
      return this.props.id + '_key_' + num;
    }
  }, {
    key: "render",
    value: function render() {
      var selectedAnswer = parseInt(this.state.currentValue, 10);
      var _this$props = this.props,
          id = _this$props.id,
          scaleWrapperId = _this$props.scaleWrapperId,
          name = _this$props.name,
          isRequired = _this$props.isRequired,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue,
          minValueText = _this$props.minValueText,
          maxValueText = _this$props.maxValueText,
          readonly = _this$props.readonly,
          forPrint = _this$props.forPrint;
      name = name || id;
      scaleWrapperId = scaleWrapperId || id + '_scale_wrapper';
      var labels = [];
      var width = 100 / (maxValue - minValue + 1) + '%';
      var widthObj = {
        width: width
      };

      for (var i = 0, num = minValue; num <= maxValue; i++, num++) {
        var axisId = this.getAxisId(num);
        var Button = ButtonDefault;
        var radio = null;
        var textColorObj = this.axisTextColors[this.axisTextColors.length - 1];
        var bgColorObj = {
          backgroundColor: 'rgba(' + this.props.baseRgbColor + ', 1)'
        };

        var defaultRadio = _react["default"].createElement(_Radio["default"], {
          forPrint: forPrint,
          onChange: this.handleChange,
          name: name,
          id: axisId,
          "data-hw-width": num,
          "data-hw-value": num,
          defaultChecked: selectedAnswer === num,
          value: 'hw-likert-button_val_' + num,
          isRequired: isRequired
        });

        if (!readonly) {
          textColorObj = this.axisTextColors[i];
          bgColorObj = this.axisBgColors[i];
          radio = defaultRadio;
        }

        if (forPrint) {
          radio = defaultRadio;
        }

        if (!isNaN(selectedAnswer) && num <= selectedAnswer) {
          // color all the squares to the left of and including the selected answer
          Button = ButtonActive;
        } else {
          bgColorObj = {};
          textColorObj = {
            color: 'rgb(' + this.props.darkTextRgbColor + ')'
          };
        }

        labels.push(_react["default"].createElement(Button, {
          id: axisId + '_label',
          key: axisId,
          style: _objectSpread({}, bgColorObj, {}, widthObj),
          readonly: readonly,
          forPrint: forPrint
        }, _react["default"].createElement(ButtonLabel, {
          htmlFor: axisId,
          readonly: readonly
        }, _react["default"].createElement(ButtonLabelNumber, {
          style: textColorObj,
          readonly: readonly
        }, num), radio)));
      }

      var textValueEquivalent = readonly ? _react["default"].createElement(_ScreenReaderOnly["default"], null, "".concat(selectedAnswer || 0, " of ").concat(maxValue)) : null;
      return _react["default"].createElement(Root, {
        className: "hw-likert-scale",
        id: id,
        "data-hw-likert-min": minValue,
        "data-hw-likert-max": maxValue
      }, _react["default"].createElement(LabelsContainer, {
        className: "hw-likert-labels"
      }, _react["default"].createElement(LeftScaleLabel, {
        className: "hw-likert-label hw-likert-label-left",
        "aria-hidden": "true"
      }, _react["default"].createElement(ScaleLabelText, null, minValueText)), _react["default"].createElement(RightScaleLabel, {
        className: "hw-likert-label hw-likert-label-right",
        "aria-hidden": "true"
      }, _react["default"].createElement(ScaleLabelText, null, maxValueText))), _react["default"].createElement("div", {
        id: scaleWrapperId,
        className: "hw-likert-scale-wrapper"
      }, _react["default"].createElement("div", {
        className: "hw-likert-axis",
        "aria-hidden": readonly
      }, labels), textValueEquivalent));
    }
  }]);

  return LikertScale;
}(_react["default"].Component);

LikertScale.propTypes = {
  id: _propTypes["default"].string.isRequired,
  answerId: _propTypes["default"].string,
  isRequired: _propTypes["default"].bool,
  selectedAnswer: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  minValue: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  maxValue: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  minValueText: _propTypes["default"].string,
  maxValueText: _propTypes["default"].string,
  name: _propTypes["default"].string,
  scaleWrapperId: _propTypes["default"].string,
  baseRgbColor: _propTypes["default"].string,
  darkTextRgbColor: _propTypes["default"].string,
  lightTextRgbColor: _propTypes["default"].string,
  readonly: _propTypes["default"].bool,
  forPrint: _propTypes["default"].bool,
  onAnswer: _propTypes["default"].func
};
LikertScale.defaultProps = {
  isRequired: false,
  minValue: 0,
  maxValue: 10,
  minValueText: 'Not at all important',
  maxValueText: 'Extremely important',
  baseRgbColor: '1, 122, 203',
  darkTextRgbColor: '54, 57, 66',
  lightTextRgbColor: '255, 255, 255',
  readonly: false,
  forPrint: false,
  onAnswer: function onAnswer() {}
};

var _default = (0, _styledComponents.withTheme)(LikertScale);

exports["default"] = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Dialog = _interopRequireDefault(__webpack_require__(480));

var _DialogContent = _interopRequireDefault(__webpack_require__(482));

var _styles = __webpack_require__(257);

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _uniqueId = _interopRequireDefault(__webpack_require__(216));

var _Button = _interopRequireDefault(__webpack_require__(120));

var _ButtonGroup = _interopRequireDefault(__webpack_require__(388));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: ", ";\n  color: ", ";\n  font-size: 1.25rem;\n  font-weight: 500;\n  line-height: 1.2;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

// TODO: Material UI doesn't support overriding a theme locally by using the
// theme prop, like styled-components does. The theme argument in the
// withStyles function can only be updated using the MuiThemeProvider. The
// @material-ui/styles package (currently in alpha) is supposed to release
// with material-ui v4, and will support this functionality. Until then, we
// need these inline default values, to support a component having a default
// theme without requiring the consumer to use a ThemeProvider component in
// their app.
var Dialog = (0, _styles.withStyles)(function (theme) {
  return {
    paper: {
      margin: "".concat(theme.spacingXxl || '64px', " ").concat(theme.spacingL || '24px'),
      padding: theme.spacingL || '24px'
    }
  };
})(_Dialog["default"]);
var DialogContent = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: '0',
      '& > *:first-child': {
        marginTop: 0
      },
      '& > *:last-child': {
        marginBottom: 0
      }
    }
  };
})(_DialogContent["default"]);

var Title = _styledComponents["default"].h2(_templateObject(), function (props) {
  return props.hasContent ? "0 0 ".concat(props.theme.spacingL) : 0;
}, function (props) {
  return props.theme.colorTextPrimary;
});

var Actions = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.theme.spacingL;
});

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.titleId = (0, _uniqueId["default"])('hw-modal-title');
    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          children = _this$props.children,
          className = _this$props.className,
          maxWidth = _this$props.maxWidth,
          onClose = _this$props.onClose,
          _onExited = _this$props.onExited,
          open = _this$props.open,
          title = _this$props.title,
          theme = _this$props.theme,
          classes = _this$props.classes,
          fullWidth = _this$props.fullWidth,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExiting = _this$props.onExiting,
          PaperProps = _this$props.PaperProps,
          scroll = _this$props.scroll,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          showTitle = _this$props.showTitle,
          showActions = _this$props.showActions,
          otherProps = _objectWithoutProperties(_this$props, ["actions", "children", "className", "maxWidth", "onClose", "onExited", "open", "title", "theme", "classes", "fullWidth", "onEnter", "onEntering", "onExit", "onExiting", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "showTitle", "showActions"]);

      var hasContent = _react["default"].Children.count(children) > 0;
      return _react["default"].createElement(Dialog, _extends({}, otherProps, {
        "aria-labelledby": this.titleId,
        className: (0, _classnames["default"])('hw-modal', className),
        open: open // this is because the Material dialog ONLY fires its native onClose with escape or overlay click, not any time the modal is closed

        , onExited: function onExited() {
          onClose();
          _onExited && _onExited();
        },
        scroll: "paper",
        maxWidth: maxWidth
      }), showTitle && _react["default"].createElement(Title, {
        id: this.titleId,
        className: "hw-modal-title",
        theme: theme,
        hasContent: hasContent
      }, title), children && _react["default"].createElement(DialogContent, {
        className: "hw-modal-content"
      }, children), showActions && _react["default"].createElement(Actions, {
        theme: theme
      }, _react["default"].createElement(_ButtonGroup["default"], {
        className: "hw-modal-actions"
      }, actions || _react["default"].createElement(_Button["default"], {
        color: "neutralLight",
        rounded: true,
        onClick: onClose
      }, "Close"))));
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  actions: _propTypes["default"].any,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disableBackdropClick: _propTypes["default"].bool,
  disableEscapeKeyDown: _propTypes["default"].bool,
  fullScreen: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].oneOf(['xs', 'sm', 'md', false]),
  onBackdropClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onEntered: _propTypes["default"].func,
  onExited: _propTypes["default"].func,
  onEscapeKeyDown: _propTypes["default"].func,
  open: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string.isRequired,
  showTitle: _propTypes["default"].bool,
  showActions: _propTypes["default"].bool,
  // TODO: update this propType with all the variables being used in the modal
  // once @material-ui/styles package is being used.
  theme: _propTypes["default"].shape({
    colorTextPrimary: _propTypes["default"].string,
    spacingL: _propTypes["default"].string
  })
};
Modal.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  maxWidth: 'sm',
  onClose: function onClose() {},
  theme: _Theme.defaultTheme,
  showTitle: true,
  showActions: true
};

var _default = (0, _styledComponents.withTheme)(Modal);

exports["default"] = _default;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 1em 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  margin: 0;\n  padding: 0;\n  font-size: 1em;\n  line-height: normal;\n  font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  margin: 2em 0;\n  padding: 0;\n  font-size: 0.8em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].fieldset(_templateObject());

var Legend = _styledComponents["default"].legend(_templateObject2());

var OrderedList = _styledComponents["default"].ol(_templateObject3());

var ListItem = _styledComponents["default"].li(_templateObject4());

var References = /*#__PURE__*/function (_Component) {
  _inherits(References, _Component);

  function References() {
    _classCallCheck(this, References);

    return _possibleConstructorReturn(this, _getPrototypeOf(References).apply(this, arguments));
  }

  _createClass(References, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          references = _this$props.references,
          referencesLabel = _this$props.referencesLabel,
          otherProps = _objectWithoutProperties(_this$props, ["references", "referencesLabel"]);

      return _react["default"].createElement(Root, otherProps, _react["default"].createElement(Legend, null, referencesLabel), _react["default"].createElement(OrderedList, null, references.map(function (reference) {
        return _react["default"].createElement(ListItem, {
          key: reference.id
        }, reference.title);
      })));
    }
  }]);

  return References;
}(_react.Component);

References.defaultProps = {
  referencesLabel: 'References'
};
References.propTypes = {
  referencesLabel: _propTypes["default"].string,
  references: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string
  })).isRequired
};

var _default = (0, _styledComponents.withTheme)(References);

exports["default"] = _default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _Theme = __webpack_require__(17);

var _Tab = _interopRequireDefault(__webpack_require__(243));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: ", ";\n  text-align: center;\n  box-sizing: border-box;\n  flex: ", ";\n\n  :first-child {\n    margin-left: 0;\n  }\n\n  :last-child {\n    margin-right: 0;\n  }\n\n  @media screen and (max-width: 750px) {\n    width: inherit;\n    margin: 5px 2px 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: stretch;\n  overflow-x: auto;\n  margin: 0;\n  padding: 0 ", ";\n  box-sizing: border-box;\n  list-style: none;\n  width: ", ";\n\n  @media screen and (max-width: 750px) {\n    width: 100%;\n    padding: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Root = _styledComponents["default"].ol(_templateObject(), function (props) {
  return props.theme.spacingL;
}, function (props) {
  return props.stretch ? '100%' : 'auto';
});

var Container = _styledComponents["default"].li(_templateObject2(), function (props) {
  return "".concat(props.theme.spacingXs, " ").concat(props.theme.spacingXs, " 0");
}, function (props) {
  return props.stretch ? '1' : '0 1 auto';
});

var TabGroup = /*#__PURE__*/function (_Component) {
  _inherits(TabGroup, _Component);

  function TabGroup() {
    var _this;

    _classCallCheck(this, TabGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabGroup).call(this));
    _this.tabGroup = _react["default"].createRef();
    return _this;
  }

  _createClass(TabGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollToActive();
    }
  }, {
    key: "scrollToActive",
    value: function scrollToActive() {
      var parent = this.tabGroup.current; // grab the first active tab, if there is one

      var activeTab = parent && parent.querySelector('.hw-tab-is-active');

      if (parent && activeTab) {
        var parentLeft = parent.offsetLeft;
        var parentWidth = parent.offsetWidth;
        var tabLeft = activeTab.offsetLeft;
        var tabWidth = activeTab.offsetWidth;
        var amountToScroll = tabLeft - parentLeft - parentWidth / 2 + tabWidth / 2;
        parent.scrollLeft = amountToScroll;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          stretch = _this$props.stretch,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className", "stretch", "theme"]);

      return _react["default"].createElement(Root, _extends({
        ref: this.tabGroup,
        className: (0, _classnames["default"])('hw-tab-group', className),
        stretch: stretch,
        theme: theme
      }, otherProps), _react["default"].Children.map(children, function (tab, index) {
        return _react["default"].createElement(Container, {
          key: index,
          stretch: stretch,
          theme: theme
        }, tab);
      }));
    }
  }]);

  return TabGroup;
}(_react.Component);

TabGroup.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    type: _propTypes["default"].oneOf([_Tab["default"]])
  }), _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].oneOf([_Tab["default"]])
  }))]),
  className: _propTypes["default"].string,
  stretch: _propTypes["default"].bool,
  theme: _propTypes["default"].shape({
    spacingXs: _propTypes["default"].string,
    spacingL: _propTypes["default"].string
  })
};
TabGroup.defaultProps = {
  stretch: true,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(TabGroup);

exports["default"] = _default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = __webpack_require__(7);

var _kebabCase = _interopRequireDefault(__webpack_require__(872));

var _defaultTheme = _interopRequireDefault(__webpack_require__(167));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;_e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  :root {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

// Make theme variables available as CSS custom properties.
// For example, theme.colorPrimary will be available in CSS
// as var(--color-primary)
var CssVars = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (props) {
  return Object.entries(props.theme).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "--".concat((0, _kebabCase["default"])(key), ": ").concat(value, ";");
  }).join('\n');
});
CssVars.defaultProps = {
  theme: _defaultTheme["default"]
};
var _default = CssVars;
exports["default"] = _default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styledComponents = __webpack_require__(7);

var _styles = __webpack_require__(257);

var _createTheme = _interopRequireDefault(__webpack_require__(246));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var hwTheme = (0, _createTheme["default"])(theme);
  var muiTheme = (0, _styles.createMuiTheme)(theme);
  return _react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: hwTheme
  }, _react["default"].createElement(_styles.MuiThemeProvider, {
    theme: muiTheme
  }, children));
};

ThemeProvider.propTypes = {
  theme: _propTypes["default"].object
};
var _default = ThemeProvider;
exports["default"] = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _upperFirst = _interopRequireDefault(__webpack_require__(874));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

// Returns theme variables based on 'color' prop. This is useful
// in styled-components when you want to set a theme color based
// on props. The 'variant' option can be used to get the light
// or dark version of a color.
//
// Example:
// getThemeVariable('color', { variant: 'light' })({ color: 'primary', theme: { ... } })
// => theme.colorPrimaryLight
var getThemeVariable = function getThemeVariable(variable) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? undefined : _ref$variant;

  return function (props) {
    var theme = props.theme,
        color = props.color;
    variant = variant ? (0, _upperFirst["default"])(variant) : undefined;
    color = (0, _upperFirst["default"])(color);

    switch (variable) {
      case 'colorText':
        {
          return theme["colorTextOn".concat(color).concat(variant || '')];
        }

      case 'color':
      default:
        {
          return theme["color".concat(color).concat(variant || '')];
        }
    }
  };
};

var _default = getThemeVariable;
exports["default"] = _default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 8px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding-left: 23px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 1em;\n  font-weight: 500;\n  position: relative;\n  border: 1px solid #fbcfcd;\n  color: #b20b04;\n  background-color: #fde7e6;\n  padding: 7px;\n  width: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var ErrorLabel = _styledComponents["default"].label(_templateObject());

var ValidationBox = _styledComponents["default"].span(_templateObject2());

var ValidationText = _styledComponents["default"].span(_templateObject3());

var ValidationGlyph = _styledComponents["default"].span(_templateObject4());

var ValidationError = /*#__PURE__*/function (_React$Component) {
  _inherits(ValidationError, _React$Component);

  function ValidationError() {
    _classCallCheck(this, ValidationError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).apply(this, arguments));
  }

  _createClass(ValidationError, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          forId = _this$props.forId,
          otherAttributes = _objectWithoutProperties(_this$props, ["children", "forId"]);

      return _react["default"].createElement(ErrorLabel, {
        role: "alert",
        "aria-atomic": "true",
        htmlFor: forId,
        className: 'hw-validation-label'
      }, _react["default"].createElement(ValidationBox, _extends({
        className: 'hw-validation-box'
      }, otherAttributes), _react["default"].createElement(ValidationGlyph, {
        className: 'hw-validation-glyph'
      }, _react["default"].createElement("svg", {
        role: "presentation",
        focusable: "false",
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react["default"].createElement("g", null, _react["default"].createElement("path", {
        fill: "#950803",
        strokeWidth: "0",
        d: "m15.34324,12.81328l-4.8294,-4.82941l4.82853,-4.82941l-2.48229,-2.48405l-4.8294,4.82941l-4.8294,-4.82941l-2.48229,2.48405l4.82853,4.82941l-4.8294,4.82941l2.48405,2.48317l4.82853,-4.82941l4.82853,4.82941",
        id: "svg_1",
        className: "x_glyph",
        stroke: "#000"
      })))), _react["default"].createElement(ValidationText, {
        className: 'hw-validation-text'
      }, children)));
    }
  }]);

  return ValidationError;
}(_react["default"].Component);

ValidationError.propTypes = {
  children: _propTypes["default"].node.isRequired,
  forId: _propTypes["default"].string
};

var _default = (0, _styledComponents.withTheme)(ValidationError);

exports["default"] = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireWildcard(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Theme = __webpack_require__(17);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { "default": obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj["default"] = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  display: block;\n  width: 3em;\n  height: 3em;\n  left: 50%;\n  top: 50%;\n  transform: translate(-1.5em, -1.5em);\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  width: 100%;\n  border: none;\n\n  &:focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  &:hover .hw-video-thumbnail-overlay,\n  &:focus .hw-video-thumbnail-overlay {\n    opacity: 1;\n  }\n\n  & rect {\n    fill: ", ";\n    fill-opacity: 0.8;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var Videothumbnail = _styledComponents["default"].button(_templateObject(), function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.theme.colorPrimary;
});

var VideoThumbnailImage = _styledComponents["default"].img(_templateObject2());

var VideoThumbnailOverlay = _styledComponents["default"].span(_templateObject3());

var VideoThumbnailIcon = _styledComponents["default"].svg(_templateObject4());

var VideoThumbnail = /*#__PURE__*/function (_Component) {
  _inherits(VideoThumbnail, _Component);

  function VideoThumbnail() {
    _classCallCheck(this, VideoThumbnail);

    return _possibleConstructorReturn(this, _getPrototypeOf(VideoThumbnail).apply(this, arguments));
  }

  _createClass(VideoThumbnail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          src = _this$props.src,
          alt = _this$props.alt,
          onThumbnailClick = _this$props.onThumbnailClick,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["title", "src", "alt", "onThumbnailClick", "theme"]);

      var thumbSrc = src.replace('_640x360.jpg', '.jpg').replace('.jpg', '_640x360.jpg'); // Normalize to correct aspect ratio

      return _react["default"].createElement(Videothumbnail, _extends({
        type: "button",
        className: "hw-video-thumbnail",
        onClick: onThumbnailClick,
        theme: theme
      }, otherProps), _react["default"].createElement(VideoThumbnailImage, {
        className: "hw-video-thumbnail-image",
        src: thumbSrc,
        alt: alt || "open video: ".concat(title)
      }), _react["default"].createElement(VideoThumbnailOverlay, {
        className: "hw-video-thumbnail-overlay"
      }, _react["default"].createElement(VideoThumbnailIcon, {
        focusable: "false",
        "aria-hidden": "true",
        role: "presentation",
        className: 'hw-video-thumbnail-icon',
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react["default"].createElement("g", null, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40"
      }), _react["default"].createElement("g", {
        transform: "translate(12.5, 12.5)"
      }, _react["default"].createElement("polygon", {
        points: "5 3.125 5 11.875 11.875 7.5",
        fill: "#fafafa"
      }))))));
    }
  }]);

  return VideoThumbnail;
}(_react.Component);

VideoThumbnail.propTypes = {
  title: _propTypes["default"].string,
  src: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string,
  onThumbnailClick: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    colorPrimary: _propTypes["default"].string,
    focusIndicator: _propTypes["default"].string,
    focusIndicatorOffset: _propTypes["default"].string
  })
};
VideoThumbnail.defaultProps = {
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(VideoThumbnail);

exports["default"] = _default;

/***/ }),
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "id": "0DCF0013-57AC-4BDB-82C5-F897E904A122",
    "hash": "-1048848141",
    "certifiedDate": "2016-10-31",
    "lang": "en-us",
    "docType": "enhancedshareddp",
    "title": {
        "consumer": "Knee Osteoarthritis: Is It Time to Think About Surgery?"
    },
    "legal": {
        "logoUrl": "https://cdn.healthwise.net/common/images/hwlogo/hwlogo.png",
        "copyrightText": "© 1995-2018 Healthwise, Incorporated. Healthwise, Healthwise for every health decision, and the Healthwise logo are trademarks of Healthwise, Incorporated.",
        "disclaimerText": "This information does not replace the advice of a doctor. Healthwise, Incorporated, disclaims any warranty or liability for your use of this information.",
        "termsOfUseUrl": "https://www.healthwise.org/specialpages/legal/terms.aspx",
        "privacyPolicyUrl": "https://www.healthwise.org/specialpages/legal/privacy.aspx",
        "moreInformationUrl": "https://www.healthwise.org",
        "toLearnMoreHtml": "To learn more about Healthwise, visit <a href=\"https://www.healthwise.org\">Healthwise.org</a>.",
        "yourUseOfThisInformationHtml": "Your use of this information means that you agree to the <a href=\"https://www.healthwise.org/specialpages/legal/terms.aspx\">Terms of Use</a> and <a href=\"https://www.healthwise.org/specialpages/legal/privacy.aspx\">Privacy Policy</a>.",
        "html": "<div class=\"HwLegal\"><div class=\"HwLogo\"><img width=\"112\" height=\"46\" src=\"https://cdn.healthwise.net/common/images/hwlogo/hwlogo.png\" alt=\"\"/></div><div class=\"HwDisclaimer\"><p>This information does not replace the advice of a doctor. Healthwise, Incorporated, disclaims any warranty or liability for your use of this information. Your use of this information means that you agree to the <a href=\"https://www.healthwise.org/specialpages/legal/terms.aspx\">Terms of Use</a> and <a href=\"https://www.healthwise.org/specialpages/legal/privacy.aspx\">Privacy Policy</a>.</p></div><div class=\"HwCopyright\"><p class=\"HwCopyrightLink\">To learn more about Healthwise, visit <a href=\"https://www.healthwise.org\">Healthwise.org</a>.</p><p>© 1995-2018 Healthwise, Incorporated. Healthwise, Healthwise for every health decision, and the Healthwise logo are trademarks of Healthwise, Incorporated.</p></div></div>"
    },
    "navigation": {
        "html": null,
        "topics": [{
            "id": "29EFF69E-AF6C-4AC0-B4A4-9E96339F5973",
            "title": "Home",
            "tab": "home",
            "visited": true
        }, {
            "id": "E13C0714-6323-4EFC-8FAB-201F930C44AE",
            "title": "Facts",
            "tab": "facts",
            "visited": false
        }, {
            "id": "3BDBB678-6534-4EDE-B381-D63273F51CA6",
            "title": "Compare",
            "tab": "compare",
            "visited": false
        }, {
            "id": "BF94110E-935C-4AD1-AF75-A1FF867F0CFC",
            "title": "Learn",
            "tab": "learn",
            "visited": false
        }, {
            "id": "07B32256-C609-45DE-989A-254C10F2DF29",
            "title": "Decide",
            "tab": "decide",
            "visited": false
        }, {
            "id": "57CC0731-1A49-4230-9AE7-012E37C5C82B",
            "title": "Summary",
            "tab": "summary",
            "visited": false
        }]
    },
    "credits": {
        "author": {
            "name": "Healthwise Staff"
        },
        "primaryReviewers": [{
            "name": "Adam Husney MD - Family Medicine"
        }, {
            "name": "Jeffrey N. Katz MD, MPH - Rheumatology"
        }, {
            "name": "Elizabeth T. Russo MD - Internal Medicine"
        }, {
            "name": "Kathleen Romito MD - Family Medicine"
        }, {
            "name": "Martin J. Gabica MD - Family Medicine"
        }, {
            "name": "Anne C. Poinier MD - Internal Medicine"
        }, {
            "name": "Kenneth J. Koval MD - Orthopedic Surgery, Orthopedic Trauma"
        }, {
            "name": "David Bardana MD, FRCSC - Orthopedic Surgery, Sports Medicine"
        }, {
            "name": "Catherine D. Serio PhD - Behavioral Health"
        }],
        "secondaryReviewers": []
    },
    "topics": [{
        "id": "29EFF69E-AF6C-4AC0-B4A4-9E96339F5973",
        "version": "3",
        "type": "esdpHome",
        "title": {
            "consumer": "Home"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0682",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Knee Osteoarthritis: Is It Time to Think About Surgery?"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Osteoarthritis: Is It Time to Think About Surgery?</h3> <div class=\"HwSection\"> <p>The pain and stiffness from knee osteoarthritis can make it hard for you to do your daily tasks. And it can keep you from doing the things you like to do. But you have options. You can have surgery to replace your knee. Or you can try treatments that don't involve surgery—things like exercise, medicines for pain, steroid shots into the knee joint, physical therapy, or losing weight (if you need to). </p> <p><em>Only you know which choice is right for you.</em> What you decide will depend on what matters most to you. Let's take a few minutes to explore your options and what you prefer. </p> </div> </div></div></section>",
            "taxonomy": [{
                "aspect": {
                    "id": "decisionOverview",
                    "label": "Decision overview",
                    "href": null
                },
                "concept": {
                    "id": "HWCV_21268",
                    "label": "Knee Problems and Injuries",
                    "href": null
                }
            }],
            "aspect": "Decision overview [decisionOverview]"
        }, {
            "id": "abx0657",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Decision Options"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 class=\"HwNoTitle\" data-element=\"title\" role=\"heading\" aria-level=\"3\">Decision Options</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/1359be2d-ee73-4392-9d0d-ce2e55b704e2/1359be2d-ee73-4392-9d0d-ce2e55b704e2.svg\" data-image-filename=\"ba_GUID-1359BE2D-EE73-4392-9D0D-CE2E55B704E2_i_n_l.svg\" class=\"HwImage\" /></div> <p> Knee replacement surgery offers better pain relief. But it also has some risks. </p> </div> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/7887a607-51db-4cf1-8508-758108d93b3c/7887a607-51db-4cf1-8508-758108d93b3c.svg\" data-image-filename=\"ba_GUID-7887A607-51DB-4CF1-8508-758108D93B3C_i_n_l.svg\" class=\"HwImage\" /></div> <p> Nonsurgical treatments have fewer risks. But they may not work as well to relieve pain. </p> </div> </div></div></section>",
            "taxonomy": [{
                "aspect": {
                    "id": "decisionOptions",
                    "label": "Decision options",
                    "href": null
                },
                "concept": {
                    "id": "HWCV_21268",
                    "label": "Knee Problems and Injuries",
                    "href": null
                }
            }],
            "aspect": "Decision options [decisionOptions]"
        }, {
            "id": "abx0476",
            "version": "3",
            "hash": "3",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "We're Curious"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectOpinion",
                    "id": "8D117012-11BC-481F-8C32-5855501CA3BC",
                    "question": "<div>Right now, what treatment are you leaning toward for your knee pain?</div>",
                    "answers": [{
                        "id": "8B2EDFBF-7519-44D0-A84A-D866B3657EFF",
                        "answer": "<div>Knee replacement surgery</div>"
                    }, {
                        "id": "0D9DBE8E-36B9-4D3A-A08F-2BC7F4A3D135",
                        "answer": "<div>Nonsurgical treatments</div>"
                    }, {
                        "id": "FE173F26-5E93-4465-822E-AFFF7FB469BF",
                        "answer": "<div>I'm not sure</div>"
                    }]
                }, {
                    "type": "hwSingleSelectOpinion",
                    "id": "B53486A4-71BD-421F-A8D8-5A119B04EF7F",
                    "question": "<div>How far along are you with this decision?</div>",
                    "answers": [{
                        "id": "E95349A0-F933-46B5-8456-A8C87EFDFE22",
                        "answer": "<div>Not yet thought about all the options</div>"
                    }, {
                        "id": "A736B47A-A788-48E7-BB75-F30E5C26978F",
                        "answer": "<div>Considering the different options</div>"
                    }, {
                        "id": "4F99D781-4D64-48A5-8B61-9DEE574EBD92",
                        "answer": "<div>Close to choosing an option</div>"
                    }]
                }],
                "navigable": "true"
            }]
        }, {
            "id": "acc4253",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Home CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">When You're Done </h3><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/a7019a36-b312-480a-9cfc-4486ca76a5e5/a7019a36-b312-480a-9cfc-4486ca76a5e5.svg\" data-image-filename=\"ba_GUID-A7019A36-B312-480A-9CFC-4486CA76A5E5_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div><p>This decision aid won't make your decision for you. But it will help you think about what matters to you and what questions you may have for your doctor. At the end, you'll get a summary of which way you're leaning and what matters most to you. You can share that with your doctor or loved ones. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "E13C0714-6323-4EFC-8FAB-201F930C44AE",
        "version": "2",
        "type": "esdpFacts",
        "title": {
            "consumer": "Facts"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0683",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Key Facts to Know"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Key Facts to Know</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/c3452187-409f-47c0-ae04-dd69745fb023/c3452187-409f-47c0-ae04-dd69745fb023.svg\" data-image-filename=\"ba_GUID-C3452187-409F-47C0-AE04-DD69745FB023_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <ul> <li><em>Knee arthritis symptoms may come and go.</em> They don't always get worse over time. </li> <li><em>Nonsurgical treatments help many people feel better and do more, often for a long time.</em> But for people who have severe knee arthritis, they may not work as well as knee replacement surgery. </li> <li><em>Knee replacement surgery usually works very well.</em> After surgery, most people have much less pain and can do more activities. </li> <li><em>Knee replacement surgery is a major surgery.</em> Risks aren't common, but they can be serious. Recovery also takes work and time. </li> <li><em>Most knee replacements last for at least 10 years.</em> For some people, it makes sense to delay surgery for as long as they can to reduce the chance of needing to replace the joint again later. On the other hand, if you wait too long to have surgery, you might have a harder time with strength and range of motion after surgery. </li> </ul> </div> </div></div></section>"
        }, {
            "id": "D2E671DF-564A-444D-9C75-73B4A7BA7BF4",
            "version": "3",
            "type": "Gallery",
            "title": {
                "consumer": "Gallery"
            },
            "navigable": false,
            "topics": [{
                "id": "abx1485",
                "version": "2",
                "hash": "2",
                "certifiedDate": "2016-10-31",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Arthritis: Treatments"
                },
                "abstract": {
                    "consumer": "Learn about the different treatment options for knee arthritis, and hear stories of what others have tried.",
                    "clinical": "Discusses the range of treatment options for knee arthritis, including lifestyle changes to knee replacement surgery."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Kathleen Romito MD - Family Medicine, Martin J. Gabica MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Arthritis: Treatments</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/SD/abq5105.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/hls/EF0/filesequence.m3u8?Expires=1526509544&amp;Signature=Jr~O0TYYQzbU6bEcfa21cJ-nGWHGAww8fKicuROu4iHAb2xuin5-t0g4q2yWIBeEDbTpGQPHPNjQXYM~iyubq5siQHMrESshpQeKke~ER-UbzSBjdufd2RFal4WHPy4fLsAbCljsOmCRCqaQgYygKLjdL~6L0QwJndU-OZaujjE_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E0/abq5105.mp4?Expires=1526509544&amp;Signature=hkGcUMwC8lvTtfpzFiQrG4FCro7TqLTN0GdWXKOJE-7NDjoxd64CEDI1TZVPXabSuUVFrst4~pFpGcldjA~WPevaESt0tlcaBLlTnKSX1wmg5Jvrqn13au7knkUoPKeL6jCDkHrFkJRhhmDWByZhQ7eXiElrNDQbUFD8ZcbfNxs_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "treatmentOptions",
                        "label": "Treatment options",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_20488",
                        "label": "Knee Arthritis",
                        "href": null
                    }
                }],
                "aspect": "Treatment options [treatmentOptions]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/SD/abq5105.jpg",
                "duration": "00:02:08",
                "transcript": {
                    "html": "<p>[Dr. Tomek] \"Arthritis affects different people differently.</p><p>The disease progresses at a different rate in everyone, and for a lot of people arthritis can stay very stable for years.</p><p>In other patients the arthritis progresses much quicker.\"</p><p>[Azell] \"About 2, 3 o'clock, I could feel myself limping.</p><p>That's what bothered me the most. I didn't want to walk around limping.\"</p><p>[Dr. Tomek] \"Knee osteoarthritis treatment often starts with lifestyle changes ... weight loss, improving exercise, becoming more active ... in spite of the knee pain.\"</p><p>[Bill] \"Right now with the exercises that I'm doing and with the cortisone shots and ibuprofen, it's helped me tolerate the pain.</p><p>So I can put off this surgery for a little while.\"</p><p>[Dr. Tomek] \"If lifestyle changes, exercise, weight loss, over-the-counter medications don't work, surgery is something that we discuss with patients.</p><p>And the surgery that most often gets discussed is total knee replacement.</p><p>The major benefit of a knee replacement is that in the vast majority of patients it reduces knee pain, allowing patients to get back to activities that they may have avoided for a long time.</p><p>The downside of knee replacement is that a small number of patients may have a complication associated with the surgery.</p><p>The recovery after knee replacement varies between patients.</p><p>Some patients recover very quickly and get back to a point of walking and activities that, frankly, sometimes are surprising to me.</p><p>Other patients take longer.\"</p><p>[Susan] \"Since the surgery, I don't have the strength that I would like to have in my leg.</p><p>It's probably a little better than what I had before I went in for the surgery.</p><p>I just never have gotten it all the way back to 100% of normal.\"</p><p>[Dr. Tomek] \"In the long term as knee implants age, some patients may need another operation to replace parts of the implant that have worn out. Everyone is different.</p><p>Everyone has different motivations and goals with respect to their knee arthritis.</p><p>And the more that your physician understands this, the more they'll be able to guide you with your decision.\"</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E3/abq5105.mp4?Expires=1526509544&Signature=f5MYT3cZflpsKlpYHcLN4n5N3acSIq492otlS63CL~Lj1qTzDhYoSj~p2Y3r7KJR8~RmOpHspCGh3XopEn4nfDN84-2Hrm5D-U1jBQC7zFNxzda-NhYjxITPnOQ~fLD0Sq1fAo7v2NWPEREBBZZc-xr49fmrMtV~zXvRzwPIPPg_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E4/abq5105.mp4?Expires=1526509544&Signature=Y8qU7wgFDGTyOriRY8fq41r6fCzdtXzjB5SD4oL9n3C25boCQ2gWlRPjbI6WROLGYBFfM~LTdcb9BeChirRwbNRJujteTIg29TWKyEQyqZSrnrTWSBsDf0cFqGj~4naXVSdn9hJ7zvDaTY7-f4-weB79VoNKPjoKi2dHV2ZB9UE_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/E0/abq5105.mp4?Expires=1526509544&Signature=hkGcUMwC8lvTtfpzFiQrG4FCro7TqLTN0GdWXKOJE-7NDjoxd64CEDI1TZVPXabSuUVFrst4~pFpGcldjA~WPevaESt0tlcaBLlTnKSX1wmg5Jvrqn13au7knkUoPKeL6jCDkHrFkJRhhmDWByZhQ7eXiElrNDQbUFD8ZcbfNxs_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/hls/EF1/filesequence.m3u8?Expires=1526509544&Signature=melfWLF2RXh97EZAjbfO4txVdi8LUYSfN~V7~WOyZ2FkJwxpeyWNCWWhRn89cyU5kDaDmCuwkufFy408lubLOQpTaIararpZRtlQZHeAToIjtdUvp~qdOjXY80DANVT6zN~FF48b-qg06K5uPAqdP4awnV~6NastXq~81vnEf6s_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5105/SD/hls/EF0/filesequence.m3u8?Expires=1526509544&Signature=Jr~O0TYYQzbU6bEcfa21cJ-nGWHGAww8fKicuROu4iHAb2xuin5-t0g4q2yWIBeEDbTpGQPHPNjQXYM~iyubq5siQHMrESshpQeKke~ER-UbzSBjdufd2RFal4WHPy4fLsAbCljsOmCRCqaQgYygKLjdL~6L0QwJndU-OZaujjE_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5105/abq5105.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>Users will learn about different treatment options for knee arthritis.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Discusses the range of treatment options for knee arthritis, including lifestyle changes to knee replacement surgery.</p>"
                },
                "teaser": {
                    "html": "<p>Learn about the different treatment options for knee arthritis, and hear stories of what others have tried.</p>"
                },
                "hwid": "abq5105"
            }, {
                "id": "zm6212",
                "version": "3",
                "hash": "3",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwSlideshow",
                "title": {
                    "consumer": "Knee replacement surgery"
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Anne C. Poinier MD - Internal Medicine, Adam Husney MD - Family Medicine, Kenneth J. Koval MD - Orthopedic Surgery; Orthopedic Trauma, David Bardana MD; FRCSC - Orthopedic Surgery; Sports Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwActionTask\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee replacement surgery</h3> <ol class=\"HwOrderedSteps\"> <li> <div class=\"HwCmd\">Normal knee joint. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/fd7e5e2e-b22b-5867-a05e-4bf8c148920d/fd7e5e2e-b22b-5867-a05e-4bf8c148920d.jpg\" data-image-filename=\"bf_GUID-fd7e5e2e-b22b-5867-a05e-4bf8c148920d_m_n_l.jpg\" alt=\"Normal knee joint\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p> Inside a normal knee joint, thick cushioning (cartilage) covers and protects the ends of your bones. This is called hyaline cartilage. Another type of cartilage, called meniscal cartilage or meniscus, acts like a shock absorber between the bones and keeps the knee joint stable by spreading out the load evenly across the joint. The two menisci (plural of meniscus) protect and cushion the surface of the joint and the ends of your bones. </p> </div> </li> <li> <div class=\"HwCmd\">Osteoarthritis of the knee. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/e9d5a6d9-0300-50ae-a5e6-3683114fad2e/e9d5a6d9-0300-50ae-a5e6-3683114fad2e.jpg\" data-image-filename=\"bf_GUID-e9d5a6d9-0300-50ae-a5e6-3683114fad2e_m_n_l.jpg\" alt=\"Knee joint with osteoarthritis\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p>In osteoarthritis, the cartilage that protects and cushions the knee joint breaks down over time. As the cartilage wears down, the bone surfaces rub against each other. This damages the tissue and bone, causing pain. Osteoarthritis is common in the knee joints. </p> </div> </li> <li> <div class=\"HwCmd\">Femoral component is placed. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/c2abd1da-9912-5518-9d40-3e2181e0d02c/c2abd1da-9912-5518-9d40-3e2181e0d02c.jpg\" data-image-filename=\"bf_GUID-c2abd1da-9912-5518-9d40-3e2181e0d02c_m_n_l.jpg\" alt=\"Knee replacement surgery: Femoral component\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p> The damaged cartilage is removed from the lower end of the femur and the femoral component is placed. </p> </div> </li> <li> <div class=\"HwCmd\">Tibial component is placed. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/594106fc-c7ef-5a08-86b9-48089292cd57/594106fc-c7ef-5a08-86b9-48089292cd57.jpg\" data-image-filename=\"bf_GUID-594106fc-c7ef-5a08-86b9-48089292cd57_m_n_l.jpg\" alt=\"Knee replacement surgery: Tibial component\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p>The damaged cartilage is removed from the upper end of the tibia and the tibial component is placed. </p> </div> </li> <li> <div class=\"HwCmd\">Patellar component is placed. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/25af7b96-31a4-5d4e-aeb6-c31d7aa6c2ef/25af7b96-31a4-5d4e-aeb6-c31d7aa6c2ef.jpg\" data-image-filename=\"bf_GUID-25af7b96-31a4-5d4e-aeb6-c31d7aa6c2ef_m_n_l.jpg\" alt=\"Knee replacement surgery: Patellar component\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> <p> The damaged cartilage is removed from the patella and the patellar component is placed. </p> </div> </li> <li> <div class=\"HwCmd\">Knee replacement surgery is complete. </div> <div class=\"HwInfo\"><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/bad580b1-8c5d-51a8-b280-20877b2d4609/bad580b1-8c5d-51a8-b280-20877b2d4609.jpg\" data-image-filename=\"bf_GUID-bad580b1-8c5d-51a8-b280-20877b2d4609_m_n_l.jpg\" alt=\"Completed knee replacement surgery\" data-image-type=\"medical\" class=\"HwMedicalImage\" /></div> </div> </li> </ol></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "howDone",
                        "label": "How it's done",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "How it's done [howDone]"
            }]
        }, {
            "id": "acc0397",
            "version": "4",
            "hash": "4",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Facts CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p>Let's explore your options. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "3BDBB678-6534-4EDE-B381-D63273F51CA6",
        "version": "1",
        "type": "esdpCompare",
        "title": {
            "consumer": "Compare"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0686",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Compare Your Options"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Compare Your Options</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/beb11f81-5d05-417c-8b5d-ccacdb36c1ae/beb11f81-5d05-417c-8b5d-ccacdb36c1ae.svg\" data-image-filename=\"ba_GUID-BEB11F81-5D05-417C-8B5D-CCACDB36C1AE_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <table> <tgroup cols=\"3\"><thead> <tr> <th colname=\"col1\">​</th> <th colname=\"col2\"><p>Knee Replacement Surgery </p></th> <th colname=\"col3\"><p>Nonsurgical Treatments </p></th> </tr></thead> <tbody> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/966557b8-bf41-4e62-baff-fa4ee2b104af/966557b8-bf41-4e62-baff-fa4ee2b104af.svg\" data-image-filename=\"ba_GUID-966557B8-BF41-4E62-BAFF-FA4EE2B104AF_i_n_l.svg\" class=\"HwImage\" /></div> <p>What's involved </p> </td> <td colname=\"col2\"> <ul> <li>Major surgery. </li> <li>Short hospital stay. </li> <li>Physical therapy for several weeks, including exercises you can do at home. </li> <li>Most knee replacements last for at least 10 years. Out of 100 people who have the surgery, about 5 will need to have their knee replaced again within 10 years. Knee replacements don't last as long in men and in people who are young, active, or overweight. </li> </ul> </td> <td colname=\"col3\"> <p>Any or all of these: </p> <ul> <li>Exercise and weight loss. </li> <li>Physical therapy. </li> <li>Pain medicines (pills, skin creams). </li> <li>Steroid shots into the knee joint. </li> <li>Acupuncture and massage. </li> <li>Dietary supplements. </li> <li>Knee braces, canes, and other walking aids. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/38645992-460d-4fbb-ba81-ce0005080790/38645992-460d-4fbb-ba81-ce0005080790.svg\" data-image-filename=\"ba_GUID-38645992-460D-4FBB-BA81-CE0005080790_i_n_l.svg\" class=\"HwImage\" /></div> <p>Pain relief </p> </td> <td colname=\"col2\"> <ul> <li> Surgery works well for most people. Six months after knee replacement, about 80 out of 100 people have less pain and can do more activities than they could before the surgery.<iconarray minRange=\"80\" maxRange=\"80\" total=\"100\" iconType=\"male\">​</iconarray> </li> </ul> </td> <td colname=\"col3\"> <ul> <li> Nonsurgical treatments work well for some people. For example: <ul> <li> Leg and knee exercises can reduce pain and stiffness. And being active can make it easier to move around. </li> <li> If you're overweight, losing even a few pounds can reduce your knee pain. </li> <li> Steroid shots may give quick pain relief for a few weeks. </li> </ul> </li> <li>But for severe knee arthritis, nonsurgical treatments may not work as well as surgery. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/91466eb6-7398-4e4b-9d7b-15ea33a7937c/91466eb6-7398-4e4b-9d7b-15ea33a7937c.svg\" data-image-filename=\"ba_GUID-91466EB6-7398-4E4B-9D7B-15EA33A7937C_i_n_l.svg\" class=\"HwImage\" /></div> <p>Risks </p> </td> <td colname=\"col2\"> <ul> <li> About 4 out of 100 people have a serious complication like a joint infection, a blood clot, or a heart attack within 3 months after surgery. <iconarray minRange=\"4\" maxRange=\"4\" total=\"100\" iconType=\"male\">​</iconarray> </li> </ul> <ul> <li> If you are older or have other health problems, your risk may be higher. </li> </ul> </td> <td colname=\"col3\"> <ul> <li>In general, these treatments have fewer risks than surgery. Some may have side effects. For example, any medicine used to treat pain can have side effects. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/26d2b509-f716-4370-b18f-cf1bd305cb05/26d2b509-f716-4370-b18f-cf1bd305cb05.svg\" data-image-filename=\"ba_GUID-26D2B509-F716-4370-B18F-CF1BD305CB05_i_n_l.svg\" class=\"HwImage\" /></div> <p>Recovery </p> </td> <td colname=\"col2\"> <ul> <li>It usually takes people about 3 months to get back to doing most of their usual activities. But it may take a little longer than that for some people. </li> <li> It may take 6 to 12 months to make a full recovery and reach your maximum knee strength and range of motion. </li> </ul> </td> <td colname=\"col3\"> <ul> <li> In general, these treatments allow you to keep doing most of your usual activities. But your knee pain may limit how much you can do. </li> </ul> </td> </tr> <tr> <td colname=\"col1\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/844c0c42-574d-436d-8733-8806e1a77042/844c0c42-574d-436d-8733-8806e1a77042.svg\" data-image-filename=\"ba_GUID-844C0C42-574D-436D-8733-8806E1A77042_i_n_l.svg\" class=\"HwImage\" /></div> <p>Cost </p> </td> <td colname=\"col2\"> <ul> <li>The cost of surgery varies. Check your insurance coverage. </li> <li>Also think about costs of help you may need during recovery. </li> </ul> </td> <td colname=\"col3\"> <ul> <li>This may include the costs of over-the-counter pills or creams, walking aids, or treatments that your insurance doesn't cover. </li> </ul> </td> </tr> </tbody> </tgroup> </table> </div> </div></div></section>"
        }, {
            "id": "acc0388",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Compare CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p>Ready to test your knowledge? </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "BF94110E-935C-4AD1-AF75-A1FF867F0CFC",
        "version": "1",
        "type": "esdpLearn",
        "title": {
            "consumer": "Learn"
        },
        "navigable": false,
        "topics": [{
            "id": "abx0687",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "Check the Facts"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "intro": "<div><div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/020cdef3-a3cc-4015-bd19-70a6c1084b9a/020cdef3-a3cc-4015-bd19-70a6c1084b9a.svg\" data-image-filename=\"ba_GUID-020CDEF3-A3CC-4015-BD19-70A6C1084B9A_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div><p>Now that you've read the facts about each option, let's see what you've learned. We've got a few quick questions to find out. If you're not sure about the answers, check the Compare page again. Or you can make a note to ask your doctor for more information. </p></div>",
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectQuiz",
                    "id": "45AB39C3-AB0D-4C7C-87E6-E9FB3429EF09",
                    "question": "<div>Which treatment is most likely to provide relief from severe knee pain caused by osteoarthritis?</div>",
                    "answers": [{
                        "id": "686BB62D-73C9-4127-A459-DBA70702BCB2",
                        "answer": "<div>Surgery</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "3895A083-6EF4-49E3-BDF1-14B1A0186570",
                        "answer": "<div>Nonsurgical treatments</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "A77F0579-54AE-4F14-92BF-909C6F222567",
                        "answer": "<div>Both are about the same</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "DAF8111F-40EA-4F43-A6CC-DDB93B74D8DA",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "CBEF352D-20B8-4DAE-9F43-0D8F6178A14A",
                    "question": "<div>If 100 people have knee replacement surgery, about how many will need to have the same knee replaced again in less than 10 years?</div>",
                    "answers": [{
                        "id": "C77AC0EA-CE62-42E7-A948-03385C7DDE44",
                        "answer": "<div>More than half</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "CB29818C-5D85-4D8B-A882-47E7150900E7",
                        "answer": "<div>About half</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "C2173870-F3C5-40B7-AEC7-4CD0D50CF95D",
                        "answer": "<div>Less than half</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "5EA1DF45-D08B-415A-83FF-5EBED740CD97",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "CD5CE9F4-E114-4B3F-9276-4301BC9E0C8E",
                    "question": "<div>Take 100 people who have knee replacement surgery. Six months later, about how many will have less knee pain than they had before the surgery?</div>",
                    "answers": [{
                        "id": "EADE9CAC-653A-497A-9CE9-6225D37E69FB",
                        "answer": "<div>20</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "78E2D4A3-4F8B-46FD-9DC9-1523593F5452",
                        "answer": "<div>40</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "64A8E7FC-C09D-4B11-8045-AC817A689659",
                        "answer": "<div>60</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "5C09A9AD-D78A-457F-86CC-503478089977",
                        "answer": "<div>80</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "94F087ED-2190-4F08-8972-9D9A1C5C3C15",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "7C723441-9FCB-4E68-B3C1-CCC400BB1318",
                    "question": "<div>Serious complications can happen after knee replacement surgery, including life-threatening blood clots, infections, heart attacks, and even death. If 100 people have knee replacement surgery, about how many will have a serious complication within 3 months after surgery?</div>",
                    "answers": [{
                        "id": "C1882206-5FFC-4F4B-9CC1-9378E8604611",
                        "answer": "<div>4</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "AF5A4807-CFA4-4825-A186-F147932667A1",
                        "answer": "<div>10</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "88D7E73B-0F9C-4954-A0CD-C038A0C50806",
                        "answer": "<div>14</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "A2E5557B-B1CF-4D68-807C-5E25B1155057",
                        "answer": "<div>20</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "7C8572F2-96AA-4508-8939-948F2069F880",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }, {
                    "type": "hwSingleSelectQuiz",
                    "id": "6628DF77-A452-4995-AA1B-DF8707BF6794",
                    "question": "<div>After knee replacement surgery, about how many months does it take most people to get back to doing their usual activities?</div>",
                    "answers": [{
                        "id": "1409CC6F-8E58-4D8C-A87D-17E5E3A1F4CC",
                        "answer": "<div>Less than 2 months</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "8ED217D3-88BE-4249-8146-DDE39EEBB286",
                        "answer": "<div>2 to 6 months</div>",
                        "feedback": "<div>Correct</div>",
                        "correctAnswer": "true"
                    }, {
                        "id": "F2AA090D-7260-4AD5-9EB2-1870659FADA9",
                        "answer": "<div>7 to 12 months</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "65F2929E-3C3E-42DC-A0B6-E126743CFC60",
                        "answer": "<div>More than 12 months</div>",
                        "feedback": "<div>Incorrect</div>"
                    }, {
                        "id": "09A744B1-B681-4287-8E1E-97980782ECFF",
                        "answer": "<div>I'm not sure</div>",
                        "feedback": "<div>Incorrect</div>"
                    }]
                }],
                "altTitle": "Knowledge Questions",
                "navigable": "true"
            }]
        }, {
            "id": "acc0392",
            "version": "4",
            "hash": "4",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Learn CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p> Now let's think about what's right for you. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "07B32256-C609-45DE-989A-254C10F2DF29",
        "version": "3",
        "type": "esdpDecide",
        "title": {
            "consumer": "Decide"
        },
        "navigable": false,
        "topics": [{
            "id": "acc4252",
            "version": "5",
            "hash": "5",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Decide What's Right for You"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Decide What's Right for You</h3> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/d8d97996-f05c-4006-b836-0a8896230ec2/d8d97996-f05c-4006-b836-0a8896230ec2.svg\" data-image-filename=\"ba_GUID-D8D97996-F05C-4006-B836-0A8896230EC2_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <div class=\"HwSection\"> <p>What you decide will depend on how you feel about the benefits and risks of each option. Talk to your doctor about what matters most to you. Together, you can make the decision that's right for you. </p> </div> </div></div></section>"
        }, {
            "id": "abx0518",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "What Matters to You?"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "intro": "<div><p> On a scale from 0 to 10, with 0 being not at all important and 10 being extremely important, please mark how important each reason is to you as you think about your decision. </p><p class=\"HwLeadIn\">How important is it to you to… </p></div>",
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "50121A94-35F3-4727-A7FD-4CB73D6F28B4",
                    "id": "D0C86392-8A1E-482A-8EF3-F0D30F22EA2F",
                    "question": "<div>Relieve your knee pain?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "AD0D709C-88AC-479E-A449-F973E08185CD",
                    "id": "A4A1BC36-AA4B-4BF8-B3A7-E3BAFDAC1E50",
                    "question": "<div>Not be limited in what you can do because of your knee pain?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "F02D2D26-6C68-4CEF-B18C-CC38C340D52C",
                    "id": "FC8A6FA1-2503-4481-B1D0-45A964C55443",
                    "question": "<div>Avoid taking pain medicine for a long time?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "25F797CD-EBA1-45E8-9011-C0FF990DDBC6",
                    "id": "64CB932E-B8EF-47FD-BBE1-A04F9ECEB8AE",
                    "question": "<div>Avoid having knee surgery?</div>"
                }, {
                    "type": "hwSingleSelectScale",
                    "minValueText": "Not at all important",
                    "maxValueText": "Extremely important",
                    "minValue": "0",
                    "maxValue": "10",
                    "answerId": "9E368D3E-486D-4953-888F-AD8B1CF99D14",
                    "id": "3EBA6B06-5395-43D8-B670-4AE9B9F20147",
                    "question": "<div>Avoid a treatment with a long recovery time?</div>"
                }],
                "altTitle": "Values",
                "navigable": "true"
            }]
        }, {
            "id": "acc4255",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "Your Notes"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "content": [{
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwOpenQuestion",
                    "answerId": "948E76EC-F994-4EAD-8205-2E684B0C4CE8",
                    "id": "948E76EC-F994-4EAD-8205-2E684B0C4CE8",
                    "question": "<div> Questions, concerns, or notes:</div>"
                }],
                "altTitle": "Concerns/Questions",
                "navigable": "true"
            }]
        }, {
            "id": "abx0519",
            "version": "3",
            "hash": "3",
            "certifiedDate": "2017-03-21",
            "lang": "en-us",
            "type": "hwDecisionAssessment",
            "title": {
                "consumer": "Which Way Are You Leaning?"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology"
                }]
            },
            "content": [{
                "type": "hwDecisionAssessment",
                "interactions": [{
                    "type": "hwSingleSelectOpinion",
                    "id": "6FFBF2E7-78F7-4B2A-9F06-FCBAE435DC39",
                    "question": "<div>At this time, what treatment are you leaning toward for your knee pain?</div>",
                    "answers": [{
                        "id": "195D7BDC-30A9-44C3-98B8-9778A4FBC7E7",
                        "answer": "<div>Knee replacement surgery</div>"
                    }, {
                        "id": "2942075F-9B46-4825-96E6-D5A181E9731B",
                        "answer": "<div>Nonsurgical treatments</div>"
                    }, {
                        "id": "D1671833-220B-4C85-BDB6-8100194F7D55",
                        "answer": "<div>I'm not sure</div>"
                    }]
                }, {
                    "type": "hwSingleSelectOpinion",
                    "id": "BF31AD83-C34A-4DFE-A4F7-DB9E301DD508",
                    "question": "<div>How far along are you with this decision?</div>",
                    "answers": [{
                        "id": "C4305F08-9876-4FE8-A43B-50A2F58A09D4",
                        "answer": "<div>Not yet thought about all the options</div>"
                    }, {
                        "id": "B3708DC0-BB0C-40D8-B7B1-D0D49D51FD40",
                        "answer": "<div>Considering the different options</div>"
                    }, {
                        "id": "68AB5E26-3207-41E4-898D-1E3109E4B8E7",
                        "answer": "<div>Close to choosing an option</div>"
                    }]
                }],
                "altTitle": "Treatment Preference",
                "navigable": "true"
            }]
        }, {
            "id": "acc4251",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Decide CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p> You're almost done! Complete this final step to see a summary of your responses. The summary may help you talk with your doctor or loved ones about your decision. </p></div>",
            "outputClass": "HwCTA"
        }]
    }, {
        "id": "57CC0731-1A49-4230-9AE7-012E37C5C82B",
        "version": "2",
        "type": "decisionSummary",
        "title": {
            "consumer": "Summary"
        },
        "navigable": false,
        "topics": [{
            "id": "acc0395",
            "version": "6",
            "hash": "6",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwDecisionComponent",
            "title": {
                "consumer": "Your Decision Summary"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwDecisionComponent\"> <h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Your Decision Summary</h3> <div class=\"HwSection\"> <div class=\"HwImageWrapper\"><img src=\"https://cdn.healthwise.net/common/images/28c9e1db-e6b6-420b-b84a-cf6d452f88b8/28c9e1db-e6b6-420b-b84a-cf6d452f88b8.svg\" data-image-filename=\"ba_GUID-28C9E1DB-E6B6-420B-B84A-CF6D452F88B8_i_n_l.svg\" class=\"HwImage HwIconTitle\" /></div> <p> This summary of your responses shows which way you're leaning and what matters most to you. </p> </div> </div></div></section>",
            "taxonomy": [{
                "aspect": {
                    "id": "decisionOverview",
                    "label": "Decision overview",
                    "href": null
                },
                "concept": {
                    "id": "HWCV_21268",
                    "label": "Knee Problems and Injuries",
                    "href": null
                }
            }],
            "aspect": "Decision overview [decisionOverview]"
        }, {
            "id": "acc4254",
            "version": "7",
            "hash": "7",
            "certifiedDate": "2017-06-05",
            "lang": "en-us",
            "type": "hwMessage",
            "title": {
                "consumer": "Summary CTA"
            },
            "navigable": false,
            "credits": {
                "author": {
                    "name": "Healthwise Staff"
                },
                "primaryReviewers": [{
                    "name": "Elizabeth T. Russo MD - Internal Medicine"
                }]
            },
            "html": "<div class=\"HwStructuredWrapper\"><p> Print or email a copy to help you talk with your doctor or loved ones about your decision. </p></div>",
            "outputClass": "HwCTA"
        }, {
            "id": "1F26B8D3-D1B2-464B-A938-C71352421DB3",
            "version": "2",
            "type": "Gallery",
            "title": {
                "consumer": "Explore Your Next Step"
            },
            "navigable": false,
            "topics": [{
                "id": "abx0479",
                "version": "3",
                "hash": "3",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Replacement Surgery"
                },
                "abstract": {
                    "consumer": "Learn what to expect during knee replacement surgery and how it can ease the pain of arthritis.",
                    "clinical": "Discusses cartilage damage in the knee. Shows how damaged parts of the knee are removed and replaced during surgery."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Adam Husney MD - Family Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Replacement Surgery</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/SD/abn1940.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&amp;Signature=nSJtcKxNbX8fdUWVEeinZT3oK00ztjGYq~Hip2PByS3pPnTiMxEe5C~ZdOka6Ne5xzVJdhvwm4YEGa7FUVJ9R79vV1qpkpi90mbapu2BRjRvQBFI6nKTPikwfVpv9Q--UhA8Wjf6gDElSe2vpZDMtgz9mHPXl9-anC02hbTDTjs_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E0/abn1940.mp4?Expires=1526509545&amp;Signature=aaJVy4jbhs6vH4vBY65PVdvmselrnfoemQLZDn3yl5F0~xDFzWilaUTzxK5qRNtPf0zbrOrWf3OMpQMeVrhIYxSQtWI-CqU5sjB2cjC8HeCtBD1jpaPpmdHPS61dwl8I-SivKL05t3wayxi2vEmK7KBd-Q1N17-fhjlDWusa~pA_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "overview",
                        "label": "Overview",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "Overview [overview]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/SD/abn1940.jpg",
                "duration": "00:01:44",
                "transcript": {
                    "html": "<p>Your knee is a joint that connects the thighbone to the shinbone.</p><p>The joint is covered by another bone-the kneecap.</p><p>The joint is cushioned and protected by cartilage.</p><p>But if you have arthritis, this protective surface breaks down.</p><p>As the cartilage breaks down, the bony surfaces of the joint rub against each other, which causes damage and pain.</p><p>When this happens, your doctor may recommend surgery to replace the damaged parts of your knee with new metal and plastic parts.</p><p>You'll most likely be asleep for the surgery, so you won't feel any pain.</p><p>Here's how knee replacement surgery is done ... The damaged cartilage and bone at the end of the thighbone is removed.</p><p>Then a metal cap is placed at the end of the bone.</p><p>The damaged cartilage and bone on the top of the shinbone is removed, and a metal plate is placed into the bone.</p><p>The metal plate has a plastic liner on top that helps the joint move easily.</p><p>The damaged cartilage and bone may also be removed from the back of the kneecap and replaced by a metal plate and plastic liner.</p><p>All these pieces are made to work together like a normal knee joint.</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E3/abn1940.mp4?Expires=1526509545&Signature=dMCDq9F46-EpdHfqBpATiZPwiCx0vHhy6y~bkKka17axv6oV0spFpbHQxb7IUgPea-Mi5iFPdnQ5TiQNOXNA7lvS9OPcQGmMh2fLOS0N4FSGyvlYMU-1Z6r2g6Cok~wjfGmF0lvl5fID~wF5LsXYCRRJX3EJl6ecE8SLKSwoa8s_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E4/abn1940.mp4?Expires=1526509545&Signature=Ag192ZEUt1NgXt5HU-iesVLhUXzCJ~qJb6AZbeor48Y7GdSxzITGh-jggEBRkAbBJbHQJQ82~wo4BDhe6NrJhGdoiqZI6fjqq-WkIG16nZdrmVA0Z-ShZC83kpIAsofQi4dwkVHT2DQXWsTnGC3TLNFAmGAVezFqJHJCsGRt5uU_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/E0/abn1940.mp4?Expires=1526509545&Signature=aaJVy4jbhs6vH4vBY65PVdvmselrnfoemQLZDn3yl5F0~xDFzWilaUTzxK5qRNtPf0zbrOrWf3OMpQMeVrhIYxSQtWI-CqU5sjB2cjC8HeCtBD1jpaPpmdHPS61dwl8I-SivKL05t3wayxi2vEmK7KBd-Q1N17-fhjlDWusa~pA_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/hls/EF1/filesequence.m3u8?Expires=1526509545&Signature=SQBytQBbxIARZrHkaICxSUk5e~vijUCSgUUPVxtzis8irRqBiRMOjJIGkhMw99Lc4yGQDPfyBCVxUkDMN3mVzDVtDIPeyzZXc2rMIMhdEQJMKAos36kAK~Hc5H9YJCBVuPLkXZ6G6P-HvIwFNKJePziO1wHeiWsgY1hcDWHYgSI_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abn1940/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&Signature=nSJtcKxNbX8fdUWVEeinZT3oK00ztjGYq~Hip2PByS3pPnTiMxEe5C~ZdOka6Ne5xzVJdhvwm4YEGa7FUVJ9R79vV1qpkpi90mbapu2BRjRvQBFI6nKTPikwfVpv9Q--UhA8Wjf6gDElSe2vpZDMtgz9mHPXl9-anC02hbTDTjs_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abn1940/abn1940.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>The user will learn what knee replacement surgery is and how it is done.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Discusses cartilage damage in the knee. Shows how damaged parts of the knee are removed and replaced during surgery.</p>"
                },
                "teaser": {
                    "html": "<p>Learn what to expect during knee replacement surgery and how it can ease the pain of arthritis.</p>"
                },
                "hwid": "abn1940"
            }, {
                "id": "abx0478",
                "version": "2",
                "hash": "2",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Replacement Surgery: How Others Decided"
                },
                "abstract": {
                    "consumer": "Hear what other people thought about as they decided whether to have knee replacement surgery.",
                    "clinical": "Provides personal stories about why some people choose to have knee replacement surgery while others try medicine or lifestyle changes first."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Adam Husney MD - Family Medicine, Catherine D. Serio PhD - Behavioral Health, David Bardana MD; FRCSC - Orthopedic Surgery; Sports Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Replacement Surgery: How Others Decided</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/SD/abp6406.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&amp;Signature=OicuQybRwXOwalkFqtNDxHM2kV5vn~NrvqlVHw7KehQ8YPxRa0XCxYQfQL6qs57FhCdg71CxaJQ2Ow~LFxmVEIbdhXG58mQnJauZ3zgLGn2RJXn5u8-5ArMXbVSDBp3R1VYG~vBPk3Eof22mKd2DEcDZPvjKDC1AxhG0S3SEydQ_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E0/abp6406.mp4?Expires=1526509545&amp;Signature=WuMMN9qOfffsA-vQ54jpNj-6k1VvWH0Eum3ReLLepMdPiqa1IJp-SgL1n1VStmy6ZNsDHfVXtVVTw5rj5G-V6VWV6Ixr0ZsZNLzHulPQ7v0y52Gzq98DaRkGd0RqtNQs3EyIn1o8K2tzRdqrbpKw0oxK6haWDylB9Lj~mMP1mVk_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "decisionOverview",
                        "label": "Decision overview",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "Decision overview [decisionOverview]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/SD/abp6406.jpg",
                "duration": "00:02:34",
                "transcript": {
                    "html": "<p>When you're deciding whether to have knee replacement surgery, it may help to hear what other people thought about as they made their decision.</p><p>[Man's Voice] \"I've been taking pain medicine for the arthritis in my knee, but it just isn't working. I've thought about knee replacement ... but for me, that would be a last resort ... and my doctor said there are plenty of other things I can try first. I know losing some weight would help, so with her advice, I made a plan of swimming and healthy eating to help me slim down. We agree that's the best thing I can do to keep my arthritis from getting worse. She said there are other medicines we can try too.\" [Woman's Voice] \"The pain in my knees ... especially the left one ... has gotten worse and worse over the past 20 years. Now it's so bad, I can't work in my garden anymore ... and I've had to cut back on my exercise classes and volunteer work too. This is making me feel old!</p><p>It's no way to live: in constant pain and not able to do the things I love.</p><p>I know it'll take time and I'll have to do a lot of rehab, but I'm more than willing if it will help me get back to my life.\"</p><p>[Man's Voice] \"I've been an athlete most of my life, and I've had knee injuries and surgeries a few times.</p><p>At this point, my doctor says the only surgery choice I have left is knee replacement.</p><p>My right knee hurts pretty bad sometimes, so part of me would like to go ahead and get it replaced. But I heard that the joints they use only last 10 to 20 years. I worry that if I get a knee replacement at my age, I'll have to have it done again later.</p><p>For now, I'm going to try a different pain medicine.</p><p>As long as I'm able to stay active, I'm going to hold off on surgery.\"</p><p>Like the people you've just heard from, you have your own feelings about the pros and cons of surgery. It's important to share those feelings with your doctor, so that the two of you can talk them over ... combine them with the medical facts ... and choose the best treatment for you.</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E3/abp6406.mp4?Expires=1526509545&Signature=Xc2nZFObMLtpRK3iN4-H8kAhpbN7Bn9yUWR7uX28UybNM4teRRr3OAIlN6AXEvBsmumolj8c0JB0cvkMngP5QFE-mU9Z8GEFcYhkehWXJ66bOwNFx6UxQaHTtpCSlqrHzsSM6v8M2ZpT2M2SPqy~FckkRw5Gq2ufxjiaKoupVAQ_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E4/abp6406.mp4?Expires=1526509545&Signature=LBIWiSTam2zaYMuU75Omf~JNsjbvqtCkSG~MtQ2ZihZ3QlNhanJk7O7j4rUV402TdLgMLxNMWcMXyrus~XSOdVqNs8jojjIac4GzDGmb0w3suU06~AMWY7-POimGdp0vysTvtGaBZSeP2GQG2q0-CtrDhqlREEw2~p21-W23Hug_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/E0/abp6406.mp4?Expires=1526509545&Signature=WuMMN9qOfffsA-vQ54jpNj-6k1VvWH0Eum3ReLLepMdPiqa1IJp-SgL1n1VStmy6ZNsDHfVXtVVTw5rj5G-V6VWV6Ixr0ZsZNLzHulPQ7v0y52Gzq98DaRkGd0RqtNQs3EyIn1o8K2tzRdqrbpKw0oxK6haWDylB9Lj~mMP1mVk_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/hls/EF1/filesequence.m3u8?Expires=1526509545&Signature=QnxuOa6WdouaR1SxpYRDe5F4wQAdCIUWuBGx93RCQPnLKYcccQmr~wXbO8pMd8mIh9q-r~vKU7ahfqPBfOqus7OUZERy4b15884FOyn6nW0w0VmU~vXFZ6HoG0XG81-pi4KeDgoRoBzKaHATRQI5qE4Jm5UCQw1SNcbuh9t11rc_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abp6406/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&Signature=OicuQybRwXOwalkFqtNDxHM2kV5vn~NrvqlVHw7KehQ8YPxRa0XCxYQfQL6qs57FhCdg71CxaJQ2Ow~LFxmVEIbdhXG58mQnJauZ3zgLGn2RJXn5u8-5ArMXbVSDBp3R1VYG~vBPk3Eof22mKd2DEcDZPvjKDC1AxhG0S3SEydQ_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abp6406/abp6406.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>Users will gain insights that help them identify their personal preferences about knee surgery.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Provides personal stories about why some people choose to have knee replacement surgery while others try medicine or lifestyle changes first.</p>"
                },
                "teaser": {
                    "html": "<p>Hear what other people thought about as they decided whether to have knee replacement surgery.</p>"
                },
                "hwid": "abp6406"
            }, {
                "id": "abx0477",
                "version": "2",
                "hash": "2",
                "certifiedDate": "2017-03-21",
                "lang": "en-us",
                "type": "hwVideo",
                "title": {
                    "consumer": "Knee Replacement Surgery: Pros and Cons"
                },
                "abstract": {
                    "consumer": "Learn about the pros and cons of having knee replacement surgery.",
                    "clinical": "Educates patients about what knee replacement surgery involves and the pros and cons of having it done."
                },
                "navigable": false,
                "credits": {
                    "author": {
                        "name": "Healthwise Staff"
                    },
                    "primaryReviewers": [{
                        "name": "Kathleen Romito MD - Family Medicine, Adam Husney MD - Family Medicine, Jeffrey N. Katz MD; MPH - Rheumatology, David Bardana MD; FRCSC - Orthopedic Surgery; Sports Medicine"
                    }]
                },
                "html": "<section><div class=\"HwStructuredWrapper\"> <div class=\"HwStructuredContent HwMedia\"><h3 data-element=\"title\" role=\"heading\" aria-level=\"3\">Knee Replacement Surgery: Pros and Cons</h3><div class=\"HwVideo\"><video controls=\"true\" preload=\"true\" class=\"HwVideoTag\" crossorigin=\"anonymous\" poster=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/SD/abq5077.jpg\"><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&amp;Signature=itzNWrjlRE6eajrfw1WvXbD4v4b9ITxkO7wyPlu2JY4o2mrTxXVdte3dCox4OWXyw6Q-sYIC7DAGRAVYbaqgwY51vVUhGmCb4clbo7FQ0UUlu0v-STkJJ2jKT~FtxvVGy-maFaAc4CVHGKVMxybYVXij6CrkEmRyqpLgNljWcHc_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"application/x-mpegURL\" /><source src=\"https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E0/abq5077.mp4?Expires=1526509545&amp;Signature=Pzy1BB7PSYqfQXj2jMDs0~fcJA3PYGJcw8PhvIcBUa6jZbSYxZ~w1c~W~6qnkuG9M9FhKaBIL9QwetBUXUqkRlstn4ETxH-LVus8ueW0QXKE1nUo8x5Q3QdEZkS9aH4-q0q8s-zIrmQJHFJKPmyxt4JCuiJ6J6gJsttldyPyWEI_&amp;Key-Pair-Id=APKAIDLZDAU235UUEL6A\" type=\"video/mp4\" /><track label=\"English\" kind=\"captions\" srclang=\"English\" src=\"https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.vtt\" /></video></div></div></div></section>",
                "taxonomy": [{
                    "aspect": {
                        "id": "decisionOverview",
                        "label": "Decision overview",
                        "href": null
                    },
                    "concept": {
                        "id": "HWCV_21977",
                        "label": "Knee Replacement Surgery",
                        "href": null
                    }
                }],
                "aspect": "Decision overview [decisionOverview]",
                "thumbnail": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/SD/abq5077.jpg",
                "duration": "00:02:37",
                "transcript": {
                    "html": "<p>[Dr. Tomek] \"When non-operative treatment no longer controls knee pain, swelling, and other symptoms, surgery is something that we discuss with patients.</p><p>And the surgery that most often gets discussed is total knee replacement.</p><p>In knee replacement, we replace the damaged part of the knee with a metal-and-plastic implant that duplicates the function of the knee and allows bending and rotation of the knee that is much more comfortable than it would be in a severely arthritic joint.</p><p>The major benefit of knee replacement is that it reduces pain in the majority of patients.</p><p>In addition, it improves knee function.</p><p>The ability to painlessly bend and straighten the knee and to put weight on it allows patients to get back to activities that they may have avoided for a long time, such as walking, going up and down stairs and even certain sports ... The downside of knee replacement is that a small number of patients may experience surgical complications, including infection, blood clots, heart or lung risks, which in a small number of patients can be fatal.</p><p>Other patients don't get complete pain relief and may continue to have knee pain for years after the operation that doesn't get better.\"</p><p>[Susan] \"I think, in general, I'm able to do most things that I did before the surgery.</p><p>It's a different type of discomfort and pain.</p><p>I try to do everything I did before. I gave up the bicycle. That I don't do.</p><p>But other than that ... I cut the lawn. I do the gardening.</p><p>I work in the yard in the summertime a lot.\"</p><p>[Dr. Tomek] \"There may be patients who are at greater risk for undergoing knee replacement ... patients who are older ... have more medical conditions, including heart and lung disease or diabetes ... may want to weigh the advantages versus disadvantages of undergoing this procedure.</p><p>Those patients should have a detailed discussion with their physician or provider to determine if knee replacement is truly the right treatment for them.</p><p>In the long term, as knee implants age, some patients may need another operation to replace parts of the implant that have worn out or to replace pieces that have loosened from the bone.\"</p><p>[Azell] \"I know that the knee was good for 15 years.</p><p>So I figured if I didn't run, it would last longer.</p><p>And so that's why I decided to ride ... ride the bike.</p><p>If I had to have it replaced again, I would.</p><p>When I'm in my seventies, I think I'll be fine.</p><p>I think I'll still be riding, still be walking, you know, and able to have a quality of life that I'd like to keep.\"</p>"
                },
                "sources": {
                    "mp4_1080p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E3/abq5077.mp4?Expires=1526509545&Signature=JzzI3uXWDoLt8lAJfS52Qv~r~yeZU40fDq6sYQV6-rcoP3sh1IQBukkaT~ZWlJNc8adROloEFIrCN5H3T73ztry1MvWg7o02TbAJOZ6O8L~H-HRQreXabqsXVJk4eFPIGaRynAsUh9oINsEyj4pwYmuToueFk33enqyEWm9b4J8_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_720p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E4/abq5077.mp4?Expires=1526509545&Signature=jmGozbQGqiGGF6XzSdk8-Z01MuyIdmWr9oZRxOItRpDgqnnW00c2XxN79BcW2IhGTat~gMzuDzP0RFpD5YbqqOUu1MVW3UdEG2O-eqnOsZ4SVEhiJ53AZYGEcPts27G9kXTtZKFbCw3J~1hus4fZ1gMS9YTTgzob7055JvawnuE_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "mp4_288p_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/E0/abq5077.mp4?Expires=1526509545&Signature=Pzy1BB7PSYqfQXj2jMDs0~fcJA3PYGJcw8PhvIcBUa6jZbSYxZ~w1c~W~6qnkuG9M9FhKaBIL9QwetBUXUqkRlstn4ETxH-LVus8ueW0QXKE1nUo8x5Q3QdEZkS9aH4-q0q8s-zIrmQJHFJKPmyxt4JCuiJ6J6gJsttldyPyWEI_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_600k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/hls/EF1/filesequence.m3u8?Expires=1526509545&Signature=Nj8n1syMOvJX1tOpvI8wnj7axZ1YQFzTUHionIbp~SOky5Fyi9gf2EEAEFM2N1RCbGZx5rPFtu-n2ACEcXxxgXaD8QRAwnVozw0QvijkKbsWU61T7yLV3U07sF2mjAQsz2ZDS95CMMnrB1d1-bFL3il9MZ9JuTZlc6lKUiUW6AI_&Key-Pair-Id=APKAIDLZDAU235UUEL6A",
                    "hls_400k_url": "https://d20bb9v528piij.cloudfront.net/11.7/en-us/abq5077/SD/hls/EF0/filesequence.m3u8?Expires=1526509545&Signature=itzNWrjlRE6eajrfw1WvXbD4v4b9ITxkO7wyPlu2JY4o2mrTxXVdte3dCox4OWXyw6Q-sYIC7DAGRAVYbaqgwY51vVUhGmCb4clbo7FQ0UUlu0v-STkJJ2jKT~FtxvVGy-maFaAc4CVHGKVMxybYVXij6CrkEmRyqpLgNljWcHc_&Key-Pair-Id=APKAIDLZDAU235UUEL6A"
                },
                "closedCaptions": {
                    "sbv_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.sbv",
                    "srt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.srt",
                    "vtt_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.vtt",
                    "xml_url": "https://assetpool.test.hwapps.net/11.7/en-us/desktop/abq5077/abq5077.xml"
                },
                "learningObjectiveText": {
                    "html": "<p>Users will learn about the pros and cons of knee replacement surgery.</p>"
                },
                "clinicalAbstract": {
                    "html": "<p>Educates patients about what knee replacement surgery involves and the pros and cons of having it done.</p>"
                },
                "teaser": {
                    "html": "<p>Learn about the pros and cons of having knee replacement surgery.</p>"
                },
                "hwid": "abq5077"
            }]
        }]
    }],
    "worksConsulted": [{
        "id": "F65038A0-8C64-4520-9E06-F5BC8593DA08",
        "title": "Beswick AD, et al. (2012). What proportion of patients report long-term pain after total hip or knee replacement for osteoarthritis? A systematic review of prospective studies in unselected patients. BMJ Open, 2(1). DOI: 10.1136/bmjopen-2011-000435. Accessed April 24, 2016."
    }, {
        "id": "692A981E-E403-4461-9E48-EE57C1D14F61",
        "title": "Singh JA, et al. (2011). Cardiac and thromboembolic complications and mortality in patients undergoing total hip and total knee arthroplasty. Annals of the Rheumatic Diseases, 70(12): 2082–2088. DOI: 10.1136/ard.2010.148726. Accessed May 25, 2016."
    }, {
        "id": "6CCF73D6-7E57-45C1-B7F2-85E5CA964FDD",
        "title": "Kurtz SM, et al (2010). Prosthetic joint infection risk after TKA in the Medicare population. Clinical Orthopaedics and Related Research, 468(1): 52–56. DOI: 10.1007/s11999-009-1013-5. Accessed May 25, 2016."
    }, {
        "id": "99EA4248-1B3A-4E10-AFAA-4279CE6F240D",
        "title": "Mahomed NN, et al. (2005). Epidemiology of total knee replacement in the United States Medicare population. The Journal of Bone and Joint Surgery. American Volume, 87(6): 1222–1228. http://dx.doi.org/10.2106/JBJS.D.02546 Accessed May 25, 2016."
    }, {
        "id": "60AF3A55-284A-40AA-BE00-17023A512950",
        "title": "Namba RS et al. (2013). Risk factors associated with deep surgical site infections after primary total knee arthroplasty: An analysis of 56,216 knees. The Journal of Bone and Joint Surgery. American volume, 95(9): 775–782. DOI: 10.2106/JBJS.L.00211. Accessed May 25, 2016."
    }, {
        "id": "20B2B008-22CF-4E98-AA5E-5B4339D55819",
        "title": "Katz JN, et al. (2004). Association between hospital and surgeon procedure volume and the outcomes of total knee replacement. The Journal of Bone and Joint Surgery. American Volume, 86-A(9): 1909–1916. http://jbjs.org/content/86/9/1909.long. Accessed May 25, 2016."
    }, {
        "id": "182DA729-DF82-4396-8FF2-0157AA038366",
        "title": "Fernandes L, et al. (2013). European League Against Rheumatism (EULAR) recommendations for the non-pharmacological core management of hip and knee osteoarthritis. Annals of the Rheumatic Diseases, 72(7):1125–1135."
    }, {
        "id": "E9C40C4A-0D04-460F-92AA-27B043B1CA10",
        "title": "Jevsevar DS, et al. (2013). The American Academy of Orthopaedic Surgeons'evidence-based guideline on: treatment of osteoarthritis of the knee, 2nd ed. Journal of Bone and Joint Surgery. American volume, 95(20):1885–1886."
    }, {
        "id": "95E48B29-EE79-469F-B220-0E448CCEFAFC",
        "title": "McAlindon TE, et al. (2014). OARSI guidelines for the non-surgical management of knee osteoarthritis. Osteoarthritis and Cartilage, 22(3): 363–388. DOI: 10.1016/j.joca.2014.01.003."
    }, {
        "id": "99E86BD7-6CDB-4C89-AF8F-F7D6A752405B",
        "title": "National Clinical Guideline Centre (2014). Osteoarthritis: Care and management in adults. London: National Institute for Health and Care Excellence (UK). https://www.nice.org.uk/guidance/CG59."
    }, {
        "id": "0CEE9DFA-84BA-4EB8-95F1-E334D49B6411",
        "title": "Jüni P, et al. (2015). Intra-articular corticosteroid for knee osteoarthritis. Cochrane Database of Systematic Reviews (10). DOI: 10.1002/14651858.CD005328.pub3. Accessed April 24, 2016."
    }, {
        "id": "9EC65FBB-72AF-4F08-A334-8F766EFDECBF",
        "title": "Fransen M, et al. (2015). Exercise for osteoarthritis of the knee. Cochrane Database of Systematic Reviews (1). doi: 10.1002/14651858.CD004376.pub3."
    }, {
        "id": "666A59EE-E16B-41C9-9871-766FC689193C",
        "title": "Hochberg MC, et al. (2012). American College of Rheumatology 2012 recommendations for the use of nonpharmacologic and pharmacologic therapies in osteoarthritis of the hand, hip, and knee. Arthritis Care & Research, 64(4): 465–474."
    }, {
        "id": "0161FBFE-0CF7-45A1-ADC4-39F1FAF25E78",
        "title": "Bartels EM, et al. (2016). Aquatic exercise for the treatment of knee and hip osteoarthritis. Cochrane Database of Systematic Reviews(3). DOI: 10.1002/14651858.CD005523.pub3. Accessed March 17, 2017."
    }, {
        "id": "5459AAA2-71B4-4AB3-B012-55E390F76328",
        "title": "Higuera CA, et al. (2010). Mid-America Orthopaedic Association Physician in Training Award: predictors of early adverse outcomes after knee and hip arthroplasty in geriatric patients, Clinical Orthopaedics and Related Research, 469(5): 1391-1400. Accessed March 17, 2017."
    }],
    "applicationUrl": ""
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AnswerCorrectIndicator = __webpack_require__(1012);

var _AnswerCorrectIndicator2 = _interopRequireDefault(_AnswerCorrectIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnswerCorrectIndicator = function (_React$Component) {
  _inherits(AnswerCorrectIndicator, _React$Component);

  function AnswerCorrectIndicator() {
    _classCallCheck(this, AnswerCorrectIndicator);

    return _possibleConstructorReturn(this, (AnswerCorrectIndicator.__proto__ || Object.getPrototypeOf(AnswerCorrectIndicator)).apply(this, arguments));
  }

  _createClass(AnswerCorrectIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          children = _props.children;


      var outerClasses = 'hw-answer-correct-indicator ' + _AnswerCorrectIndicator2.default.answer_correct_indicator;
      var wrapperClasses = 'hw-answer-correct-indicator-wrapper ' + _AnswerCorrectIndicator2.default.answer_correct_indicator_wrapper;
      var iconClasses = 'hw-answer-correct-indicator-icon ' + _AnswerCorrectIndicator2.default.answer_correct_indicator_icon;
      var checkmarkClasses = 'hw-answer-correct-indicator-icon ' + _AnswerCorrectIndicator2.default.answer_correct_indicator_checkmark;
      var indicatorTextClasses = 'hw-answer-correct-indicator-text ' + _AnswerCorrectIndicator2.default.answer_correct_indicator_text;

      return _react2.default.createElement(
        'span',
        { className: outerClasses, id: id },
        _react2.default.createElement(
          'span',
          { className: wrapperClasses },
          _react2.default.createElement(
            'svg',
            { role: 'presentation', className: iconClasses, width: '23', height: '18', focusable: 'false' },
            _react2.default.createElement(
              'g',
              { className: checkmarkClasses },
              _react2.default.createElement('line', { y2: '14.78125', x2: '9.190340', y1: '9.525510', x1: '2.40625', strokeWidth: '2' }),
              _react2.default.createElement('line', { y2: '2.406250', x2: '20.46875', y1: '14.84056', x1: '7.86972', strokeWidth: '2' })
            )
          ),
          _react2.default.createElement(
            'span',
            { className: indicatorTextClasses },
            children
          )
        )
      );
    }
  }]);

  return AnswerCorrectIndicator;
}(_react2.default.Component);

AnswerCorrectIndicator.propTypes = {
  id: _propTypes2.default.string,
  children: _propTypes2.default.string
};

AnswerCorrectIndicator.defaultProps = {
  children: 'Correct'
};

exports.default = AnswerCorrectIndicator;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _AnswerIncorrectIndicator = __webpack_require__(1013);

var _AnswerIncorrectIndicator2 = _interopRequireDefault(_AnswerIncorrectIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnswerIncorrectIndicator = function (_React$Component) {
  _inherits(AnswerIncorrectIndicator, _React$Component);

  function AnswerIncorrectIndicator() {
    _classCallCheck(this, AnswerIncorrectIndicator);

    return _possibleConstructorReturn(this, (AnswerIncorrectIndicator.__proto__ || Object.getPrototypeOf(AnswerIncorrectIndicator)).apply(this, arguments));
  }

  _createClass(AnswerIncorrectIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          children = _props.children;


      var outerClasses = (0, _classnames2.default)(_defineProperty({
        'hw-answer-incorrect-indicator': true
      }, _AnswerIncorrectIndicator2.default.answer_incorrect_indicator, true));
      var wrapperClasses = (0, _classnames2.default)(_defineProperty({
        'hw-answer-incorrect-indicator-wrapper': true
      }, _AnswerIncorrectIndicator2.default.answer_incorrect_indicator_wrapper, true));
      var indicatorTextClasses = (0, _classnames2.default)(_defineProperty({
        'hw-answer-incorrect-indicator-text': true
      }, _AnswerIncorrectIndicator2.default.answer_incorrect_indicator_text, true));

      return _react2.default.createElement(
        'span',
        { className: outerClasses, id: id },
        _react2.default.createElement(
          'span',
          { className: wrapperClasses },
          _react2.default.createElement(
            'span',
            { className: indicatorTextClasses },
            children
          )
        )
      );
    }
  }]);

  return AnswerIncorrectIndicator;
}(_react2.default.Component);

AnswerIncorrectIndicator.propTypes = {
  id: _propTypes2.default.string,
  children: _propTypes2.default.string
};

AnswerIncorrectIndicator.defaultProps = {
  children: 'Incorrect'
};

exports.default = AnswerIncorrectIndicator;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _CompareBox = __webpack_require__(1014);

var _CompareBox2 = _interopRequireDefault(_CompareBox);

var _Heading = __webpack_require__(99);

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompareBox = function (_Component) {
  _inherits(CompareBox, _Component);

  function CompareBox() {
    _classCallCheck(this, CompareBox);

    return _possibleConstructorReturn(this, (CompareBox.__proto__ || Object.getPrototypeOf(CompareBox)).apply(this, arguments));
  }

  _createClass(CompareBox, [{
    key: 'getNewCompareBoxObject',
    value: function getNewCompareBoxObject() {
      return { title: null, content: [] };
    }
  }, {
    key: 'render',
    value: function render() {
      var parts = [];
      var part = this.getNewCompareBoxObject();
      var counter = 0;

      var wrapperClasses = (0, _classnames2.default)(_defineProperty({
        'hw-compare-box-wrapper': true
      }, _CompareBox2.default.compare_box_wrapper, true));
      var compareBoxClasses = (0, _classnames2.default)(_defineProperty({
        'hw-compare-box': true
      }, _CompareBox2.default.compare_box, true));
      var compareBoxItemClasses = (0, _classnames2.default)(_defineProperty({
        'hw-compare-box-item': true
      }, _CompareBox2.default.compare_box_item, true));
      var compareBoxTitleClasses = (0, _classnames2.default)(_defineProperty({
        'hw-compare-box-title': true
      }, _CompareBox2.default.compare_box_title, true));
      var compareBoxContentClasses = (0, _classnames2.default)(_defineProperty({
        'hw-compare-box-content': true
      }, _CompareBox2.default.compare_box_content, true));

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child && (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && child.type !== 'h3') {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = child.props.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var section = _step2.value;

                if (section && (typeof section === 'undefined' ? 'undefined' : _typeof(section)) === 'object') {
                  if (section.props['data-element'] === 'title') {
                    part.title = section.props.children[0];
                  } else {
                    part.content.push(section);
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (part.content.length !== 0) {
              parts.push(_react2.default.createElement(
                'div',
                { key: 'hw-compare-box-item-key-' + counter++, className: compareBoxItemClasses },
                _react2.default.createElement(
                  _Heading2.default,
                  { headingLevel: 3, styleLevel: 0, className: compareBoxTitleClasses },
                  part.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: compareBoxContentClasses },
                  part.content
                )
              ));
              part = this.getNewCompareBoxObject();
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return _react2.default.createElement(
        'fieldset',
        { className: wrapperClasses },
        _react2.default.createElement(
          'div',
          { className: compareBoxClasses },
          parts
        )
      );
    }
  }]);

  return CompareBox;
}(_react.Component);

CompareBox.propTypes = {
  children: _propTypes2.default.node
};

exports.default = CompareBox;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _CompareIconArray = __webpack_require__(1015);

var _CompareIconArray2 = _interopRequireDefault(_CompareIconArray);

var _IconArray = __webpack_require__(427);

var _IconArray2 = _interopRequireDefault(_IconArray);

var _theme = __webpack_require__(168);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompareIconArray = function (_Component) {
  _inherits(CompareIconArray, _Component);

  function CompareIconArray() {
    _classCallCheck(this, CompareIconArray);

    return _possibleConstructorReturn(this, (CompareIconArray.__proto__ || Object.getPrototypeOf(CompareIconArray)).apply(this, arguments));
  }

  _createClass(CompareIconArray, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          minrange = _props.minrange,
          maxrange = _props.maxrange,
          total = _props.total,
          icontype = _props.icontype,
          minRange = _props.minRange,
          maxRange = _props.maxRange,
          iconType = _props.iconType;

      var wrapperClasses = (0, _classnames2.default)(_defineProperty({
        'hw-compare-icon-array': true
      }, _CompareIconArray2.default.compare_icon_array, true));

      return _react2.default.createElement(
        'div',
        { className: wrapperClasses },
        _react2.default.createElement(_IconArray2.default, {
          minRange: minrange || minRange,
          maxRange: maxrange || maxRange,
          total: total,
          iconType: icontype || iconType,
          theme: _theme2.default.defaultTheme
        })
      );
    }
  }]);

  return CompareIconArray;
}(_react.Component);

CompareIconArray.propTypes = {
  minrange: _propTypes2.default.string,
  minRange: _propTypes2.default.string,
  maxrange: _propTypes2.default.string,
  maxRange: _propTypes2.default.string,
  icontype: _propTypes2.default.string,
  iconType: _propTypes2.default.string,
  total: _propTypes2.default.string
};

exports.default = CompareIconArray;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _CompareTable = __webpack_require__(1016);

var _CompareTable2 = _interopRequireDefault(_CompareTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var filterOutBadChildren = function filterOutBadChildren(children) {
  return children.filter(function (value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
  });
};

var keyCounter = 0;
var getTableKey = function getTableKey() {
  return 'compare-table-body-' + keyCounter++;
};

var CompareTable = function (_Component) {
  _inherits(CompareTable, _Component);

  function CompareTable() {
    _classCallCheck(this, CompareTable);

    return _possibleConstructorReturn(this, (CompareTable.__proto__ || Object.getPrototypeOf(CompareTable)).apply(this, arguments));
  }

  _createClass(CompareTable, [{
    key: 'getHeadingRowInfo',
    value: function getHeadingRowInfo(tableHeadChildren) {
      var filtered = filterOutBadChildren(tableHeadChildren);
      var filteredRow = filterOutBadChildren(filtered[0].props.children);
      return {
        left: filteredRow[1].props.children[0].props.children[0],
        right: filteredRow[2].props.children[0].props.children[0]
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var Sticky = void 0;
      var StickyContainer = void 0;
      if (this.props.readOnly) {
        Sticky = GenericContainer;
        StickyContainer = GenericContainer;
      } else {
        try {
          console.log(/*require.resolve*/(160)); // Prevents errors in dev tools
          var ReactSticky = __webpack_require__(160);
          Sticky = ReactSticky.Sticky;
          StickyContainer = ReactSticky.StickyContainer;
        } catch (e) {
          Sticky = GenericContainer;
          StickyContainer = GenericContainer;
        }
      }

      try {
        var filteredTableGroupParts = filterOutBadChildren(this.props.children);
        var tableGroup = filteredTableGroupParts.filter(function (value) {
          return value.type === 'tgroup';
        });

        var filteredTableParts = filterOutBadChildren(tableGroup[0].props.children);
        var tableHead = filteredTableParts.filter(function (value) {
          return value.type === 'thead';
        });
        var tableBody = filteredTableParts.filter(function (value) {
          return value.type === 'tbody';
        });

        var columnText = this.getHeadingRowInfo(tableHead[0].props.children);

        var headTextClasses = (0, _classnames2.default)('hw-compare-head-text', _CompareTable2.default.headCellText);

        return _react2.default.createElement(
          StickyContainer,
          { className: _CompareTable2.default.compare },
          _react2.default.createElement(
            Sticky,
            { className: 'hw-compare-head-row' },
            _react2.default.createElement(
              'div',
              { className: '' + _CompareTable2.default.headCellVisibleWrapper },
              _react2.default.createElement(
                'span',
                { className: _CompareTable2.default.headCell + ' hw-compare-head-cell' },
                _react2.default.createElement(
                  'span',
                  {
                    'aria-hidden': true,
                    role: 'presentation',
                    className: headTextClasses
                  },
                  columnText.left
                )
              ),
              _react2.default.createElement(
                'span',
                { className: _CompareTable2.default.headCell + ' hw-compare-head-cell' },
                _react2.default.createElement(
                  'span',
                  {
                    'aria-hidden': true,
                    role: 'presentation',
                    className: headTextClasses
                  },
                  columnText.right
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                'aria-hidden': true,
                role: 'presentation',
                className: _CompareTable2.default.headCellVisibleUnderscore
              },
              ' '
            )
          ),
          _react2.default.createElement(
            'table',
            { className: _CompareTable2.default.compareTable },
            _react2.default.createElement(CompareHeaderRowForA11y, { columnText: columnText }),
            _react2.default.createElement(
              CompareTableBody,
              null,
              tableBody[0].props.children
            )
          )
        );
      } catch (err) {
        console.error(err);
        return _react2.default.createElement(
          'table',
          { className: _CompareTable2.default.compareTable },
          this.props.children
        );
      }
    }
  }]);

  return CompareTable;
}(_react.Component);

var CompareHeaderRowForA11y = function (_Component2) {
  _inherits(CompareHeaderRowForA11y, _Component2);

  function CompareHeaderRowForA11y() {
    _classCallCheck(this, CompareHeaderRowForA11y);

    return _possibleConstructorReturn(this, (CompareHeaderRowForA11y.__proto__ || Object.getPrototypeOf(CompareHeaderRowForA11y)).apply(this, arguments));
  }

  _createClass(CompareHeaderRowForA11y, [{
    key: 'render',
    value: function render() {
      var columnText = this.props.columnText;

      var headCellClasses = (0, _classnames2.default)(_CompareTable2.default.forAssistiveTech, _CompareTable2.default.headCellText);

      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          {
            className: _CompareTable2.default.forFixedWidthLayoutRow,
            'aria-hidden': true,
            role: 'presentation'
          },
          _react2.default.createElement(
            'td',
            { 'aria-hidden': true, role: 'presentation' },
            ' '
          ),
          _react2.default.createElement(
            'td',
            {
              'aria-hidden': true,
              role: 'presentation',
              className: _CompareTable2.default.forFixedWidthLayout
            },
            ' '
          ),
          _react2.default.createElement(
            'td',
            {
              'aria-hidden': true,
              role: 'presentation',
              className: _CompareTable2.default.forFixedWidthLayout
            },
            ' '
          )
        ),
        _react2.default.createElement(
          'tr',
          { className: _CompareTable2.default.forAssistiveTech },
          _react2.default.createElement(
            'td',
            { 'aria-hidden': true, role: 'presentation', key: 'compare-table-head-0' },
            ''
          ),
          _react2.default.createElement(
            'th',
            {
              scope: 'col',
              className: _CompareTable2.default.headCell,
              key: 'compare-table-head-1'
            },
            _react2.default.createElement(
              'span',
              { className: headCellClasses },
              columnText.left
            )
          ),
          _react2.default.createElement(
            'th',
            {
              scope: 'col',
              className: _CompareTable2.default.headCell,
              key: 'compare-table-head-2'
            },
            _react2.default.createElement(
              'span',
              { className: headCellClasses },
              columnText.right
            )
          )
        )
      );
    }
  }]);

  return CompareHeaderRowForA11y;
}(_react.Component);

var CompareTableBody = function (_Component3) {
  _inherits(CompareTableBody, _Component3);

  function CompareTableBody() {
    _classCallCheck(this, CompareTableBody);

    return _possibleConstructorReturn(this, (CompareTableBody.__proto__ || Object.getPrototypeOf(CompareTableBody)).apply(this, arguments));
  }

  _createClass(CompareTableBody, [{
    key: 'getRow',
    value: function getRow(rowCells) {
      var cells = [];
      var rowHeader = rowCells.shift();
      var headerChildren = filterOutBadChildren(rowHeader.props.children);

      var compareTableCellClasses = (0, _classnames2.default)('compareTableCell', _CompareTable2.default.cell);
      var titleRowClasses = (0, _classnames2.default)('sectionTitleRow', _CompareTable2.default.sectionTitleRow);
      var titleCellClasses = (0, _classnames2.default)('sectionTitleCell', _CompareTable2.default.sectionTitleCell);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = rowCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cell = _step.value;

          var cellElements = filterOutBadChildren(cell.props.children);
          cells.push(_react2.default.createElement(
            'td',
            { className: compareTableCellClasses, key: getTableKey() },
            cellElements
          ));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [_react2.default.createElement(
        'tr',
        { className: titleRowClasses, key: getTableKey(), 'aria-hidden': true },
        _react2.default.createElement(
          'td',
          { className: _CompareTable2.default.forAssistiveTech, key: getTableKey() },
          ' '
        ),
        _react2.default.createElement(
          'td',
          { className: titleCellClasses, key: getTableKey(), colSpan: '2' },
          _react2.default.createElement(
            'span',
            { className: _CompareTable2.default.sectionTitleParent },
            headerChildren
          )
        )
      ), _react2.default.createElement(
        'tr',
        { key: getTableKey() },
        _react2.default.createElement(
          'th',
          { className: _CompareTable2.default.forAssistiveTech, scope: 'row', key: getTableKey() },
          headerChildren.filter(function (node) {
            return typeof node.type === 'function';
          })
        ),
        cells
      )];
    }
  }, {
    key: 'render',
    value: function render() {
      var rows = [];
      var children = this.props.children;

      var filteredRows = filterOutBadChildren(children);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = filteredRows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var filteredRow = _step2.value;

          var filteredCells = filterOutBadChildren(filteredRow.props.children);
          rows.push(this.getRow(filteredCells));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return _react2.default.createElement(
        'tbody',
        null,
        rows
      );
    }
  }]);

  return CompareTableBody;
}(_react.Component);

var GenericContainer = function (_Component4) {
  _inherits(GenericContainer, _Component4);

  function GenericContainer() {
    _classCallCheck(this, GenericContainer);

    return _possibleConstructorReturn(this, (GenericContainer.__proto__ || Object.getPrototypeOf(GenericContainer)).apply(this, arguments));
  }

  _createClass(GenericContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          attributes = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        'div',
        attributes,
        children
      );
    }
  }]);

  return GenericContainer;
}(_react.Component);

CompareTable.propTypes = {
  children: _propTypes2.default.node,
  readOnly: _propTypes2.default.bool
};

CompareHeaderRowForA11y.propTypes = {
  columnText: _propTypes2.default.shape({
    left: _propTypes2.default.string.isRequired,
    right: _propTypes2.default.string.isRequired
  }).isRequired
};

CompareTableBody.propTypes = {
  children: _propTypes2.default.array
};

GenericContainer.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.default = CompareTable;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContentArticle = __webpack_require__(1018);

var _ContentArticle2 = _interopRequireDefault(_ContentArticle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentArticle = function (_Component) {
  _inherits(ContentArticle, _Component);

  function ContentArticle() {
    _classCallCheck(this, ContentArticle);

    return _possibleConstructorReturn(this, (ContentArticle.__proto__ || Object.getPrototypeOf(ContentArticle)).apply(this, arguments));
  }

  _createClass(ContentArticle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'article',
        { className: 'hw-content-article ' + _ContentArticle2.default.content_article },
        this.props.children
      );
    }
  }]);

  return ContentArticle;
}(_react.Component);

ContentArticle.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ContentArticle;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EmailSummary = __webpack_require__(1019);

var _EmailSummary2 = _interopRequireDefault(_EmailSummary);

var _Heading = __webpack_require__(99);

var _Heading2 = _interopRequireDefault(_Heading);

var _InputText = __webpack_require__(428);

var _InputText2 = _interopRequireDefault(_InputText);

var _TextArea = __webpack_require__(244);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _Button = __webpack_require__(120);

var _Button2 = _interopRequireDefault(_Button);

var _LoadingIndicator = __webpack_require__(166);

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _actions = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailSummary = function (_Component) {
  _inherits(EmailSummary, _Component);

  function EmailSummary(props) {
    _classCallCheck(this, EmailSummary);

    var _this = _possibleConstructorReturn(this, (EmailSummary.__proto__ || Object.getPrototypeOf(EmailSummary)).call(this, props));

    _this.validateEmailFields = _this.validateEmailFields.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onOkay = _this.onOkay.bind(_this);
    _this.onSend = _this.onSend.bind(_this);
    _this.resetState = _this.resetState.bind(_this);

    _this.state = {
      email1: '',
      email2: '',
      showError: false,
      showButtonShake: false
    };
    return _this;
  }

  _createClass(EmailSummary, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // if there's an error sending the email, scroll to the top, to ensure the error is seen
      if (this.props.emailSuccess === false) {
        document.getElementsByClassName('ReactModal__Content')[0].scrollTop = 0;
      } else if (this.props.emailSuccess === true) {
        _reactDom2.default.findDOMNode(this.refs.okayButton).focus();
      }
    }

    // returns boolean for validity

  }, {
    key: 'validateEmailFields',
    value: function validateEmailFields() {
      var email1isValid = this.email1Validator();
      var email2isValid = this.email2Validator();
      var isValid = email1isValid && email2isValid;

      this.setState({
        showError: !isValid,
        showButtonShake: !isValid
      });

      return isValid;
    }
  }, {
    key: 'getStatusText',
    value: function getStatusText(status) {
      switch (status) {
        case true:
          return 'Success! Your email has been sent.';
        case false:
          return 'Error! Something went wrong. Try again.';
        default:
          return '';
      }
    }
  }, {
    key: 'getStatus',
    value: function getStatus(status) {
      var statusText = this.getStatusText(status);
      switch (status) {
        case true:
          return _react2.default.createElement(
            'div',
            { className: _EmailSummary2.default.statusSuccess },
            statusText
          );
        case false:
          return _react2.default.createElement(
            'div',
            { className: _EmailSummary2.default.statusError },
            statusText
          );
        default:
          return null;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e, whichEmail) {
      var obj = {};
      obj[whichEmail] = e.target.value;
      // clear the error on any change
      obj.showError = false;
      obj.blankinlineError = false;
      obj.showSuccess = false;

      this.setState(obj);
    }
  }, {
    key: 'onOkay',
    value: function onOkay() {
      this.props.setEmailStatus(null);
      this.props.onOkay();
    }
  }, {
    key: 'onSend',
    value: function onSend() {
      // validate form before sending
      if (this.validateEmailFields()) {
        var _props = this.props,
            responses = _props.responses,
            esdpMap = _props.esdpMap;

        var json = {};
        json.recipientName = this.recipientName;
        json.to = this.state.email1;
        json.subject = 'Decision Summary - ' + esdpMap.title.consumer;
        json.optionalMessage = this.optionalMessage;
        json.responses = responses;
        json.questionGroups = esdpMap.topics[4].topics.filter(function (topic) {
          return topic.type === 'hwDecisionAssessment';
        });
        json.checkmarkCID = 'checkmark';
        json.healthwiseLogoCID = 'healthwiseLogo';
        json.resources = [{
          name: 'checkmark',
          type: 'image/jpeg',
          content: '/9j/4AAQSkZJRgABAQIACwALAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/wAALCAAcABwBAREA/8QAGQAAAwADAAAAAAAAAAAAAAAAAwQGAgUI/8QAKhAAAQQBAwQCAgEFAAAAAAAAAQIDBAUGERIhAAcxQRNRImEUI3FygpP/2gAIAQEAAD8A6fzTJbCJaRMYxiIxNyKa0Xh/IJEeFHB2mQ9t5KdfxSgaFatQCAFKSm12/kygH8gznLLGWeVGLPVXspP0huPt0T/kVn7J6BNrcyw5o2NHb2GWVjI3SKixKFy9g8mM+AkqWPOx3du8BSerKhtq+9pYdxVSEyYUxpLzDgBG5JHsHkH0QeQdQepTtokS8kzi6e/KU9d/wgT5QxHZbShA/W5Tq/7unrE92cHGI32TOWqmYtA+5HsWXmlNyGXUqKQgtK0VuWdNg0/LUfvRbs3FzGcmxzXNJEqJKvShUKiLh+Kqip1+NBT7eUFblq+9Bxpp0rh9sjHb3MqJmM47EjX6nI6Gxw0H40eS4n/q86r/AG6bXLbwbuLPcslBjHspeaealq4bi2IbS0ptw+Eh1DbRSTxvSsHladT5J2mwrIO4dZnNjWlVrAIUUpVo1JWgf0lvI8LU3qdpPI19gACky7I6rFqR22t3y2ykhDbaE7nZDquENNIHK3FHgJHJPWp7X01hX0UqxvWUNXN3Ocs57IUFBhawlKGdffxtIabJHBKCRweqaxhQ7GC9AsIjEuI+gtvMPthbbiT5SpJ4I/R6jUdt2YSfhx/MMtoYg4TEizkPsoH0gSW3ShP0EkAegOnsfwGiqrZF3IcsLq5bSUt2FtKVJdaB8hoH8GgffxpTr716q+v/2Q=='
        }, {
          name: 'healthwiseLogo',
          type: 'image/png',
          content: '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'
        }];

        this.props.onSend(json);

        return true;
      } else {
        this.setState({ showButtonShake: true });

        return false;
      }
    }
  }, {
    key: 'resetState',
    value: function resetState() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.state.showButtonShake) {
          _this2.setState({ showButtonShake: false });
        }
      }, 875);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var status = this.getStatus(this.props.emailSuccess);
      var statusText = this.getStatusText(this.props.emailSuccess);
      var loading = this.props.emailSuccess === _actions.SUMMARY_EMAIL_STATUS__LOADING ? _react2.default.createElement(
        'div',
        { className: _EmailSummary2.default.loading },
        _react2.default.createElement(_LoadingIndicator2.default, { style: { top: '50%', marginTop: '-15px' } })
      ) : null;
      var shakeButtonClasses = 'shake';

      var themeOverride = {
        colorBackgroundLight: 'white',
        colorTextPrimary: 'rgb(66, 66, 66)',
        colorTextSecondary: '#676767',
        colorError: '#dd372f',
        focusIndicator: '2px dotted rgb(66, 66, 66)',
        focusIndicatorOffset: '2px'
      };

      if (this.state.showButtonShake) {
        shakeButtonClasses += ' shake-active';
        // reset "shake" state (after a timeout)
        this.resetState();
      }

      return this.props.emailSuccess === true ? _react2.default.createElement(
        'div',
        { className: _EmailSummary2.default.wrapper },
        _react2.default.createElement(
          _Heading2.default,
          {
            headingLevel: 2,
            styleLevel: 1,
            id: 'emailSummary_heading',
            className: _EmailSummary2.default.heading,
            'aria-label': statusText
          },
          _react2.default.createElement(
            'svg',
            {
              className: _EmailSummary2.default.emailSvg,
              role: 'presentation',
              focusable: 'false',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 32 23'
            },
            _react2.default.createElement(
              'g',
              { fill: 'none' },
              _react2.default.createElement('path', {
                d: 'M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z',
                fill: '#017acd'
              }),
              _react2.default.createElement('path', {
                d: 'M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77 2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885 1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311 29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538 21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z',
                stroke: '#017acd'
              })
            )
          ),
          'Email Your Decision Summary'
        ),
        status,
        _react2.default.createElement(
          'div',
          { className: _EmailSummary2.default.buttonsWrapper },
          _react2.default.createElement(
            _Button2.default,
            { onClick: this.onOkay, ref: 'okayButton' },
            'Okay'
          )
        )
      ) : _react2.default.createElement(
        'div',
        { className: _EmailSummary2.default.wrapper },
        _react2.default.createElement(
          _Heading2.default,
          {
            headingLevel: 2,
            styleLevel: 1,
            id: 'emailSummary_heading',
            className: _EmailSummary2.default.heading,
            'aria-label': 'Email Summary Modal Window (use the cancel button to close)'
          },
          _react2.default.createElement(
            'svg',
            {
              className: _EmailSummary2.default.emailSvg,
              role: 'presentation',
              focusable: 'false',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 32 23'
            },
            _react2.default.createElement(
              'g',
              { fill: 'none' },
              _react2.default.createElement('path', {
                d: 'M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z',
                fill: '#017acd'
              }),
              _react2.default.createElement('path', {
                d: 'M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77 2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885 1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311 29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538 21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z',
                stroke: '#017acd'
              })
            )
          ),
          'Email Your Decision Summary'
        ),
        status,
        _react2.default.createElement(
          'fieldset',
          { className: 'hw-compare-box-wrapper' },
          _react2.default.createElement(_InputText2.default, {
            type: 'text',
            label: 'Name of Recipient:',
            autoFocus: true,
            onChange: function onChange(e) {
              _this3.recipientName = e.target.value;
            },
            theme: themeOverride
          }),
          _react2.default.createElement(_InputText2.default, {
            type: 'email',
            label: 'Recipient\'s Email Address:',
            required: true,
            onChange: function onChange(e) {
              _this3.onChange(e, 'email1');
            },
            getValidator: function getValidator(validator) {
              return _this3.email1Validator = validator;
            },
            theme: themeOverride
          }),
          _react2.default.createElement(_InputText2.default, {
            type: 'email',
            label: 'Confirm Email Address:',
            required: true,
            onChange: function onChange(e) {
              _this3.onChange(e, 'email2');
            },
            validators: {
              matching: function matching(val) {
                var otherEmail = _this3.state.email1;
                return !!(otherEmail.length && val === otherEmail);
              }
            },
            validationErrors: {
              matching: 'Emails must match.'
            },
            getValidator: function getValidator(validator) {
              return _this3.email2Validator = validator;
            },
            theme: themeOverride
          }),
          _react2.default.createElement(_InputText2.default, { type: 'text', label: 'Your Name:', theme: themeOverride }),
          _react2.default.createElement(_TextArea2.default, {
            label: 'Your Message to the Recipient:',
            maxCharacters: '250',
            onChange: function onChange(e) {
              _this3.optionalMessage = e.target.value;
            },
            theme: themeOverride
          }),
          _react2.default.createElement(
            'div',
            { className: _EmailSummary2.default.buttonsWrapper },
            _react2.default.createElement(
              'span',
              { className: shakeButtonClasses },
              _react2.default.createElement(
                _Button2.default,
                { rounded: true, onClick: this.onSend },
                'Send'
              )
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                rounded: true,
                className: _EmailSummary2.default.secondaryButton,
                onClick: this.props.onCancel
              },
              'Cancel'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'By selecting "Send," you understand and agree that the decision summary and any message you\'ve included for the recipient will be sent via unencrypted email to the email address you provided above.'
        ),
        loading
      );
    }
  }]);

  return EmailSummary;
}(_react.Component);

EmailSummary.propTypes = {
  onCancel: _propTypes2.default.func,
  onSend: _propTypes2.default.func,
  onOkay: _propTypes2.default.func,
  esdpMap: _propTypes2.default.object,
  responses: _propTypes2.default.object,
  emailSuccess: _propTypes2.default.any,
  setEmailStatus: _propTypes2.default.func
};

EmailSummary.defaultsProps = {
  onCancel: function onCancel() {},
  onSend: function onSend() {},
  onOkay: function onOkay() {}
};

exports.default = EmailSummary;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EsdpMap = __webpack_require__(1020);

var _EsdpMap2 = _interopRequireDefault(_EsdpMap);

var _TabNavigation = __webpack_require__(123);

var _Insights = __webpack_require__(70);

var _Insights2 = _interopRequireDefault(_Insights);

var _Translation = __webpack_require__(247);

var _Translation2 = _interopRequireDefault(_Translation);

var _Footer = __webpack_require__(393);

var _Footer2 = _interopRequireDefault(_Footer);

var _NavigationHeading = __webpack_require__(455);

var _NavigationHeading2 = _interopRequireDefault(_NavigationHeading);

var _TabGroup = __webpack_require__(432);

var _TabGroup2 = _interopRequireDefault(_TabGroup);

var _Tab = __webpack_require__(243);

var _Tab2 = _interopRequireDefault(_Tab);

var _CreditsAndReferences = __webpack_require__(381);

var _CreditsAndReferences2 = _interopRequireDefault(_CreditsAndReferences);

var _StandardDisclaimer = __webpack_require__(462);

var _StandardDisclaimer2 = _interopRequireDefault(_StandardDisclaimer);

var _LoadingIndicator = __webpack_require__(166);

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EsdpMap = function (_Component) {
  _inherits(EsdpMap, _Component);

  function EsdpMap(props) {
    _classCallCheck(this, EsdpMap);

    var _this = _possibleConstructorReturn(this, (EsdpMap.__proto__ || Object.getPrototypeOf(EsdpMap)).call(this, props));

    _this.handleTopicTabClick = _this.handleTopicTabClick.bind(_this);

    _this.lastPageViewed = false;
    _this.currentTopic = '';

    _this.insights = new _Insights2.default();
    _this.insights.setConfigOption('applicationName', 'esdp');
    _this.insights.setConfigOption('application', 'esdp');
    _this.insights.setConfigOption('product', props.product);
    return _this;
  }

  _createClass(EsdpMap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadMap(this.props.mapId);
      this.props.updateStatus('In-Progress');
      this.setDocumentTitle();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInitialState();
      var currentTopic = (0, _TabNavigation.GetTopicNavigationInfoByPathName)(nextProps.navigationInfo, window.location.pathname);
      this.currentTopic = currentTopic.title;
      this.setDocumentTitle(currentTopic);
      this.setVisitedState(this.props.params.topicId);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // focus the active tab on page load
      var tab = document.querySelector('.hw-tab-is-active');
      if (tab && typeof tab.focus === 'function') {
        tab.focus();
      }
    }
  }, {
    key: 'setDocumentTitle',
    value: function setDocumentTitle(topic) {
      var esdpMap = this.props.esdpMap;

      if (esdpMap && esdpMap.title && esdpMap.title.consumer && document && document.title) {
        document.title = topic.title ? esdpMap.title.consumer + ' - ' + topic.title : esdpMap.title.consumer;
        this.recordPageView(topic.id);
      } else {
        document.title = (0, _Translation2.default)(this.props.localization, 'Loading');
      }
    }
  }, {
    key: 'recordPageView',
    value: function recordPageView(topicId) {
      var props = this.props;
      var topic = props.esdpMap.topics.filter(function (topic) {
        return topic.id === topicId;
      })[0];

      // only send pageViewed once
      if (this.lastPageViewed !== topic.id) {
        this.insights.trackEvent({
          pageName: document.title,
          eventName: 'pageViewed',
          documentHwid: topic.id,
          documentType: 'esdp',
          documentTitle: topic.topics[0].title.consumer,
          docLanguage: topic.topics[0].lang,
          sectionHwid: 'tab',
          sectionTitle: topic.title.consumer
        });
      }

      this.lastPageViewed = topic.id;
    }
  }, {
    key: 'getTopicLocation',
    value: function getTopicLocation(mapId, localization, topicId) {
      return '/' + mapId + '/' + localization + '/' + topicId;
    }
  }, {
    key: 'isAlreadyVisited',
    value: function isAlreadyVisited(topicId) {
      var toReturn = false;

      this.props.navigationInfo.forEach(function (navItem) {
        if (navItem.id === topicId && navItem.visited) {
          toReturn = true;
        }
      });

      return toReturn;
    }
  }, {
    key: 'setInitialState',
    value: function setInitialState() {
      var _props = this.props,
          mapId = _props.mapId,
          localization = _props.localization,
          children = _props.children,
          esdpMap = _props.esdpMap,
          router = _props.router;

      if (children === null && esdpMap !== null && Array.isArray(esdpMap.topics) && esdpMap.topics[0]) {
        var topicId = esdpMap.topics[0].id;
        this.setVisitedState(topicId);
        var topicLocation = this.getTopicLocation(mapId, localization, topicId);
        router.replace(topicLocation);
      }
    }
  }, {
    key: 'setVisitedState',
    value: function setVisitedState(topicId) {
      if (!this.isAlreadyVisited(topicId)) {
        this.props.setVisitedNav(topicId);
      }
    }
  }, {
    key: 'handleTopicTabClick',
    value: function handleTopicTabClick(event, topicLocation, topicId) {
      event.preventDefault();

      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'pageAction',
        actionName: 'navigation',
        actionContext: this.currentTopic
      });

      this.setVisitedState(topicId);
      this.props.router.push(topicLocation);
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e, prevTab, nextTab) {
      switch (e.which) {
        case 37:
          return this.props.router.push(prevTab);
        case 39:
          return this.props.router.push(nextTab);
        default:
          return;
      }
    }
  }, {
    key: 'createTopicTab',
    value: function createTopicTab(topic, index, topics) {
      var _this2 = this;

      var _props2 = this.props,
          mapId = _props2.mapId,
          localization = _props2.localization;

      var navItems = this.props.esdpMap.navigation.topics;
      var summaryTabId = navItems[navItems.length - 1].id;
      var summaryEnabled = this.props.appMeta.summaryTabEnabled;
      var isDisabled = !summaryEnabled && topic.id === summaryTabId;

      var topicLocation = this.getTopicLocation(mapId, localization, topic.id);
      var topicLink = this.props.router.createHref(topicLocation);
      var isActive = this.props.router.isActive(topicLocation);
      var isAlreadyVisited = this.isAlreadyVisited(topic.id);

      var targetIndex = index - 1 >= 0 ? index - 1 : topics.length - 1;
      if (!summaryEnabled && topics[targetIndex].id === summaryTabId) {
        // handle disabled, not elegant for multiple disabled tabs but esdp only has summary 
        targetIndex--;
      }
      var prevTopic = topics[targetIndex];
      var prevTabLink = this.getTopicLocation(mapId, localization, prevTopic.id);

      targetIndex = index + 1 <= topics.length - 1 ? index + 1 : 0;
      if (!summaryEnabled && topics[targetIndex].id === summaryTabId) {
        targetIndex = 0;
      }
      var nextTopic = topics[targetIndex];
      var nextTabLink = this.getTopicLocation(mapId, localization, nextTopic.id);

      var onClick = isDisabled ? function (event) {
        event.stopPropagation();
        event.preventDefault();
      } : function (event) {
        return _this2.handleTopicTabClick(event, topicLocation, topic.id);
      };

      return _react2.default.createElement(
        _Tab2.default,
        {
          key: topic.id,
          onKeyUp: function onKeyUp(e) {
            return _this2.handleKeyUp(e, prevTabLink, nextTabLink);
          },
          href: topicLink,
          onClick: onClick,
          isActive: isActive,
          tabIndex: isActive ? null : '-1',
          'aria-current': isActive ? 'step' : 'false',
          visited: isAlreadyVisited,
          disabled: isDisabled
        },
        topic.title.consumer
      );
    }
  }, {
    key: 'createTopicTabs',
    value: function createTopicTabs(topics) {
      var _this3 = this;

      return topics.map(function (topic, index, topics) {
        return _this3.createTopicTab(topic, index, topics);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var esdpMap = this.props.esdpMap;


      if (esdpMap !== null) {
        var topics = esdpMap.topics;
        var legal = Object.assign({
          logoUrl: null,
          copyrightText: null,
          disclaimerText: null,
          yourUseOfThisInformationHtml: null,
          toLearnMoreHtml: null
        }, esdpMap.legal);
        var credits = esdpMap.credits;
        var references = esdpMap.worksConsulted;
        var asOfDate = esdpMap.certifiedDate;
        var appRoot = esdpMap.applicationUrl;
        var onSelection = function onSelection(fontSize) {
          var _guid = esdpMap.id;
          var _root = appRoot;
          var _lang = esdpMap.lang;
          var newPath = _root + '/Print/Esdp/' + _lang + '/' + _guid + '/' + fontSize;
          window.open(newPath, '_blank');
        };

        if (topics != null) {
          var tabs = this.createTopicTabs(topics);

          return _react2.default.createElement(
            'div',
            { className: _EsdpMap2.default.container },
            _react2.default.createElement(
              _NavigationHeading2.default,
              { onSelection: onSelection },
              _react2.default.createElement(
                _TabGroup2.default,
                null,
                tabs
              )
            ),
            this.props.children,
            _react2.default.createElement(
              _Footer2.default,
              null,
              _react2.default.createElement(
                'div',
                { className: _EsdpMap2.default.credits_wrapper },
                _react2.default.createElement(_CreditsAndReferences2.default, {
                  id: 'hw-esdp-credits-and-references',
                  credits: credits,
                  references: references,
                  asOfDate: asOfDate
                })
              ),
              _react2.default.createElement(_StandardDisclaimer2.default, {
                logoSrc: legal.logoUrl,
                copyright: legal.copyrightText,
                disclaimer: legal.disclaimerText,
                externalHtml: legal.yourUseOfThisInformationHtml,
                learnMoreHtml: legal.toLearnMoreHtml
              })
            )
          );
        } else {
          return _react2.default.createElement(
            'div',
            null,
            'Missing topics'
          );
        }
      } else {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_LoadingIndicator2.default, null)
        );
      }
    }
  }]);

  return EsdpMap;
}(_react.Component);

EsdpMap.defaultProps = {
  esdpMap: null,
  product: 'communicate'
};

EsdpMap.propTypes = {
  children: _propTypes2.default.element,
  appMeta: _propTypes2.default.shape({
    summaryTabEnabled: _propTypes2.default.bool.isRequired
  }),
  esdpMap: _propTypes2.default.shape({
    navigation: _propTypes2.default.shape({
      topics: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      })).isRequired
    }),
    title: _propTypes2.default.shape({
      consumer: _propTypes2.default.string
    }).isRequired
  }),
  navigationInfo: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.object,
  loadMap: _propTypes2.default.func.isRequired,
  updateStatus: _propTypes2.default.func.isRequired,
  setVisitedNav: _propTypes2.default.func.isRequired,
  localization: _propTypes2.default.string.isRequired,
  mapId: _propTypes2.default.string.isRequired,
  product: _propTypes2.default.string.isRequired,
  router: _propTypes2.default.object
};

exports.default = EsdpMap;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TabNavigation = __webpack_require__(123);

var _BlockHeading = __webpack_require__(387);

var _BlockHeading2 = _interopRequireDefault(_BlockHeading);

var _SectionHeading = __webpack_require__(461);

var _SectionHeading2 = _interopRequireDefault(_SectionHeading);

var _SubSectionHeading = __webpack_require__(463);

var _SubSectionHeading2 = _interopRequireDefault(_SubSectionHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var headingTypes = {
  sectionHeading: 'SectionHeading',
  subSectionHeading: 'SubSectionHeading',
  blockHeading: 'BlockHeading'
};

var HeadingMap = {
  'home': [headingTypes.sectionHeading, headingTypes.blockHeading],
  'facts': [headingTypes.sectionHeading, headingTypes.blockHeading],
  'compare': [headingTypes.sectionHeading],
  'learn': [headingTypes.sectionHeading],
  'decide': [headingTypes.sectionHeading, headingTypes.blockHeading, headingTypes.blockHeading, headingTypes.blockHeading],
  'summary': [headingTypes.sectionHeading, headingTypes.blockHeading, headingTypes.blockHeading]
};

var HeadingFactory = function (_Component) {
  _inherits(HeadingFactory, _Component);

  function HeadingFactory() {
    _classCallCheck(this, HeadingFactory);

    return _possibleConstructorReturn(this, (HeadingFactory.__proto__ || Object.getPrototypeOf(HeadingFactory)).apply(this, arguments));
  }

  _createClass(HeadingFactory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          currentLocation = _props.currentLocation,
          sectionIndex = _props.sectionIndex,
          image = _props.image;

      var headingType = HeadingMap[currentLocation][sectionIndex];
      switch (headingType) {
        case headingTypes.sectionHeading:
          return _react2.default.createElement(
            _SectionHeading2.default,
            { image: image },
            children
          );
        case headingTypes.subSectionHeading:
          return _react2.default.createElement(
            _SubSectionHeading2.default,
            null,
            children
          );
      }
      return _react2.default.createElement(
        _BlockHeading2.default,
        null,
        children
      );
    }
  }]);

  return HeadingFactory;
}(_react.Component);

HeadingFactory.propTypes = {
  children: _propTypes2.default.node.isRequired,
  image: _propTypes2.default.node,
  currentLocation: _propTypes2.default.oneOf(_TabNavigation.TabMap).isRequired,
  sectionIndex: _propTypes2.default.number.isRequired
};

exports.default = HeadingFactory;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ImageCompareBox = __webpack_require__(1022);

var _ImageCompareBox2 = _interopRequireDefault(_ImageCompareBox);

var _SvgImage = __webpack_require__(122);

var _SvgImage2 = _interopRequireDefault(_SvgImage);

var _theme = __webpack_require__(168);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageCompareBox = function (_Component) {
  _inherits(ImageCompareBox, _Component);

  function ImageCompareBox() {
    _classCallCheck(this, ImageCompareBox);

    return _possibleConstructorReturn(this, (ImageCompareBox.__proto__ || Object.getPrototypeOf(ImageCompareBox)).apply(this, arguments));
  }

  _createClass(ImageCompareBox, [{
    key: 'render',
    value: function render() {
      var parts = [];
      var part = {};
      var counter = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child && (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && child.type !== 'h3') {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = child.props.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var section = _step2.value;

                if (section && (typeof section === 'undefined' ? 'undefined' : _typeof(section)) === 'object') {
                  if (section.props.className === 'HwImageWrapper') {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                      for (var _iterator3 = section.props.children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var element = _step3.value;

                        if (element.props && element.props.src && new RegExp('\\.svg$').test(element.props.src)) {
                          part.image = _react2.default.createElement(_SvgImage2.default, {
                            src: element.props.src,
                            alt: element.props.alt,
                            additionalClassName: element.props.className,
                            theme: _theme2.default.defaultTheme
                          });
                        } else {
                          part.image = section;
                        }
                      }
                    } catch (err) {
                      _didIteratorError3 = true;
                      _iteratorError3 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                          _iterator3.return();
                        }
                      } finally {
                        if (_didIteratorError3) {
                          throw _iteratorError3;
                        }
                      }
                    }
                  } else {
                    part.content = section;
                  }

                  if (_typeof(part.content) === 'object') {
                    parts.push(_react2.default.createElement(
                      'div',
                      {
                        key: 'hw-image-compare-box-item-key-' + counter++,
                        className: 'hw-image-compare-box-item ' + _ImageCompareBox2.default.image_compare_box_item
                      },
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'hw-image-compare-box-image ' + _ImageCompareBox2.default.image_compare_box_image
                        },
                        part.image
                      ),
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'hw-image-compare-box-content ' + _ImageCompareBox2.default.image_compare_box_content
                        },
                        part.content
                      )
                    ));
                    part = {};
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return _react2.default.createElement(
        'fieldset',
        {
          className: 'hw-image-compare-box-wrapper ' + _ImageCompareBox2.default.image_compare_box_wrapper
        },
        _react2.default.createElement(
          'div',
          { className: 'hw-image-compare-box ' + _ImageCompareBox2.default.image_compare_box },
          parts
        )
      );
    }
  }]);

  return ImageCompareBox;
}(_react.Component);

ImageCompareBox.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ImageCompareBox;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _CompareTable = __webpack_require__(446);

var _CompareTable2 = _interopRequireDefault(_CompareTable);

var _ImageCompareBox = __webpack_require__(451);

var _ImageCompareBox2 = _interopRequireDefault(_ImageCompareBox);

var _CompareBox = __webpack_require__(444);

var _CompareBox2 = _interopRequireDefault(_CompareBox);

var _CompareIconArray = __webpack_require__(445);

var _CompareIconArray2 = _interopRequireDefault(_CompareIconArray);

var _LoadingIndicator = __webpack_require__(166);

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _Paragraph = __webpack_require__(456);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _ListItem = __webpack_require__(249);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _UnorderedList = __webpack_require__(466);

var _UnorderedList2 = _interopRequireDefault(_UnorderedList);

var _SvgImage = __webpack_require__(122);

var _SvgImage2 = _interopRequireDefault(_SvgImage);

var _ComponentBuilder = __webpack_require__(61);

var _ComponentBuilder2 = _interopRequireDefault(_ComponentBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoConcept = function (_Component) {
  _inherits(InfoConcept, _Component);

  function InfoConcept(props) {
    _classCallCheck(this, InfoConcept);

    var _this = _possibleConstructorReturn(this, (InfoConcept.__proto__ || Object.getPrototypeOf(InfoConcept)).call(this, props));

    _this.getComponentMap.bind(_this);
    return _this;
  }

  _createClass(InfoConcept, [{
    key: 'getComponentMap',
    value: function getComponentMap(aspect, title, sectionIndex, currentLocation) {
      var _this2 = this;

      var componentMap = [{
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'p';
        },
        use: _Paragraph2.default
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'ul';
        },
        use: _UnorderedList2.default
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'h3';
        },
        ignore: true
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'table' && currentLocation === 'compare';
        },
        use: _CompareTable2.default
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'li';
        },
        use: _ListItem2.default
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'iconarray';
        },
        use: _CompareIconArray2.default
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'img' && (node.getAttribute('class') || '').toLowerCase().indexOf('hwicontitle') !== -1;
        },
        ignore: true
      }, {
        when: function when(node) {
          return node && (node.tagName || '').toLowerCase() === 'img' && new RegExp('^https?://.*\\.svg$').test(node.getAttribute('src'));
        },
        use: _SvgImage2.default
      }];

      if ((aspect || '').indexOf('[decisionOptions]') !== -1) {
        componentMap.push({
          when: function when(node) {
            return node && (node.getAttribute('class') || '').indexOf('HwDecisionComponent') !== -1 && _this2.doesDescendantNodeHaveClassName(node, 'HwImageWrapper');
          },
          use: _ImageCompareBox2.default
        });
        componentMap.push({
          when: function when(node) {
            return node && (node.getAttribute('class') || '').indexOf('HwDecisionComponent') !== -1;
          },
          use: _CompareBox2.default
        });
        componentMap.unshift({
          when: function when(node) {
            return node && (node.tagName || '').toLowerCase() === 'h3' && node.parentElement && (node.parentElement.className || '') === 'HwSection';
          },
          use: 'span'
        });
      }

      return componentMap;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.generateReactComponents();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { ref: function ref(wrapper) {
            _this3.wrapper = wrapper;
          } },
        _react2.default.createElement(_LoadingIndicator2.default, null)
      );
    }
  }, {
    key: 'doesDescendantNodeHaveClassName',
    value: function doesDescendantNodeHaveClassName(parent, className) {
      var isSuccessful = false;
      if (parent && parent.childNodes) {
        for (var key in parent.childNodes) {
          if (parent.childNodes.hasOwnProperty(key)) {
            var node = parent.childNodes[key];
            if (node.tagName) {
              if (node && (node.getAttribute('class') || '').indexOf(className) !== -1) {
                isSuccessful = true;
                break;
              } else {
                isSuccessful = isSuccessful || this.doesDescendantNodeHaveClassName(node, className);
              }
            }
          }
        }
      }
      return isSuccessful;
    }
  }, {
    key: 'generateReactComponents',
    value: function generateReactComponents() {
      var _props = this.props,
          item = _props.item,
          title = _props.title,
          sectionIndex = _props.sectionIndex,
          currentLocation = _props.currentLocation;

      var componentBuilder = new _ComponentBuilder2.default({
        componentMap: this.getComponentMap(item.aspect, title, sectionIndex, currentLocation)
      });
      var component = componentBuilder.build(item.html);
      this.wrapper.innerHTML = '';
      _reactDom2.default.render(component, this.wrapper);
    }
  }]);

  return InfoConcept;
}(_react.Component);

InfoConcept.propTypes = {
  sectionIndex: _propTypes2.default.number,
  currentLocation: _propTypes2.default.string,
  title: _propTypes2.default.string,
  item: _propTypes2.default.shape({
    html: _propTypes2.default.string.isRequired,
    aspect: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['hwDecisionComponent']).isRequired
  }).isRequired
};

exports.default = InfoConcept;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(85);

var _actions = __webpack_require__(86);

var _Interaction = __webpack_require__(1023);

var _Interaction2 = _interopRequireDefault(_Interaction);

var _QuizWrapper = __webpack_require__(458);

var _QuizWrapper2 = _interopRequireDefault(_QuizWrapper);

var _QuestionBlock = __webpack_require__(250);

var _QuestionBlock2 = _interopRequireDefault(_QuestionBlock);

var _LikertScale = __webpack_require__(429);

var _LikertScale2 = _interopRequireDefault(_LikertScale);

var _QuestionMultChoiceSingleAnswer = __webpack_require__(457);

var _QuestionMultChoiceSingleAnswer2 = _interopRequireDefault(_QuestionMultChoiceSingleAnswer);

var _TextArea = __webpack_require__(244);

var _TextArea2 = _interopRequireDefault(_TextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Interaction = function (_Component) {
  _inherits(Interaction, _Component);

  function Interaction() {
    _classCallCheck(this, Interaction);

    return _possibleConstructorReturn(this, (Interaction.__proto__ || Object.getPrototypeOf(Interaction)).apply(this, arguments));
  }

  _createClass(Interaction, [{
    key: 'render',
    value: function render() {
      var item = this.props.item;

      this.handleLikertAnswer = this.handleLikertAnswer.bind(this);
      this.handleMultChoiceAnsweredQuestion = this.handleMultChoiceAnsweredQuestion.bind(this);
      this.handleMultChoiceAnsweredQuizQuestion = this.handleMultChoiceAnsweredQuizQuestion.bind(this);
      this.handleOpenQuestion = this.handleOpenQuestion.bind(this);

      return this.renderInteractionType(item);
    }
  }, {
    key: 'handleLikertAnswer',
    value: function handleLikertAnswer(e, selectedValue, answerId) {
      var response = {
        id: e.target.name,
        answerId: answerId,
        type: this.props.item.type,
        // this emulates the format of the other answers, so the same action can handle it easily
        answers: [{
          id: answerId,
          answer: selectedValue
        }]
      };

      this.props.updateResponses('LikertResponse', response);
    }
  }, {
    key: 'handleMultChoiceAnsweredQuestion',
    value: function handleMultChoiceAnsweredQuestion(event) {
      var response = {
        'id': event.target.name,
        'answerId': event.target.value,
        'answers': this.props.item.answers,
        'question': this.props.item.question,
        'type': this.props.item.type
      };

      this.props.updateResponses('OpinionResponse', response);
    }
  }, {
    key: 'handleMultChoiceAnsweredQuizQuestion',
    value: function handleMultChoiceAnsweredQuizQuestion(event) {
      var response = {
        'id': event.target.name,
        'answerId': event.target.value,
        'answers': this.props.item.answers,
        'question': this.props.item.question,
        'type': this.props.item.type
      };

      this.props.updateResponses('QuizResponse', response);
    }
  }, {
    key: 'handleOpenQuestion',
    value: function handleOpenQuestion(e) {
      var props = this.props;
      var response = {
        id: props.item.id,
        answerId: props.item.answerId,
        type: props.item.type,
        // this emulates the format of the other answers, so the same action can handle it easily
        answers: [{
          id: props.item.answerId,
          answer: e.target.value
        }]
      };

      this.props.updateResponses('LikertResponse', response);
    }
  }, {
    key: 'renderInteractionType',
    value: function renderInteractionType(item) {
      var handleLikertAnswer = this.handleLikertAnswer;

      var _props = this.props,
          responseState = _props.responseState,
          onQuestionRender = _props.onQuestionRender,
          readonly = _props.readonly,
          propArguments = _objectWithoutProperties(_props, ['responseState', 'onQuestionRender', 'readonly']);

      var selectedAnswer = (responseState.responses[item.id] || { answer: { value: null, id: null } }).answer;
      var toRender = null;

      switch (item.type) {
        case 'hwSingleSelectScale':
          // default render
          toRender = _react2.default.createElement(_LikertScale2.default, _extends({
            id: item.id,
            answerId: item.answerId,
            name: item.id,
            onAnswer: handleLikertAnswer,
            selectedAnswer: selectedAnswer.value,
            readonly: readonly
          }, propArguments));

          // allow the parent to replace render (in this case -- with "Go back to answer" for unanswered questions on the summary page)
          if (onQuestionRender) {
            var customRender = onQuestionRender(item.id);
            // only custom render if the parent function hands us something
            if (customRender) {
              toRender = customRender;
            }
          }

          return _react2.default.createElement(
            _QuizWrapper2.default,
            null,
            _react2.default.createElement(
              _QuestionBlock2.default,
              { questionId: item.id, question: item.question },
              toRender
            )
          );

        case 'hwSingleSelectOpinion':
          // default render
          toRender = _react2.default.createElement(
            _QuizWrapper2.default,
            null,
            _react2.default.createElement(_QuestionMultChoiceSingleAnswer2.default, _extends({
              responses: responseState.responses,
              onAnswer: this.handleMultChoiceAnsweredQuestion,
              selectedAnswer: selectedAnswer.id,
              readonly: readonly
            }, item, propArguments))
          );

          // allow the parent to replace render (in this case, with "Go back to answer" for unanswered questions on the summary page)
          if (onQuestionRender) {
            var _customRender = onQuestionRender(item.id);
            // only custom render if the parent function hands us something
            if (_customRender) {
              toRender = _react2.default.createElement(
                _QuizWrapper2.default,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'hw-esdp-interaction-question-wrapper' },
                  _react2.default.createElement(
                    _QuestionBlock2.default,
                    { questionId: item.id, question: item.question },
                    _customRender
                  )
                )
              );
            }
          }

          return toRender;

        case 'hwSingleSelectQuiz':
          return _react2.default.createElement(
            _QuizWrapper2.default,
            null,
            _react2.default.createElement(_QuestionMultChoiceSingleAnswer2.default, _extends({
              responses: responseState.responses,
              selectedAnswer: selectedAnswer.id,
              onAnswer: this.handleMultChoiceAnsweredQuizQuestion,
              readonly: readonly
            }, item, propArguments))
          );

        case 'hwOpenQuestion':
          return _react2.default.createElement(
            _QuizWrapper2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: _Interaction2.default.notes_wrapper },
              _react2.default.createElement(_TextArea2.default, {
                label: item.question,
                readonly: readonly,
                value: selectedAnswer.value,
                maxCharacters: 250,
                onBlur: this.handleOpenQuestion
              })
            )
          );

        default:
          throw new Error('Unknown interaction type: ' + item.type);
      }
    }
  }, {
    key: 'rawMarkup',
    value: function rawMarkup(markup) {
      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: markup } });
    }
  }]);

  return Interaction;
}(_react.Component);

Interaction.propTypes = {
  responseState: _propTypes2.default.object,
  updateResponses: _propTypes2.default.func.isRequired,
  item: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    answers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired,
      answer: _propTypes2.default.string.isRequired,
      correctAnswer: _propTypes2.default.string,
      feedback: _propTypes2.default.string
    })),
    question: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['hwSingleSelectOpinion', 'hwSingleSelectQuiz', 'hwSingleSelectScale', 'hwOpenQuestion'])
  }).isRequired,
  onQuestionRender: _propTypes2.default.func,
  readonly: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return state;
}, { updateResponses: _actions.updateResponses })(Interaction);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ComponentBuilder = __webpack_require__(61);

var _ComponentBuilder2 = _interopRequireDefault(_ComponentBuilder);

var _Interaction = __webpack_require__(453);

var _Interaction2 = _interopRequireDefault(_Interaction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LearningAssessment = function (_Component) {
  _inherits(LearningAssessment, _Component);

  function LearningAssessment() {
    _classCallCheck(this, LearningAssessment);

    return _possibleConstructorReturn(this, (LearningAssessment.__proto__ || Object.getPrototypeOf(LearningAssessment)).apply(this, arguments));
  }

  _createClass(LearningAssessment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          responseState = _props.responseState,
          onQuestionRender = _props.onQuestionRender,
          readonly = _props.readonly;

      return _react2.default.createElement(
        'section',
        null,
        this.rawMarkup(item.content[0].intro),

        // TODO: Should content actually be an array?
        item.content[0].interactions.map(function (interaction) {
          return _react2.default.createElement(_Interaction2.default, { key: interaction.id, item: interaction, responseState: responseState, onQuestionRender: onQuestionRender, readonly: readonly });
        })
      );
    }
  }, {
    key: 'rawMarkup',
    value: function rawMarkup(markup) {
      if (markup) {
        var componentBuilder = new _ComponentBuilder2.default({
          componentMap: [{
            when: function when(node) {
              return node && (node.tagName || '').toLowerCase() === 'img' && (node.getAttribute('class') || '').toLowerCase().indexOf('hwicontitle') !== -1;
            },
            ignore: true
          }]
        });
        return componentBuilder.build('<div>' + markup + '</div>');
      }
      return null;
    }
  }]);

  return LearningAssessment;
}(_react.Component);

LearningAssessment.propTypes = {
  responseState: _propTypes2.default.object,
  item: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(['hwDecisionAssessment'])
  }).isRequired,
  onQuestionRender: _propTypes2.default.func,
  readonly: _propTypes2.default.bool
};

exports.default = LearningAssessment;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavigationHeading = __webpack_require__(1025);

var _NavigationHeading2 = _interopRequireDefault(_NavigationHeading);

var _Translation = __webpack_require__(247);

var _Translation2 = _interopRequireDefault(_Translation);

var _Icon = __webpack_require__(165);

var _DropDown = __webpack_require__(391);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _FeatureFlipper = __webpack_require__(392);

var _FeatureFlipper2 = _interopRequireDefault(_FeatureFlipper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavigationHeading = function (_Component) {
  _inherits(NavigationHeading, _Component);

  function NavigationHeading() {
    _classCallCheck(this, NavigationHeading);

    return _possibleConstructorReturn(this, (NavigationHeading.__proto__ || Object.getPrototypeOf(NavigationHeading)).apply(this, arguments));
  }

  _createClass(NavigationHeading, [{
    key: 'render',
    value: function render() {
      var printItems = [{ name: 'Small', value: '12pt', component: _react2.default.createElement(
          'span',
          { style: { 'fontSize': '1em' } },
          'Small'
        ) }, { name: 'Medium', value: '14pt', component: _react2.default.createElement(
          'span',
          { style: { 'fontSize': '1.25em' } },
          'Medium'
        ) }, { name: 'Large', value: '16pt', component: _react2.default.createElement(
          'span',
          { style: { 'fontSize': '1.75em' } },
          'Large'
        ) }];
      return _react2.default.createElement(
        'nav',
        { className: _NavigationHeading2.default.nav },
        _react2.default.createElement(
          'div',
          { className: _NavigationHeading2.default.banner },
          _react2.default.createElement(
            'div',
            { className: _NavigationHeading2.default.bannerInner },
            _react2.default.createElement(
              'h1',
              { className: _NavigationHeading2.default.bannerText },
              (0, _Translation2.default)(this.props.localization, 'DecisionAid')
            ),
            _react2.default.createElement(
              _FeatureFlipper2.default,
              {
                evaluate: (document.getElementById('hw-hide-esdp-print-drop-down') || { value: 'false' }).value !== 'true',
                'data-instructions': 'Keep in place until 11.2 is no longer available in production' },
              _react2.default.createElement(_DropDown2.default, {
                items: printItems,
                prompt: 'Print',
                maintainPrompt: true,
                onSelect: this.props.onSelection,
                icon: (0, _Icon.PrinterIcon)({ role: 'presentation', className: 'hw-icon-white' })
              })
            )
          )
        ),
        this.props.children
      );
    }
  }]);

  return NavigationHeading;
}(_react.Component);

NavigationHeading.propTypes = {
  children: _propTypes2.default.node,
  localization: _propTypes2.default.string,
  onSelection: _propTypes2.default.func.isRequired
};

NavigationHeading.defaultProps = {
  localization: 'en-us',
  onSelection: function onSelection(value, event) {
    console.error('No onSelection function provided. ' + value, event);
  }
};

exports.default = NavigationHeading;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paragraph = __webpack_require__(1026);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Paragraph = function (_Component) {
  _inherits(Paragraph, _Component);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          otherAttributes = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        'p',
        _extends({ className: 'hw-paragraph ' + _Paragraph2.default.paragraph }, otherAttributes),
        children
      );
    }
  }]);

  return Paragraph;
}(_react.Component);

Paragraph.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Paragraph;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuestionMultChoiceSingleAnswer = __webpack_require__(1028);

var _QuestionMultChoiceSingleAnswer2 = _interopRequireDefault(_QuestionMultChoiceSingleAnswer);

var _QuestionBlock = __webpack_require__(250);

var _QuestionBlock2 = _interopRequireDefault(_QuestionBlock);

var _RadioQuizAnswer = __webpack_require__(459);

var _RadioQuizAnswer2 = _interopRequireDefault(_RadioQuizAnswer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuestionMultChoiceSingleAnswer = function (_React$Component) {
  _inherits(QuestionMultChoiceSingleAnswer, _React$Component);

  function QuestionMultChoiceSingleAnswer() {
    _classCallCheck(this, QuestionMultChoiceSingleAnswer);

    return _possibleConstructorReturn(this, (QuestionMultChoiceSingleAnswer.__proto__ || Object.getPrototypeOf(QuestionMultChoiceSingleAnswer)).apply(this, arguments));
  }

  _createClass(QuestionMultChoiceSingleAnswer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          question = _props.question,
          answers = _props.answers,
          correctAnswerText = _props.correctAnswerText,
          incorrectAnswerText = _props.incorrectAnswerText,
          selectedAnswer = _props.selectedAnswer,
          onAnswer = _props.onAnswer,
          readonly = _props.readonly,
          forPrint = _props.forPrint,
          otherAttributes = _objectWithoutProperties(_props, ['id', 'question', 'answers', 'correctAnswerText', 'incorrectAnswerText', 'selectedAnswer', 'onAnswer', 'readonly', 'forPrint']);

      var hasCorrectAnswer = answers.reduce(function (prev, curr) {
        return prev || curr.correctAnswer === 'true';
      }, false);
      var answerElements = void 0;
      answerElements = answers.map(function (answer, key) {
        var isCorrect = answer.correctAnswer === 'true';
        var isSelectedAnswer = selectedAnswer === answer.id;
        var questionHasSelectedAnswer = !!selectedAnswer;
        return _react2.default.createElement(_RadioQuizAnswer2.default, {
          key: key,
          id: answer.id,
          name: id,
          label: answer.answer,
          value: answer.id,
          hasCorrectAnswer: hasCorrectAnswer,
          correctAnswerText: correctAnswerText,
          incorrectAnswerText: incorrectAnswerText,
          showEvaluation: isSelectedAnswer || isCorrect && questionHasSelectedAnswer,
          isSelected: isSelectedAnswer,
          isCorrect: isCorrect,
          onAnswer: onAnswer,
          readonly: readonly,
          forPrint: forPrint
        });
      });

      return _react2.default.createElement(
        'div',
        { role: 'radiogroup', className: 'hw-question-mult-choice-single-answer ' + _QuestionMultChoiceSingleAnswer2.default.question_mult_choice_single_answer },
        _react2.default.createElement(
          _QuestionBlock2.default,
          { questionId: id, question: question },
          _react2.default.createElement(
            'div',
            { className: 'hw-question-mult-choice-single-answer-group ' + _QuestionMultChoiceSingleAnswer2.default.question_mult_choice_single_answer_group },
            answerElements
          )
        )
      );
    }
  }]);

  return QuestionMultChoiceSingleAnswer;
}(_react2.default.Component);

QuestionMultChoiceSingleAnswer.propTypes = {
  id: _propTypes2.default.string.isRequired,
  question: _propTypes2.default.string.isRequired,
  selectedAnswer: _propTypes2.default.string,
  correctAnswerText: _propTypes2.default.string,
  incorrectAnswerText: _propTypes2.default.string,
  onAnswer: _propTypes2.default.func,
  answers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    answer: _propTypes2.default.string.isRequired,
    feedback: _propTypes2.default.string,
    correctAnswer: _propTypes2.default.string
  })).isRequired,
  readonly: _propTypes2.default.bool,
  forPrint: _propTypes2.default.bool
};

exports.default = QuestionMultChoiceSingleAnswer;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuizWrapper = __webpack_require__(1029);

var _QuizWrapper2 = _interopRequireDefault(_QuizWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuizWrapper = function (_Component) {
  _inherits(QuizWrapper, _Component);

  function QuizWrapper() {
    _classCallCheck(this, QuizWrapper);

    return _possibleConstructorReturn(this, (QuizWrapper.__proto__ || Object.getPrototypeOf(QuizWrapper)).apply(this, arguments));
  }

  _createClass(QuizWrapper, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'hw-quiz-wrapper ' + _QuizWrapper2.default.quiz_wrapper },
        this.props.children
      );
    }
  }]);

  return QuizWrapper;
}(_react.Component);

QuizWrapper.propTypes = {
  children: _propTypes2.default.node
};

exports.default = QuizWrapper;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RadioQuizAnswer = __webpack_require__(1030);

var _RadioQuizAnswer2 = _interopRequireDefault(_RadioQuizAnswer);

var _Radio = __webpack_require__(241);

var _Radio2 = _interopRequireDefault(_Radio);

var _AnswerCorrectIndicator = __webpack_require__(442);

var _AnswerCorrectIndicator2 = _interopRequireDefault(_AnswerCorrectIndicator);

var _AnswerIncorrectIndicator = __webpack_require__(443);

var _AnswerIncorrectIndicator2 = _interopRequireDefault(_AnswerIncorrectIndicator);

var _ComponentBuilder = __webpack_require__(61);

var _ComponentBuilder2 = _interopRequireDefault(_ComponentBuilder);

var _KeyGen = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioQuizAnswer = function (_React$Component) {
  _inherits(RadioQuizAnswer, _React$Component);

  function RadioQuizAnswer() {
    _classCallCheck(this, RadioQuizAnswer);

    return _possibleConstructorReturn(this, (RadioQuizAnswer.__proto__ || Object.getPrototypeOf(RadioQuizAnswer)).apply(this, arguments));
  }

  _createClass(RadioQuizAnswer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          name = _props.name,
          value = _props.value,
          hiddenLabel = _props.hiddenLabel,
          label = _props.label,
          isCorrect = _props.isCorrect,
          hasCorrectAnswer = _props.hasCorrectAnswer,
          correctAnswerText = _props.correctAnswerText,
          incorrectAnswerText = _props.incorrectAnswerText,
          showEvaluation = _props.showEvaluation,
          isSelected = _props.isSelected,
          onAnswer = _props.onAnswer,
          readonly = _props.readonly,
          forPrint = _props.forPrint,
          otherAttributes = _objectWithoutProperties(_props, ['id', 'name', 'value', 'hiddenLabel', 'label', 'isCorrect', 'hasCorrectAnswer', 'correctAnswerText', 'incorrectAnswerText', 'showEvaluation', 'isSelected', 'onAnswer', 'readonly', 'forPrint']);

      if (hiddenLabel) {
        hiddenLabel = _react2.default.createElement(
          'span',
          { className: _RadioQuizAnswer2.default.common_hidden_text },
          hiddenLabel
        );
      }

      var evaluationIndicator = null;
      var mistakenClassName = null;
      var answerElement = label;
      id = id || (0, _KeyGen.getKey)();

      if (/^<div(.+)div>$/.test(label)) {
        var componentBuilder = new _ComponentBuilder2.default({
          componentMap: [{
            when: function when(node) {
              return node && (node.tagName || '').toLowerCase() === 'div';
            },
            use: 'span',
            withProps: { className: _RadioQuizAnswer2.default.radio_quiz_answer_wrapper }
          }]
        });
        answerElement = componentBuilder.build(label);
      } else {
        answerElement = _react2.default.createElement('span', { className: _RadioQuizAnswer2.default.radio_quiz_answer_wrapper, dangerouslySetInnerHTML: { __html: label } });
      }

      if (isCorrect && showEvaluation) {
        evaluationIndicator = _react2.default.createElement(
          'span',
          { className: _RadioQuizAnswer2.default.radio_quiz_answer_evaluation },
          _react2.default.createElement(
            _AnswerCorrectIndicator2.default,
            null,
            correctAnswerText
          )
        );
        mistakenClassName = _RadioQuizAnswer2.default.radio_quiz_answer_unmistaken;
      } else if (hasCorrectAnswer && showEvaluation) {
        evaluationIndicator = _react2.default.createElement(
          'span',
          { className: _RadioQuizAnswer2.default.radio_quiz_answer_evaluation },
          _react2.default.createElement(
            _AnswerIncorrectIndicator2.default,
            null,
            incorrectAnswerText
          )
        );
        mistakenClassName = _RadioQuizAnswer2.default.radio_quiz_answer_mistaken;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          { htmlFor: id, className: 'hw-radio-quiz-answer-label ' + _RadioQuizAnswer2.default.radio_quiz_answer_label + (showEvaluation ? ' ' + _RadioQuizAnswer2.default.radio_quiz_answer_active : '') },
          _react2.default.createElement(
            'span',
            { className: 'hw-radio-quiz-answer-row ' + mistakenClassName + ' ' + _RadioQuizAnswer2.default.radio_quiz_answer_row },
            hiddenLabel,
            _react2.default.createElement(
              'span',
              { className: _RadioQuizAnswer2.default.radio_quiz_answer_radio_wrapper },
              _react2.default.createElement(_Radio2.default, _extends({ id: id, name: name, value: value, onClick: onAnswer, checked: isSelected, readonly: readonly, forPrint: forPrint }, otherAttributes))
            ),
            answerElement,
            evaluationIndicator
          )
        )
      );
    }
  }]);

  return RadioQuizAnswer;
}(_react2.default.Component);

RadioQuizAnswer.propTypes = {
  id: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  hiddenLabel: _propTypes2.default.string,
  label: _propTypes2.default.string.isRequired,
  correctAnswerText: _propTypes2.default.string,
  incorrectAnswerText: _propTypes2.default.string,
  isCorrect: _propTypes2.default.bool,
  showEvaluation: _propTypes2.default.bool,
  isSelected: _propTypes2.default.bool,
  onAnswer: _propTypes2.default.func,
  hasCorrectAnswer: _propTypes2.default.bool,
  readonly: _propTypes2.default.bool,
  forPrint: _propTypes2.default.bool
};

RadioQuizAnswer.defaultProps = {
  isCorrect: false,
  showEvaluation: false,
  isSelected: false,
  hasCorrectAnswer: false
};

exports.default = RadioQuizAnswer;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _RelatedContent = __webpack_require__(1031);

var _RelatedContent2 = _interopRequireDefault(_RelatedContent);

var _Insights = __webpack_require__(70);

var _Insights2 = _interopRequireDefault(_Insights);

var _MediaServiceVideo = __webpack_require__(239);

var _MediaServiceVideo2 = _interopRequireDefault(_MediaServiceVideo);

var _Heading = __webpack_require__(99);

var _Heading2 = _interopRequireDefault(_Heading);

var _VideoThumbnail = __webpack_require__(437);

var _VideoThumbnail2 = _interopRequireDefault(_VideoThumbnail);

var _Action = __webpack_require__(378);

var _Action2 = _interopRequireDefault(_Action);

var _Article = __webpack_require__(379);

var _Article2 = _interopRequireDefault(_Article);

var _Story = __webpack_require__(385);

var _Story2 = _interopRequireDefault(_Story);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelatedContent = function (_Component) {
  _inherits(RelatedContent, _Component);

  function RelatedContent(props) {
    _classCallCheck(this, RelatedContent);

    var _this = _possibleConstructorReturn(this, (RelatedContent.__proto__ || Object.getPrototypeOf(RelatedContent)).call(this, props));

    _this.cleanupPreviousVideo = _this.cleanupPreviousVideo.bind(_this);
    _this.renderCloseButton = _this.renderCloseButton.bind(_this);
    _this.focusCloseButton = _this.focusCloseButton.bind(_this);

    _this.insights = new _Insights2.default();
    _this.thumbnailComponents = {};
    _this.videoComponents = {};
    _this.articlePositions = {};
    _this.activeItemCloseButton = null;
    _this.state = {
      activeItem: null
    };
    return _this;
  }

  _createClass(RelatedContent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevState) {
      // animate window scroll (from the current window position to destination)
      // - tweaked quite a bit from https://stackoverflow.com/a/8918062
      var animateScroll = function animateScroll(to, duration) {
        if (duration <= 0) return;

        var start = window.scrollY || window.pageYOffset;
        var difference = start > to ? start - to : start + to;
        var perTick = difference / duration * 10;
        var toScroll = start > to ? start - perTick : start + perTick;

        if (perTick < 10) {
          window.scrollTo(0, to);
          return;
        }

        setTimeout(function () {
          window.scrollTo(0, toScroll);
          animateScroll(to, duration - 10);
        }, 10);
      };

      var activeItem = this.state.activeItem;

      // scroll to new item (in the case that one article is open, then the other article is opened, so it won't be at the bottom)
      if (activeItem && prevState.activeItem !== activeItem) {
        var headerOffset = 70;
        animateScroll(this.articlePositions[activeItem.id] - headerOffset, 500);
        this.focusCloseButton();
      }
    }
  }, {
    key: 'cleanupPreviousVideo',
    value: function cleanupPreviousVideo(itemToClean) {
      var previousItem = this.state.activeItem;

      if (previousItem && previousItem.id && previousItem.type === 'hwVideo') {
        _reactDom2.default.unmountComponentAtNode(this.videoComponents[previousItem.id]);
      }
    }
  }, {
    key: 'onVideoThumbnailClick',
    value: function onVideoThumbnailClick(item) {
      var _props = this.props,
          mediaHash = _props.mediaHash,
          mediaServiceUrl = _props.mediaServiceUrl,
          mediaToken = _props.mediaToken;

      var animationDelay = 300; // ms

      if (this.state.activeItem !== item) {
        this.cleanupPreviousVideo();

        _reactDom2.default.render(_react2.default.createElement(_MediaServiceVideo2.default, {
          hideDisclaimer: true,
          setFocus: true,
          hideType: true,
          hideAbstract: true,
          updateTimeout: animationDelay,
          mediaHash: mediaHash,
          item: item,
          mediaServiceUrl: mediaServiceUrl,
          mediaToken: mediaToken
        }), this.videoComponents[item.id]);

        this.setState({ activeItem: item });
      }
    }
  }, {
    key: 'onArticleThumbnailClick',
    value: function onArticleThumbnailClick(item) {
      if (this.state.activeItem !== item) {
        this.setState({ activeItem: item });
      }
    }
  }, {
    key: 'focusCloseButton',
    value: function focusCloseButton() {
      var _this2 = this;

      setTimeout(function () {
        _this2.activeItemCloseButton.focus();
      }, 300);
    }
  }, {
    key: 'onCloseClick',
    value: function onCloseClick(item) {
      var _this3 = this;

      if (item && item.id && item.type === 'hwVideo') {
        _reactDom2.default.unmountComponentAtNode(this.videoComponents[item.id]);

        if (this.thumbnailComponents[item.id]) {
          setTimeout(function () {
            _this3.thumbnailComponents[item.id].querySelector('button').focus(); // Prevent "Freak Out" mode
          }, 100); // Wait for animation to complete
        }
      }

      this.setState({ activeItem: null });
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton(item) {
      var _this4 = this;

      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          'aria-label': 'Close',
          className: _RelatedContent2.default.contentClose,
          onClick: function onClick() {
            return _this4.onCloseClick(item);
          },
          ref: function ref(el) {
            if (_this4.state.activeItem && _this4.state.activeItem.id == item.id) {
              _this4.activeItemCloseButton = el;
            }
          }
        },
        _react2.default.createElement(
          'svg',
          {
            focusable: 'false',
            role: 'presentation',
            width: '20px',
            height: '20px',
            viewBox: '0 0 20 20',
            version: '1.1'
          },
          _react2.default.createElement(
            'title',
            null,
            'Close'
          ),
          _react2.default.createElement(
            'g',
            { transform: 'translate(-2.000000, -2.000000)' },
            _react2.default.createElement('polygon', {
              points: '22 4.01428571 19.9857143 2 12 9.98571429 4.01428571 2 2 4.01428571 9.98571429 12 2 19.9857143 4.01428571 22 12 14.0142857 19.9857143 22 22 19.9857143 14.0142857 12',
              fill: '#9e9e9e',
              fillRule: 'evenodd',
              stroke: 'none',
              strokeWidth: '1'
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var itemList = this.props.item;
      var renderCloseButton = this.renderCloseButton;
      var thumbnails = [];
      var articlePositions = this.articlePositions;

      itemList.topics.forEach(function (item, i) {
        if (item.thumbnail) {
          if (i > 0) {
            thumbnails.push(_react2.default.createElement('hr', { className: _RelatedContent2.default.rule, key: 'hr' + i }));
          }
          var isActiveItem = _this5.state.activeItem === item;

          switch (item.type) {
            case 'hwVideo':
              var videoClickAction = isActiveItem ? null : function () {
                return _this5.onVideoThumbnailClick(item);
              };
              var durationSegments = item.duration.split(':');

              // change duration format from 00:00:00 to 00:00 (when the video isn't hours long)
              if (durationSegments.length === 3 && durationSegments[0] === '00') {
                durationSegments.shift();
              }

              thumbnails.push(_react2.default.createElement(
                'article',
                {
                  id: 'id_' + item.id,
                  key: i,
                  className: _RelatedContent2.default.contentArticle + ' ' + _RelatedContent2.default.contentType_video,
                  'aria-expanded': _this5.state.activeItem === item,
                  onClick: videoClickAction,
                  ref: function ref(me) {
                    // get cross-browser (IE) compatability
                    var toScroll = window.scrollY || window.pageYOffset;
                    // set the initial location of this video on the page (before we expand/contract, etc.)
                    if (!articlePositions[item.id]) articlePositions[item.id] = Math.round(toScroll + me.getBoundingClientRect().top);
                  }
                },
                renderCloseButton(item),
                _react2.default.createElement(
                  'div',
                  { className: _RelatedContent2.default.content },
                  _react2.default.createElement(
                    'div',
                    { className: _RelatedContent2.default.clearfix },
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentMedia },
                      _react2.default.createElement(
                        'div',
                        {
                          className: _RelatedContent2.default.contentThumbnail,
                          ref: function ref(element) {
                            _this5.thumbnailComponents[item.id] = element;
                          }
                        },
                        _react2.default.createElement(_VideoThumbnail2.default, {
                          src: item.thumbnail,
                          title: item.title.consumer
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentDescription },
                      _react2.default.createElement(
                        'header',
                        { className: _RelatedContent2.default.contentHeader },
                        _react2.default.createElement(
                          'p',
                          { className: 'hw-relatedContent-p' },
                          'Video'
                        ),
                        _react2.default.createElement(
                          _Heading2.default,
                          { headingLevel: 4, styleLevel: 3 },
                          item.title.consumer,
                          ' (',
                          durationSegments.join(':'),
                          ')'
                        )
                      ),
                      _react2.default.createElement(
                        'p',
                        {
                          className: 'hw-relatedContent-p ' + _RelatedContent2.default.contentAbstract
                        },
                        item.abstract.consumer
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentMedia },
                      _react2.default.createElement('div', {
                        className: _RelatedContent2.default.contentFull,
                        ref: function ref(element) {
                          _this5.videoComponents[item.id] = element;
                        }
                      })
                    )
                  )
                )
              ));
              break;

            // currently what we get for "Article"
            case 'Map':
            case 'Product Map':
              var articleClickAction = function articleClickAction() {
                return _this5.onArticleThumbnailClick(item);
              };

              thumbnails.push(_react2.default.createElement(
                'article',
                {
                  id: 'id_' + item.id,
                  key: i,
                  className: _RelatedContent2.default.contentArticle + ' ' + _RelatedContent2.default.contentType_article,
                  'aria-expanded': _this5.state.activeItem === item,
                  onClick: articleClickAction,
                  ref: function ref(me) {
                    // get cross-browser (IE) compatability
                    var toScroll = window.scrollY || window.pageYOffset;
                    // set the initial location of this video on the page (before we expand/contract, etc.)
                    if (!articlePositions[item.id]) articlePositions[item.id] = Math.round(toScroll + me.getBoundingClientRect().top);
                  }
                },
                renderCloseButton(item),
                _react2.default.createElement(
                  'div',
                  { className: _RelatedContent2.default.content },
                  _react2.default.createElement(
                    'div',
                    { className: _RelatedContent2.default.clearfix },
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentDescription },
                      _react2.default.createElement(
                        'header',
                        { className: _RelatedContent2.default.contentHeader },
                        _react2.default.createElement(
                          'p',
                          { className: 'hw-relatedContent-p' },
                          'Article'
                        ),
                        _react2.default.createElement(
                          _Heading2.default,
                          { headingLevel: 4, styleLevel: 3 },
                          item.title.consumer
                        )
                      ),
                      _react2.default.createElement(
                        'p',
                        {
                          className: 'hw-relatedContent-p ' + _RelatedContent2.default.contentAbstract
                        },
                        item.abstract.consumer
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentMedia },
                      _react2.default.createElement(
                        'div',
                        { className: _RelatedContent2.default.contentThumbnail },
                        _react2.default.createElement(
                          'button',
                          { type: 'button', className: _RelatedContent2.default.articleButton },
                          _react2.default.createElement('img', { src: item.thumbnail, alt: item.title.consumer })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.fullArticle },
                      _react2.default.createElement(
                        'div',
                        { className: _RelatedContent2.default.contentFull },
                        _react2.default.createElement(_Article2.default, { productMap: item })
                      )
                    )
                  )
                )
              ));
              break;

            // "hwTeaser" content type
            // - this type has a nested topic to reveal after user interaction ("click", in this case)
            case 'hwTeaser':
              var teaserClickAction = function teaserClickAction() {
                return _this5.onArticleThumbnailClick(item);
              };
              var toShow = item.topics[0];

              var labels = {
                hwAction: 'Tips',
                hwStory: 'Story',
                default: 'Article'
              };
              var label = labels[toShow.type] || labels['default'];

              var component = toShow.type === 'hwStory' ? _react2.default.createElement(_Story2.default, { data: toShow }) : _react2.default.createElement(_Action2.default, { data: toShow });

              thumbnails.push(_react2.default.createElement(
                'article',
                {
                  id: 'id_' + item.id,
                  key: i,
                  className: _RelatedContent2.default.contentArticle + ' ' + _RelatedContent2.default.contentType_article,
                  'aria-expanded': _this5.state.activeItem === item,
                  onClick: teaserClickAction,
                  ref: function ref(me) {
                    // get cross-browser (IE) compatability
                    var toScroll = window.scrollY || window.pageYOffset;
                    // set the initial location of this video on the page (before we expand/contract, etc.)
                    if (!articlePositions[item.id]) articlePositions[item.id] = Math.round(toScroll + me.getBoundingClientRect().top);
                  }
                },
                renderCloseButton(item),
                _react2.default.createElement(
                  'div',
                  { className: _RelatedContent2.default.content },
                  _react2.default.createElement(
                    'div',
                    { className: _RelatedContent2.default.clearfix },
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentDescription },
                      _react2.default.createElement(
                        'header',
                        { className: _RelatedContent2.default.contentHeader },
                        _react2.default.createElement(
                          'p',
                          { className: 'hw-relatedContent-p' },
                          label
                        ),
                        _react2.default.createElement(
                          _Heading2.default,
                          { headingLevel: 4, styleLevel: 3 },
                          item.title.consumer
                        )
                      ),
                      _react2.default.createElement(
                        'p',
                        {
                          className: 'hw-relatedContent-p ' + _RelatedContent2.default.contentAbstract
                        },
                        item.abstract.consumer
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.contentMedia },
                      _react2.default.createElement(
                        'div',
                        { className: _RelatedContent2.default.contentThumbnail },
                        _react2.default.createElement(
                          'button',
                          { type: 'button', className: _RelatedContent2.default.articleButton },
                          _react2.default.createElement('img', { src: item.thumbnail, alt: item.title.consumer })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _RelatedContent2.default.fullArticle },
                      _react2.default.createElement(
                        'div',
                        { className: _RelatedContent2.default.contentFull },
                        component
                      )
                    )
                  )
                )
              ));
              break;

            default:
              console.error('Unknown related content type: ' + item.type);
              break;
          }
        }
      });

      return _react2.default.createElement(
        'section',
        { className: _RelatedContent2.default.relatedContent },
        thumbnails
      );
    }
  }]);

  return RelatedContent;
}(_react.Component);

RelatedContent.propTypes = {
  item: _propTypes2.default.object,
  mediaServiceUrl: _propTypes2.default.string,
  mediaHash: _propTypes2.default.string,
  mediaToken: _propTypes2.default.string
};

RelatedContent.defaultProps = {
  onVideoStart: function onVideoStart() {}
};

exports.default = RelatedContent;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SectionHeading = __webpack_require__(1032);

var _SectionHeading2 = _interopRequireDefault(_SectionHeading);

var _Heading = __webpack_require__(99);

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionHeading = function (_Component) {
  _inherits(SectionHeading, _Component);

  function SectionHeading() {
    _classCallCheck(this, SectionHeading);

    return _possibleConstructorReturn(this, (SectionHeading.__proto__ || Object.getPrototypeOf(SectionHeading)).apply(this, arguments));
  }

  _createClass(SectionHeading, [{
    key: 'render',
    value: function render() {
      var imageElement = null;
      if (this.props.image) {
        imageElement = _react2.default.createElement(
          'span',
          { className: 'hw-esdp-section-heading-image ' + _SectionHeading2.default.esdp_section_heading_image },
          this.props.image
        );
      }

      var headingElement = _react2.default.createElement(
        'div',
        { className: 'hw-esdp-section-heading ' + _SectionHeading2.default.esdp_section_heading },
        imageElement,
        _react2.default.createElement(
          _Heading2.default,
          { tabIndex: '-1', headingLevel: 2, styleLevel: 1, className: 'hw-esdp-heading ' + _SectionHeading2.default.heading },
          this.props.children
        )
      );

      return headingElement;
    }
  }]);

  return SectionHeading;
}(_react.Component);

SectionHeading.propTypes = {
  children: _propTypes2.default.node.isRequired,
  image: _propTypes2.default.node
};

exports.default = SectionHeading;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
      value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StandardDisclaimer = __webpack_require__(1033);

var _StandardDisclaimer2 = _interopRequireDefault(_StandardDisclaimer);

var _ComponentBuilder = __webpack_require__(61);

var _ComponentBuilder2 = _interopRequireDefault(_ComponentBuilder);

var _HealthwiseLogo = __webpack_require__(394);

var _HealthwiseLogo2 = _interopRequireDefault(_HealthwiseLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StandardDisclaimer = function (_React$Component) {
      _inherits(StandardDisclaimer, _React$Component);

      function StandardDisclaimer() {
            _classCallCheck(this, StandardDisclaimer);

            return _possibleConstructorReturn(this, (StandardDisclaimer.__proto__ || Object.getPrototypeOf(StandardDisclaimer)).apply(this, arguments));
      }

      _createClass(StandardDisclaimer, [{
            key: 'render',
            value: function render() {
                  var _props = this.props,
                      id = _props.id,
                      learnMoreHtml = _props.learnMoreHtml,
                      logoAltText = _props.logoAltText,
                      externalHtml = _props.externalHtml,
                      copyright = _props.copyright,
                      disclaimer = _props.disclaimer,
                      forPrint = _props.forPrint,
                      otherAttributes = _objectWithoutProperties(_props, ['id', 'learnMoreHtml', 'logoAltText', 'externalHtml', 'copyright', 'disclaimer', 'forPrint']);

                  var componentBuilder = new _ComponentBuilder2.default({
                        componentMap: [{
                              when: function when(node) {
                                    return node && (node.tagName || '').toLowerCase() === 'a';
                              },
                              use: 'a',
                              withProps: { target: '_blank' }
                        }]
                  });

                  var learnMoreElement = null;

                  if (learnMoreHtml) {
                        learnMoreElement = componentBuilder.build('<span>' + learnMoreHtml + '</span>');
                  }

                  return _react2.default.createElement(
                        'div',
                        { id: id, className: 'hw-standard-disclaimer ' + _StandardDisclaimer2.default.standard_disclaimer + (forPrint ? ' ' + _StandardDisclaimer2.default.standard_disclaimer_print : '') },
                        _react2.default.createElement(
                              'div',
                              { className: 'hw-standard-disclaimer-legal ' + _StandardDisclaimer2.default.legal },
                              _react2.default.createElement(
                                    'p',
                                    { className: 'hw-standard-disclaimer-disclaimer ' + _StandardDisclaimer2.default.disclaimer },
                                    disclaimer,
                                    ' ',
                                    componentBuilder.build('<span>' + externalHtml + '</span>'),
                                    ' ',
                                    learnMoreElement,
                                    ' ',
                                    copyright
                              )
                        ),
                        _react2.default.createElement(
                              'div',
                              { className: 'hw-standard-disclaimer-logo ' + _StandardDisclaimer2.default.logo },
                              _react2.default.createElement(
                                    'a',
                                    { className: 'hw-standard-disclaimer-logo-link ' + _StandardDisclaimer2.default.logo_link, href: 'http://www.healthwise.org/', target: '_blank' },
                                    _react2.default.createElement(
                                          'svg',
                                          { className: 'hw-healthwise-logo hw-standard-disclaimer-logo-image ' + _StandardDisclaimer2.default.logo_image,
                                                title: logoAltText,
                                                width: '165px',
                                                height: '74px',
                                                viewBox: '0 0 116 43',
                                                fill: 'none',
                                                xmlns: 'http://www.w3.org/2000/svg' },
                                          _react2.default.createElement('path', { d: 'M22.4572 29.511C22.4572 29.5398 22.4284 29.5686 22.4284 29.5974C22.3708 29.6838 22.3132 29.7989 22.2844 29.8853C22.1693 30.1157 22.0541 30.3172 21.9389 30.5187C21.5071 31.1521 20.96 31.5552 20.2978 31.728C19.7796 31.8719 19.2613 31.9295 18.7143 31.8719C18.1097 31.8143 17.5339 31.6416 17.0444 31.3537C16.1807 30.8354 15.6048 30.0293 15.4033 28.9928C15.3457 28.7913 15.3457 28.5897 15.3169 28.3594C15.3169 28.3306 15.3169 28.273 15.3169 28.2442H24.5877L24.6165 27.9563C24.6165 27.8699 24.6453 27.7836 24.6453 27.6972C24.7029 26.4304 24.5013 25.2787 24.0695 24.2422C23.6952 23.3785 23.1769 22.6587 22.5147 22.1405C21.7662 21.5646 20.8736 21.1904 19.866 21.0176C19.0022 20.9024 18.2536 20.9024 17.5339 21.0752C15.864 21.4783 14.5972 22.4572 13.7622 23.9831C13.2152 24.962 12.9273 26.0561 12.9273 27.2365C12.8985 28.5609 13.1288 29.6838 13.647 30.6915C14.1365 31.6992 14.8275 32.5053 15.72 33.0524C16.7565 33.7146 17.8506 34.0313 19.031 34.0313C19.5492 34.0313 20.0387 33.9737 20.5857 33.8585C22.198 33.4842 23.4073 32.5629 24.1846 31.1521C24.2998 30.9218 24.415 30.6915 24.5013 30.4611C24.5589 30.346 24.5877 30.2596 24.6453 30.1444L24.7317 29.9717L22.6299 29.2231L22.4572 29.511ZM15.3745 26.1712C15.5761 24.9332 16.1519 24.0983 17.1596 23.5512C18.1673 23.0042 19.2613 22.9754 20.413 23.4361C21.1328 23.724 21.651 24.3286 21.9677 25.1636C22.0541 25.4227 22.1117 25.6818 22.1693 25.9697C22.1693 26.0273 22.198 26.0849 22.198 26.1712H15.3745Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M37.9181 26.3152C37.9181 24.7317 37.9469 23.1194 37.9181 21.5071V21.3343H35.5572V22.7163C35.2405 22.2844 34.895 21.9677 34.4919 21.7086C33.3115 20.96 31.9871 20.7873 30.4324 21.1616C29.3095 21.4207 28.3306 22.0541 27.5532 22.9754C26.6895 24.0407 26.1712 25.3075 26.0561 26.7471C25.9409 28.1003 26.1137 29.2807 26.5455 30.4036C27.3805 32.4766 28.8776 33.7146 30.9506 34.0313C31.2385 34.0889 31.5264 34.0889 31.7855 34.0889C32.4477 34.0889 33.0524 33.9737 33.6282 33.7146C34.4631 33.3691 35.0965 32.822 35.5572 32.1311L35.6436 33.7146H37.9757V33.513C37.8893 31.1522 37.8893 28.7049 37.9181 26.3152ZM35.586 27.3229L35.5572 27.4957C35.5572 28.5322 35.3269 29.3959 34.9238 30.1733C34.3192 31.2673 33.4554 31.8431 32.275 31.9295C31.2385 32.0159 30.3748 31.6992 29.655 31.037C29.1655 30.5763 28.82 29.9717 28.6185 29.2519C28.3018 28.0427 28.3018 26.891 28.6185 25.8258C28.964 24.7317 29.5398 23.9831 30.4324 23.5225C30.9218 23.2921 31.4401 23.1482 31.9583 23.1482C32.1598 23.1482 32.3614 23.177 32.5629 23.2058C34.0313 23.4361 34.9526 24.3574 35.3557 25.9985C35.442 26.344 35.4708 26.6895 35.5284 27.035C35.5572 27.1214 35.586 27.2365 35.586 27.3229Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M64.6652 24.271C64.3485 22.8315 63.5135 21.8238 62.1603 21.3055C61.3542 20.9888 60.4329 20.9025 59.4827 21.0752C58.3887 21.2767 57.5249 21.7662 56.8627 22.5436C56.8339 22.5723 56.8339 22.5723 56.8052 22.6011V15.2018H54.4443V33.7434H56.8052V31.5552C56.8052 29.8853 56.8052 28.1866 56.8052 26.488C56.8052 26.0273 56.8627 25.5666 56.9779 25.1924C57.237 24.271 57.7841 23.6376 58.6478 23.3209C59.1085 23.1482 59.5979 23.1194 60.2601 23.2058C60.8071 23.2633 61.2966 23.4937 61.6709 23.868C62.1891 24.3862 62.4482 25.0484 62.4482 25.9121C62.477 27.6972 62.4482 29.511 62.4482 31.2385C62.4482 31.9295 62.4482 32.6205 62.4482 33.3115V33.7146H64.8091V33.4842C64.8091 33.4554 64.8091 33.3979 64.8091 33.3691V31.4401C64.8091 29.6262 64.8091 27.726 64.8091 25.8833C64.8667 25.3651 64.7803 24.8181 64.6652 24.271Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M10.5952 24.2422C10.3649 23.177 9.78903 22.342 8.92529 21.7374C8.26309 21.2767 7.51452 21.0464 6.62199 21.0176C5.44155 20.96 4.40506 21.2479 3.51253 21.8814C3.22462 22.0829 2.9655 22.342 2.76396 22.6011V15.2018H0.403076V33.7434H2.76396V31.4401C2.76396 29.799 2.76396 28.1579 2.76396 26.5167C2.76396 25.6818 2.93671 25.0484 3.25341 24.4726C3.65649 23.8104 4.17473 23.4361 4.89451 23.2633C5.32638 23.1482 5.78704 23.1482 6.30529 23.2345C7.22661 23.4073 7.83122 23.8967 8.17672 24.7605C8.37826 25.3075 8.40705 25.8833 8.40705 26.344V33.7721H10.7679V31.4401C10.7679 29.655 10.7679 27.7836 10.7679 25.9697C10.7967 25.3939 10.7103 24.8181 10.5952 24.2422Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M50.8742 31.6704C50.2983 31.584 49.9816 31.2961 49.8377 30.8066C49.7513 30.5187 49.7225 30.202 49.7225 29.8853C49.7225 28.2442 49.7225 26.6031 49.7225 24.962V23.5225C49.7225 23.5225 49.7225 23.5225 49.7225 23.4937H52.5728V21.3343H49.7225V17.5339H47.4768V18.2824C47.4768 18.7431 47.4768 19.175 47.4768 19.6356C47.4768 19.8372 47.448 20.0963 47.4192 20.3266C47.2753 20.8449 47.0161 21.1616 46.5555 21.2767C46.3251 21.3343 46.0948 21.3343 45.8645 21.3631H45.8069C45.6629 21.3631 45.519 21.3631 45.3462 21.3631C45.2887 21.3631 45.2023 21.3631 45.1447 21.3631H44.9144V23.5225H47.3328V25.3075C47.3328 26.9198 47.3328 28.5321 47.3328 30.1444C47.3328 30.6051 47.3616 31.1521 47.5344 31.6992C47.8511 32.7069 48.5133 33.3691 49.4922 33.6858C49.924 33.8297 50.3559 33.8873 50.8454 33.8873C51.2484 33.8873 51.6803 33.8297 52.1122 33.7434C52.5441 33.657 52.6016 33.5706 52.6016 33.1387V31.5552L52.3713 31.6128C51.7955 31.6992 51.306 31.728 50.8742 31.6704Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M43.3597 15.2018H40.9988V33.7434H43.3597V15.2018Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M83.5235 21.1328C83.2644 21.1328 83.178 21.3055 83.1492 21.4207C82.3431 24.0983 81.5369 26.8047 80.7307 29.4822L80.4716 30.346C80.4716 30.3748 80.4428 30.4036 80.4428 30.4324L77.1606 21.1328H74.771L71.5463 30.4324L68.6672 21.1328H66.076L70.2507 33.7146H72.698L75.9514 24.3286C77.0167 27.3805 78.0819 30.4324 79.1472 33.4842C79.2048 33.6282 79.32 33.7146 79.4639 33.7146C80.0973 33.7146 80.7307 33.7146 81.3354 33.7146C81.5657 33.7146 81.6521 33.5706 81.6809 33.4554C82.8325 29.8853 84.0129 26.3152 85.1646 22.7451L85.5677 21.4783L85.6828 21.104H84.9055C84.5024 21.1328 84.0129 21.1328 83.5235 21.1328Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M113.006 29.1943L112.948 29.3671C112.775 29.9141 112.516 30.3748 112.142 30.7779C111.912 31.037 111.595 31.3537 111.163 31.5552C110.328 31.9295 109.407 31.9871 108.428 31.7568C107.622 31.5552 106.931 31.1234 106.412 30.4612C105.981 29.9141 105.75 29.3095 105.664 28.6473C105.635 28.5033 105.635 28.3594 105.635 28.2154V28.1866H114.877L115.021 28.1579L115.05 28.0139C115.05 27.9851 115.05 27.9563 115.05 27.9275C115.05 27.7836 115.05 27.6396 115.05 27.4957C115.05 27.1502 115.05 26.8047 115.05 26.488C114.992 25.3651 114.676 24.3286 114.129 23.4073C113.61 22.5148 112.862 21.8238 111.912 21.3919C111.336 21.104 110.702 20.9312 110.011 20.8737C109.263 20.7873 108.601 20.8161 107.996 20.9312C106.614 21.2192 105.462 21.9389 104.599 23.033C103.821 24.0407 103.361 25.1924 103.217 26.4304C103.101 27.3805 103.159 28.2442 103.332 29.0792C103.62 30.4612 104.253 31.6128 105.203 32.4765C105.894 33.11 106.7 33.5706 107.593 33.8297C108.169 34.0025 108.802 34.0889 109.407 34.0889C109.695 34.0889 109.983 34.0601 110.299 34.0313C111.134 33.9161 111.969 33.6282 112.718 33.1675C113.582 32.6205 114.244 31.9007 114.704 30.9506C114.791 30.7779 114.877 30.6051 114.935 30.4036C114.963 30.3172 114.992 30.2308 115.05 30.1444L115.136 29.9717L113.006 29.1943ZM112.631 26.0561H105.721C105.721 26.0273 105.721 25.9985 105.75 25.9697C105.808 25.7682 105.837 25.5666 105.894 25.3651C106.211 24.415 106.816 23.6952 107.766 23.2633C108.226 23.0618 108.716 22.9466 109.263 22.9466C109.752 22.9466 110.184 23.0042 110.587 23.1482C111.163 23.3209 111.624 23.6664 111.998 24.1847C112.372 24.7317 112.574 25.3363 112.631 26.0561Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M101.259 28.3018C100.798 27.5532 100.107 27.035 99.2147 26.7471C98.6388 26.5455 98.0054 26.4016 97.4296 26.2864C97.2281 26.2288 97.0265 26.2 96.7962 26.1425L96.5947 26.0849C96.2204 25.9985 95.8461 25.9121 95.5294 25.7106C95.1263 25.4803 94.896 25.1636 94.8672 24.7317C94.7808 24.0119 95.0687 23.5225 95.7597 23.1482C96.2492 22.8603 96.8538 22.8027 97.516 22.9178C98.5237 23.1194 99.1571 23.6952 99.445 24.7029C99.445 24.7605 99.4738 24.7893 99.4738 24.8469L99.5314 25.1348L101.662 24.3574L101.633 24.1847C101.432 23.3209 101 22.5148 100.366 21.9677C99.7617 21.4207 99.0131 21.0464 98.1494 20.9025C97.4296 20.7585 96.7386 20.7585 96.1052 20.8737C95.3854 20.9888 94.7232 21.2479 94.1762 21.651C93.1685 22.3708 92.5927 23.3209 92.5063 24.4438C92.4199 25.4227 92.7078 26.2576 93.3125 26.9486C93.8307 27.5244 94.5217 27.9563 95.3279 28.1579C95.9037 28.3018 96.4795 28.4458 97.0265 28.5609L97.3432 28.6473C97.9479 28.7913 98.4373 28.9352 98.8692 29.2807C99.3298 29.6262 99.5314 30.3172 99.301 30.8354C99.0707 31.3825 98.6676 31.728 98.063 31.9007C97.5736 32.0447 97.0841 32.0447 96.5083 31.9583C95.4142 31.7856 94.7232 31.1809 94.4065 30.1445C94.3777 30.0581 94.3489 29.9429 94.3489 29.8565C94.3489 29.799 94.3202 29.7414 94.3202 29.6838L94.2914 29.4823L92.132 30.2308L92.1608 30.4612C92.1608 30.5187 92.1896 30.6051 92.1896 30.6627C92.2184 30.8354 92.276 30.9506 92.3048 31.0946C92.7654 32.3902 93.6867 33.2827 95.1551 33.8009C95.6446 33.9737 96.1628 34.0889 96.6235 34.0889C96.825 34.0889 96.9977 34.0889 97.1993 34.0889C97.4584 34.0889 97.7463 34.0889 98.0054 34.0601C98.6388 34.0025 99.2435 33.8009 99.8769 33.3979C100.597 32.966 101.086 32.4478 101.403 31.7568C101.691 31.1809 101.806 30.5475 101.748 29.8853C101.691 29.2807 101.547 28.7625 101.259 28.3018Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M89.9727 21.1328H87.5831V33.7146H89.9727V21.1328Z',
                                                fill: '#132D77' }),
                                          _react2.default.createElement('path', { d: 'M104.253 10.48C104.455 10.9695 104.224 11.5165 103.735 11.7181L98.0631 14.0501C97.5736 14.2517 97.0266 14.0214 96.825 13.5319C96.6235 13.0425 96.8538 12.4954 97.3433 12.2939L103.015 9.96179C103.476 9.76025 104.052 9.99058 104.253 10.48Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M104.714 16.9005C104.714 17.4187 104.282 17.8506 103.764 17.8506H101.345C100.827 17.8506 100.395 17.4187 100.395 16.9005C100.395 16.3822 100.827 15.9504 101.345 15.9504H103.793C104.311 15.9504 104.714 16.3822 104.714 16.9005Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M98.2933 16.9005C98.2933 17.4187 97.8615 17.8506 97.3432 17.8506H94.896C94.3777 17.8506 93.9459 17.4187 93.9459 16.9005C93.9459 16.3822 94.3777 15.9504 94.896 15.9504H97.3432C97.8903 15.9504 98.2933 16.3822 98.2933 16.9005Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M95.1839 1.41076C95.6734 1.6123 95.9037 2.15934 95.7022 2.64879L93.3701 8.32067C93.1685 8.81012 92.6215 9.04045 92.132 8.83891C91.6426 8.63737 91.4123 8.09034 91.6138 7.60088L93.9459 1.92901C94.1474 1.43955 94.6945 1.20922 95.1839 1.41076Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M100.05 5.6143C100.424 5.98859 100.424 6.59321 100.05 6.96749L98.3222 8.69497C97.9479 9.06925 97.3433 9.06925 96.969 8.69497C96.5947 8.32068 96.5947 7.71606 96.969 7.34178L98.6965 5.6143C99.0708 5.24002 99.6754 5.24002 100.05 5.6143Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M95.5006 10.1633C95.8749 10.5376 95.8749 11.1422 95.5006 11.5165L93.7731 13.244C93.3988 13.6183 92.7942 13.6183 92.4199 13.244C92.0456 12.8697 92.0456 12.2651 92.4199 11.8908L94.1474 10.1633C94.5505 9.78903 95.1263 9.78903 95.5006 10.1633Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M82.343 1.41076C82.8324 1.20922 83.3795 1.43955 83.581 1.92901L85.9131 7.60088C86.1146 8.09034 85.8843 8.63737 85.3949 8.83891C84.9054 9.04045 84.3584 8.81012 84.1568 8.32067L81.8248 2.64879C81.652 2.15934 81.8823 1.6123 82.343 1.41076Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M88.7635 0.950104C89.2817 0.950104 89.7136 1.38197 89.7136 1.90022V4.31868C89.7136 4.83692 89.2817 5.26879 88.7635 5.26879C88.2452 5.26879 87.8134 4.83692 87.8134 4.31868V1.87142C87.8134 1.35318 88.2452 0.950104 88.7635 0.950104Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M88.7635 7.37057C89.2817 7.37057 89.7136 7.80244 89.7136 8.32069V10.7679C89.7136 11.2862 89.2817 11.7181 88.7635 11.7181C88.2452 11.7181 87.8134 11.2862 87.8134 10.7679V8.32069C87.8134 7.77365 88.2452 7.37057 88.7635 7.37057Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M73.3025 10.48C73.5041 9.99058 74.0511 9.76025 74.5405 9.96179L80.2124 12.2939C80.7019 12.4954 80.9322 13.0425 80.7307 13.5319C80.5291 14.0214 79.9821 14.2517 79.4926 14.0501L73.8208 11.7181C73.3313 11.5165 73.101 10.9695 73.3025 10.48Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M77.4772 5.6143C77.8515 5.24002 78.4561 5.24002 78.8304 5.6143L80.5579 7.34178C80.9322 7.71606 80.9322 8.32068 80.5579 8.69497C80.1836 9.06925 79.579 9.06925 79.2047 8.69497L77.4772 6.96749C77.103 6.59321 77.103 5.98859 77.4772 5.6143Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M82.0263 10.1633C82.4006 9.78903 83.0052 9.78903 83.3795 10.1633L85.107 11.8908C85.4813 12.2651 85.4813 12.8697 85.107 13.244C84.7327 13.6183 84.1281 13.6183 83.7538 13.244L82.0263 11.5165C81.652 11.1134 81.652 10.5088 82.0263 10.1633Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M79.2336 16.9005C79.2336 16.3822 79.6654 15.9504 80.1837 15.9504H82.6309C83.1492 15.9504 83.5811 16.3822 83.5811 16.9005C83.5811 17.4187 83.1492 17.8506 82.6309 17.8506H80.1837C79.6654 17.8506 79.2336 17.4187 79.2336 16.9005Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M72.8131 16.9005C72.8131 16.3822 73.245 15.9504 73.7632 15.9504H76.2105C76.7287 15.9504 77.1606 16.3822 77.1606 16.9005C77.1606 17.4187 76.7287 17.8506 76.2105 17.8506H73.7632C73.245 17.8506 72.8131 17.4187 72.8131 16.9005Z',
                                                fill: '#6CDFDF' }),
                                          _react2.default.createElement('path', { d: 'M71.719 41.1427C71.5175 41.1427 71.3159 41.1139 71.1432 41.0276C70.9705 40.9412 70.8553 40.826 70.7401 40.6533L70.7977 40.5381V41.0851H70.2507V37.3423H70.7977V38.9546L70.7113 38.8394C70.7977 38.6955 70.9417 38.5803 71.1144 38.4939C71.2872 38.4075 71.4599 38.3788 71.6902 38.3788C71.9494 38.3788 72.1797 38.4363 72.3812 38.5515C72.5828 38.6667 72.7555 38.8394 72.8707 39.041C72.9858 39.2425 73.0434 39.5016 73.0434 39.7607C73.0434 40.0199 72.9858 40.2502 72.8707 40.4805C72.7555 40.6821 72.5828 40.8548 72.3812 40.97C72.2085 41.0851 71.9781 41.1427 71.719 41.1427ZM71.6614 40.6245C71.8054 40.6245 71.9494 40.5957 72.0933 40.5093C72.2373 40.4229 72.3236 40.3366 72.3812 40.1926C72.4388 40.0487 72.4964 39.9047 72.4964 39.7319C72.4964 39.5592 72.4676 39.4152 72.3812 39.3001C72.2948 39.1849 72.2085 39.0697 72.0933 38.9834C71.9781 38.897 71.8342 38.8682 71.6614 38.8682C71.5175 38.8682 71.3735 38.897 71.2584 38.9834C71.1432 39.0697 71.028 39.1561 70.9705 39.3001C70.9129 39.444 70.8553 39.588 70.8553 39.7319C70.8553 39.9047 70.8841 40.0487 70.9705 40.1926C71.028 40.3366 71.1432 40.4229 71.2584 40.5093C71.3735 40.5957 71.5175 40.6245 71.6614 40.6245Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M73.792 42.1792C73.7344 42.1792 73.648 42.1792 73.5905 42.1504C73.5329 42.1216 73.4753 42.1216 73.4177 42.0928V41.6034C73.4465 41.6034 73.5041 41.6322 73.5617 41.6322C73.6193 41.6322 73.6768 41.6322 73.7344 41.6322C73.8784 41.6322 73.9935 41.6034 74.0799 41.517C74.1663 41.4594 74.2239 41.3443 74.2815 41.2003L74.4542 40.7972V41.2579L73.3026 38.35H73.9072L74.7709 40.5669H74.5694L75.4043 38.35H76.0089L74.8285 41.3155C74.7709 41.4882 74.6845 41.6034 74.5982 41.7473C74.5118 41.8625 74.3966 41.9489 74.2815 42.0353C74.1663 42.1216 73.9647 42.1792 73.792 42.1792Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M77.9667 41.0852L76.959 37.3999H77.5637L78.3698 40.5669H78.2259L79.0608 37.3999H79.6654L80.5004 40.5669H80.3564L81.1626 37.3999H81.7672L80.7595 41.0852H80.0973L79.2336 37.9469H79.4063L78.5426 41.0852H77.9667Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M83.2643 41.1427C83.0052 41.1427 82.7749 41.0851 82.5445 40.97C82.343 40.8548 82.1702 40.6821 82.0551 40.4805C81.9399 40.279 81.8823 40.0199 81.8823 39.7608C81.8823 39.5016 81.9399 39.2425 82.0551 39.041C82.1702 38.8394 82.3142 38.6667 82.5157 38.5515C82.7173 38.4363 82.9476 38.3788 83.1779 38.3788C83.3795 38.3788 83.5522 38.4076 83.725 38.4939C83.8689 38.5515 84.0129 38.6667 84.128 38.7818C84.2432 38.897 84.3296 39.041 84.3872 39.1849C84.4448 39.3289 84.4735 39.5016 84.4735 39.6744C84.4735 39.7032 84.4735 39.7607 84.4735 39.8183C84.4735 39.8759 84.4735 39.9047 84.4447 39.9335H82.343V39.5016H84.1568L83.8977 39.7032C83.9265 39.5304 83.9265 39.3865 83.8689 39.2713C83.8113 39.1561 83.725 39.041 83.6098 38.9834C83.4946 38.9258 83.3795 38.8682 83.2067 38.8682C83.0628 38.8682 82.9188 38.897 82.8036 38.9834C82.6885 39.0698 82.6021 39.1561 82.5445 39.3001C82.4869 39.444 82.4581 39.6168 82.4581 39.7895C82.4294 39.9623 82.4582 40.135 82.5445 40.2502C82.6021 40.3942 82.7173 40.4805 82.8324 40.5669C82.9476 40.6533 83.0916 40.6821 83.2355 40.6821C83.4083 40.6821 83.5234 40.6533 83.6386 40.5669C83.7538 40.4805 83.8401 40.3942 83.8977 40.279L84.3584 40.5093C84.3008 40.6245 84.2144 40.7397 84.128 40.8548C84.0417 40.97 83.8977 41.0276 83.725 41.0851C83.6098 41.1139 83.4371 41.1427 83.2643 41.1427Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M86.4602 41.1427C86.2587 41.1427 86.0571 41.1139 85.8844 41.0276C85.7116 40.9412 85.5965 40.826 85.4813 40.6533L85.5389 40.5381V41.0851H85.0206V37.3423H85.5677V38.9546L85.4813 38.8394C85.5677 38.6955 85.7116 38.5803 85.8844 38.4939C86.0571 38.4076 86.2299 38.3788 86.4602 38.3788C86.7193 38.3788 86.9497 38.4364 87.1512 38.5515C87.3527 38.6667 87.5255 38.8394 87.6406 39.041C87.7558 39.2425 87.8134 39.5016 87.8134 39.7608C87.8134 40.0199 87.7558 40.2502 87.6406 40.4805C87.5255 40.6821 87.3527 40.8548 87.1512 40.97C86.9497 41.0852 86.7193 41.1427 86.4602 41.1427ZM86.4026 40.6245C86.5466 40.6245 86.6905 40.5957 86.8345 40.5093C86.9784 40.423 87.0648 40.3366 87.1224 40.1926C87.18 40.0487 87.2376 39.9047 87.2376 39.732C87.2376 39.5592 87.2088 39.4153 87.1224 39.3001C87.0648 39.1561 86.9496 39.0698 86.8345 38.9834C86.7193 38.897 86.5754 38.8682 86.4026 38.8682C86.2587 38.8682 86.1147 38.897 85.9995 38.9834C85.8844 39.0698 85.7692 39.1561 85.7116 39.3001C85.654 39.444 85.5965 39.588 85.5965 39.732C85.5965 39.9047 85.6253 40.0487 85.7116 40.1926C85.7692 40.3366 85.8844 40.423 85.9995 40.5093C86.1147 40.5957 86.2587 40.6245 86.4026 40.6245Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M88.3892 41.0852V37.3999H88.9362L90.3182 39.3001H90.059L91.4122 37.3999H91.9593V41.0852H91.3834V38.0909L91.6138 38.1484L90.2318 40.0487H90.1742L88.821 38.1484L89.0226 38.0909V41.0852H88.3892Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M92.7079 41.0852V37.3999H93.9171C94.2914 37.3999 94.6369 37.4862 94.9248 37.6302C95.2127 37.7742 95.4143 38.0045 95.587 38.2636C95.731 38.5515 95.8173 38.8682 95.8173 39.2137C95.8173 39.588 95.731 39.9047 95.587 40.1638C95.4431 40.4517 95.2127 40.6533 94.9248 40.826C94.6369 40.97 94.3202 41.0564 93.9171 41.0564H92.7079V41.0852ZM93.2837 40.5669H93.9171C94.1762 40.5669 94.4066 40.5093 94.5793 40.3942C94.7521 40.279 94.9248 40.135 95.0112 39.9335C95.0976 39.732 95.1551 39.5016 95.1551 39.2425C95.1551 38.9834 95.0976 38.7531 95.0112 38.5515C94.9248 38.35 94.7521 38.206 94.5793 38.0909C94.4066 37.9757 94.1762 37.9181 93.9171 37.9181H93.2837V40.5669Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M97.2281 41.0852V37.3999H97.8039V41.0852H97.2281Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M99.7905 42.1792C99.589 42.1792 99.4162 42.1504 99.2435 42.0928C99.0707 42.0353 98.9268 41.9489 98.8116 41.8337C98.6964 41.7186 98.61 41.6034 98.5525 41.4594L99.0707 41.2579C99.1283 41.3731 99.2147 41.4882 99.3298 41.5746C99.445 41.661 99.6177 41.6898 99.7905 41.6898C99.9345 41.6898 100.05 41.661 100.165 41.6034C100.28 41.5458 100.366 41.4594 100.424 41.3731C100.481 41.2579 100.51 41.1427 100.51 40.9988V40.3942L100.625 40.5093C100.539 40.6821 100.395 40.7972 100.251 40.8836C100.078 40.97 99.9057 41.0276 99.7041 41.0276C99.445 41.0276 99.2435 40.97 99.0419 40.8548C98.8404 40.7397 98.6964 40.5957 98.5813 40.3942C98.4661 40.1926 98.4085 39.9623 98.4085 39.732C98.4085 39.4728 98.4661 39.2425 98.5813 39.0698C98.6964 38.8682 98.8404 38.7243 99.0419 38.6091C99.2435 38.4939 99.445 38.4364 99.7041 38.4364C99.9057 38.4364 100.078 38.4939 100.251 38.5803C100.424 38.6667 100.539 38.7819 100.654 38.9546L100.568 39.0986V38.5227H101.115V41.0564C101.115 41.2867 101.057 41.4882 100.942 41.6898C100.827 41.8913 100.683 42.0065 100.481 42.1216C100.28 42.1216 100.05 42.1792 99.7905 42.1792ZM99.7617 40.4805C99.9057 40.4805 100.05 40.4517 100.165 40.3654C100.28 40.3078 100.366 40.1926 100.453 40.0775C100.51 39.9623 100.568 39.8183 100.568 39.6744C100.568 39.5304 100.539 39.3865 100.453 39.2713C100.395 39.1561 100.28 39.041 100.165 38.9834C100.05 38.9258 99.9057 38.8682 99.7617 38.8682C99.6177 38.8682 99.4738 38.897 99.3586 38.9834C99.2435 39.041 99.1571 39.1561 99.0707 39.2713C99.0131 39.3865 98.9555 39.5304 98.9555 39.6744C98.9555 39.8183 98.9843 39.9623 99.0707 40.0775C99.1283 40.1926 99.2435 40.3078 99.3586 40.3654C99.4738 40.4517 99.6177 40.4805 99.7617 40.4805Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M101.748 41.0851V38.4076H102.295V38.9258L102.209 38.8682C102.267 38.6955 102.382 38.5803 102.526 38.4939C102.67 38.4076 102.842 38.35 103.015 38.35C103.217 38.35 103.389 38.3788 103.533 38.4651C103.677 38.5515 103.793 38.6667 103.879 38.8106C103.965 38.9546 103.994 39.1273 103.994 39.3289V41.0564H103.447V39.4728C103.447 39.3289 103.418 39.2425 103.361 39.1273C103.303 39.041 103.245 38.9546 103.159 38.897C103.073 38.8394 102.958 38.8106 102.842 38.8106C102.727 38.8106 102.612 38.8394 102.526 38.897C102.439 38.9546 102.353 39.0122 102.324 39.1273C102.267 39.2137 102.238 39.3289 102.238 39.4728V41.0564H101.748V41.0851Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M104.627 38.0333V37.3999H105.174V38.0333H104.627ZM104.627 41.0852V38.4076H105.174V41.0852H104.627Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M106.988 41.1139C106.7 41.1139 106.499 41.0276 106.326 40.8836C106.182 40.7397 106.096 40.5093 106.096 40.2214V38.9258H105.635V38.4076H105.722C105.837 38.4076 105.952 38.3788 106.009 38.2924C106.067 38.206 106.125 38.1197 106.125 38.0045V37.8029H106.672V38.4076H107.276V38.9258H106.672V40.1926C106.672 40.279 106.7 40.3654 106.729 40.423C106.758 40.4805 106.816 40.5381 106.873 40.5669C106.931 40.5957 107.017 40.6245 107.132 40.6245C107.161 40.6245 107.19 40.6245 107.219 40.6245C107.247 40.6245 107.276 40.6245 107.305 40.6245V41.1139C107.247 41.1139 107.219 41.1139 107.161 41.1427C107.103 41.1715 107.046 41.1139 106.988 41.1139Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M109.032 41.1427C108.773 41.1427 108.543 41.0851 108.313 40.97C108.111 40.8548 107.938 40.6821 107.823 40.4805C107.708 40.279 107.651 40.0199 107.651 39.7608C107.651 39.5016 107.708 39.2425 107.823 39.041C107.938 38.8394 108.082 38.6667 108.284 38.5515C108.485 38.4363 108.716 38.3788 108.946 38.3788C109.148 38.3788 109.32 38.4076 109.493 38.4939C109.637 38.5515 109.781 38.6667 109.896 38.7818C110.011 38.897 110.098 39.041 110.155 39.1849C110.213 39.3289 110.242 39.5016 110.242 39.6744C110.242 39.7032 110.242 39.7607 110.242 39.8183C110.242 39.8759 110.242 39.9047 110.213 39.9335H108.082V39.5016H109.896L109.637 39.7032C109.666 39.5304 109.666 39.3865 109.608 39.2713C109.551 39.1561 109.464 39.041 109.349 38.9834C109.234 38.9258 109.119 38.8682 108.946 38.8682C108.802 38.8682 108.658 38.897 108.543 38.9834C108.428 39.0698 108.342 39.1561 108.284 39.3001C108.226 39.444 108.198 39.6168 108.198 39.7895C108.169 39.9623 108.198 40.135 108.284 40.2502C108.342 40.3942 108.457 40.4805 108.572 40.5669C108.687 40.6533 108.831 40.6821 108.975 40.6821C109.148 40.6821 109.263 40.6533 109.378 40.5669C109.493 40.4805 109.58 40.3942 109.637 40.279L110.098 40.5093C110.04 40.6245 109.954 40.7397 109.867 40.8548C109.781 40.97 109.637 41.0276 109.464 41.0851C109.378 41.1139 109.205 41.1427 109.032 41.1427Z',
                                                fill: '#FF5236' }),
                                          _react2.default.createElement('path', { d: 'M88.7634 15.4609C87.9861 15.4609 87.3527 16.0943 87.3527 16.8717C87.3527 17.649 87.9861 18.2825 88.7634 18.2825C89.5408 18.2825 90.1742 17.649 90.1742 16.8717C90.203 16.0943 89.5408 15.4609 88.7634 15.4609Z',
                                                fill: '#FF5236' })
                                    )
                              )
                        )
                  );
            }
      }]);

      return StandardDisclaimer;
}(_react2.default.Component);

StandardDisclaimer.propTypes = {
      id: _propTypes2.default.string,
      logoAltText: _propTypes2.default.string,
      copyright: _propTypes2.default.string,
      disclaimer: _propTypes2.default.string,
      forPrint: _propTypes2.default.bool,
      learnMoreHtml: _propTypes2.default.string,
      externalHtml: _propTypes2.default.string
};

StandardDisclaimer.defaultProps = {
      logoAltText: 'Click here to learn about Ignite Healthwise, LLC',
      copyright: '© 2024 Ignite Healthwise, LLC.',
      disclaimer: 'This information does not replace the advice of a doctor. Ignite Healthwise, LLC, disclaims any warranty or liability for your use of this information.',
      externalHtml: 'Your use of this information means that you agree to the <a href="https://www.healthwise.org/specialpages/legal/terms.aspx">Terms of Use</a> and <a href="https://www.healthwise.org/specialpages/legal/privacy.aspx" xmlns="">Privacy Policy</a>. To learn more about Ignite Healthwise, LLC, visit <a href="https://webmdignite.com/">webmdignite.com</a>.'
};

exports.default = StandardDisclaimer;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Heading = __webpack_require__(99);

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubSectionHeading = function (_Component) {
  _inherits(SubSectionHeading, _Component);

  function SubSectionHeading() {
    _classCallCheck(this, SubSectionHeading);

    return _possibleConstructorReturn(this, (SubSectionHeading.__proto__ || Object.getPrototypeOf(SubSectionHeading)).apply(this, arguments));
  }

  _createClass(SubSectionHeading, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Heading2.default,
        { headingLevel: 3, styleLevel: 1 },
        this.props.children
      );
    }
  }]);

  return SubSectionHeading;
}(_react.Component);

SubSectionHeading.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = SubSectionHeading;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SummaryPage = __webpack_require__(1034);

var _SummaryPage2 = _interopRequireDefault(_SummaryPage);

var _Content = __webpack_require__(248);

var _Content2 = _interopRequireDefault(_Content);

var _EmailSummary = __webpack_require__(448);

var _EmailSummary2 = _interopRequireDefault(_EmailSummary);

var _Insights = __webpack_require__(70);

var _Insights2 = _interopRequireDefault(_Insights);

var _Modal = __webpack_require__(430);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(120);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var currentLocationLabel = 'summary';

var SummaryPage = function (_Component) {
  _inherits(SummaryPage, _Component);

  function SummaryPage(props) {
    _classCallCheck(this, SummaryPage);

    var _this = _possibleConstructorReturn(this, (SummaryPage.__proto__ || Object.getPrototypeOf(SummaryPage)).call(this, props));

    _this.onQuestionRender = _this.onQuestionRender.bind(_this);
    _this.onEmail = _this.onEmail.bind(_this);
    _this.onPrint = _this.onPrint.bind(_this);
    _this.getEmailModal = _this.getEmailModal.bind(_this);

    _this.decideTopics = _this.props.esdpMap.topics[4];
    _this.summaryTopics = _this.props.esdpMap.topics[5];
    _this.recordedResponses = _this.props.responseState.responses;
    _this.insights = new _Insights2.default();

    _this.state = { showEmailModal: false };
    return _this;
  }

  _createClass(SummaryPage, [{
    key: 'getSvg',
    value: function getSvg(name) {
      switch (name) {
        case 'check':
          return _react2.default.createElement(
            'svg',
            {
              role: 'presentation',
              focusable: 'false',
              xmlns: 'http://www.w3.org/2000/svg',
              viewBox: '0 0 95.5 95.5',
              className: _SummaryPage2.default.svg_check
            },
            _react2.default.createElement(
              'g',
              null,
              _react2.default.createElement('polygon', { points: '43.77 57.24 31.91 45.13 27.76 49.03 44.11 65.94 70.23 33.3 65.77 29.73 43.77 57.24' }),
              _react2.default.createElement('path', { d: 'M48.74,3.78a44.06,44.06,0,1,0,44.32,43.8A44.11,44.11,0,0,0,48.74,3.78Zm.49,84.46A40.4,40.4,0,1,1,89.39,47.6,40.44,40.44,0,0,1,49.23,88.23Z' })
            )
          );
        case 'email':
          return '<svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 23"><g fill="none"><path d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z" fill="#FFF"/><path d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77 2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885 1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311 29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538 21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z" stroke="#FFF"/></g></svg>';
        case 'print':
          return '<svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" version="1.1"><g style="fill-rule:evenodd;fill:none"><path d="M5.42372881 12.7457627C4.67471186 12.7457627 4.06779661 13.352678 4.06779661 14.1016949 4.06779661 14.8507119 4.67471186 15.4576271 5.42372881 15.4576271 6.17274576 15.4576271 6.77966102 14.8507119 6.77966102 14.1016949 6.77966102 13.352678 6.17274576 12.7457627 5.42372881 12.7457627" fill="#fff"/><path d="M5.42372881 12.7457627C4.67471186 12.7457627 4.06779661 13.352678 4.06779661 14.1016949 4.06779661 14.8507119 4.67471186 15.4576271 5.42372881 15.4576271 6.17274576 15.4576271 6.77966102 14.8507119 6.77966102 14.1016949 6.77966102 13.352678 6.17274576 12.7457627 5.42372881 12.7457627L5.42372881 12.7457627Z" stroke="#fff"/><path d="M30.6440678 21.9661017C30.6440678 22.8631864 29.9140339 23.5932203 29.0169492 23.5932203L25.220339 23.5932203 25.220339 20.3389831 26.8474576 20.3389831C27.1473898 20.3389831 27.3898305 20.096 27.3898305 19.7966102 27.3898305 19.4972203 27.1473898 19.2542373 26.8474576 19.2542373L25.220339 19.2542373 6.77966102 19.2542373 5.15254237 19.2542373C4.85261017 19.2542373 4.61016949 19.4972203 4.61016949 19.7966102 4.61016949 20.096 4.85261017 20.3389831 5.15254237 20.3389831L6.77966102 20.3389831 6.77966102 23.5932203 2.98305085 23.5932203C2.0859661 23.5932203 1.3559322 22.8631864 1.3559322 21.9661017L1.3559322 11.6610169C1.3559322 10.7639322 2.0859661 10.0338983 2.98305085 10.0338983L6.77966102 10.0338983 25.220339 10.0338983 29.0169492 10.0338983C29.9140339 10.0338983 30.6440678 10.7639322 30.6440678 11.6610169L30.6440678 21.9661017ZM7.86440678 30.1016949L24.1355932 30.1016949 24.1355932 20.3389831 7.86440678 20.3389831 7.86440678 30.1016949ZM7.86440678 8.94915254L24.1355932 8.94915254 24.1355932 1.3559322 7.86440678 1.3559322 7.86440678 8.94915254ZM29.0169492 8.94915254L25.220339 8.94915254 25.220339 0.271186441 6.77966102 0.271186441 6.77966102 8.94915254 2.98305085 8.94915254C1.48772881 8.94915254 0.271186441 10.1656949 0.271186441 11.6610169L0.271186441 21.9661017C0.271186441 23.4614237 1.48772881 24.6779661 2.98305085 24.6779661L6.77966102 24.6779661 6.77966102 31.1864407 25.220339 31.1864407 25.220339 24.6779661 29.0169492 24.6779661C30.5122712 24.6779661 31.7288136 23.4614237 31.7288136 21.9661017L31.7288136 11.6610169C31.7288136 10.1656949 30.5122712 8.94915254 29.0169492 8.94915254L29.0169492 8.94915254Z" fill="#fff"/><path d="M30.6440678 21.9661017C30.6440678 22.8631864 29.9140339 23.5932203 29.0169492 23.5932203L25.220339 23.5932203 25.220339 20.3389831 26.8474576 20.3389831C27.1473898 20.3389831 27.3898305 20.096 27.3898305 19.7966102 27.3898305 19.4972203 27.1473898 19.2542373 26.8474576 19.2542373L25.220339 19.2542373 6.77966102 19.2542373 5.15254237 19.2542373C4.85261017 19.2542373 4.61016949 19.4972203 4.61016949 19.7966102 4.61016949 20.096 4.85261017 20.3389831 5.15254237 20.3389831L6.77966102 20.3389831 6.77966102 23.5932203 2.98305085 23.5932203C2.0859661 23.5932203 1.3559322 22.8631864 1.3559322 21.9661017L1.3559322 11.6610169C1.3559322 10.7639322 2.0859661 10.0338983 2.98305085 10.0338983L6.77966102 10.0338983 25.220339 10.0338983 29.0169492 10.0338983C29.9140339 10.0338983 30.6440678 10.7639322 30.6440678 11.6610169L30.6440678 21.9661017 30.6440678 21.9661017ZM7.86440678 30.1016949L24.1355932 30.1016949 24.1355932 20.3389831 7.86440678 20.3389831 7.86440678 30.1016949ZM7.86440678 8.94915254L24.1355932 8.94915254 24.1355932 1.3559322 7.86440678 1.3559322 7.86440678 8.94915254ZM29.0169492 8.94915254L25.220339 8.94915254 25.220339 0.271186441 6.77966102 0.271186441 6.77966102 8.94915254 2.98305085 8.94915254C1.48772881 8.94915254 0.271186441 10.1656949 0.271186441 11.6610169L0.271186441 21.9661017C0.271186441 23.4614237 1.48772881 24.6779661 2.98305085 24.6779661L6.77966102 24.6779661 6.77966102 31.1864407 25.220339 31.1864407 25.220339 24.6779661 29.0169492 24.6779661C30.5122712 24.6779661 31.7288136 23.4614237 31.7288136 21.9661017L31.7288136 11.6610169C31.7288136 10.1656949 30.5122712 8.94915254 29.0169492 8.94915254L29.0169492 8.94915254Z" stroke="#fff"/><path d="M11.1186441 27.3898305L20.8813559 27.3898305C21.1812881 27.3898305 21.4237288 27.1468475 21.4237288 26.8474576 21.4237288 26.5480678 21.1812881 26.3050847 20.8813559 26.3050847L11.1186441 26.3050847C10.8187119 26.3050847 10.5762712 26.5480678 10.5762712 26.8474576 10.5762712 27.1468475 10.8187119 27.3898305 11.1186441 27.3898305" fill="#fff"/><path d="M11.1186441 27.3898305L20.8813559 27.3898305C21.1812881 27.3898305 21.4237288 27.1468475 21.4237288 26.8474576 21.4237288 26.5480678 21.1812881 26.3050847 20.8813559 26.3050847L11.1186441 26.3050847C10.8187119 26.3050847 10.5762712 26.5480678 10.5762712 26.8474576 10.5762712 27.1468475 10.8187119 27.3898305 11.1186441 27.3898305L11.1186441 27.3898305Z" stroke="#fff"/><path d="M11.1186441 26.1355932L20.8813559 26.1355932C21.1812881 26.1355932 21.4237288 25.8926102 21.4237288 25.5932203 21.4237288 25.2938305 21.1812881 25.0508475 20.8813559 25.0508475L11.1186441 25.0508475C10.8187119 25.0508475 10.5762712 25.2938305 10.5762712 25.5932203 10.5762712 25.8926102 10.8187119 26.1355932 11.1186441 26.1355932" fill="#fff"/><path d="M11.1186441 24.1355932L20.8813559 24.1355932C21.1812881 24.1355932 21.4237288 23.8926102 21.4237288 23.5932203 21.4237288 23.2938305 21.1812881 23.0508475 20.8813559 23.0508475L11.1186441 23.0508475C10.8187119 23.0508475 10.5762712 23.2938305 10.5762712 23.5932203 10.5762712 23.8926102 10.8187119 24.1355932 11.1186441 24.1355932L11.1186441 24.1355932Z" stroke="#fff"/></g></svg>';
        case 'reset':
          return '<svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><polygon points="23.3629091 -7.27272727e-05 23.3629091 23.3641455 0 23.3641455 0 -7.27272727e-05"/></defs><g><path d="M11.6818182-0.0000727272727C14.8076364-0.0000727272727 17.7734545 1.26610909 19.9392727 3.42392727L23.3632727-0.0000727272727 23.3632727 10.0777455 13.3509091 10.0777455 17.58 5.81592727C16.0330909 4.27410909 13.9138182 3.35410909 11.6818182 3.35410909 7.08109091 3.35410909 3.33781818 7.08938182 3.33781818 11.6901091 3.33781818 16.2908364 7.08109091 20.0297455 11.6818182 20.0297455 14.6512727 20.0297455 17.4207273 18.4290182 18.9101818 15.8544727L21.7996364 17.5250182C19.7152727 21.1272 15.8381818 23.3642909 11.6818182 23.3642909 5.24036364 23.3642909-0.000363636364 18.1228364-0.000363636364 11.6821091 -0.000363636364 5.24138182 5.24036364-0.0000727272727 11.6818182-0.0000727272727" fill="#FFF"/></g></svg>';
        default:
          return null;
      }
    }
  }, {
    key: 'onQuestionRender',
    value: function onQuestionRender(questionId) {
      var props = this.props;
      var recordedResponse = this.props.responseState.responses[questionId];

      if (!recordedResponse) {
        // this is all to create the URL
        var urlParts = props.router.getCurrentLocation().pathname;
        urlParts = urlParts.split('/');
        urlParts.pop();
        var topicBase = urlParts.join('/') + '/';
        var decideTopicId = this.decideTopics.id;
        var hashLink = topicBase + decideTopicId + '#q_' + questionId;

        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            {
              tabIndex: '0',
              onClick: function onClick(e) {
                e.preventDefault();
                props.router.push(hashLink);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.keyCode == 13) {
                  e.preventDefault();
                  props.router.push(hashLink);
                }
              },
              className: _SummaryPage2.default.go_back_link
            },
            'Go back to choose an answer...'
          )
        );
      } else if (recordedResponse.type === 'hwSingleSelectOpinion') {
        // clean up the html in this property
        var answer = recordedResponse.answer.value;
        answer = answer.replace('<div>', '').replace('</div>', '');

        return _react2.default.createElement(
          'p',
          {
            className: 'hw-summary-page-answered-mult-choice ' + _SummaryPage2.default.answered_mult_choice
          },
          this.getSvg('check'),
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: answer } })
        );
      }
    }
  }, {
    key: 'onEmail',
    value: function onEmail(e) {
      e.preventDefault();
      e.stopPropagation();

      this.setState({ showEmailModal: true });

      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'pageAction',
        actionName: 'emailModalOpened',
        actionContext: 'Summary'
      });
    }
  }, {
    key: 'onPrint',
    value: function onPrint(e) {
      e.preventDefault();
      e.stopPropagation();

      var esdp = this.props.esdpMap;
      var summary = esdp.topics[5];

      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'documentPrinted',
        documentHwid: summary.type,
        documentType: 'esdp',
        documentTitle: summary.title.consumer,
        docLanguage: esdp.lang
      });

      window && window.print();
    }
  }, {
    key: 'navigateToTab',
    value: function navigateToTab(zeroBasedNavIndex) {
      var nav = this.props.esdpMap.navigation.topics;

      var urlParts = this.props.router.location.pathname;
      urlParts = urlParts.split('/');
      urlParts.pop();

      var newUrl = urlParts.join('/') + '/' + nav[zeroBasedNavIndex].id;

      this.props.router.push(newUrl);
      window.scrollTo(0, 0);
    }
  }, {
    key: 'getButtons',
    value: function getButtons() {
      switch (this.props.topic.type) {
        case 'decisionSummary':
          var bgEmailStyles = {
            backgroundImage: "url('data:image/svg+xml;base64," + window.btoa(this.getSvg('email')) + "')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '30px center',
            paddingLeft: '64px',
            backgroundSize: '28px 28px'
          };
          var bgPrintStyles = {
            backgroundImage: "url('data:image/svg+xml;base64," + window.btoa(this.getSvg('print')) + "')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '30px center',
            paddingLeft: '64px',
            backgroundSize: '28px 28px'
          };

          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _Button2.default,
              {
                style: bgEmailStyles,
                onClick: this.onEmail,
                'aria-label': 'Email a copy of your summary to help you talk about your decision'
              },
              'Email'
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                style: bgPrintStyles,
                onClick: this.onPrint,
                'aria-label': 'Print a copy of your summary to help you talk about your decision'
              },
              'Print'
            )
          );
        default:
          return null;
      }
    }
  }, {
    key: 'getEmailModal',
    value: function getEmailModal() {
      var _this2 = this;

      var _props = this.props,
          appMeta = _props.appMeta,
          setSummaryEmailStatus = _props.setSummaryEmailStatus;


      return _react2.default.createElement(
        _Modal2.default,
        {
          aria: { describedby: 'emailSummary_heading' },
          disableBackdropClick: true,
          open: this.state.showEmailModal,
          title: 'Email summary',
          showTitle: false,
          showActions: false,
          maxWidth: 'md'
        },
        _react2.default.createElement(_EmailSummary2.default, {
          emailSuccess: appMeta.summaryEmailSuccess,
          setEmailStatus: setSummaryEmailStatus,
          esdpMap: this.props.esdpMap,
          responses: this.props.responseState.responses,
          onCancel: function onCancel() {
            _this2.insights.trackEvent({
              pageName: document.title,
              eventName: 'pageAction',
              actionName: 'emailModalCancelled',
              actionContext: 'Summary'
            });

            _this2.setState({ showEmailModal: false });
          },
          onOkay: function onOkay() {
            _this2.setState({ showEmailModal: false });
          },
          onSend: function onSend(emailFields) {
            _this2.props.emailEsdpSummary(emailFields);
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // get the relevant question groups (decision assessments from the Decide tab)
      var questionGroupsData = this.decideTopics.topics.filter(function (obj) {
        return obj.type === 'hwDecisionAssessment';
      });

      var newQuestionGroupsData = [questionGroupsData[2], questionGroupsData[0], questionGroupsData[1]];
      questionGroupsData = newQuestionGroupsData;

      // if the open answer hasn't been answered or has a blank answer, don't output it
      var openQuestionId = questionGroupsData[2].content[0].interactions[0].id;
      if (!this.recordedResponses[openQuestionId] || !this.recordedResponses[openQuestionId].answer.value.trim().length) {
        questionGroupsData.pop();
      }

      var questionGroups = questionGroupsData.map(function (contentItem, order) {
        return _react2.default.createElement(_Content2.default, {
          key: contentItem.id,
          item: contentItem,
          onQuestionRender: _this3.onQuestionRender,
          location: currentLocationLabel,
          sectionIndex: 1,
          'data-page-order': order + 1,
          readonly: true
        });
      });

      var mediaServiceInfo = this.props.mediaServiceInfo;

      // handling the order for each topic in a more manual way, since they are improperly ordered
      var titleTopicData = this.summaryTopics.topics[0];
      var galleryTopicData = this.summaryTopics.topics[2];

      var ctaTopicData = this.summaryTopics.topics[1];
      var titleTopic = _react2.default.createElement(_Content2.default, {
        key: titleTopicData.id,
        item: titleTopicData,
        location: currentLocationLabel,
        sectionIndex: 0
      });
      var ctaTopic = _react2.default.createElement(_Content2.default, {
        key: ctaTopicData.id,
        item: ctaTopicData,
        actionButtons: this.getButtons(),
        location: currentLocationLabel,
        sectionIndex: 2
      });
      var galleryTopic = _react2.default.createElement(_Content2.default, {
        key: galleryTopicData.id,
        item: galleryTopicData,
        isSummary: true,
        location: currentLocationLabel,
        sectionIndex: 3,
        mediaServiceUrl: mediaServiceInfo.mediaServiceUrl,
        mediaHash: mediaServiceInfo.mediaHash,
        mediaToken: mediaServiceInfo.mediaToken
      });

      return _react2.default.createElement(
        'section',
        { className: _SummaryPage2.default.content_section },
        titleTopic,
        questionGroups,
        ctaTopic,
        galleryTopic,
        this.getEmailModal()
      );
    }
  }]);

  return SummaryPage;
}(_react.Component);

SummaryPage.propTypes = {
  router: _propTypes2.default.object,
  appMeta: _propTypes2.default.object,
  mediaServiceInfo: _propTypes2.default.object,
  esdpMap: _propTypes2.default.object.isRequired,
  responseState: _propTypes2.default.object.isRequired,
  topic: _propTypes2.default.shape({
    title: _propTypes2.default.shape({
      consumer: _propTypes2.default.string.isRequired
    }).isRequired,
    type: _propTypes2.default.string
  }).isRequired,
  emailEsdpSummary: _propTypes2.default.func,
  setSummaryEmailStatus: _propTypes2.default.func
};

exports.default = SummaryPage;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContentArticle = __webpack_require__(447);

var _ContentArticle2 = _interopRequireDefault(_ContentArticle);

var _Content = __webpack_require__(248);

var _Content2 = _interopRequireDefault(_Content);

var _SummaryPage = __webpack_require__(464);

var _SummaryPage2 = _interopRequireDefault(_SummaryPage);

var _Insights = __webpack_require__(70);

var _Insights2 = _interopRequireDefault(_Insights);

var _Button = __webpack_require__(120);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Topic = function (_Component) {
  _inherits(Topic, _Component);

  function Topic(props) {
    _classCallCheck(this, Topic);

    var _this = _possibleConstructorReturn(this, (Topic.__proto__ || Object.getPrototypeOf(Topic)).call(this, props));

    _this.navigateToTab = _this.navigateToTab.bind(_this);

    _this.insights = new _Insights2.default();
    return _this;
  }

  _createClass(Topic, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToHashId();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToHashId();
    }

    // emulate URL anchor scroll functionality in our architecture

  }, {
    key: 'scrollToHashId',
    value: function scrollToHashId() {
      var removeHash = this.removeHash;
      // get URL hash (minus the hash mark)
      var hash = window.location.hash.substring(1);

      // if there's a hash, scroll to that ID
      if (hash && hash.length) {
        // setTimeout and requestAnimationFrame help ensure a true DOM repaint/reflow before we try to scroll
        // - reference: http://stackoverflow.com/a/34999925
        setTimeout(window.requestAnimationFrame(function () {
          var el = document.getElementById(hash);
          if (!el) {
            el = document.getElementById(hash.replace('q_', ''));
          }
          if (el) {
            el.scrollIntoView();
            // this adjust the scroll amount to account for our fixed header
            window.scrollBy(0, -45);
          }
          // clean up the hash, so we don't scroll on every prop update
          removeHash(el);
        }), 0);
      }
    }

    // tweaked from http://stackoverflow.com/questions/1397329/how-to-remove-the-hash-from-window-location-with-javascript-without-page-refresh/5298684#5298684

  }, {
    key: 'removeHash',
    value: function removeHash(el) {
      var loc = window.location;
      var hist = window.history;

      // use modern browser history API
      if (hist && 'pushState' in hist) {
        hist.replaceState('', document.title, loc.pathname + loc.search);
        if (el) {
          setTimeout(window.requestAnimationFrame(function () {
            if (el.nextSibling && typeof el.nextSibling !== 'undefined') {
              var sibling = el.nextSibling;
              var inputList = sibling.querySelectorAll('input');
              if (inputList && inputList.length > 0) {
                inputList[0].focus();
              }
            }
          }));
        }

        // fallback for older browsers
      } else {
        // prevent scrolling by storing the page's current scroll offset
        var scrollV = document.body.scrollTop;
        var scrollH = document.body.scrollLeft;

        loc.hash = '';

        // restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
      }
    }
  }, {
    key: 'navigateToTab',
    value: function navigateToTab(zeroBasedNavIndex) {
      var nav = this.props.esdpMap.navigation.topics;

      var urlParts = this.props.router.location.pathname;
      urlParts = urlParts.split('/');
      urlParts.pop();

      var newUrl = urlParts.join('/') + '/' + nav[zeroBasedNavIndex].id;

      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'pageAction',
        actionName: zeroBasedNavIndex === 5 ? 'createSummary' : 'inlineNavigation',
        actionContext: nav[zeroBasedNavIndex - 1].title
      });

      this.props.router.push(newUrl);
      window.scrollTo(0, 0);
    }
  }, {
    key: 'onFinishClick',
    value: function onFinishClick() {
      // Expecting leaning questions to always be the fourth item...
      var leaningQuestions = this.props.topic.topics[3];
      if (leaningQuestions) {
        var firstQuestionId = leaningQuestions.content[0].interactions[0].id;
        var recordedResponse = this.props.responseState.responses[firstQuestionId];
        if (recordedResponse) {
          this.props.updateStatus('Completed');
        } else {
          this.props.updateStatus('Partial');
        }
      }

      // enable Summary tab
      this.props.enableSummary();

      // navigate to Summary tab
      this.navigateToTab(5);
    }
  }, {
    key: 'getButton',
    value: function getButton() {
      var _this2 = this;

      var navigateToTab = this.navigateToTab;

      switch (this.props.topic.type) {
        case 'esdpHome':
          return _react2.default.createElement(
            _Button2.default,
            { role: 'link', onClick: function onClick() {
                return navigateToTab(1);
              } },
            'Next'
          );
        case 'esdpFacts':
          return _react2.default.createElement(
            _Button2.default,
            { role: 'link', onClick: function onClick() {
                return navigateToTab(2);
              } },
            'Next'
          );
        case 'esdpCompare':
          return _react2.default.createElement(
            _Button2.default,
            { role: 'link', onClick: function onClick() {
                return navigateToTab(3);
              } },
            'Next'
          );
        case 'esdpLearn':
          return _react2.default.createElement(
            _Button2.default,
            { role: 'link', onClick: function onClick() {
                return navigateToTab(4);
              } },
            'Next'
          );
        case 'esdpDecide':
          return _react2.default.createElement(
            _Button2.default,
            { role: 'link', onClick: function onClick() {
                return _this2.onFinishClick();
              } },
            'Finish'
          );
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          responseState = _props.responseState,
          topic = _props.topic,
          navigationInfo = _props.navigationInfo,
          resourcesRoot = _props.resourcesRoot,
          mediaServiceInfo = _props.mediaServiceInfo;

      var actionButton = this.getButton();

      // summary topic gets different treatment
      var content = topic.type === 'decisionSummary' ? _react2.default.createElement(_SummaryPage2.default, this.props) : topic.topics.map(function (contentItem, index) {
        return _react2.default.createElement(_Content2.default, {
          key: contentItem.id,
          sectionIndex: index,
          item: contentItem,
          responseState: responseState,
          actionButtons: actionButton,
          navigationInfo: navigationInfo,
          resourcesRoot: resourcesRoot,
          mediaServiceUrl: mediaServiceInfo.mediaServiceUrl,
          mediaHash: mediaServiceInfo.mediaHash,
          mediaToken: mediaServiceInfo.mediaToken
        });
      });

      return _react2.default.createElement(
        _ContentArticle2.default,
        null,
        content
      );
    }
  }]);

  return Topic;
}(_react.Component);

Topic.propTypes = {
  router: _propTypes2.default.object,
  esdpMap: _propTypes2.default.object,
  mediaServiceInfo: _propTypes2.default.object,
  responseState: _propTypes2.default.object,
  navigationInfo: _propTypes2.default.array,
  updateStatus: _propTypes2.default.func.isRequired,
  enableSummary: _propTypes2.default.func,
  resourcesRoot: _propTypes2.default.string,
  topic: _propTypes2.default.shape({
    topics: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired,
      content: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        interactions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          id: _propTypes2.default.string.isRequired
        }))
      }))
    })).isRequired,
    title: _propTypes2.default.shape({
      consumer: _propTypes2.default.string
    }).isRequired,
    type: _propTypes2.default.string
  }).isRequired
};

exports.default = Topic;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _UnorderedList = __webpack_require__(1035);

var _UnorderedList2 = _interopRequireDefault(_UnorderedList);

var _ListItem = __webpack_require__(249);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnorderedList = function (_Component) {
  _inherits(UnorderedList, _Component);

  function UnorderedList() {
    _classCallCheck(this, UnorderedList);

    return _possibleConstructorReturn(this, (UnorderedList.__proto__ || Object.getPrototypeOf(UnorderedList)).apply(this, arguments));
  }

  _createClass(UnorderedList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          otherAttributes = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        'ul',
        _extends({ className: 'hw-unordered-list ' + _UnorderedList2.default.unordered_list }, otherAttributes),
        children
      );
    }
  }]);

  return UnorderedList;
}(_react.Component);

UnorderedList.propTypes = {
  children: function children(props, propName, componentName) {
    var prop = props[propName];

    var error = null;
    _react2.default.Children.forEach(prop, function (child) {
      if (child.type !== _ListItem2.default) {
        if (typeof child !== 'string' || !child.match(/^[\n\r\s]+$/)) {
          // Ignore whitespace beetween elements
          error = new Error('\'' + componentName + '\' children should be of type \'ListItem\', not ' + (typeof child === 'undefined' ? 'undefined' : _typeof(child)) + ': ' + JSON.stringify(child));
        }
      }
    });

    return error;
  }
};

exports.default = UnorderedList;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(85);

var _actions = __webpack_require__(86);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    setInterval(function () {
      _this.props.updateJWT();
    }, 540000);
    return _this;
  }

  _createClass(App, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'div',
        { className: 'hwEsdpApp' },
        children
      );
    }
  }]);

  return App;
}(_react.Component);

App.propTypes = {
  children: _propTypes2.default.node,
  updateJWT: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  return {
    serviceInfo: state.serviceInfo
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, _extends({}, actions))(App);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(85);

var _reactRouter = __webpack_require__(159);

var _actions = __webpack_require__(86);

var Actions = _interopRequireWildcard(_actions);

var _EsdpMap = __webpack_require__(449);

var _EsdpMap2 = _interopRequireDefault(_EsdpMap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoutedEsdpMap = (0, _reactRouter.withRouter)(_EsdpMap2.default);

var EsdpMapContainer = function (_Component) {
  _inherits(EsdpMapContainer, _Component);

  function EsdpMapContainer() {
    _classCallCheck(this, EsdpMapContainer);

    return _possibleConstructorReturn(this, (EsdpMapContainer.__proto__ || Object.getPrototypeOf(EsdpMapContainer)).apply(this, arguments));
  }

  _createClass(EsdpMapContainer, [{
    key: 'render',
    value: function render() {
      // TODO: Strip router params from coming in to component
      // var { routeParams, ...otherProps } = this.props
      return _react2.default.createElement(RoutedEsdpMap, this.props);
    }
  }]);

  return EsdpMapContainer;
}(_react.Component);

function mapStateToProps(state, ownProps) {
  return {
    appMeta: state.appMeta,
    esdpMap: state.esdpMap,
    navigationInfo: state.navigationInfo,
    localization: ownProps.routeParams.localization,
    mapId: ownProps.routeParams.mapId
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, _extends({}, Actions))(EsdpMapContainer);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(85);

var _actions = __webpack_require__(86);

var Actions = _interopRequireWildcard(_actions);

var _Topic = __webpack_require__(465);

var _Topic2 = _interopRequireDefault(_Topic);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TopicContainer = function (_Component) {
  _inherits(TopicContainer, _Component);

  function TopicContainer() {
    _classCallCheck(this, TopicContainer);

    return _possibleConstructorReturn(this, (TopicContainer.__proto__ || Object.getPrototypeOf(TopicContainer)).apply(this, arguments));
  }

  _createClass(TopicContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Topic2.default, this.props);
    }
  }]);

  return TopicContainer;
}(_react.Component);

function mapStateToProps(state, ownProps) {
  return {
    appMeta: state.appMeta,
    esdpMap: state.esdpMap,
    topic: state.esdpMap.topics.find(function (topic) {
      return topic.id === ownProps.routeParams.topicId;
    }),
    responseState: state.responseState,
    resourcesRoot: state.prescriptionInfo.resourcesRoot,
    mediaServiceInfo: { mediaServiceUrl: state.prescriptionInfo.mediaServiceUrl, mediaHash: state.prescriptionInfo.mediaHash, mediaToken: state.prescriptionInfo.mediaToken },
    navigationInfo: state.navigationInfo
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, _extends({}, Actions))(TopicContainer);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRouterRedux = __webpack_require__(119);

var _redux = __webpack_require__(222);

var _actions = __webpack_require__(86);

var ActionTypes = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function esdpMap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  if (action.type === ActionTypes.MAP_LOADED) {
    state = action.mapData.data;
  }

  return state;
}

function appMeta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { summaryTabEnabled: false, summaryEmailSuccess: null };
  var action = arguments[1];

  switch (action.type) {
    case ActionTypes.SUMMARY_TAB_ENABLED:
      return _extends({}, state, {
        summaryTabEnabled: action.enabled
      });
    case ActionTypes.SUMMARY_EMAIL_STATUS:
      return _extends({}, state, {
        summaryEmailSuccess: action.status
      });
    default:
      return state;
  }
}

function serviceInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { consumerServiceUrl: 'http://consumerservice.local', contentServiceUrl: 'http://contentservice.local', isMocked: true };
  var action = arguments[1];

  switch (action.type) {
    case ActionTypes.JWT_REFRESH:
      return _extends({}, state, {
        token: action.token
      });
    default:
      return state;
  }
}

function prescriptionInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  return state;
}

function navigationInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case ActionTypes.MAP_LOADED:
      return action.mapData.navigationInfo.map(function (info) {
        info.visited = false;
        return info;
      });

    case ActionTypes.SET_VISITED_NAV:
      {
        return state.map(function (info) {
          if (info.id === action.id) {
            info.visited = true;
          }
          return info;
        });
      }

    default:
      return state;
  }
}

function responseState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'sequenceNumber': 0, 'responses': {} };
  var action = arguments[1];

  // in this case, the state is currently the same for all 3 types
  var newState = _extends({}, state, {
    responses: action && action.responses
  });

  switch (action.type) {
    case ActionTypes.LIKERT_RESPONSE:
      return newState;
    case ActionTypes.OPINION_RESPONSE:
      return newState;
    case ActionTypes.QUIZ_RESPONSE:
      return newState;
    default:
      return state;
  }
}

var rootReducer = (0, _redux.combineReducers)({
  esdpMap: esdpMap,
  appMeta: appMeta,
  routing: _reactRouterRedux.routerReducer,
  serviceInfo: serviceInfo,
  responseState: responseState,
  prescriptionInfo: prescriptionInfo,
  navigationInfo: navigationInfo
});

exports.default = rootReducer;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(472);
} else {
  module.exports = require('./configureStore.dev');
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(222);

var _reduxThunk = __webpack_require__(234);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRouterRedux = __webpack_require__(119);

var _reducers = __webpack_require__(470);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(history, preloadedState) {
  return (0, _redux.createStore)(_reducers2.default, preloadedState, (0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)));
}

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _withStyles = _interopRequireDefault(__webpack_require__(87));

var _Fade = _interopRequireDefault(__webpack_require__(253));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2["default"])(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react["default"].createElement(_Fade["default"], (0, _extends2["default"])({
    "in": open,
    timeout: transitionDuration
  }, other), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, (0, _defineProperty2["default"])({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

 false ? Backdrop.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes["default"].bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
    enter: _propTypes["default"].number,
    exit: _propTypes["default"].number
  })])
} : void 0;
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles["default"])(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports["default"] = _default;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop["default"];
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(477));

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(45);

var _withStyles = _interopRequireDefault(__webpack_require__(87));

var _helpers = __webpack_require__(260);

var _Modal = _interopRequireDefault(__webpack_require__(485));

var _Fade = _interopRequireDefault(__webpack_require__(253));

var _transitions = __webpack_require__(171);

var _Paper = _interopRequireDefault(__webpack_require__(488));

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// @inheritedComponent Modal
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      display: 'flex',
      flexDirection: 'column',
      margin: 48,
      position: 'relative',
      overflowY: 'auto' // Fix IE 11 issue, to remove at some point.

    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      flex: '0 1 auto',
      maxHeight: 'calc(100% - 96px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      margin: '48px auto'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360),
      '&$paperScrollBody': (0, _defineProperty2["default"])({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 360) + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': (0, _defineProperty2["default"])({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': (0, _defineProperty2["default"])({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': (0, _defineProperty2["default"])({}, theme.breakpoints.down(theme.breakpoints.values.lg + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': (0, _defineProperty2["default"])({}, theme.breakpoints.down(theme.breakpoints.values.xl + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: '100%'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0
      }
    }
  };
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

exports.styles = styles;

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Dialog, _React$Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleMouseDown = function (event) {
      _this.mouseDownTarget = event.target;
    };

    _this.handleBackdropClick = function (event) {
      // Ignore the events not coming from the "backdrop"
      // We don't want to close the dialog when clicking the dialog content.
      if (event.target !== event.currentTarget) {
        return;
      } // Make sure the event starts and ends on the same DOM element.


      if (event.target !== _this.mouseDownTarget) {
        return;
      }

      _this.mouseDownTarget = null;

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(Dialog, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          fullScreen = _this$props.fullScreen,
          fullWidth = _this$props.fullWidth,
          maxWidth = _this$props.maxWidth,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          open = _this$props.open,
          PaperComponent = _this$props.PaperComponent,
          _this$props$PaperProp = _this$props.PaperProps,
          PaperProps = _this$props$PaperProp === void 0 ? {} : _this$props$PaperProp,
          scroll = _this$props.scroll,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2["default"])(_this$props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      return _react["default"].createElement(_Modal["default"], (0, _extends2["default"])({
        className: (0, _classnames["default"])(classes.root, className),
        BackdropProps: (0, _extends2["default"])({
          transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true,
        disableBackdropClick: disableBackdropClick,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        role: "dialog"
      }, other), _react["default"].createElement(TransitionComponent, (0, _extends2["default"])({
        appear: true,
        "in": open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
      }, TransitionProps), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.container, classes["scroll".concat((0, _helpers.capitalize)(scroll))]),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleMouseDown,
        role: "document"
      }, _react["default"].createElement(PaperComponent, (0, _extends2["default"])({
        elevation: 24
      }, PaperProps, {
        className: (0, _classnames["default"])(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], (_classNames = {}, (0, _defineProperty2["default"])(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2["default"])(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2["default"])(_classNames, classes.paperFullWidth, fullWidth), _classNames), PaperProps.className)
      }), children))));
    }
  }]);
  return Dialog;
}(_react["default"].Component);

 false ? Dialog.propTypes = {
  /**
   * @ignore
   */
  BackdropProps: _propTypes["default"].object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes["default"].bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes["default"].bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes["default"].bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes["default"].bool,

  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes["default"].func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes["default"].func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes["default"].func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes["default"].func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes["default"].func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes["default"].func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes["default"].func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes["default"].func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes["default"].func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: _utils.componentPropType,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes["default"].object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes["default"].oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   */
  TransitionComponent: _utils.componentPropType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
    enter: _propTypes["default"].number,
    exit: _propTypes["default"].number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes["default"].object
} : void 0;
Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  PaperComponent: _Paper["default"],
  scroll: 'paper',
  TransitionComponent: _Fade["default"],
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles["default"])(styles, {
  name: 'MuiDialog'
})(Dialog);

exports["default"] = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog["default"];
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(479));

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _withStyles = _interopRequireDefault(__webpack_require__(87));

var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    padding: '0 24px 24px',
    '&:first-child': {
      paddingTop: 24
    }
  }
};
exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2["default"])(props, ["classes", "children", "className"]);
  return _react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.root, className)
  }, other), children);
}

 false ? DialogContent.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string
} : void 0;

var _default = (0, _withStyles["default"])(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports["default"] = _default;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent["default"];
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__(481));

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(925));

var _transitions = __webpack_require__(171);

var _withTheme = _interopRequireDefault(__webpack_require__(259));

var _utils = __webpack_require__(514);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2["default"])({}, styleProp, _react["default"].isValidElement(children) ? children.props.style : {});
      return _react["default"].createElement(_Transition["default"], (0, _extends2["default"])({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react["default"].cloneElement(children, (0, _extends2["default"])({
          style: (0, _extends2["default"])({
            opacity: 0
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react["default"].Component);

 false ? Fade.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),

  /**
   * If `true`, the component will transition in.
   */
  "in": _propTypes["default"].bool,

  /**
   * @ignore
   */
  onEnter: _propTypes["default"].func,

  /**
   * @ignore
   */
  onExit: _propTypes["default"].func,

  /**
   * @ignore
   */
  style: _propTypes["default"].object,

  /**
   * @ignore
   */
  theme: _propTypes["default"].object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
    enter: _propTypes["default"].number,
    exit: _propTypes["default"].number
  })])
} : void 0;
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme["default"])()(Fade);

exports["default"] = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(235));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(22));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _utils = __webpack_require__(45);

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _RootRef = _interopRequireDefault(__webpack_require__(492));

var _Portal = _interopRequireDefault(__webpack_require__(490));

var _helpers = __webpack_require__(260);

var _withStyles = _interopRequireDefault(__webpack_require__(87));

var _ModalManager = _interopRequireDefault(__webpack_require__(254));

var _Backdrop = _interopRequireDefault(__webpack_require__(478));

var _manageAriaHidden = __webpack_require__(255);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom["default"].findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */

exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Modal);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Modal).call(this));
    _this.mounted = false;

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument["default"])(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)), container);

      doc.addEventListener('focus', _this.enforceFocus, true);

      if (_this.dialogRef) {
        _this.handleOpened();
      }
    };

    _this.handleRendered = function () {
      if (_this.props.onRendered) {
        _this.props.onRendered();
      }

      if (_this.props.open) {
        _this.handleOpened();
      } else {
        (0, _manageAriaHidden.ariaHidden)(_this.modalRef, true);
      }
    };

    _this.handleOpened = function () {
      _this.autoFocus();

      _this.props.manager.mount((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this))); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;
    };

    _this.handleClose = function (reason) {
      var hasTransition = getHasTransition(_this.props);
      /* If the component does not have a transition or is unmounting remove the Modal
      otherwise let the transition handle removing the style, this prevents elements
      moving around when the Modal is closed. */

      if (!(hasTransition && _this.props.closeAfterTransition) || reason === 'unmount') {
        _this.props.manager.remove((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
      }

      var doc = (0, _ownerDocument["default"])(_this.mountNode);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      if (_this.props.closeAfterTransition) {
        _this.props.manager.remove((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
      }

      _this.setState({
        exited: true
      });
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleKeyDown = function (event) {
      // event.defaultPrevented:
      //
      // Ignore events that have been `event.preventDefault()` marked.
      // preventDefault() is meant to stop default behaviours like
      // clicking a checkbox to check it, hitting a button to submit a form,
      // and hitting left arrow to move the cursor in a text input etc.
      // Only special HTML elements have these default bahaviours.
      //
      // To remove in v4.
      if (event.key !== 'Escape' || !_this.isTopModal() || event.defaultPrevented) {
        return;
      } // Swallow the event, in case someone is listening for the escape key on the body.


      event.stopPropagation();

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.enforceFocus = function () {
      // The Modal might not already be mounted.
      if (!_this.isTopModal() || _this.props.disableEnforceFocus || !_this.mounted || !_this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument["default"])(_this.mountNode).activeElement;

      if (!_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.handlePortalRef = function (ref) {
      _this.mountNode = ref ? ref.getMountNode() : ref;
    };

    _this.handleModalRef = function (ref) {
      _this.modalRef = ref;
    };

    _this.onRootRef = function (ref) {
      _this.dialogRef = ref;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.lastFocus = (0, _ownerDocument["default"])(this.mountNode).activeElement;
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose('unmount');
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      // We might render an empty child.
      if (this.props.disableAutoFocus || !this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument["default"])(this.mountNode).activeElement;

      if (!this.dialogRef.contains(currentActiveElement)) {
        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning["default"])(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.lastFocus = currentActiveElement;
        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus || !this.lastFocus) {
        return;
      } // Not all elements in IE 11 have a focus method.
      // Because IE 11 market share is low, we accept the restore focus being broken
      // and we silent the issue.


      if (this.lastFocus.focus) {
        this.lastFocus.focus();
      }

      this.lastFocus = null;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          closeAfterTransition = _this$props.closeAfterTransition,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2["default"])(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      var childProps = {}; // It's a Transition like component

      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react["default"].createElement(_Portal["default"], {
        ref: this.handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react["default"].createElement("div", (0, _extends2["default"])({
        ref: this.handleModalRef,
        onKeyDown: this.handleKeyDown,
        role: "presentation",
        className: (0, _classnames["default"])(classes.root, className, (0, _defineProperty2["default"])({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react["default"].createElement(BackdropComponent, (0, _extends2["default"])({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react["default"].createElement(_RootRef["default"], {
        rootRef: this.onRootRef
      }, _react["default"].cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react["default"].Component);

 false ? Modal.propTypes = {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _utils.componentPropType,

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: _propTypes["default"].object,

  /**
   * A single child content element.
   */
  children: _propTypes["default"].element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: _propTypes["default"].bool,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes["default"].bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes["default"].bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes["default"].bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes["default"].bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes["default"].bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes["default"].bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes["default"].bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes["default"].bool,

  /**
   * @ignore
   *
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes["default"].object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes["default"].func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes["default"].func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes["default"].func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes["default"].func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes["default"].bool.isRequired
} : void 0;
Modal.defaultProps = {
  BackdropComponent: _Backdrop["default"],
  closeAfterTransition: false,
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager["default"]()
};

var _default = (0, _withStyles["default"])(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports["default"] = _default;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal["default"];
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager["default"];
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(484));

var _ModalManager = _interopRequireDefault(__webpack_require__(254));

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports["default"] = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(729));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _ownerWindow = _interopRequireDefault(__webpack_require__(515));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a vertical scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument["default"])(container);
  var win = (0, _ownerWindow["default"])(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow["default"])(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _utils = __webpack_require__(45);

var _withStyles = _interopRequireDefault(__webpack_require__(87));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2["default"])({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2["default"])(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning["default"])(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames["default"])(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2["default"])({}, classes.rounded, !square), classNameProp);
  return _react["default"].createElement(Component, (0, _extends2["default"])({
    className: className
  }, other));
}

 false ? Paper.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes["default"].number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes["default"].bool
} : void 0;
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles["default"])(styles, {
  name: 'MuiPaper'
})(Paper);

exports["default"] = _default;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper["default"];
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(487));

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(22));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _utils = __webpack_require__(45);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom["default"].findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument["default"])(_reactDom["default"].findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2["default"])(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(function () {
            if (_this2.props.onRendered) {
              // This might be triggered earlier than the componentDidUpdate of a parent element.
              // We need to account for it.
              clearTimeout(_this2.renderedTimer);
              _this2.renderedTimer = setTimeout(_this2.props.onRendered);
            }
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
      clearTimeout(this.renderedTimer);
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom["default"].findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom["default"].createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react["default"].Component);

 false ? Portal.propTypes = {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes["default"].bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes["default"].func
} : void 0;
Portal.defaultProps = {
  disablePortal: false
};

if (false) {
  process.env.NODE_ENV !== "production" ? Portal.propTypes = (0, _utils.exactProp)(Portal.propTypes) : void 0;
}

var _default = Portal;
exports["default"] = _default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal["default"];
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(489));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(22));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(45);

var _reactHelpers = __webpack_require__(516);

/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2["default"])(this, RootRef);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RootRef).apply(this, arguments));
  }

  (0, _createClass2["default"])(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = _reactDom["default"].findDOMNode(this);
      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = _reactDom["default"].findDOMNode(this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
        }

        this.ref = ref;
        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      (0, _reactHelpers.setRef)(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react["default"].Component);

 false ? RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
}

var _default = RootRef;
exports["default"] = _default;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef["default"];
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(491));

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports["default"] = _default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports["default"] = _default;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports["default"] = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports["default"] = _default;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports["default"] = _default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(371);

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MuiThemeProviderOld = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(51));

var _createClass2 = _interopRequireDefault(__webpack_require__(52));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(58));

var _inherits2 = _interopRequireDefault(__webpack_require__(59));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _brcast = _interopRequireDefault(__webpack_require__(523));

var _utils = __webpack_require__(45);

var _themeListener = _interopRequireWildcard(__webpack_require__(170));

/* eslint-disable no-underscore-dangle */

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProviderOld =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(MuiThemeProviderOld, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProviderOld(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MuiThemeProviderOld);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MuiThemeProviderOld).call(this)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast["default"])();
    _this.outerTheme = _themeListener["default"].initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));

    return _this;
  }

  (0, _createClass2["default"])(MuiThemeProviderOld, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _this$props = this.props,
          disableStylesGeneration = _this$props.disableStylesGeneration,
          sheetsCache = _this$props.sheetsCache,
          sheetsManager = _this$props.sheetsManager;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      if (sheetsCache !== undefined) {
        muiThemeProviderOptions.sheetsCache = sheetsCache;
      }

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      return _ref = {}, (0, _defineProperty2["default"])(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2["default"])(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener["default"].subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener["default"].unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning["default"])(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends2["default"])({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProviderOld;
}(_react["default"].Component);

exports.MuiThemeProviderOld = MuiThemeProviderOld;
 false ? MuiThemeProviderOld.propTypes = {
  /**
   * You can wrap a node.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes["default"].bool,

  /**
   * @ignore
   *
   * In beta.
   */
  sheetsCache: _propTypes["default"].object,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes["default"].object,

  /**
   * A theme object.
   */
  theme: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? MuiThemeProviderOld.propTypes = (0, _utils.exactProp)(MuiThemeProviderOld.propTypes) : void 0;
}

MuiThemeProviderOld.childContextTypes = (0, _extends2["default"])({}, _themeListener["default"].contextTypes, {
  muiThemeProviderOptions: _propTypes["default"].object
});
MuiThemeProviderOld.contextTypes = (0, _extends2["default"])({}, _themeListener["default"].contextTypes, {
  muiThemeProviderOptions: _propTypes["default"].object
});
/* istanbul ignore if */

if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider) {
  _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider = MuiThemeProviderOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider;
exports["default"] = _default;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(33));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning["default"])(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */

function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */

function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
   false ? (0, _warning["default"])(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
   false ? (0, _warning["default"])(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
   false ? (0, _warning["default"])(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2["default"])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2["default"])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _extends3 = _interopRequireDefault(__webpack_require__(23));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3["default"])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3["default"])({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2["default"])({}, breakpoints.up('sm'), (0, _extends3["default"])({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2["default"])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2["default"])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _deepmerge = _interopRequireDefault(__webpack_require__(138));

var _indigo = _interopRequireDefault(__webpack_require__(495));

var _pink = _interopRequireDefault(__webpack_require__(496));

var _grey = _interopRequireDefault(__webpack_require__(494));

var _red = _interopRequireDefault(__webpack_require__(497));

var _common = _interopRequireDefault(__webpack_require__(493));

var _colorManipulator = __webpack_require__(499);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common["default"].white,
    "default": _grey["default"][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common["default"].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey["default"][800],
    "default": '#303030'
  },
  action: {
    active: _common["default"].white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo["default"][300],
    main: _indigo["default"][500],
    dark: _indigo["default"][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink["default"].A200,
    main: _pink["default"].A400,
    dark: _pink["default"].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red["default"][300],
    main: _red["default"][500],
    dark: _red["default"][700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2["default"])(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning["default"])(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning["default"])(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge["default"])((0, _extends2["default"])({
    // A collection of common colors.
    common: _common["default"],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey["default"],
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createStyles;

function createStyles(styles) {
  return styles;
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(28));

var _deepmerge = _interopRequireDefault(__webpack_require__(138));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _utils = __webpack_require__(45);

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      _ref$useNextVariants = _ref.useNextVariants,
      useNextVariants = _ref$useNextVariants === void 0 ? Boolean(_utils.ponyfillGlobal.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__) : _ref$useNextVariants,
      _ref$suppressWarning = _ref.suppressWarning,
      suppressWarning = _ref$suppressWarning === void 0 ? false : _ref$suppressWarning,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "useNextVariants", "suppressWarning", "allVariants"]);

   false ? (0, _warning["default"])(useNextVariants || suppressWarning, 'Material-UI: you are using the deprecated typography variants ' + 'that will be removed in the next major release.' + '\nPlease read the migration guide under https://v3.material-ui.com/style/typography#migration-to-typography-v2') : void 0;
  var coef = fontSize / 14;

  var pxToRem = function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0, _extends2["default"])({
      color: palette.text.primary,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following http://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var nextVariants = {
    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1Next: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2Next: buildVariant(fontWeightRegular, 14, 1.5, 0.15),
    buttonNext: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    captionNext: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  }; // To remove in v4

  var oldVariants = {
    display4: (0, _extends2["default"])({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2["default"])({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2["default"])({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2["default"])({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2["default"])({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2["default"])({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2["default"])({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2["default"])({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2["default"])({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2["default"])({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2["default"])({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  };
  return (0, _deepmerge["default"])((0, _extends2["default"])({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium
  }, oldVariants, nextVariants, useNextVariants ? {
    body1: nextVariants.body1Next,
    body2: nextVariants.body2Next,
    button: nextVariants.buttonNext,
    caption: nextVariants.captionNext
  } : {}, {
    useNextVariants: useNextVariants
  }), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _typeof2 = _interopRequireDefault(__webpack_require__(69));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _deepmerge = _interopRequireDefault(__webpack_require__(138));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning["default"])((0, _typeof2["default"])(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2["default"])({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning["default"])(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge["default"])(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports["default"] = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme.props || !name || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var _default = getThemeProps;
exports["default"] = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _warning = _interopRequireDefault(__webpack_require__(33));

var _utils = __webpack_require__(45);

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0, _extends2["default"])({}, baseClasses);

  if (false) {
    process.env.NODE_ENV !== "production" ? (0, _warning["default"])(false, ["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes property of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className property instead.'].join('\n')) : void 0;
    return baseClasses;
  }

  Object.keys(newClasses).forEach(function (key) {
     false ? (0, _warning["default"])(baseClasses[key] || !newClasses[key], ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n')) : void 0;
     false ? (0, _warning["default"])(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

var _default = mergeClasses;
exports["default"] = _default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  "delete": function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache["delete"](key2);
  }
};
var _default = multiKeyStore;
exports["default"] = _default;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Share the same values than in
// https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/ns.js
var ns = {
  jss: '64a55d578f856d258dc345b094a2a2b3',
  sheetsRegistry: 'd4bd0baacbc52bbd48bbb9eb24344ecd',
  sheetOptions: '6fc570d6bd61383819d0f9e7407c452d'
};
var _default = ns;
exports["default"] = _default;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports["default"] = _default;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports["default"] = _default;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports["default"] = _default;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports["default"] = _default;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument["default"])(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports["default"] = _default;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.setRef = setRef;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

function cloneElementWithClassName(child, className) {
  return _react["default"].cloneElement(child, {
    className: (0, _classnames["default"])(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react["default"].Children.map(children, function (child) {
    return _react["default"].isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react["default"].isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function chainPropTypes(propType1, propType2) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var _default = chainPropTypes;
exports["default"] = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(69));

var _reactIs = __webpack_require__(111);

/**
 * A factory that returns a propTypes validator that only accepts values that
 * are also accepted by React.createElement
 * e.g. "div", functional, class components, forwardRef etc.
 *
 * @param {boolean} isRequired If `true` returns a validator
 *                             that will throw if nullish values are passed
 */
function createComponentProp(isRequired) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function componentPropType(props, key, componentName, location, propFullName) {
    var prop = props[key];
    var propName = propFullName || key;
    var message;

    if (prop == null) {
      if (isRequired) {
        message = "The ".concat(location, " `").concat(propName, "` is marked as required in `").concat(componentName, "`, ") + "but its value is `".concat((0, _typeof2["default"])(prop), "`.");
      }
    } else if (!(0, _reactIs.isValidElementType)(prop)) {
      var preciseType = (0, _typeof2["default"])(prop);
      message = "Invalid ".concat(location, " `").concat(propName, "` of type `").concat(preciseType, "` ") + "supplied to `".concat(componentName, "`, expected a component.");
    }

    if (message != null) {
      // change error message slightly on every check to prevent caching when testing
      // which would not trigger console errors on subsequent fails
      return new Error("".concat(message).concat( false ? Date.now() : ''));
    }

    return null;
  };
}

var componentPropType = createComponentProp(false);
componentPropType.isRequired = createComponentProp(true);
var _default = componentPropType;
exports["default"] = _default;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(44));

var _extends3 = _interopRequireDefault(__webpack_require__(23));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3["default"])({}, propTypes, (0, _defineProperty2["default"])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports["default"] = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionName = getFunctionName;
exports["default"] = void 0;
// Fork of recompose/getDisplayName with added IE 11 support
// Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || getFunctionName(Component) || 'Component';
}

var _default = getDisplayName;
exports["default"] = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports["default"] = _default;

/***/ }),
/* 522 */,
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast(initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState() {
    return _state;
  }

  function setState(state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) {
        listeners[keys[i]](state);
      }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.');
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId;
  }

  // remove subscription by removing the listener function
  function unsubscribe(id) {
    delete listeners[id];
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe };
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);

/***/ }),
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(199);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(727);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(728);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(141);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(199);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(725);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(141);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(199);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

exports.__esModule = true;
exports["default"] = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(297));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle["default"])(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

exports.__esModule = true;
exports["default"] = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(297));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(737));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(730));

var _removeStyle = _interopRequireDefault(__webpack_require__(732));

var _properties = __webpack_require__(734);

var _isTransform = _interopRequireDefault(__webpack_require__(733));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle["default"])(property)] || (0, _getComputedStyle2["default"])(node).getPropertyValue((0, _hyphenateStyle["default"])(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle["default"])(node, (0, _hyphenateStyle["default"])(key));
    } else if ((0, _isTransform["default"])(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle["default"])(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

exports.__esModule = true;
exports["default"] = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(298));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM["default"]) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports["default"] = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

exports.__esModule = true;
exports["default"] = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(736));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate["default"])(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

exports.__esModule = true;
exports["default"] = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(298));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM["default"]) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */
/***/ (function(module, exports) {

function FocusGroup(options) {
  options = options || {};
  var userKeybindings = options.keybindings || {};
  this._settings = {
    keybindings: {
      next: userKeybindings.next || { keyCode: 40 },
      prev: userKeybindings.prev || { keyCode: 38 },
      first: userKeybindings.first,
      last: userKeybindings.last
    },
    wrap: options.wrap,
    stringSearch: options.stringSearch,
    stringSearchDelay: 800
  };

  // Construct a keybinding lookup that will be more useful later
  this._keybindingsLookup = [];
  var action;
  var eventMatchers;
  for (action in this._settings.keybindings) {
    eventMatchers = this._settings.keybindings[action];
    if (!eventMatchers) continue;
    [].concat(eventMatchers).forEach(function (eventMatcher) {
      eventMatcher.metaKey = eventMatcher.metaKey || false;
      eventMatcher.ctrlKey = eventMatcher.ctrlKey || false;
      eventMatcher.altKey = eventMatcher.altKey || false;
      eventMatcher.shiftKey = eventMatcher.shiftKey || false;
      this._keybindingsLookup.push({
        action: action,
        eventMatcher: eventMatcher
      });
    }.bind(this));
  }

  this._searchString = '';
  this._members = [];
  if (options.members) this.setMembers(options.members);
  this._boundHandleKeydownEvent = this._handleKeydownEvent.bind(this);
}

FocusGroup.prototype.activate = function () {
  // Use capture in case other libraries might grab it first -- i.e. React
  document.addEventListener('keydown', this._boundHandleKeydownEvent, true);
  return this;
};

FocusGroup.prototype.deactivate = function () {
  document.removeEventListener('keydown', this._boundHandleKeydownEvent, true);
  this._clearSearchStringRefreshTimer();
  return this;
};

FocusGroup.prototype._handleKeydownEvent = function (event) {
  // Only respond to keyboard events when
  // focus is already within the focus-group
  var activeElementIndex = this._getActiveElementIndex();
  if (activeElementIndex === -1) return;

  // See if the event matches any registered keybinds
  var eventBound = false;
  this._keybindingsLookup.forEach(function (keybinding) {
    if (!matchesEvent(keybinding.eventMatcher, event)) return;
    eventBound = true;
    event.preventDefault();
    switch (keybinding.action) {
      case 'next':
        this.moveFocusForward();
        break;
      case 'prev':
        this.moveFocusBack();
        break;
      case 'first':
        this.moveFocusToFirst();
        break;
      case 'last':
        this.moveFocusToLast();
        break;
      default:
        return;
    }
  }.bind(this));

  if (!eventBound) {
    this._handleUnboundKey(event);
  }
};

FocusGroup.prototype.moveFocusForward = function () {
  var activeElementIndex = this._getActiveElementIndex();
  var targetIndex;
  if (activeElementIndex < this._members.length - 1) {
    targetIndex = activeElementIndex + 1;
  } else if (this._settings.wrap) {
    targetIndex = 0;
  } else {
    targetIndex = activeElementIndex;
  }
  this.focusNodeAtIndex(targetIndex);
  return targetIndex;
};

FocusGroup.prototype.moveFocusBack = function () {
  var activeElementIndex = this._getActiveElementIndex();
  var targetIndex;
  if (activeElementIndex > 0) {
    targetIndex = activeElementIndex - 1;
  } else if (this._settings.wrap) {
    targetIndex = this._members.length - 1;
  } else {
    targetIndex = activeElementIndex;
  }
  this.focusNodeAtIndex(targetIndex);
  return targetIndex;
};

FocusGroup.prototype.moveFocusToFirst = function () {
  this.focusNodeAtIndex(0);
};

FocusGroup.prototype.moveFocusToLast = function () {
  this.focusNodeAtIndex(this._members.length - 1);
};

FocusGroup.prototype._handleUnboundKey = function (event) {
  if (!this._settings.stringSearch) return;

  // While a string search is underway, ignore spaces
  // and prevent the default space-key behavior
  if (this._searchString !== '' && (event.key === ' ' || event.keyCode === 32)) {
    event.preventDefault();
    return -1;
  }

  // Only respond to letter keys
  if (!isLetterKeyCode(event.keyCode)) return -1;

  // If the letter key is part of a key combo,
  // let it do whatever it was going to do
  if (event.ctrlKey || event.metaKey || event.altKey) return -1;

  event.preventDefault();

  this._addToSearchString(String.fromCharCode(event.keyCode));
  this._runStringSearch();
};

FocusGroup.prototype._clearSearchString = function () {
  this._searchString = '';
};

FocusGroup.prototype._addToSearchString = function (letter) {
  // Always store the lowercase version of the letter
  this._searchString += letter.toLowerCase();
};

FocusGroup.prototype._startSearchStringRefreshTimer = function () {
  var self = this;
  this._clearSearchStringRefreshTimer();
  this._stringSearchTimer = setTimeout(function () {
    self._clearSearchString();
  }, this._settings.stringSearchDelay);
};

FocusGroup.prototype._clearSearchStringRefreshTimer = function () {
  clearTimeout(this._stringSearchTimer);
};

FocusGroup.prototype._runStringSearch = function () {
  this._startSearchStringRefreshTimer();
  this.moveFocusByString(this._searchString);
};

FocusGroup.prototype.moveFocusByString = function (str) {
  var member;
  for (var i = 0, l = this._members.length; i < l; i++) {
    member = this._members[i];
    if (!member.text) continue;

    if (member.text.indexOf(str) === 0) {
      return focusNode(member.node);
    }
  }
};

FocusGroup.prototype._findIndexOfNode = function (searchNode) {
  for (var i = 0, l = this._members.length; i < l; i++) {
    if (this._members[i].node === searchNode) {
      return i;
    }
  }
  return -1;
};

FocusGroup.prototype._getActiveElementIndex = function () {
  return this._findIndexOfNode(document.activeElement);
};

FocusGroup.prototype.focusNodeAtIndex = function (index) {
  var member = this._members[index];
  if (member) focusNode(member.node);
  return this;
};

FocusGroup.prototype.addMember = function (memberData, index) {
  var node = memberData.node || memberData;
  var nodeText = memberData.text || node.getAttribute('data-focus-group-text') || node.textContent || '';

  this._checkNode(node);

  var cleanedNodeText = nodeText.replace(/[\W_]/g, '').toLowerCase();
  var member = {
    node: node,
    text: cleanedNodeText
  };

  if (index !== null && index !== undefined) {
    this._members.splice(index, 0, member);
  } else {
    this._members.push(member);
  }
  return this;
};

FocusGroup.prototype.removeMember = function (member) {
  var removalIndex = typeof member === 'number' ? member : this._findIndexOfNode(member);
  if (removalIndex === -1) return;
  this._members.splice(removalIndex, 1);
  return this;
};

FocusGroup.prototype.clearMembers = function () {
  this._members = [];
  return this;
};

FocusGroup.prototype.setMembers = function (nextMembers) {
  this.clearMembers();
  for (var i = 0, l = nextMembers.length; i < l; i++) {
    this.addMember(nextMembers[i]);
  }
  return this;
};

FocusGroup.prototype.getMembers = function () {
  return this._members;
};

FocusGroup.prototype._checkNode = function (node) {
  if (!node.nodeType || node.nodeType !== window.Node.ELEMENT_NODE) {
    throw new Error('focus-group: only DOM nodes allowed');
  }
  return node;
};

function matchesEvent(matcher, event) {
  for (var key in matcher) {
    if (event[key] !== undefined && matcher[key] !== event[key]) return false;
  }
  return true;
}

function isLetterKeyCode(keyCode) {
  return keyCode >= 65 && keyCode <= 90;
}

function focusNode(node) {
  if (!node || !node.focus) return;
  node.focus();
  if (node.tagName.toLowerCase() === 'input') node.select();
}

module.exports = function createFocusGroup(options) {
  return new FocusGroup(options);
};

/***/ }),
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name];
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);

/***/ }),
/* 749 */,
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(752);

function isObjectObject(o) {
  return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor, prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object') return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */
function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */
function isFunction(payload) {
    return typeof payload === 'function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */
function isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */
function isFullArray(payload) {
    return isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */
function isEmptyArray(payload) {
    return isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */
function isMap(payload) {
    return getType(payload) === 'Map';
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */
function isWeakMap(payload) {
    return getType(payload) === 'WeakMap';
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */
function isSet(payload) {
    return getType(payload) === 'Set';
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */
function isWeakSet(payload) {
    return getType(payload) === 'WeakSet';
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */
function isBlob(payload) {
    return getType(payload) === 'Blob';
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */
function isFile(payload) {
    return getType(payload) === 'File';
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */
function isPromise(payload) {
    return getType(payload) === 'Promise';
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */
function isError(payload) {
    return getType(payload) === 'Error';
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */
function isNaNValue(payload) {
    return getType(payload) === 'Number' && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return isBoolean(payload) || isNull(payload) || isUndefined(payload) || isNumber(payload) || isString(payload) || isSymbol(payload);
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */
var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function (value) {
        return a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}

exports.getType = getType;
exports.isAnyObject = isAnyObject;
exports.isArray = isArray;
exports.isBlob = isBlob;
exports.isBoolean = isBoolean;
exports.isDate = isDate;
exports.isEmptyArray = isEmptyArray;
exports.isEmptyObject = isEmptyObject;
exports.isEmptyString = isEmptyString;
exports.isError = isError;
exports.isFile = isFile;
exports.isFullArray = isFullArray;
exports.isFullObject = isFullObject;
exports.isFullString = isFullString;
exports.isFunction = isFunction;
exports.isMap = isMap;
exports.isNaNValue = isNaNValue;
exports.isNull = isNull;
exports.isNullOrUndefined = isNullOrUndefined;
exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isObjectLike = isObjectLike;
exports.isOneOf = isOneOf;
exports.isPlainObject = isPlainObject;
exports.isPrimitive = isPrimitive;
exports.isPromise = isPromise;
exports.isRegExp = isRegExp;
exports.isSet = isSet;
exports.isString = isString;
exports.isSymbol = isSymbol;
exports.isType = isType;
exports.isUndefined = isUndefined;
exports.isWeakMap = isWeakMap;
exports.isWeakSet = isWeakSet;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isObject(val) {
  return val != null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && Array.isArray(val) === false;
};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(748);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(754);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(305);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */

  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = jssNested;

var _warning = __webpack_require__(758);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(726);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _isInBrowser = __webpack_require__(141);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(304);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(762);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(766);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(765);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(764);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(205);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(92);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(306);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(142);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(767);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(768);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _warning = __webpack_require__(93);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _warning = __webpack_require__(93);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(108);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(92);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(142);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(92);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(142);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(307);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(772);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(771);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(769);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(770);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(773);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _warning = __webpack_require__(93);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(205);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(92);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(143);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */

  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _RuleList = __webpack_require__(108);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */

  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _toCss = __webpack_require__(206);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */

  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _RuleList = __webpack_require__(108);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */

  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _toCss = __webpack_require__(206);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */

  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(307);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;

/***/ }),
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;

/***/ }),
/* 812 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;

/***/ }),
/* 813 */,
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(145),
    arrayMap = __webpack_require__(796),
    isArray = __webpack_require__(150),
    isSymbol = __webpack_require__(870);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(812);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}

module.exports = castSlice;

/***/ }),
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(815),
    hasUnicode = __webpack_require__(319),
    stringToArray = __webpack_require__(863),
    toString = __webpack_require__(151);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);

    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;

    var chr = strSymbols ? strSymbols[0] : string.charAt(0);

    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(797),
    deburr = __webpack_require__(866),
    words = __webpack_require__(875);

/** Used to compose unicode capture groups. */
var rsApos = '[\'\u2019]';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(811);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C', '\xe7': 'c',
  '\xd0': 'D', '\xf0': 'd',
  '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N', '\xf1': 'n',
  '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C', '\u0108': 'C', '\u010A': 'C', '\u010C': 'C',
  '\u0107': 'c', '\u0109': 'c', '\u010B': 'c', '\u010D': 'c',
  '\u010E': 'D', '\u0110': 'D', '\u010F': 'd', '\u0111': 'd',
  '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011A': 'E',
  '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011B': 'e',
  '\u011C': 'G', '\u011E': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011D': 'g', '\u011F': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I', '\u012A': 'I', '\u012C': 'I', '\u012E': 'I', '\u0130': 'I',
  '\u0129': 'i', '\u012B': 'i', '\u012D': 'i', '\u012F': 'i', '\u0131': 'i',
  '\u0134': 'J', '\u0135': 'j',
  '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L', '\u013B': 'L', '\u013D': 'L', '\u013F': 'L', '\u0141': 'L',
  '\u013A': 'l', '\u013C': 'l', '\u013E': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014A': 'N',
  '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014B': 'n',
  '\u014C': 'O', '\u014E': 'O', '\u0150': 'O',
  '\u014D': 'o', '\u014F': 'o', '\u0151': 'o',
  '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
  '\u015A': 'S', '\u015C': 'S', '\u015E': 'S', '\u0160': 'S',
  '\u015B': 's', '\u015D': 's', '\u015F': 's', '\u0161': 's',
  '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't', '\u0165': 't', '\u0167': 't',
  '\u0168': 'U', '\u016A': 'U', '\u016C': 'U', '\u016E': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u', '\u016B': 'u', '\u016D': 'u', '\u016F': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W', '\u0175': 'w',
  '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z', '\u017B': 'Z', '\u017D': 'Z',
  '\u017A': 'z', '\u017C': 'z', '\u017E': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017F': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;

/***/ }),
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;

/***/ }),
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(798),
    hasUnicode = __webpack_require__(319),
    unicodeToArray = __webpack_require__(864);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

module.exports = stringToArray;

/***/ }),
/* 864 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;

/***/ }),
/* 865 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = '[\'\u2019]',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(827),
    toString = __webpack_require__(151);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;

/***/ }),
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(109),
    isObjectLike = __webpack_require__(94);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 871 */,
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(826);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function (result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;

/***/ }),
/* 873 */,
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(825);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(799),
    hasUnicodeWord = __webpack_require__(833),
    toString = __webpack_require__(151),
    unicodeWords = __webpack_require__(865);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) {
        isEqual = areInputsEqual;
    }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concatArrays */
/* unused harmony export merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_what__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_what___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_what__);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
        s += arguments[i].length;
    }for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key) ? 'enumerable' : 'nonenumerable';
    if (propType === 'enumerable') carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isPlainObject"])(newComer)) {
        // extend merge rules
        if (extensions && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isArray"])(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isPlainObject"])(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isSymbol"])(key) && !Object.getOwnPropertyNames(newComer).includes(key) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isSymbol"])(key) && !Object.getOwnPropertySymbols(newComer).includes(key)) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isPlainObject"])(origin) ?
        // @ts-ignore
        origin[key] : undefined;
        // extend merge rules
        if (extensions && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isArray"])(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isPlainObject"])(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isPlainObject"])(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isArray"])(originVal) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_is_what__["isArray"])(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 878 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(2);
var specialAssign = __webpack_require__(153);

var checkedProps = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  tag: PropTypes.string
};

var AriaMenuButtonButton = function (_React$Component) {
  _inherits(AriaMenuButtonButton, _React$Component);

  function AriaMenuButtonButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AriaMenuButtonButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AriaMenuButtonButton.__proto__ || Object.getPrototypeOf(AriaMenuButtonButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
      if (_this.props.disabled) return;

      var ambManager = _this.context.ambManager;

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          if (!ambManager.isOpen) {
            ambManager.openMenu({ focusMenu: true });
          } else {
            ambManager.focusItem(0);
          }
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          ambManager.toggleMenu();
          break;
        case 'Escape':
          ambManager.handleMenuKey(event);
          break;
        default:
          // (Potential) letter keys
          ambManager.handleButtonNonArrowKey(event);
      }
    }, _this.handleClick = function () {
      if (_this.props.disabled) return;
      _this.context.ambManager.toggleMenu();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AriaMenuButtonButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context.ambManager.button = this;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.context.ambManager.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;

      var buttonProps = {
        // "The menu button itself has a role of button."
        role: 'button',
        tabIndex: props.disabled ? '' : '0',
        // "The menu button has an aria-haspopup property, set to true."
        'aria-haspopup': true,
        'aria-expanded': this.context.ambManager.isOpen,
        'aria-disabled': props.disabled,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        onBlur: this.context.ambManager.handleBlur
      };

      specialAssign(buttonProps, props, checkedProps);

      return React.createElement(props.tag, buttonProps, props.children);
    }
  }]);

  return AriaMenuButtonButton;
}(React.Component);

AriaMenuButtonButton.propTypes = checkedProps;
AriaMenuButtonButton.contextTypes = {
  ambManager: PropTypes.object.isRequired
};
AriaMenuButtonButton.defaultProps = { tag: 'span' };

module.exports = AriaMenuButtonButton;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _class, _temp2;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(22);
var PropTypes = __webpack_require__(2);
var createTapListener = __webpack_require__(938);
var specialAssign = __webpack_require__(153);

var checkedProps = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  tag: PropTypes.string
};

module.exports = (_temp2 = _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.addTapListener = function () {
      var el = ReactDOM.findDOMNode(_this);
      if (!el) return;
      var doc = el.ownerDocument;
      if (!doc) return;
      _this.tapListener = createTapListener(doc.documentElement, _this.handleTap);
    }, _this.handleTap = function (event) {
      if (ReactDOM.findDOMNode(_this).contains(event.target)) return;
      if (ReactDOM.findDOMNode(_this.context.ambManager.button).contains(event.target)) return;
      _this.context.ambManager.closeMenu();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context.ambManager.menu = this;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var ambManager = this.context.ambManager;
      if (ambManager.isOpen && !this.tapListener) {
        this.addTapListener();
      } else if (!ambManager.isOpen && this.tapListener) {
        this.tapListener.remove();
        delete this.tapListener;
      }

      if (!ambManager.isOpen) {
        // Clear the ambManager's items, so they
        // can be reloaded next time this menu opens
        ambManager.clearItems();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.tapListener) this.tapListener.remove();
      this.context.ambManager.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var ambManager = this.context.ambManager;

      var childrenToRender = function () {
        if (typeof props.children === 'function') {
          return props.children({ isOpen: ambManager.isOpen });
        }
        if (ambManager.isOpen) return props.children;
        return false;
      }();

      if (!childrenToRender) return false;

      var menuProps = {
        onKeyDown: ambManager.handleMenuKey,
        role: 'menu',
        onBlur: ambManager.handleBlur
      };

      specialAssign(menuProps, props, checkedProps);

      return React.createElement(props.tag, menuProps, childrenToRender);
    }
  }]);

  return _class;
}(React.Component), _class.propTypes = checkedProps, _class.defaultProps = { tag: 'div' }, _class.contextTypes = {
  ambManager: PropTypes.object.isRequired
}, _temp2);

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(2);
var specialAssign = __webpack_require__(153);

var checkedProps = {
  children: PropTypes.node.isRequired,
  tag: PropTypes.string,
  text: PropTypes.string,
  value: PropTypes.any
};

var AriaMenuButtonMenuItem = function (_React$Component) {
  _inherits(AriaMenuButtonMenuItem, _React$Component);

  function AriaMenuButtonMenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AriaMenuButtonMenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AriaMenuButtonMenuItem.__proto__ || Object.getPrototypeOf(AriaMenuButtonMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      _this.selectItem(event);
    }, _this.selectItem = function (event) {
      // If there's no value, we'll send the child
      var value = typeof _this.props.value !== 'undefined' ? _this.props.value : _this.props.children;
      _this.context.ambManager.handleSelection(value, event);
    }, _this.registerNode = function (node) {
      _this.node = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AriaMenuButtonMenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.context.ambManager.addItem({
        node: this.node,
        text: this.props.text
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var menuItemProps = {
        onClick: this.selectItem,
        onKeyDown: this.handleKeyDown,
        role: 'menuitem',
        tabIndex: '-1',
        ref: this.registerNode
      };

      specialAssign(menuItemProps, this.props, checkedProps);

      return React.createElement(this.props.tag, menuItemProps, this.props.children);
    }
  }]);

  return AriaMenuButtonMenuItem;
}(React.Component);

AriaMenuButtonMenuItem.propTypes = checkedProps;
AriaMenuButtonMenuItem.defaultProps = { tag: 'div' };
AriaMenuButtonMenuItem.contextTypes = {
  ambManager: PropTypes.object.isRequired
};

module.exports = AriaMenuButtonMenuItem;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(2);
var createManager = __webpack_require__(889);
var specialAssign = __webpack_require__(153);

var checkedProps = {
  children: PropTypes.node.isRequired,
  onMenuToggle: PropTypes.func,
  onSelection: PropTypes.func.isRequired,
  closeOnSelection: PropTypes.bool,
  tag: PropTypes.string
};

var AriaMenuButtonWrapper = function (_React$Component) {
  _inherits(AriaMenuButtonWrapper, _React$Component);

  function AriaMenuButtonWrapper() {
    _classCallCheck(this, AriaMenuButtonWrapper);

    return _possibleConstructorReturn(this, (AriaMenuButtonWrapper.__proto__ || Object.getPrototypeOf(AriaMenuButtonWrapper)).apply(this, arguments));
  }

  _createClass(AriaMenuButtonWrapper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        ambManager: this.manager
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.manager = createManager({
        onMenuToggle: this.props.onMenuToggle,
        onSelection: this.props.onSelection,
        closeOnSelection: this.props.closeOnSelection,
        id: this.props.id
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var wrapperProps = {};
      specialAssign(wrapperProps, this.props, checkedProps);
      return React.createElement(this.props.tag, wrapperProps, this.props.children);
    }
  }]);

  return AriaMenuButtonWrapper;
}(React.Component);

AriaMenuButtonWrapper.propTypes = checkedProps;
AriaMenuButtonWrapper.defaultProps = { tag: 'div' };
AriaMenuButtonWrapper.childContextTypes = {
  ambManager: PropTypes.object
};

module.exports = AriaMenuButtonWrapper;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ReactDOM = __webpack_require__(22);
var createFocusGroup = __webpack_require__(742);
var externalStateControl = __webpack_require__(328);

var focusGroupOptions = {
  wrap: true,
  stringSearch: true
};

var protoManager = {
  init: function init(options) {
    this.options = options || {};

    if (typeof this.options.closeOnSelection === 'undefined') {
      this.options.closeOnSelection = true;
    }

    if (this.options.id) {
      externalStateControl.registerManager(this.options.id, this);
    }

    this.handleBlur = handleBlur.bind(this);
    this.handleSelection = handleSelection.bind(this);
    this.handleMenuKey = handleMenuKey.bind(this);

    // "With focus on the drop-down menu, the Up and Down Arrow
    // keys move focus within the menu items, "wrapping" at the top and bottom."
    // "Typing a letter (printable character) key moves focus to the next
    // instance of a visible node whose title begins with that printable letter."
    //
    // All of the above is handled by focus-group.
    this.focusGroup = createFocusGroup(focusGroupOptions);

    // These component references are added when the relevant components mount
    this.button = null;
    this.menu = null;

    // State trackers
    this.isOpen = false;
  },
  focusItem: function focusItem(index) {
    this.focusGroup.focusNodeAtIndex(index);
  },
  addItem: function addItem(item) {
    this.focusGroup.addMember(item);
  },
  clearItems: function clearItems() {
    this.focusGroup.clearMembers();
  },
  handleButtonNonArrowKey: function handleButtonNonArrowKey(event) {
    this.focusGroup._handleUnboundKey(event);
  },
  destroy: function destroy() {
    this.button = null;
    this.menu = null;
    this.focusGroup.deactivate();
    clearTimeout(this.blurTimer);
    clearTimeout(this.moveFocusTimer);
  },
  update: function update() {
    this.menu.setState({ isOpen: this.isOpen });
    this.button.setState({ menuOpen: this.isOpen });
    this.options.onMenuToggle && this.options.onMenuToggle({ isOpen: this.isOpen });
  },
  openMenu: function openMenu(openOptions) {
    if (this.isOpen) return;
    openOptions = openOptions || {};
    this.isOpen = true;
    this.update();
    this.focusGroup.activate();
    if (openOptions.focusMenu) {
      var self = this;
      this.moveFocusTimer = setTimeout(function () {
        self.focusItem(0);
      }, 0);
    }
  },
  closeMenu: function closeMenu(closeOptions) {
    if (!this.isOpen) return;
    closeOptions = closeOptions || {};
    this.isOpen = false;
    this.update();
    if (closeOptions.focusButton) {
      ReactDOM.findDOMNode(this.button).focus();
    }
  },
  toggleMenu: function toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
};

function handleBlur() {
  var self = this;
  self.blurTimer = setTimeout(function () {
    var buttonNode = ReactDOM.findDOMNode(self.button);
    var menuNode = ReactDOM.findDOMNode(self.menu);
    var activeEl = buttonNode.ownerDocument.activeElement;
    if (buttonNode && activeEl === buttonNode) return;
    if (menuNode && menuNode.contains(activeEl)) return;
    if (self.isOpen) self.closeMenu({ focusButton: false });
  }, 0);
}

function handleSelection(value, event) {
  if (this.options.closeOnSelection) this.closeMenu({ focusButton: true });
  this.options.onSelection(value, event);
}

function handleMenuKey(event) {
  // "With focus on the drop-down menu, pressing Escape closes
  // the menu and returns focus to the button.
  if (this.isOpen && event.key === 'Escape') {
    event.preventDefault();
    this.closeMenu({ focusButton: true });
  }
}

module.exports = function (options) {
  var newManager = Object.create(protoManager);
  newManager.init(options);
  return newManager;
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var externalStateControl = __webpack_require__(328);

module.exports = {
  Wrapper: __webpack_require__(888),
  Button: __webpack_require__(885),
  Menu: __webpack_require__(886),
  MenuItem: __webpack_require__(887),
  openMenu: externalStateControl.openMenu,
  closeMenu: externalStateControl.closeMenu
};

/***/ }),
/* 891 */,
/* 892 */,
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



/***/ }),
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(22));

var _reactLifecyclesCompat = __webpack_require__(893);

var _PropTypes = __webpack_require__(926);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }newObj["default"] = obj;return newObj;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props["in"]) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref["in"];

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props["in"]) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom["default"].findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps["in"];
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react["default"].Children.only(children);

    return _react["default"].cloneElement(child, childProps);
  };

  return Transition;
}(_react["default"].Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  "in": PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  "in": false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports["default"] = _default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var timeoutsShape =  false ? _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
  enter: _propTypes["default"].number,
  exit: _propTypes["default"].number,
  appear: _propTypes["default"].number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
  enter: _propTypes["default"].string,
  exit: _propTypes["default"].string,
  active: _propTypes["default"].string
}), _propTypes["default"].shape({
  enter: _propTypes["default"].string,
  enterDone: _propTypes["default"].string,
  enterActive: _propTypes["default"].string,
  exit: _propTypes["default"].string,
  exitDone: _propTypes["default"].string,
  exitActive: _propTypes["default"].string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (factory) {
	( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module['exports'] = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : window['stylisRuleSheet'] = factory();
})(function () {

	'use strict';

	return function (insertRule) {
		var delimiter = '/*|*/';
		var needle = delimiter + '}';

		function toSheet(block) {
			if (block) try {
				insertRule(block + '}');
			} catch (e) {}
		}

		return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
					break;
				// selector
				case 2:
					if (ns === 0) return content + delimiter;
					break;
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0] + content), '';
						default:
							return content + (at === 0 ? delimiter : '');
					}
				case -2:
					content.split(needle).forEach(toSheet);
			}
		};
	};
});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e(null) :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e(null)),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : window.stylis = e(null);
}(function e(a) {
  "use strict";
  var r = /^\0+/g,
      c = /[\0\r\f]/g,
      s = /: */g,
      t = /zoo|gra/,
      i = /([,: ])(transform)/g,
      f = /,+\s*(?![^(]*[)])/g,
      n = / +\s*(?![^(]*[)])/g,
      l = / *[\0] */g,
      o = /,\r+?/g,
      h = /([\t\r\n ])*\f?&/g,
      u = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
      d = /\W+/g,
      b = /@(k\w+)\s*(\S*)\s*/,
      p = /::(place)/g,
      k = /:(read-only)/g,
      g = /\s+(?=[{\];=:>])/g,
      A = /([[}=:>])\s+/g,
      C = /(\{[^{]+?);(?=\})/g,
      w = /\s{2,}/g,
      v = /([^\(])(:+) */g,
      m = /[svh]\w+-[tblr]{2}/,
      x = /\(\s*(.*)\s*\)/g,
      $ = /([\s\S]*?);/g,
      y = /-self|flex-/g,
      O = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      j = /stretch|:\s*\w+\-(?:conte|avail)/,
      z = /([^-])(image-set\()/,
      N = "-webkit-",
      S = "-moz-",
      F = "-ms-",
      W = 59,
      q = 125,
      B = 123,
      D = 40,
      E = 41,
      G = 91,
      H = 93,
      I = 10,
      J = 13,
      K = 9,
      L = 64,
      M = 32,
      P = 38,
      Q = 45,
      R = 95,
      T = 42,
      U = 44,
      V = 58,
      X = 39,
      Y = 34,
      Z = 47,
      _ = 62,
      ee = 43,
      ae = 126,
      re = 0,
      ce = 12,
      se = 11,
      te = 107,
      ie = 109,
      fe = 115,
      ne = 112,
      le = 111,
      oe = 105,
      he = 99,
      ue = 100,
      de = 112,
      be = 1,
      pe = 1,
      ke = 0,
      ge = 1,
      Ae = 1,
      Ce = 1,
      we = 0,
      ve = 0,
      me = 0,
      xe = [],
      $e = [],
      ye = 0,
      Oe = null,
      je = -2,
      ze = -1,
      Ne = 0,
      Se = 1,
      Fe = 2,
      We = 3,
      qe = 0,
      Be = 1,
      De = "",
      Ee = "",
      Ge = "";function He(e, a, s, t, i) {
    for (var f, n, o = 0, h = 0, u = 0, d = 0, g = 0, A = 0, C = 0, w = 0, m = 0, $ = 0, y = 0, O = 0, j = 0, z = 0, R = 0, we = 0, $e = 0, Oe = 0, je = 0, ze = s.length, Je = ze - 1, Re = "", Te = "", Ue = "", Ve = "", Xe = "", Ye = ""; R < ze;) {
      if (C = s.charCodeAt(R), R === Je) if (h + d + u + o !== 0) {
        if (0 !== h) C = h === Z ? I : Z;d = u = o = 0, ze++, Je++;
      }if (h + d + u + o === 0) {
        if (R === Je) {
          if (we > 0) Te = Te.replace(c, "");if (Te.trim().length > 0) {
            switch (C) {case M:case K:case W:case J:case I:
                break;default:
                Te += s.charAt(R);}C = W;
          }
        }if (1 === $e) switch (C) {case B:case q:case W:case Y:case X:case D:case E:case U:
            $e = 0;case K:case J:case I:case M:
            break;default:
            for ($e = 0, je = R, g = C, R--, C = W; je < ze;) {
              switch (s.charCodeAt(je++)) {case I:case J:case W:
                  ++R, C = g, je = ze;break;case V:
                  if (we > 0) ++R, C = g;case B:
                  je = ze;}
            }}switch (C) {case B:
            for (g = (Te = Te.trim()).charCodeAt(0), y = 1, je = ++R; R < ze;) {
              switch (C = s.charCodeAt(R)) {case B:
                  y++;break;case q:
                  y--;break;case Z:
                  switch (A = s.charCodeAt(R + 1)) {case T:case Z:
                      R = Qe(A, R, Je, s);}break;case G:
                  C++;case D:
                  C++;case Y:case X:
                  for (; R++ < Je && s.charCodeAt(R) !== C;) {}}if (0 === y) break;R++;
            }if (Ue = s.substring(je, R), g === re) g = (Te = Te.replace(r, "").trim()).charCodeAt(0);switch (g) {case L:
                if (we > 0) Te = Te.replace(c, "");switch (A = Te.charCodeAt(1)) {case ue:case ie:case fe:case Q:
                    f = a;break;default:
                    f = xe;}if (je = (Ue = He(a, f, Ue, A, i + 1)).length, me > 0 && 0 === je) je = Te.length;if (ye > 0) if (f = Ie(xe, Te, Oe), n = Pe(We, Ue, f, a, pe, be, je, A, i, t), Te = f.join(""), void 0 !== n) if (0 === (je = (Ue = n.trim()).length)) A = 0, Ue = "";if (je > 0) switch (A) {case fe:
                    Te = Te.replace(x, Me);case ue:case ie:case Q:
                    Ue = Te + "{" + Ue + "}";break;case te:
                    if (Ue = (Te = Te.replace(b, "$1 $2" + (Be > 0 ? De : ""))) + "{" + Ue + "}", 1 === Ae || 2 === Ae && Le("@" + Ue, 3)) Ue = "@" + N + Ue + "@" + Ue;else Ue = "@" + Ue;break;default:
                    if (Ue = Te + Ue, t === de) Ve += Ue, Ue = "";} else Ue = "";break;default:
                Ue = He(a, Ie(a, Te, Oe), Ue, t, i + 1);}Xe += Ue, O = 0, $e = 0, z = 0, we = 0, Oe = 0, j = 0, Te = "", Ue = "", C = s.charCodeAt(++R);break;case q:case W:
            if ((je = (Te = (we > 0 ? Te.replace(c, "") : Te).trim()).length) > 1) {
              if (0 === z) if ((g = Te.charCodeAt(0)) === Q || g > 96 && g < 123) je = (Te = Te.replace(" ", ":")).length;if (ye > 0) if (void 0 !== (n = Pe(Se, Te, a, e, pe, be, Ve.length, t, i, t))) if (0 === (je = (Te = n.trim()).length)) Te = "\0\0";switch (g = Te.charCodeAt(0), A = Te.charCodeAt(1), g) {case re:
                  break;case L:
                  if (A === oe || A === he) {
                    Ye += Te + s.charAt(R);break;
                  }default:
                  if (Te.charCodeAt(je - 1) === V) break;Ve += Ke(Te, g, A, Te.charCodeAt(2));}
            }O = 0, $e = 0, z = 0, we = 0, Oe = 0, Te = "", C = s.charCodeAt(++R);}
      }switch (C) {case J:case I:
          if (h + d + u + o + ve === 0) switch ($) {case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:
              break;default:
              if (z > 0) $e = 1;}if (h === Z) h = 0;else if (ge + O === 0 && t !== te && Te.length > 0) we = 1, Te += "\0";if (ye * qe > 0) Pe(Ne, Te, a, e, pe, be, Ve.length, t, i, t);be = 1, pe++;break;case W:case q:
          if (h + d + u + o === 0) {
            be++;break;
          }default:
          switch (be++, Re = s.charAt(R), C) {case K:case M:
              if (d + o + h === 0) switch (w) {case U:case V:case K:case M:
                  Re = "";break;default:
                  if (C !== M) Re = " ";}break;case re:
              Re = "\\0";break;case ce:
              Re = "\\f";break;case se:
              Re = "\\v";break;case P:
              if (d + h + o === 0 && ge > 0) Oe = 1, we = 1, Re = "\f" + Re;break;case 108:
              if (d + h + o + ke === 0 && z > 0) switch (R - z) {case 2:
                  if (w === ne && s.charCodeAt(R - 3) === V) ke = w;case 8:
                  if (m === le) ke = m;}break;case V:
              if (d + h + o === 0) z = R;break;case U:
              if (h + u + d + o === 0) we = 1, Re += "\r";break;case Y:case X:
              if (0 === h) d = d === C ? 0 : 0 === d ? C : d;break;case G:
              if (d + h + u === 0) o++;break;case H:
              if (d + h + u === 0) o--;break;case E:
              if (d + h + o === 0) u--;break;case D:
              if (d + h + o === 0) {
                if (0 === O) switch (2 * w + 3 * m) {case 533:
                    break;default:
                    y = 0, O = 1;}u++;
              }break;case L:
              if (h + u + d + o + z + j === 0) j = 1;break;case T:case Z:
              if (d + o + u > 0) break;switch (h) {case 0:
                  switch (2 * C + 3 * s.charCodeAt(R + 1)) {case 235:
                      h = Z;break;case 220:
                      je = R, h = T;}break;case T:
                  if (C === Z && w === T && je + 2 !== R) {
                    if (33 === s.charCodeAt(je + 2)) Ve += s.substring(je, R + 1);Re = "", h = 0;
                  }}}if (0 === h) {
            if (ge + d + o + j === 0 && t !== te && C !== W) switch (C) {case U:case ae:case _:case ee:case E:case D:
                if (0 === O) {
                  switch (w) {case K:case M:case I:case J:
                      Re += "\0";break;default:
                      Re = "\0" + Re + (C === U ? "" : "\0");}we = 1;
                } else switch (C) {case D:
                    if (z + 7 === R && 108 === w) z = 0;O = ++y;break;case E:
                    if (0 == (O = --y)) we = 1, Re += "\0";}break;case K:case M:
                switch (w) {case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:
                    break;default:
                    if (0 === O) we = 1, Re += "\0";}}if (Te += Re, C !== M && C !== K) $ = C;
          }}m = w, w = C, R++;
    }if (je = Ve.length, me > 0) if (0 === je && 0 === Xe.length && 0 === a[0].length == false) if (t !== ie || 1 === a.length && (ge > 0 ? Ee : Ge) === a[0]) je = a.join(",").length + 2;if (je > 0) {
      if (f = 0 === ge && t !== te ? function (e) {
        for (var a, r, s = 0, t = e.length, i = Array(t); s < t; ++s) {
          for (var f = e[s].split(l), n = "", o = 0, h = 0, u = 0, d = 0, b = f.length; o < b; ++o) {
            if (0 === (h = (r = f[o]).length) && b > 1) continue;if (u = n.charCodeAt(n.length - 1), d = r.charCodeAt(0), a = "", 0 !== o) switch (u) {case T:case ae:case _:case ee:case M:case D:
                break;default:
                a = " ";}switch (d) {case P:
                r = a + Ee;case ae:case _:case ee:case M:case E:case D:
                break;case G:
                r = a + r + Ee;break;case V:
                switch (2 * r.charCodeAt(1) + 3 * r.charCodeAt(2)) {case 530:
                    if (Ce > 0) {
                      r = a + r.substring(8, h - 1);break;
                    }default:
                    if (o < 1 || f[o - 1].length < 1) r = a + Ee + r;}break;case U:
                a = "";default:
                if (h > 1 && r.indexOf(":") > 0) r = a + r.replace(v, "$1" + Ee + "$2");else r = a + r + Ee;}n += r;
          }i[s] = n.replace(c, "").trim();
        }return i;
      }(a) : a, ye > 0) if (void 0 !== (n = Pe(Fe, Ve, f, e, pe, be, je, t, i, t)) && 0 === (Ve = n).length) return Ye + Ve + Xe;if (Ve = f.join(",") + "{" + Ve + "}", Ae * ke != 0) {
        if (2 === Ae && !Le(Ve, 2)) ke = 0;switch (ke) {case le:
            Ve = Ve.replace(k, ":" + S + "$1") + Ve;break;case ne:
            Ve = Ve.replace(p, "::" + N + "input-$1") + Ve.replace(p, "::" + S + "$1") + Ve.replace(p, ":" + F + "input-$1") + Ve;}ke = 0;
      }
    }return Ye + Ve + Xe;
  }function Ie(e, a, r) {
    var c = a.trim().split(o),
        s = c,
        t = c.length,
        i = e.length;switch (i) {case 0:case 1:
        for (var f = 0, n = 0 === i ? "" : e[0] + " "; f < t; ++f) {
          s[f] = Je(n, s[f], r, i).trim();
        }break;default:
        f = 0;var l = 0;for (s = []; f < t; ++f) {
          for (var h = 0; h < i; ++h) {
            s[l++] = Je(e[h] + " ", c[f], r, i).trim();
          }
        }}return s;
  }function Je(e, a, r, c) {
    var s = a,
        t = s.charCodeAt(0);if (t < 33) t = (s = s.trim()).charCodeAt(0);switch (t) {case P:
        switch (ge + c) {case 0:case 1:
            if (0 === e.trim().length) break;default:
            return s.replace(h, "$1" + e.trim());}break;case V:
        switch (s.charCodeAt(1)) {case 103:
            if (Ce > 0 && ge > 0) return s.replace(u, "$1").replace(h, "$1" + Ge);break;default:
            return e.trim() + s.replace(h, "$1" + e.trim());}default:
        if (r * ge > 0 && s.indexOf("\f") > 0) return s.replace(h, (e.charCodeAt(0) === V ? "" : "$1") + e.trim());}return e + s;
  }function Ke(e, a, r, c) {
    var l,
        o = 0,
        h = e + ";",
        u = 2 * a + 3 * r + 4 * c;if (944 === u) return function (e) {
      var a = e.length,
          r = e.indexOf(":", 9) + 1,
          c = e.substring(0, r).trim(),
          s = e.substring(r, a - 1).trim();switch (e.charCodeAt(9) * Be) {case 0:
          break;case Q:
          if (110 !== e.charCodeAt(10)) break;default:
          for (var t = s.split((s = "", f)), i = 0, r = 0, a = t.length; i < a; r = 0, ++i) {
            for (var l = t[i], o = l.split(n); l = o[r];) {
              var h = l.charCodeAt(0);if (1 === Be && (h > L && h < 90 || h > 96 && h < 123 || h === R || h === Q && l.charCodeAt(1) !== Q)) switch (isNaN(parseFloat(l)) + (-1 !== l.indexOf("("))) {case 1:
                  switch (l) {case "infinite":case "alternate":case "backwards":case "running":case "normal":case "forwards":case "both":case "none":case "linear":case "ease":case "ease-in":case "ease-out":case "ease-in-out":case "paused":case "reverse":case "alternate-reverse":case "inherit":case "initial":case "unset":case "step-start":case "step-end":
                      break;default:
                      l += De;}}o[r++] = l;
            }s += (0 === i ? "" : ",") + o.join(" ");
          }}if (s = c + s + ";", 1 === Ae || 2 === Ae && Le(s, 1)) return N + s + s;return s;
    }(h);else if (0 === Ae || 2 === Ae && !Le(h, 1)) return h;switch (u) {case 1015:
        return 97 === h.charCodeAt(10) ? N + h + h : h;case 951:
        return 116 === h.charCodeAt(3) ? N + h + h : h;case 963:
        return 110 === h.charCodeAt(5) ? N + h + h : h;case 1009:
        if (100 !== h.charCodeAt(4)) break;case 969:case 942:
        return N + h + h;case 978:
        return N + h + S + h + h;case 1019:case 983:
        return N + h + S + h + F + h + h;case 883:
        if (h.charCodeAt(8) === Q) return N + h + h;if (h.indexOf("image-set(", 11) > 0) return h.replace(z, "$1" + N + "$2") + h;return h;case 932:
        if (h.charCodeAt(4) === Q) switch (h.charCodeAt(5)) {case 103:
            return N + "box-" + h.replace("-grow", "") + N + h + F + h.replace("grow", "positive") + h;case 115:
            return N + h + F + h.replace("shrink", "negative") + h;case 98:
            return N + h + F + h.replace("basis", "preferred-size") + h;}return N + h + F + h + h;case 964:
        return N + h + F + "flex-" + h + h;case 1023:
        if (99 !== h.charCodeAt(8)) break;return l = h.substring(h.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), N + "box-pack" + l + N + h + F + "flex-pack" + l + h;case 1005:
        return t.test(h) ? h.replace(s, ":" + N) + h.replace(s, ":" + S) + h : h;case 1e3:
        switch (o = (l = h.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(o)) {case 226:
            l = h.replace(m, "tb");break;case 232:
            l = h.replace(m, "tb-rl");break;case 220:
            l = h.replace(m, "lr");break;default:
            return h;}return N + h + F + l + h;case 1017:
        if (-1 === h.indexOf("sticky", 9)) return h;case 975:
        switch (o = (h = e).length - 10, u = (l = (33 === h.charCodeAt(o) ? h.substring(0, o) : h).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))) {case 203:
            if (l.charCodeAt(8) < 111) break;case 115:
            h = h.replace(l, N + l) + ";" + h;break;case 207:case 102:
            h = h.replace(l, N + (u > 102 ? "inline-" : "") + "box") + ";" + h.replace(l, N + l) + ";" + h.replace(l, F + l + "box") + ";" + h;}return h + ";";case 938:
        if (h.charCodeAt(5) === Q) switch (h.charCodeAt(6)) {case 105:
            return l = h.replace("-items", ""), N + h + N + "box-" + l + F + "flex-" + l + h;case 115:
            return N + h + F + "flex-item-" + h.replace(y, "") + h;default:
            return N + h + F + "flex-line-pack" + h.replace("align-content", "").replace(y, "") + h;}break;case 973:case 989:
        if (h.charCodeAt(3) !== Q || 122 === h.charCodeAt(4)) break;case 931:case 953:
        if (true === j.test(e)) if (115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0)) return Ke(e.replace("stretch", "fill-available"), a, r, c).replace(":fill-available", ":stretch");else return h.replace(l, N + l) + h.replace(l, S + l.replace("fill-", "")) + h;break;case 962:
        if (h = N + h + (102 === h.charCodeAt(5) ? F + h : "") + h, r + c === 211 && 105 === h.charCodeAt(13) && h.indexOf("transform", 10) > 0) return h.substring(0, h.indexOf(";", 27) + 1).replace(i, "$1" + N + "$2") + h;}return h;
  }function Le(e, a) {
    var r = e.indexOf(1 === a ? ":" : "{"),
        c = e.substring(0, 3 !== a ? r : 10),
        s = e.substring(r + 1, e.length - 1);return Oe(2 !== a ? c : c.replace(O, "$1"), s, a);
  }function Me(e, a) {
    var r = Ke(a, a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2));return r !== a + ";" ? r.replace($, " or ($1)").substring(4) : "(" + a + ")";
  }function Pe(e, a, r, c, s, t, i, f, n, l) {
    for (var o, h = 0, u = a; h < ye; ++h) {
      switch (o = $e[h].call(Te, e, u, r, c, s, t, i, f, n, l)) {case void 0:case false:case true:case null:
          break;default:
          u = o;}
    }if (u !== a) return u;
  }function Qe(e, a, r, c) {
    for (var s = a + 1; s < r; ++s) {
      switch (c.charCodeAt(s)) {case Z:
          if (e === T) if (c.charCodeAt(s - 1) === T && a + 2 !== s) return s + 1;break;case I:
          if (e === Z) return s + 1;}
    }return s;
  }function Re(e) {
    for (var a in e) {
      var r = e[a];switch (a) {case "keyframe":
          Be = 0 | r;break;case "global":
          Ce = 0 | r;break;case "cascade":
          ge = 0 | r;break;case "compress":
          we = 0 | r;break;case "semicolon":
          ve = 0 | r;break;case "preserve":
          me = 0 | r;break;case "prefix":
          if (Oe = null, !r) Ae = 0;else if ("function" != typeof r) Ae = 1;else Ae = 2, Oe = r;}
    }return Re;
  }function Te(a, r) {
    if (void 0 !== this && this.constructor === Te) return e(a);var s = a,
        t = s.charCodeAt(0);if (t < 33) t = (s = s.trim()).charCodeAt(0);if (Be > 0) De = s.replace(d, t === G ? "" : "-");if (t = 1, 1 === ge) Ge = s;else Ee = s;var i,
        f = [Ge];if (ye > 0) if (void 0 !== (i = Pe(ze, r, f, f, pe, be, 0, 0, 0, 0)) && "string" == typeof i) r = i;var n = He(xe, f, r, 0, 0);if (ye > 0) if (void 0 !== (i = Pe(je, n, f, f, pe, be, n.length, 0, 0, 0)) && "string" != typeof (n = i)) t = 0;return De = "", Ge = "", Ee = "", ke = 0, pe = 1, be = 1, we * t == 0 ? n : n.replace(c, "").replace(g, "").replace(A, "$1").replace(C, "$1").replace(w, " ");
  }if (Te.use = function e(a) {
    switch (a) {case void 0:case null:
        ye = $e.length = 0;break;default:
        if ("function" == typeof a) $e[ye++] = a;else if ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a))) for (var r = 0, c = a.length; r < c; ++r) {
          e(a[r]);
        } else qe = 0 | !!a;}return e;
  }, Te.set = Re, void 0 !== a) Re(a);return Te;
});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 937 */,
/* 938 */
/***/ (function(module, exports) {

module.exports = function createTapListener(el, callback, useCapture) {
  var startX = 0;
  var startY = 0;
  var touchStarted = false;
  var touchMoved = false;
  // Assume that if a touchstart event initiates, the user is
  // using touch and click events should be ignored.
  // If this isn't done, touch-clicks will fire the callback
  // twice: once on touchend, once on the subsequent "click".
  var usingTouch = false;

  el.addEventListener('click', handleClick, useCapture);
  el.addEventListener('touchstart', handleTouchstart, useCapture);

  function handleClick(e) {
    if (usingTouch) return;
    callback(e);
  }

  function handleTouchstart(e) {
    usingTouch = true;

    if (touchStarted) return;
    touchStarted = true;

    el.addEventListener('touchmove', handleTouchmove, useCapture);
    el.addEventListener('touchend', handleTouchend, useCapture);
    el.addEventListener('touchcancel', handleTouchcancel, useCapture);

    touchMoved = false;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }

  function handleTouchmove(e) {
    if (touchMoved) return;

    if (Math.abs(e.touches[0].clientX - startX) <= 10 && Math.abs(e.touches[0].clientY - startY) <= 10) return;

    touchMoved = true;
  }

  function handleTouchend(e) {
    touchStarted = false;
    removeSecondaryTouchListeners();
    if (!touchMoved) {
      callback(e);
    }
  }

  function handleTouchcancel() {
    touchStarted = false;
    touchMoved = false;
    startX = 0;
    startY = 0;
  }

  function removeSecondaryTouchListeners() {
    el.removeEventListener('touchmove', handleTouchmove, useCapture);
    el.removeEventListener('touchend', handleTouchend, useCapture);
    el.removeEventListener('touchcancel', handleTouchcancel, useCapture);
  }

  function removeTapListener() {
    el.removeEventListener('click', handleClick, useCapture);
    el.removeEventListener('touchstart', handleTouchstart, useCapture);
    removeSecondaryTouchListeners();
  }

  return {
    remove: removeTapListener
  };
};

/***/ }),
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__healthwise_enhanced_shared_decision_point__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__healthwise_enhanced_shared_decision_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__healthwise_enhanced_shared_decision_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
__webpack_require__.p = window.hwResourcePublicPath; // eslint-disable-line camelcase






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__healthwise_enhanced_shared_decision_point___default.a, { baseRoute: '/Client/Esdp' }), document.getElementById('root'));

/***/ }),
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"answer_correct_indicator":"AnswerCorrectIndicator--answer_correct_indicator--32HzM","answer_correct_indicator_wrapper":"AnswerCorrectIndicator--answer_correct_indicator_wrapper--2ATek","answer_correct_indicator_icon":"AnswerCorrectIndicator--answer_correct_indicator_icon--27k8z","answer_correct_indicator_checkmark":"AnswerCorrectIndicator--answer_correct_indicator_checkmark--KgmQa","answer_correct_indicator_text":"AnswerCorrectIndicator--answer_correct_indicator_text--2sAvp"};

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"answer_incorrect_indicator":"AnswerIncorrectIndicator--answer_incorrect_indicator--3pa6r","answer_incorrect_indicator_wrapper":"AnswerIncorrectIndicator--answer_incorrect_indicator_wrapper--3XY6J","answer_incorrect_indicator_checkmark":"AnswerIncorrectIndicator--answer_incorrect_indicator_checkmark--2NcZU","answer_incorrect_indicator_checkmark_alt":"AnswerIncorrectIndicator--answer_incorrect_indicator_checkmark_alt--1Szg4","answer_incorrect_indicator_text":"AnswerIncorrectIndicator--answer_incorrect_indicator_text--30Lkp"};

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"compare_box_wrapper":"CompareBox--compare_box_wrapper--1DpV4","compare_box":"CompareBox--compare_box--qjs4g","compare_box_item":"CompareBox--compare_box_item--1NdsW","compare_box_title":"CompareBox--compare_box_title--160qe","compare_box_content":"CompareBox--compare_box_content--2YwbJ"};

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"compare_icon_array":"CompareIconArray--compare_icon_array--1DzjS"};

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"compare":"CompareTable--compare--3D0J9","compareTable":"CompareTable--compareTable--2Y77V","forFixedWidthLayoutRow":"CompareTable--forFixedWidthLayoutRow--TIF4U","forFixedWidthLayout":"CompareTable--forFixedWidthLayout--K0iSC","headCellVisibleWrapper":"CompareTable--headCellVisibleWrapper--11a5w","headCellVisibleUnderscore":"CompareTable--headCellVisibleUnderscore--1N7dO","headCell":"CompareTable--headCell--Haf9W","headCellText":"CompareTable--headCellText--2Zdfp","sectionTitleRow":"CompareTable--sectionTitleRow--H1iE8","sectionTitleCell":"CompareTable--sectionTitleCell--1kYd2","sectionTitleParent":"CompareTable--sectionTitleParent--2wW8R","cell":"CompareTable--cell--3EYR7","halfColumn":"CompareTable--halfColumn--3R1pE","forAssistiveTech":"CompareTable--forAssistiveTech--3RPOC"};

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"Content--keyboard_navigation_jump--1V9tm","content_section":"Content--content_section--33JQD","hide_for_print":"Content--hide_for_print--3e5Q3"};

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"ContentArticle--keyboard_navigation_jump--1z2Di","content_article":"ContentArticle--content_article--AoN4g"};

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"EmailSummary--keyboard_navigation_jump--2s0NZ","loading":"EmailSummary--loading--HcObL","label":"EmailSummary--label--2t4d5","emailSvg":"EmailSummary--emailSvg--kAYRu","statusSuccess":"EmailSummary--statusSuccess--1Y4Hu","statusError":"EmailSummary--statusError--tRJk3","wrapper":"EmailSummary--wrapper--YkMkj","secondaryButton":"EmailSummary--secondaryButton--1u7GD","shake":"EmailSummary--shake--2vhrC"};

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"EsdpMap--keyboard_navigation_jump--u1sOM","credits_wrapper":"EsdpMap--credits_wrapper--2ISjs"};

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"heading_reset":"Heading--heading_reset--1UMrE","h1_style":"Heading--h1_style--3S4_8","h2_style":"Heading--h2_style--3dDjz","h3_style":"Heading--h3_style--FejVQ","h4_style":"Heading--h4_style--24eyC","h5_style":"Heading--h5_style--hGTZk","h6_style":"Heading--h6_style--3MknT"};

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image_compare_box_wrapper":"ImageCompareBox--image_compare_box_wrapper--LBYL-","image_compare_box":"ImageCompareBox--image_compare_box--2KXUt","image_compare_box_item":"ImageCompareBox--image_compare_box_item--v2qVk","image_compare_box_image":"ImageCompareBox--image_compare_box_image--1rKHS","image_compare_box_content":"ImageCompareBox--image_compare_box_content--1VZmV"};

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"Interaction--keyboard_navigation_jump--3mr7-","notes_wrapper":"Interaction--notes_wrapper--l6rSw"};

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list_item":"ListItem--list_item--1oQPP"};

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"nav":"NavigationHeading--nav--1X0zE","banner":"NavigationHeading--banner--P_6nM","bannerInner":"NavigationHeading--bannerInner--2ORrv","svgFill":"NavigationHeading--svgFill--MBxaW","svgStroke":"NavigationHeading--svgStroke--1TTeO"};

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paragraph":"Paragraph--paragraph--PZ4LB"};

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"common_hidden_text":"QuestionBlock--common_hidden_text--2qjlM","question_block":"QuestionBlock--question_block--9jeX-","question":"QuestionBlock--question--3gaCg","question_is_required_indicator":"QuestionBlock--question_is_required_indicator--tjYQX","question_is_required":"QuestionBlock--question_is_required--2VFF3"};

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"question_mult_choice_single_answer":"QuestionMultChoiceSingleAnswer--question_mult_choice_single_answer--3qHyy","question_mult_choice_single_answer_group":"QuestionMultChoiceSingleAnswer--question_mult_choice_single_answer_group--2UytD"};

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"quiz_wrapper":"QuizWrapper--quiz_wrapper--207uU"};

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"common_hidden_text":"RadioQuizAnswer--common_hidden_text--1XWUb","radio_quiz_answer_label":"RadioQuizAnswer--radio_quiz_answer_label--1DhMh","radio_quiz_answer_row":"RadioQuizAnswer--radio_quiz_answer_row--39U2X","radio_quiz_answer_radio_wrapper":"RadioQuizAnswer--radio_quiz_answer_radio_wrapper--1Sc8Z","radio_quiz_answer_wrapper":"RadioQuizAnswer--radio_quiz_answer_wrapper--3GPBX","radio_quiz_answer_evaluation":"RadioQuizAnswer--radio_quiz_answer_evaluation--26GSJ","radio_quiz_answer_active":"RadioQuizAnswer--radio_quiz_answer_active--2mDOL","radio_quiz_answer_mistaken":"RadioQuizAnswer--radio_quiz_answer_mistaken--3vPXy","radio_quiz_answer_unmistaken":"RadioQuizAnswer--radio_quiz_answer_unmistaken--1c5Pz"};

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"RelatedContent--keyboard_navigation_jump---vzHf","contentArticle":"RelatedContent--contentArticle--3n576","fullArticle":"RelatedContent--fullArticle--3matN","contentHeader":"RelatedContent--contentHeader--1r_9a","content":"RelatedContent--content--fQswk","clearfix":"RelatedContent--clearfix--PlAIX","rule":"RelatedContent--rule--1yjc0","contentMedia":"RelatedContent--contentMedia--HxryT","contentDescription":"RelatedContent--contentDescription--3u6vf","contentAbstract":"RelatedContent--contentAbstract--2eeJC","articleButton":"RelatedContent--articleButton--4kH9J","contentFull":"RelatedContent--contentFull--LqT3r","contentThumbnail":"RelatedContent--contentThumbnail--AQpct","contentType_video":"RelatedContent--contentType_video--2nCQv","contentType_article":"RelatedContent--contentType_article--DaEqT","articleShow":"RelatedContent--articleShow--TDwrb","opacityShow":"RelatedContent--opacityShow--1i-Jh","abstractHide":"RelatedContent--abstractHide--2gVOA","contentClose":"RelatedContent--contentClose--nyYVd"};

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"SectionHeading--keyboard_navigation_jump--2IpIk","esdp_section_heading":"SectionHeading--esdp_section_heading--3peSX","esdp_section_heading_image":"SectionHeading--esdp_section_heading_image--3d4xk","heading":"SectionHeading--heading--2Vll7"};

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"standard_disclaimer":"StandardDisclaimer--standard_disclaimer--2SLri","standard_disclaimer_print":"StandardDisclaimer--standard_disclaimer_print--3tAEo","logo":"StandardDisclaimer--logo--qlins","logo_link":"StandardDisclaimer--logo_link--2-kU_","logo_image":"StandardDisclaimer--logo_image--37ryF","legal":"StandardDisclaimer--legal--9_gc8","disclaimer":"StandardDisclaimer--disclaimer--1OOlM","copyright":"StandardDisclaimer--copyright--1Wcl7"};

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"SummaryPage--keyboard_navigation_jump--jRv-L","go_back_link":"SummaryPage--go_back_link--2dHw7","answered_mult_choice":"SummaryPage--answered_mult_choice--2G-1q","img":"SummaryPage--img--3PthN","svg_check":"SummaryPage--svg_check--3rKkX","content_section":"SummaryPage--content_section--2tkz3"};

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"unordered_list":"UnorderedList--unordered_list--36a9h"};

/***/ })
],[1001]);


// WEBPACK FOOTER //
// client/esdp.d2d5176ceee8a01122ae.js